(function() {
    'use strict';

    angular
        .module('uniromaLandingApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'chart.js',
            'ui.tree',
            'ui.ace',
            'ui.codemirror',
            'ui.validate',
            'frapontillo.bootstrap-switch',
            'vcRecaptcha',
            'angular-notification-icons'
        ])
        .config(function() {
        	angular.lowercase = angular.$$lowercase;  
        })
        .config(["$qProvider", function ($qProvider) {
            $qProvider.errorOnUnhandledRejections(false);
        }])
        .config(["$locationProvider", function ($locationProvider) {
        	$locationProvider.hashPrefix("");
        }])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler', '$rootScope', '$q', '$location', '$state', 'Principal', 'Auth', 'UserContacts' ];

    function run(stateHandler, translationHandler, $rootScope, $q, $location, $state, Principal, Auth, UserContacts) {
        stateHandler.initialize();
        translationHandler.initialize();
        
        var USER_SETTINGS_STATE = 'settings';
        var HOME_STATE = 'home';
        HOME_STATE = true; // FIXME: questo risolve il fatto che non si possa accedere a reset/request da non autenticati - togliere e trovare un'altra soluzione quando verrà richiesto di mostrare solo la HOME agli utenti presenti solo su Domino
        
        $rootScope.$on("$locationChangeStart", function(event, next, current) { 
           console.log("location change start detected"); 
           var canChangePromise = canChange(event, next, current);
           canChangePromise.then(function( locationChangeAllowed ) {
        	   if ( locationChangeAllowed !== true ) {
        		   console.log("preventing change");
        		   $state.go( locationChangeAllowed || USER_SETTINGS_STATE );
               } 
           }, function() {
        	   $state.go( USER_SETTINGS_STATE );
           });
           
        });
        
        $rootScope.$on("routeChangeStart", function(event, next, current) { 
            console.log("route change start detected"); 
            var canChangePromise = canChange(event, next, current);
            canChangePromise.then(function( routeChangeAllowed ) {
         	   if ( routeChangeAllowed !== true ) {
         		   console.log("preventing change");
             	   $state.go( routeChangeAllowed || USER_SETTINGS_STATE );
               } 
            }, function() {
         	   $state.go( USER_SETTINGS_STATE );
            });
            
         });
        
        /*
         * controlla se l'utente è autenticato e ha impostato la mail privata nei contatti
         */
        function canChange(event, next, current) {
        	var deferred = $q.defer();
        	
	        if ( Principal.isAuthenticated() ) {
	        	Principal.identity().then(function(account) {
	        		if (!account || !account.login || account.login.indexOf("@") >= 0) {
		            	deferred.resolve(true);
	        		} else {
			    		UserContacts.get().$promise
						.then(getContactsThen)
						.catch(getContactsCatch);
	        		}
	            }).catch(function() {
	            	deferred.resolve(HOME_STATE);
	            });
	        } else {
	        	deferred.resolve(HOME_STATE);
	        }
	        	        
	        return deferred.promise;
	        

	        function getContactsThen (contacts) {
	        	var email = (contacts !== undefined ? contacts.email : null);
	        	var resolved = (email !== null ? true : false);
	        	deferred.resolve( resolved );
	        }

		    function getContactsCatch (err) {
		    	if (console && console.log) console.log("WARNING: error getting personal contacts: ", err);
		        deferred.resolve(true);
		    }
		        
        }
      
        
    }
    
   
    
    
    
})();


(function () {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'isEnabled': {method: 'GET', url: 'api/userEnabled', isArray: false},
            'setEnabled': {method: 'PUT', url: 'api/userEnabled', isArray: false},
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('UserContacts', UserContacts);

    UserContacts.$inject = ['$resource'];

    function UserContacts ($resource) {
        var service = $resource('api/userContacts', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                	if(data!=null && data!="")
                		data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();


'use strict';

angular.module('uniromaLandingApp')
    .factory('ScheduledJobStats', ['$resource','DateUtils',function ($resource, DateUtils) {
        return $resource('api/scheduledJobStats/stats', {}, {
            'query': { method: 'GET', isArray: true}
            
        });
    }]);

'use strict';

angular.module('uniromaLandingApp')
    .factory('ScheduledJob', ['$resource','DateUtils',function ($resource, DateUtils) {
        return $resource('api/scheduledJobs/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateStart = DateUtils.convertDateTimeFromServer(data.dateStart);
                    data.dateEnd = DateUtils.convertDateTimeFromServer(data.dateEnd);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }])
	.factory('ScheduledJobErrors', ['$resource','DateUtils',function ($resource, DateUtils) {
	    return $resource('api/scheduledJobs/errors', {}, {
	        'query': { method: 'GET', isArray: true}
	    });
	}]);
'use strict';

angular.module('uniromaLandingApp')
    .factory('RejectedType', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/rejectedTypes/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('uniromaLandingApp')
    .factory('RejectedRow', ['$resource', 'DateUtils',function ($resource, DateUtils) {
        return $resource('api/rejectedRows/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'prev': {
                method: 'GET',
                url: 'api/prevRejectedRows/:id',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'next': {
                method: 'GET',
                url: 'api/nextRejectedRows/:id',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }])
    .factory('RejectedRowFilter', ['$resource','DateUtils',function ($resource, DateUtils) {
	    return $resource('api/rejectedRows/idJobList', {}, {
	        'query': { method: 'GET', isArray: true}
	    });
	}]);

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

'use strict';

angular.module('uniromaLandingApp')
.factory('Policy', ['$resource',function ($resource) {
	return {
		policies: $resource('api/policies/:id', {}, {
			'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
		}),
		create: $resource('api/create-policy', {}, {
			'nuova': { method: 'POST',
				params: {},
				isArray: true,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			}
			
		})
	};
}]);


//(function() {
//    'use strict';
//    angular
//        .module('unimibLandingApp')
//        .factory('Policy', Policy);
//
//    Policy.$inject = ['$resource'];
//
//    function Policy ($resource) {
//        var resourceUrl =  'api/policies/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true},
//            'get': {
//                method: 'GET',
//                transformResponse: function (data) {
//                    if (data) {
//                        data = angular.fromJson(data);
//                    }
//                    return data;
//                }
//            },
//            'update': { method:'PUT' },
//            'create':{
//            	method: 'POST',
//            	url: 'api/create-policy',
//            	params: {},
//				isArray: true,
//            }
//        });
//    }
//})();




'use strict';

angular.module('uniromaLandingApp')
.factory('PolicyAnag', ['$resource',function ($resource) {
	return {
		policies: $resource('api/anag-policies/:id', {}, {
			'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
		}),
		create: $resource('api/create-anag-policy', {}, {
			'nuova': { method: 'POST',
				params: {},
				isArray: true,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			}
			
		})
	};
}]);


//(function() {
//    'use strict';
//    angular
//        .module('unimibLandingApp')
//        .factory('Policy', Policy);
//
//    Policy.$inject = ['$resource'];
//
//    function Policy ($resource) {
//        var resourceUrl =  'api/policies/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true},
//            'get': {
//                method: 'GET',
//                transformResponse: function (data) {
//                    if (data) {
//                        data = angular.fromJson(data);
//                    }
//                    return data;
//                }
//            },
//            'update': { method:'PUT' },
//            'create':{
//            	method: 'POST',
//            	url: 'api/create-policy',
//            	params: {},
//				isArray: true,
//            }
//        });
//    }
//})();




'use strict';

angular.module('uniromaLandingApp')
    .factory('Omonimie', ['$resource',function ($resource) {
    	  return $resource('api/omonimie/:username', {}, {
            'get': {
                method: 'GET'
             }
        });
    }]);

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('IdmStatiGenerali', IdmStatiGenerali);

    IdmStatiGenerali.$inject = ['$resource'];

    function IdmStatiGenerali ($resource) {
        var resourceUrl =  'api/stati-generali/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'macroStati': { url: 'api/macro-stati', method: 'GET', isArray: true},
            'ruoli': { url: 'api/ruoli-categorie', method: 'GET', isArray: true},
            'allStati': { url: 'api/stati', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('IdmCategoria', IdmCategoria);

    IdmCategoria.$inject = ['$resource'];

    function IdmCategoria ($resource) {
        var resourceUrl =  'api/categorie-utenti/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

'use strict';

angular.module('uniromaLandingApp')
	.factory('EsterniStatiSpecService', ['$resource',function ($resource) {
		return {
			stati: $resource('api/esterniStatiSpecifici', {}, {
				'get': { method: 'GET',
							params: {},
							isArray: true,
							transformResponse: function (data) {
								data = angular.fromJson(data);
								return data;
							}
                },
                'getAll': { method: 'GET',
                	url: 'api/esterniAllStatiSpecifici',
					params: {},
					isArray: true,
					transformResponse: function (data) {
						data = angular.fromJson(data);
						return data;
					}
        }
			})
		};
	}]);

'use strict';

angular.module('uniromaLandingApp').factory('Esterni', 
		['$resource', 'DateUtils',function ($resource, DateUtils) {
        return $resource('api/esternis/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                	
                    data = angular.fromJson(data);
//                    data.dtNascita = DateUtils.convertLocaleDateFromServer(data.dtNascita);
                    
                    data.dataFine = DateUtils.convertLocalDateFromServer(data.dataFine);
                    data.dataAttivazione = DateUtils.convertLocalDateFromServer(data.dataAttivazione);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
//                    data.dtNascita = DateUtils.convertLocaleDateToServer(data.dtNascita);
                    //data.provResidenza = data.provResidenza.sigla;
                    return angular.toJson(data);
                }
            },
            'activate': {
                method: 'GET',
                url: 'api/activateUser/:id',
                transformRequest: function (data) {
//                    data.dtNascita = DateUtils.convertLocaleDateToServer(data.dtNascita);
                	data.dataFine = DateUtils.convertLocalDateFromServer(data.dataFine);
                    data.dataAttivazione = DateUtils.convertLocalDateFromServer(data.dataAttivazione);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                url: 'api/public/esternis',
                transformRequest: function (data) {
//                    data.dtNascita = DateUtils.convertLocaleDateToServer(data.dtNascita);
                    //data.provResidenza = data.provResidenza.sigla;
                    return angular.toJson(data);
                }
            },
            'confirmRegistration': {
                method: 'GET',
                url: 'api/public/confirm-registration/:token',
                transformRequest: function (data) {
//                    data.dtNascita = DateUtils.convertLocaleDateToServer(data.dtNascita);
                    //data.provResidenza = data.provResidenza.sigla;
                    return angular.toJson(data);
                }
            },
            'getCountryList': {
                method: 'GET',
                url: 'api/public/iso-country-codes',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        var idx = data.findIndex(function(x) {return x.nome === 'IT'});
                        if (idx >= 0) {
                            data.unshift(data.splice(idx, 1)[0]);
                        }
                    }
                    return data;
                }
            }
        });
    }]);

'use strict';

angular.module('uniromaLandingApp')
	.factory('ComuniCodiceFiscaleService', ['$resource',function ($resource) {
		return $resource('api/public/comuni-codice-fiscale', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

	}]);

'use strict';

angular.module('uniromaLandingApp')
	.factory('CodiceFiscaleService', ['$resource',function ($resource) {
		return {
			checkCodiceFiscale: $resource('api/public/checkCodiceFiscale', {}, {
					'check': { method: 'POST',
								params: {},
								isArray: false,
								transformResponse: function (data) {
									data = angular.fromJson(data);
									return data;
								}
                }
			}),
			checkDateCodiceFiscale: $resource('api/public/checkDateCodiceFiscale',{}, { 
				'check': {	method: 'POST',
							params: {},
							isArray: false,
							transformResponse: function (data) {
									data = angular.fromJson(data);
									return data;
							}
                }
			}),
			checkCodComuneCodiceFiscale: $resource('api/public/checkCodComuneCodiceFiscale',{}, { 
				'check': {	method: 'POST',
							params: {},
							isArray: false,
							transformResponse: function (data) {
									data = angular.fromJson(data);
									return data;
							}
                }
			}),
			checkUniqueCodiceFiscale: $resource('api/public/checkUniqueCodiceFiscale',{}, { 
				'check': {	method: 'POST',
							params: {},
							isArray: false,
							transformResponse: function (data) {
									data = angular.fromJson(data);
									return data;
							}
                }
			})
		};
	}]);

'use strict';

angular.module('uniromaLandingApp')
	.factory('CategorieService', ['$resource',function ($resource) {
		return {
			external: $resource('api/public/esterniCategorie', {}, {
					'get': { method: 'GET',
								params: {},
								isArray: true,
								transformResponse: function (data) {
									data = angular.fromJson(data);
									return data;
								}
                }
			})
		};
	}]);

'use strict';

angular.module('uniromaLandingApp')
    .factory('Eccezioni', ['$resource', 'DateUtils',function ($resource, DateUtils) {
        return $resource('api/eccezionis/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('uniromaLandingApp')
    .factory('ConfigParam', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/configParams/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account','AnagraficaService'];

    function Principal ($q, Account, AnagraficaService) {
        var _identity,
            _authenticated = false,
            _logout = {logout: false},
        	_mustConfirmEmail = null;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            isLogout: isLogout,
            setLogout: setLogout,
            needPersonalMailConfirmation: needPersonalMailConfirmation,
            setPersonalMailConfirmation: setPersonalMailConfirmation
        };

        return service;
        
        function setPersonalMailConfirmation(flag){
        	_mustConfirmEmail = flag;
        }
        
        function needPersonalMailConfirmation(){
        	if(_mustConfirmEmail == null)
        		return false;
        	return _mustConfirmEmail;
        }

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }
        
        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                setLogout( false);
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                setLogout( false)
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }
        
        function isLogout () {
            return _logout;
        }
        
        function setLogout (logout) {
            _logout.logout = logout;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {
        	'save': {
        		method: 'POST', 
        		isArray: false,
        		transformResponse: function (data, headers, status) {
        			if (status == 200) {
        				return {data: data};
        			}
                    return data;
                }
        	}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {
        	'save': {
        		method: 'POST', 
        		isArray: false,
        		transformResponse: function (data, headers, status) {
        			if (status == 200) {
        				return {data: data};
        			}
                    return data;
                }
        	}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('hasAuthority', hasAuthority)
        .directive('hasAuthorityException', hasAuthorityException);

    hasAuthority.$inject = ['Principal'];
    hasAuthorityException.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
    
    function hasAuthorityException(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
        	var attrToArray = scope.$eval(attrs.hasAuthorityException);
        	var authorityMustHaveNot = attrToArray[1].replace(/\s+/g, '');
            var authorityMustHave = attrToArray[0].replace(/\s+/g, '');
            

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }
                    
                    var has = Principal.hasAnyAuthority(authorityMustHave.split(","));
                    
                    if(!has)
                    	setHidden();
                    else if(Principal.hasAnyAuthority(authorityMustHaveNot.split(","))){
                    	setHidden();
                    }
                    else{
                    	setVisible();
                    } 
                    
                };

            if (authorityMustHave.length > 0 && authorityMustHaveNot.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
        
        function checkIfHasAuthority(authority){
        	
        }
        
        function checkIfHasNOTAuthority(authority){
        	
        }
    }
    
    
    
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$window' ];

    function AuthServerProvider ($http, $localStorage, $window ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {

            
            // logout from the server
//            $http.post('api/logout').success(function (response) {
//                delete $localStorage.authenticationToken;
//                // to get a new csrf token call the api
//                $http.get('api/profile-info');
//                return response;
//            });
            // logout from the server
            var logoutUrl = "/Shibboleth.sso/Logout";
//            if ( /^[^\.]*-pp\..*$/.test($window.location) ) {
//            	logoutUrl = "/landing/Shibboleth.sso/Logout";
//            }

            $http.post('api/logout').then(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/profile-info');
                $window.location.href = logoutUrl;
                return response;
            }, function (data, status) {
            	$window.location.href = logoutUrl;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', '$window', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, $window, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities 
                		&& $rootScope.toState.data.authorities.length > 0
                		&& !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    
                	if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (oldPassword,newPassword, us_account, callback) {
            var cb = callback || angular.noop;
            var payload={
            		"oldPassword": oldPassword,
            		"newPassword":newPassword,
            		"usAccount":us_account
            }

            return Password.save(payload, function (res) {
                return cb(res);
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
        	AuthServerProvider.logout();
            Principal.authenticate(null);
            Principal.setLogout(true);
//            AuthServerProvider.logout();
//            Principal.authenticate(null);
//            $window.location.href = "/Shibboleth.sso/Logout";
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function (res) {
                return cb(res);
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

'use strict';

angular.module('uniromaLandingApp')
.factory('AnagraficaService', ['$resource',function ($resource) {
	return {
		strutturati: $resource('api/strutturati', {}, {
			'get': { method: 'GET',
				params: {},
				isArray: true,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			}
			
		}),
		anagrafiche: $resource('api/anagrafiche', {}, {
			'get': { method: 'GET',
				params: {},
				isArray: true,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			}
			
		}),
		strutturato: $resource('api/strutturato', {}, {
			'getOne': { method: 'GET',
				params: {},
				isArray: false,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'update': { method: 'PUT',
				transformRequest: function (data) {
                  return angular.toJson(data);
              }
			}
			
		}),
		
		checkPersonalInformation: $resource('api/checkPersonalInformation', {}, {
			'check': { method: 'GET',
						params: {},
						isArray: false,
						transformResponse: function (data) {
							data = angular.fromJson(data);
							return data;
						}
			}
		}) /*,
		checkUniqueAlias: $resource('api/checkUniqueAlias', {}, {
			'check': { method: 'POST',
						params: {},
						isArray: false,
						transformResponse: function (data) {
							data = angular.fromJson(data);
							return data;
						}
			}
		})*/

	};
}]);

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('registryEntities', {
                parent: 'app',
                url: '/registryEntities',
                data: {
                    authorities: ['ROLE_GESTIONE_REGISTRY'],
                    pageTitle: 'uniromaLandingApp.registryEntities.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/registry/registryEntities.html',
                        controller: 'RegistryEntitiesController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('registryEntities');
                        $translatePartialLoader.addPart('provider_tr');
                        $translatePartialLoader.addPart('product_tr');
                        $translatePartialLoader.addPart('module_tr');
                        $translatePartialLoader.addPart('service_tr');
                        
                        $translatePartialLoader.addPart('provider');
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('module');
                        $translatePartialLoader.addPart('service');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

'use strict';

angular.module('uniromaLandingApp').controller('RegistryEntitiesController', 
		['$scope','ParseLinks','Provider','$state','$stateParams','$window',function ($scope, ParseLinks,Provider,$state,$stateParams,$window) {

		function loadAll () {
			Provider.query({}, onSuccess, onError);
			function sort() {
				var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
				if (vm.predicate !== 'id') {
					result.push('id');
				}
				$scope.collapsedNode = [];
				return result;
			}
			function onSuccess(data, headers) {
				$scope.data = data;
			}
			function onError(error) {
				AlertService.error(error.data.message);
			}
		};
		loadAll();

		$scope.collapsedNode = [];
		$scope.currentNodeType = null;
		$scope.selectedNode = null;

		$scope.showNodeInfo = function(node,type){
			$scope.selectedNode = node;
			$scope.currentNodeType = type;
			$window.scrollTo(0, 0);
		};


		/* Traduzioni */

		$scope.editTranslation = function(translation){
			switch($scope.currentNodeType){
			case 'provider':
				$state.go("provider-tr.edit",{id:translation.id});
				break;
			case 'product':
				$state.go("product-tr.edit",{id:translation.id});
				break;
			case 'module':
				$state.go("module-tr.edit",{id:translation.id});
				break;
			case 'service':
				$state.go("service-tr.edit",{id:translation.id});
				break;
			}
		};

		$scope.newTranslation = function(translation){
			switch($scope.currentNodeType){
			case 'provider':
				$state.go("provider-tr.new",{id: $scope.selectedNode.id});
				break;
			case 'product':
				$state.go("product-tr.new",{id: $scope.selectedNode.id});
				break;
			case 'module':
				$state.go("module-tr.new",{id: $scope.selectedNode.id});
				break;
			case 'service':
				$state.go("service-tr.new",{id: $scope.selectedNode.id});
				break;
			}

		};

		$scope.deleteTranslation = function(translation){
			switch($scope.currentNodeType){
			case 'provider':
				$state.go("provider-tr.delete",{id: translation.id});
				break;
			case 'product':
				$state.go("product-tr.delete",{id: translation.id});
				break;
			case 'module':
				$state.go("module-tr.delete",{id: translation.id});
				break;
			case 'service':
				$state.go("service-tr.delete",{id: translation.id});
				break;
			}
		};


		// Check if a state change happened
		$scope.$on('$stateChangeSuccess',function onStateSuccess(event, toState, toParams, fromState) {
			if(fromState.name.indexOf("delete")>-1){
				$scope.selectedNode = null;
				$scope.currentNodeType = null;
			}
			if(toState.name === "registryEntities"){
				loadAll();
			}

		});

		$scope.updateCurrentNode = function(node,type){
			if($scope.selectedNode != null){
				if(node.id===$scope.selectedNode.id && $scope.currentNodeType === type)
					$scope.selectedNode = node;
			}
		};



		$scope.remove = function (scope) {
			scope.remove();
		};

		$scope.mustExpand = function (scope) {
			scope.toggle();
		};

		$scope.collapseAll = function () {
			$scope.$broadcast('angular-ui-tree:collapse-all');
			$scope.collapsedNode = [];
		};

		$scope.expandAll = function () {
			$scope.$broadcast('angular-ui-tree:expand-all');
		};

		$scope.collapseNode = function (nodeId,type,scope){
			var obj={nodeId: nodeId,type:type};
			var index = $scope.collapsedNode.map(function(o) { 
				if(o.type === type)
					return o.nodeId; 
			}).indexOf(nodeId);
			
			if(index>-1)
				$scope.collapsedNode.splice(index, 1);
			else
				$scope.collapsedNode.push(obj);
			
			scope.toggle(scope);
		};
		
		$scope.triggerCollapse = function (nodeId,type,scope){
			
			var index = $scope.collapsedNode.map(function(o) { 
				if(o.type === type)
					return o.nodeId; 
			}).indexOf(nodeId);

			if(index>-1)
				scope.toggle(scope);
		};
		
	}      
]);

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        
        vm.authorityAdmin = "ROLE_CREAZIONE_SP,ROLE_APPROVATORE_SP,ROLE_DASHBOARD_PROVISIONING,ROLE_LOG_ERRORE," +
							"ROLE_CONFIGURAZIONE_PARAM,ROLE_GESTIONE_LISTE_DISTRIBUZIONE,ROLE_GESTIONE_UTENTI" +
							"ROLE_GESTIONE_ESTERNI";

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            //$state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
        
        
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            //	factory: checkRoute,
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
    
   // checkRoute.$inject = ['$q', '$rootScope', '$location'];    
    //function checkRoute($q, $rootScope, $location) {
        /*
    	if ($rootScope.userProfile) {
            return true;
        } else {
            var deferred = $q.defer();
            $http.post("/loadUserProfile", { userToken: "blah" })
                .success(function (response) {
                    $rootScope.userProfile = response.userProfile;
                    deferred.resolve(true);
                })
                .error(function () {
                    deferred.reject();
                    $location.path("/");
                 });
            return deferred.promise;
        }
        */
    //	console.log("route check called");
    //	return true;
    //};
    
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', 'UserContacts','$state','$http','$translate'];

    function HomeController ($scope, Principal, LoginService,UserContacts,$state,$http, $translate) {
        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.escapeSingleQuote = escapeSingleQuote;
        vm.showEmailAlert = false;
        vm.mailIsMissing = false;
		vm.mailsAreEqual = false;
        
        $scope.$on('authenticationSuccess', function() {
            getAccount();
           
        });
        
        $scope.$on('languageChange', function() {
            getServicesList(true);
            //col solo $state.reload(); qui funziona male, fa il reload prima che finisca il cambio lingua, non va bene.
        });

        getAccount();
          

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if(vm.account){
                	checkPersonalInformations(vm.account);
                	getServicesList();
                	getUserType();
                }
                else if(!vm.isAuthenticated()){
                	console.log("Redirecting to /landing/auth/");
                	window.location.href = "/landing/auth/"; 
                }
                	
            });
        }
        function register () {
            $state.go('register');
        }
        
        
        function getServicesList(force){
        	var currentLang=$translate.use();
        	$http.get('api/userServiceList?lang='+currentLang).then(function(result) {
                
        		if(result.status == 200){
        			$scope.userServices = result.data;
        			if (force) $state.reload();
        		}
                
            });

        }
        
        function getUserType(){
        	$http.get('api/userType').then(function(result) {
                
        		if(result.status == 200){
        			$scope.userType = result.data;
        		}
                
            });

        };
        
        function checkPersonalInformations(account){
        	if (account.login && account.login.indexOf("@") < 0) {
	        	UserContacts.get({}, function(result, headers) {
	    	   		vm.emailPersonale = result.email;
	    	   		if (!/^I\d+$/.test(account.login.toUpperCase()))
	    	   		if(vm.emailPersonale==null || vm.emailPersonale.length==0){
	    	   			vm.account.authorities = ['ROLE_SETTINGS'];
	    	   			$state.go('settings');
	    	   		}
	    	   		
	    	   	});
        	}
        }
        
        function escapeSingleQuote(stringa){
        	stringa = stringa ? stringa.replace(/'/g, "\\'") : '';
        	return stringa;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Service_trDialogController', Service_trDialogController);

    Service_trDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Service_tr', 'Service'];

    function Service_trDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Service_tr, Service) {
        var vm = this;

        vm.service_tr = entity;
        vm.clear = clear;
        vm.save = save;
        vm.services = Service.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.service_tr.id !== null) {
                Service_tr.update(vm.service_tr, onSaveSuccess, onSaveError);
            } else {
                Service_tr.save(vm.service_tr, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:service_trUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Service_trDetailController', Service_trDetailController);

    Service_trDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Service_tr', 'Service'];

    function Service_trDetailController($scope, $rootScope, $stateParams, previousState, entity, Service_tr, Service) {
        var vm = this;

        vm.service_tr = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('uniromaLandingApp:service_trUpdate', function(event, result) {
            vm.service_tr = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Service_trDeleteController',Service_trDeleteController);

    Service_trDeleteController.$inject = ['$uibModalInstance', 'entity', 'Service_tr'];

    function Service_trDeleteController($uibModalInstance, entity, Service_tr) {
        var vm = this;

        vm.service_tr = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Service_tr.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('service-tr', {
            parent: 'entity',
            url: '/service-tr?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.service_tr.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-tr/service-trs.html',
                    controller: 'Service_trController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('service_tr');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('service-tr-detail', {
            parent: 'service-tr',
            url: '/service-tr/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.service_tr.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-tr/service-tr-detail.html',
                    controller: 'Service_trDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('service_tr');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Service_tr', function($stateParams, Service_tr) {
                    return Service_tr.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'service-tr',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('service-tr-detail.edit', {
            parent: 'service-tr-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-tr/service-tr-dialog.html',
                    controller: 'Service_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Service_tr', function(Service_tr) {
                            return Service_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-tr.new', {
            parent: 'registryEntities',
            url: '/service-tr/{id}/new',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal','Service', function($stateParams, $state, $uibModal, Service) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-tr/service-tr-dialog.html',
                    controller: 'Service_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                field: null,
                                value: null,
                                language: null,
                                id: null,
                                service: Service.get({id:$stateParams.id})
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registryEntities',null);
                }, function() {
                    $state.go('registryEntities');
                });
            }]
        })
        .state('service-tr.edit', {
            parent: 'registryEntities',
            url: '/service-tr/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-tr/service-tr-dialog.html',
                    controller: 'Service_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Service_tr', function(Service_tr) {
                            return Service_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null, { reload: 'registryEntities' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-tr.delete', {
            parent: 'registryEntities',
            url: '/service-tr/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-tr/service-tr-delete-dialog.html',
                    controller: 'Service_trDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Service_tr', function(Service_tr) {
                            return Service_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Service_tr', Service_tr);

    Service_tr.$inject = ['$resource'];

    function Service_tr ($resource) {
        var resourceUrl =  'api/service-trs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Service_trController', Service_trController);

    Service_trController.$inject = ['$state', 'Service_tr', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function Service_trController($state, Service_tr, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Service_tr.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.service_trs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('onReadFile',['$parse', function ($parse) {
		    return {
		        restrict: 'A',
		        scope: false,
		        link: function(scope, element, attrs) {
		            element.bind('change', function(e) {
		                
		                var onFileReadFn = $parse(attrs.onReadFile);
		                var reader = new FileReader();
		                
		                reader.onload = function() {
		                    var fileContents = reader.result;
		                    // invoke parsed function on scope
		                    // special syntax for passing in data
		                    // to named parameters
		                    // in the parsed function
		                    // we are providing a value for the property 'contents'
		                    // in the scope we pass in to the function
		                    scope.$apply(function() {
		                        onFileReadFn(scope, {
		                            'contents' : fileContents
		                        });
		                    });
		                };
		                reader.readAsText(element[0].files[0]);
		            });
		        }
		    };
		}])
        .controller('Service_providerDialogController', Service_providerDialogController);

    Service_providerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Service_provider', 'Distribution_list'];

    function Service_providerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Service_provider, Distribution_list) {
        var vm = this;

        vm.service_provider = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.distribution_lists = Distribution_list.query();
        
        vm.wasApproved = vm.service_provider.is_approved;
        
        
        vm.switchOptions = {
			onText : 'yes',
			offText : 'no', 
			isActive : true,
			size : 'medium',
			animate : true,
			radioOff : true,
			handleWidth : "auto",
			labelWidth : "auto",
			inverse : true,
			onColor : "uniroma",
			offColor : "default"
		};
       
        $scope.aceLoaded = function(_editor){
			// Editor part
			var _session = _editor.getSession();
			var _renderer = _editor.renderer;

			// Options
			_session.setUndoManager(new ace.UndoManager());
			_editor.setHighlightActiveLine(true);
			_editor.setHighlightSelectedWord(true);
			_editor.setShowPrintMargin(false);

		};
		
		$scope.aceOptions = {
				useWrapMode : true,
				showGutter: true,
				mode: 'xml',
				firstLineNumber: 1,
				theme: 'tomorrow',
				onLoad: $scope.aceLoaded
		};
		
        $scope.toggleActivation = function() {
          $scope.isActive = !$scope.isActive;
        }
       //--END Switch
		
		$scope.displayFileContents = function(contents) {
	        vm.service_provider.metadata = contents;
	    };
		
		

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.service_provider.id !== null) {
                Service_provider.update(vm.service_provider, onSaveSuccess, onSaveError);
            } else {
                Service_provider.save(vm.service_provider, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:service_providerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        vm.changeWhoApproved = function(){
        	
        	if(!vm.wasApproved && vm.service_provider.is_approved){
        		vm.service_provider.whoApproved = "current-user";
        	}
        };
        
        


    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Service_providerDetailController', Service_providerDetailController);

    Service_providerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Service_provider', 'Distribution_list'];

    function Service_providerDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Service_provider, Distribution_list) {
        var vm = this;

        vm.service_provider = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        
        $scope.aceLoaded = function(_editor){
			// Editor part
			var _session = _editor.getSession();
			var _renderer = _editor.renderer;

			// Options
			_session.setUndoManager(new ace.UndoManager());
			_editor.setHighlightActiveLine(true);
			_editor.setHighlightSelectedWord(true);
			_editor.setShowPrintMargin(false);

		};
		
		$scope.aceOptions = {
				useWrapMode : true,
				showGutter: true,
				mode: 'xml',
				firstLineNumber: 1,
				theme: 'tomorrow',
				onLoad: $scope.aceLoaded
		};

        var unsubscribe = $rootScope.$on('uniromaLandingApp:service_providerUpdate', function(event, result) {
            vm.service_provider = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Service_providerDeleteController',Service_providerDeleteController);

    Service_providerDeleteController.$inject = ['$uibModalInstance', 'entity', 'Service_provider'];

    function Service_providerDeleteController($uibModalInstance, entity, Service_provider) {
        var vm = this;

        vm.service_provider = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Service_provider.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .filter('startFrom', function() {
		    return function(input, start) {
		        start = +start; //parse to int
		        return input.slice(start);
		    }
		})
        .controller('Service_providerCommentsController', Service_providerCommentsController);

    Service_providerCommentsController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'commentEntity','hasNewComments','Service_provider','SpCommentService'];

    function Service_providerCommentsController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, commentEntity, hasNewComments,Service_provider,SpCommentService) {
        var vm = this;
        vm.service_provider = entity;
        vm.newComment = commentEntity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        
        vm.totalItems = vm.service_provider.comments.length;
        vm.pageSize = 3;
        vm.pageNumber = Math.round(vm.totalItems/vm.pageSize);
        vm.currentPage = vm.pageNumber-1;
        
        if(hasNewComments == true){
        	SpCommentService.setCommentsRead({id:vm.service_provider.id},{},function(){
        		return;
        	},null);
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            SpCommentService.save({id : $stateParams.id},vm.newComment, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
        	vm.service_provider.comments.push(result);
        	vm.newComment.comment = null;

        	vm.totalItems = vm.service_provider.comments.length;
        	vm.pageNumber = Math.round(vm.totalItems/vm.pageSize);
        	vm.currentPage = vm.pageNumber-1;

        	$scope.editForm.$setPristine();
        	vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        $scope.getNumber = function(num) {
            return new Array(num);   
        }
        
        $scope.nextPage = function(){
        	if(vm.currentPage != (vm.pageNumber-1))
        		vm.currentPage++;
        }
        
        $scope.prevPage = function(){
        	if(vm.currentPage != 0)
        		vm.currentPage--;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('service-provider', {
            parent: 'entity',
            url: '/service-provider',
            data: {
                authorities: ['ROLE_CREAZIONE_SP','ROLE_APPROVAZIONE_SP'],
                pageTitle: 'uniromaLandingApp.service_provider.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-provider/service-providers.html',
                    controller: 'Service_providerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('service_provider');
                    $translatePartialLoader.addPart('distribution_list');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('service-provider-detail', {
            parent: 'service-provider',
            url: '/service-provider/{id}',
            data: {
                authorities: ['ROLE_CREAZIONE_SP','ROLE_APPROVAZIONE_SP'],
                pageTitle: 'uniromaLandingApp.service_provider.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-provider/service-provider-detail.html',
                    controller: 'Service_providerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('service_provider');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Service_provider', function($stateParams, Service_provider) {
                    return Service_provider.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'service-provider',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('service-provider-detail.edit', {
            parent: 'service-provider-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_CREAZIONE_SP','ROLE_APPROVAZIONE_SP']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-provider/service-provider-dialog.html',
                    controller: 'Service_providerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Service_provider', function(Service_provider) {
                            return Service_provider.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-provider.new', {
            parent: 'service-provider',
            url: '/new',
            data: {
                authorities: ['ROLE_SP_ADD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-provider/service-provider-dialog.html',
                    controller: 'Service_providerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                description: null,
                                is_active: false,
                                is_approved: false,
                                whoCreated: 'current-user',
                                whoApproved: null,
                                metadata: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('service-provider', null, { reload: 'service-provider' });
                }, function() {
                    $state.go('service-provider');
                });
            }]
        })
        .state('service-provider.edit', {
            parent: 'service-provider',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_CREAZIONE_SP','ROLE_APPROVAZIONE_SP']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-provider/service-provider-dialog.html',
                    controller: 'Service_providerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Service_provider', function(Service_provider) {
                            return Service_provider.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-provider', null, { reload: 'service-provider' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-provider.delete', {
            parent: 'service-provider',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_CREAZIONE_SP','ROLE_APPROVAZIONE_SP']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-provider/service-provider-delete-dialog.html',
                    controller: 'Service_providerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Service_provider', function(Service_provider) {
                            return Service_provider.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-provider', null, { reload: 'service-provider' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-provider.new-list', {
            parent: 'service-provider',
            url: '/list/new',
            data: {
                authorities: ['ROLE_CREAZIONE_SP','ROLE_APPROVAZIONE_SP']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/distribution-list/distribution-list-dialog.html',
                    controller: 'Distribution_listDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('service-provider', null, { reload: 'service-provider' });
                }, function() {
                    $state.go('service-provider');
                });
            }]
        })
        .state('service-provider.comments', {
            parent: 'service-provider',
            url: '/{id}/comments',
            data: {
                authorities: ['ROLE_SP_ADD','ROLE_SP_APPROVE']
            },
            params: {
                hasNewComment: null
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-provider/service-provider-comments.html',
                    controller: 'Service_providerCommentsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Service_provider', function(Service_provider) {
                            return Service_provider.get({id : $stateParams.id}).$promise;
                        }],
                        commentEntity: function () {
                            return {
                                comment: null,
                                create_date: null,
                                id: null,
                                read: false
                            };
                        },
                        hasNewComments: function(){
                        	if($stateParams.hasNewComment != null && $stateParams.hasNewComment >-1){
                        		return true;
                        	}
                        	else{
                        		return false
                        	}
                        }
                    }
                }).result.then(function() {
                    $state.go('service-provider', null, { reload: 'service-provider' });
                }, function() {
                    $state.go('^',null,{ reload: 'service-provider' });
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Service_provider', Service_provider)
        .factory('SpCommentService',SpCommentService);

    Service_provider.$inject = ['$resource'];
    SpCommentService.$inject = ['$resource'];

    function Service_provider ($resource) {
        var resourceUrl =  'api/service-providers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    
    function SpCommentService ($resource){
    	  return $resource('api/service-providers/:id/new-comment', {}, {
    		  query: {method:'GET', params:{page:'@page'}, isArray:false},
    		  'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
    		setCommentsRead: {
    			method:'GET', 
    			url:'api/service-providers/:id/set-comments-has-read', 
    			isArray:false
    		},
    	   
    	  });
	}
    
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Service_providerController', Service_providerController);

    Service_providerController.$inject = ['DataUtils', 'Service_provider','Principal','Account','$state'];

    function Service_providerController(DataUtils, Service_provider,Principal,Account,$state) {

        var vm = this;

        vm.service_providers = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.canApprove = Principal.hasAnyAuthority(['ROLE_SP_APPROVE']);
        vm.canCreateNewSp = Principal.hasAnyAuthority(['ROLE_SP_ADD']);
        
        vm.spWithNewComments = [];
        
        Principal.identity().then(function(account) {
            vm.account = account;
        });

        loadAll();
        
        vm.switchOptions = {
			onText : 'yes',
			offText : 'no', 
			isActive : true,
			size : 'medium',
			animate : true,
			radioOff : true,
			handleWidth : "auto",
			labelWidth : "auto",
			inverse : true,
			onColor : "uniroma",
			offColor : "default",
			switchIsSelected : 'false'
		};
        

        
        function loadAll() {
            Service_provider.query(function(result) {
                vm.service_providers = result;
                vm.searchQuery = null;
            });
        };
        
        vm.toggleActivation = function(sp){
        	sp.is_active = !sp.is_active;
        	Service_provider.update(sp, onSaveSuccess, onSaveError);
        } ;
        
        vm.toggleApproved = function(sp){
        	sp.is_approved = !sp.is_approved;
        	sp.whoApproved = "current-user";
        	Service_provider.update(sp, onSaveSuccess, onSaveError);
        } ;
        
        function onSaveSuccess (result) {
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        
        vm.countNewMessages = function(sp){
        	var comments = sp.comments;
        	var counter = 0;
        	for(var i=(comments.length-1);i>=0;i--){
        		var comment = comments[i];
        		if(comment.read==null || comment.read==false){
        			var creatorUser = comment.who_commented;
        			if(creatorUser.login!=vm.account.login){
        				if(vm.spWithNewComments.indexOf(sp.id)==-1)
        					vm.spWithNewComments.push(sp.id);
        				counter++;
        			}
        		}
        	}

        	return counter;
        };
        
        vm.openComments = function(sp){
        	console.log(vm.spWithNewComments);
        	console.log(vm.spWithNewComments.indexOf(sp.id));
        	var param = {"id": sp.id,"hasNewComment":vm.spWithNewComments.indexOf(sp.id)};
        	$state.go('service-provider.comments', param);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ServiceDialogController', ServiceDialogController);

    ServiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Service', 'Module'];

    function ServiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Service, Module) {
        var vm = this;

        vm.service = entity;
        vm.clear = clear;
        vm.save = save;
        vm.modules = Module.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.service.id !== null) {
                Service.update(vm.service, onSaveSuccess, onSaveError);
            } else {
                Service.save(vm.service, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:serviceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ServiceDetailController', ServiceDetailController);

    ServiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Service', 'Module'];

    function ServiceDetailController($scope, $rootScope, $stateParams, previousState, entity, Service, Module) {
        var vm = this;

        vm.service = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('uniromaLandingApp:serviceUpdate', function(event, result) {
            vm.service = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ServiceDeleteController',ServiceDeleteController);

    ServiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Service'];

    function ServiceDeleteController($uibModalInstance, entity, Service) {
        var vm = this;

        vm.service = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Service.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('service', {
            parent: 'entity',
            url: '/service?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.service.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service/services.html',
                    controller: 'ServiceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('service');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('service-detail', {
            parent: 'service',
            url: '/service/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.service.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service/service-detail.html',
                    controller: 'ServiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('service');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Service', function($stateParams, Service) {
                    return Service.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'service',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('service-detail.edit', {
            parent: 'service-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service/service-dialog.html',
                    controller: 'ServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Service', function(Service) {
                            return Service.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service.new', {
            parent: 'registryEntities',
            url: '/{id}/service/new',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal','Module', function($stateParams, $state, $uibModal,Module) {
                $uibModal.open({
                    templateUrl: 'app/entities/service/service-dialog.html',
                    controller: 'ServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                profile: null,
                                id: null,
                                module: Module.get({id:$stateParams.id})
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('registryEntities');
                });
            }]
        })
        .state('service.edit', {
            parent: 'registryEntities',
            url: '/service/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service/service-dialog.html',
                    controller: 'ServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Service', function(Service) {
                            return Service.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service.delete', {
            parent: 'registryEntities',
            url: '/service/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service/service-delete-dialog.html',
                    controller: 'ServiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Service', function(Service) {
                            return Service.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Service', Service);

    Service.$inject = ['$resource'];

    function Service ($resource) {
        var resourceUrl =  'api/services/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll':{
            	method: 'GET',
            	url: 'api/get-all-services',
            	isArray: true
            },
            'testPolicy':{
                method: 'POST',
                url: 'api/test-policy',
                isArray: false
            },
            'testPolicyAnag':{
                method: 'POST',
                url: 'api/test-anag-policy',
                isArray: false
            },
            'authorize':{
                method: 'POST',
                url: 'api/registry/authorize',
                isArray: false
            },
            'userDetails':{
                method: 'POST',
                url: 'api/registry/user-details',
                isArray: false
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ServiceController', ServiceController);

    ServiceController.$inject = ['$state', 'Service', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ServiceController($state, Service, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Service.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.services = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

'use strict';

angular.module('uniromaLandingApp').controller('ScheduledJobDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ScheduledJob',
        function($scope, $stateParams, $uibModalInstance, entity, ScheduledJob) {

        $scope.scheduledJob = entity;
        $scope.load = function(id) {
            ScheduledJob.get({id : id}, function(result) {
                $scope.scheduledJob = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('uniromaLandingApp:scheduledJobUpdate', result);
            $uibModalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.scheduledJob.id != null) {
                ScheduledJob.update($scope.scheduledJob, onSaveFinished);
            } else {
                ScheduledJob.save($scope.scheduledJob, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('uniromaLandingApp').controller('ScheduledJobDetailController', 
		['$scope', '$rootScope', '$stateParams', 'entity', 'ScheduledJob' ,function ($scope, $rootScope, $stateParams, entity, ScheduledJob) {
        $scope.scheduledJob = entity;
        $scope.load = function (id) {
            ScheduledJob.get({id: id}, function(result) {
                $scope.scheduledJob = result;
            });
        };
        $rootScope.$on('uniromaLandingApp:scheduledJobUpdate', function(event, result) {
            $scope.scheduledJob = result;
        });
    }]);

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ScheduledJobDeleteController',ScheduledJobDeleteController);

    ScheduledJobDeleteController.$inject = ['$uibModalInstance', 'entity', 'ScheduledJob'];

    function ScheduledJobDeleteController($uibModalInstance, entity, ScheduledJob) {
        var vm = this;

        vm.scheduledJob = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	ScheduledJob.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('scheduledJob', {
                parent: 'admin',
                url: '/scheduledJobs',
                data: {
                    authorities: ['ROLE_DASHBOARD_PROVISIONING'],
                    pageTitle: 'uniromaLandingApp.scheduledJob.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/scheduledJob/scheduledJobs.html',
                        controller: 'ScheduledJobController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scheduledJob');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('scheduledJob.detail', {
                parent: 'admin',
                url: '/scheduledJob/{id}',
                data: {
                    authorities: ['ROLE_DASHBOARD_PROVISIONING'],
                    pageTitle: 'uniromaLandingApp.scheduledJob.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/scheduledJob/scheduledJob-detail.html',
                        controller: 'ScheduledJobDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scheduledJob');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ScheduledJob', function($stateParams, ScheduledJob) {
                        return ScheduledJob.get({id : $stateParams.id});
                    }]
                }
            })
            .state('scheduledJob.new', {
                parent: 'scheduledJob',
                url: '/new',
                data: {
                    authorities: ['ROLE_DASHBOARD_PROVISIONING'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scheduledJob/scheduledJob-dialog.html',
                        controller: 'ScheduledJobDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    dateStart: null,
                                    dateEnd: null,
                                    status: null,
                                    jobName: null,
                                    newRecords: null,
                                    changedRecords: null,
                                    deletedRecords: null,
                                    identicalRecords: null,
                                    rejectedRecords: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('scheduledJob', null, { reload: true });
                    }, function() {
                        $state.go('scheduledJob');
                    })
                }]
            })
            .state('scheduledJob.edit', {
                parent: 'scheduledJob',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_DASHBOARD_PROVISIONING'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scheduledJob/scheduledJob-dialog.html',
                        controller: 'ScheduledJobDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['ScheduledJob', function(ScheduledJob) {
                                return ScheduledJob.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('scheduledJob', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            })
            .state('scheduledJob.delete', {
                parent: 'scheduledJob',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_DASHBOARD_PROVISIONING']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scheduledJob/scheduledJob-delete-dialog.html',
                        controller: 'ScheduledJobDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ScheduledJob', function(ScheduledJob) {
                                return ScheduledJob.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('scheduledJob', null, { reload: 'scheduledJob' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();

'use strict';

angular.module('uniromaLandingApp').controller('ScheduledJobController', 
		['$scope','ScheduledJob','ScheduledJobStats','ParseLinks', function ($scope, ScheduledJob, ScheduledJobStats, ParseLinks) {
        $scope.scheduledJobs = [];
        $scope.page = 0;
        
        $scope.statusFilter = "";
        
        $scope.filterStatusList = [];
        
        $scope.getStatusList = function(){
        	ScheduledJobStats.query({}, function(result, headers) {
        		$scope.filterStatusList = result;
        	});
        };
        
        $scope.loadAll = function() {
            //ScheduledJob.query({page: $scope.page, size: 20, sort: [$scope.predicate + ',' + ($scope.reverse ? 'desc' : 'asc'), 'id']}, function(result, headers) {
        	ScheduledJob.query({page: $scope.page, size: 20, sort:'id,desc', statusFilter:$scope.statusFilter}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.totalItems = headers('X-Total-Count');
                $scope.scheduledJobs = result;
            });
        };
      
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();
        $scope.getStatusList();

        $scope.delete = function (id) {
            ScheduledJob.get({id: id}, function(result) {
                $scope.scheduledJob = result;
                $('#deleteScheduledJobConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            ScheduledJob.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteScheduledJobConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.scheduledJob = {
                dateStart: null,
                dateEnd: null,
                status: null,
                jobName: null,
                newRecords: null,
                changedRecords: null,
                deletedRecords: null,
                identicalRecords: null,
                rejectedRecords: null,
                id: null
            };
        };
    }]);

'use strict';

angular.module('uniromaLandingApp').controller('RejectedTypeDialogController',
    ['$scope', '$stateParams', '$modalInstance', 'entity', 'RejectedType',
        function($scope, $stateParams, $modalInstance, entity, RejectedType) {

        $scope.rejectedType = entity;
        $scope.load = function(id) {
            RejectedType.get({id : id}, function(result) {
                $scope.rejectedType = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('uniromaLandingApp:rejectedTypeUpdate', result);
            $modalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.rejectedType.id != null) {
                RejectedType.update($scope.rejectedType, onSaveFinished);
            } else {
                RejectedType.save($scope.rejectedType, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $modalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('uniromaLandingApp')
    .controller('RejectedTypeDetailController', 
    		['$scope', '$rootScope', '$stateParams', 'entity', 'RejectedType', 
    		function ($scope, $rootScope, $stateParams, entity, RejectedType) {
        $scope.rejectedType = entity;
        $scope.load = function (id) {
            RejectedType.get({id: id}, function(result) {
                $scope.rejectedType = result;
            });
        };
        $rootScope.$on('uniromaLandingApp:rejectedTypeUpdate', function(event, result) {
            $scope.rejectedType = result;
        });
    }]);

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rejectedType', {
                parent: 'entity',
                url: '/rejectedTypes',
                data: {
                    authorities: ['ROLE_LOG_ERRORE'],
                    pageTitle: 'uniromaLandingApp.rejectedType.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rejectedType/rejectedTypes.html',
                        controller: 'RejectedTypeController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('rejectedType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('rejectedType.detail', {
                parent: 'entity',
                url: '/rejectedType/{id}',
                data: {
                    authorities: ['ROLE_LOG_ERRORE'],
                    pageTitle: 'uniromaLandingApp.rejectedType.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rejectedType/rejectedType-detail.html',
                        controller: 'RejectedTypeDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('rejectedType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'RejectedType', function($stateParams, RejectedType) {
                        return RejectedType.get({id : $stateParams.id});
                    }]
                }
            })
            .state('rejectedType.new', {
                parent: 'rejectedType',
                url: '/new',
                data: {
                    authorities: ['ROLE_LOG_ERRORE'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/rejectedType/rejectedType-dialog.html',
                        controller: 'RejectedTypeDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    description: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('rejectedType', null, { reload: true });
                    }, function() {
                        $state.go('rejectedType');
                    })
                }]
            })
            .state('rejectedType.edit', {
                parent: 'rejectedType',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_LOG_ERRORE'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/rejectedType/rejectedType-dialog.html',
                        controller: 'RejectedTypeDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['RejectedType', function(RejectedType) {
                                return RejectedType.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('rejectedType', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    }
})();

'use strict';

angular.module('uniromaLandingApp')
    .controller('RejectedTypeController', 
    		['$scope', 'RejectedType', 'ParseLinks',function ($scope, RejectedType, ParseLinks) {
        $scope.rejectedTypes = [];
        $scope.page = 0;
        $scope.loadAll = function() {
            RejectedType.query({page: $scope.page, size: 20}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.rejectedTypes = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            RejectedType.get({id: id}, function(result) {
                $scope.rejectedType = result;
                $('#deleteRejectedTypeConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            RejectedType.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteRejectedTypeConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.rejectedType = {
                name: null,
                description: null,
                id: null
            };
        };
    }]);

'use strict';

angular.module('uniromaLandingApp').controller('RejectedRowDialogController',
    ['$scope', '$stateParams', '$modalInstance', 'entity', 'RejectedRow', 'RejectedType',
        function($scope, $stateParams, $modalInstance, entity, RejectedRow, RejectedType) {

        $scope.rejectedRow = entity;
        $scope.rejectedtypes = RejectedType.query();
        $scope.load = function(id) {
            RejectedRow.get({id : id}, function(result) {
                $scope.rejectedRow = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('uniromaLandingApp:rejectedRowUpdate', result);
            $modalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.rejectedRow.id != null) {
                RejectedRow.update($scope.rejectedRow, onSaveFinished);
            } else {
                RejectedRow.save($scope.rejectedRow, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $modalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('uniromaLandingApp')
    .controller('RejectedRowDetailController', 
    		['$scope', '$rootScope', '$stateParams', 'entity', 'RejectedRow', 'RejectedType', 
    		function($scope, $rootScope, $stateParams, entity, RejectedRow, RejectedType) {
        $scope.rejectedRow = entity;
        $scope.next = null;
        $scope.prev = null;
        $scope.load = function (id) {
        	console.log("ID:"+id);
            RejectedRow.prev({id: id}, function(result) {
                $scope.prev = result;
            });
            RejectedRow.next({id: id}, function(result) {
                $scope.next = result;
            });
        };
        $rootScope.$on('uniromaLandingApp:rejectedRowUpdate', function(event, result) {
            $scope.rejectedRow = result;
        });
        entity.$promise.then(function(){
        	$scope.load(entity.id);
        });
        
    }]);

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('RejectedRowDeleteController',RejectedRowDeleteController);

    RejectedRowDeleteController.$inject = ['$uibModalInstance', 'entity', 'RejectedRow'];

    function RejectedRowDeleteController($uibModalInstance, entity, RejectedRow) {
        var vm = this;

        vm.rejectedRow = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	RejectedRow.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rejectedRow', {
                parent: 'admin',
                url: '/rejectedRows',
                data: {
                    authorities: ['ROLE_LOG_ERRORE'],
                    pageTitle: 'uniromaLandingApp.rejectedRow.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rejectedRow/rejectedRows.html',
                        controller: 'RejectedRowController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('rejectedRow');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('rejectedRow.detail', {
                parent: 'admin',
                url: '/rejectedRow/{id}',
                data: {
                    authorities: ['ROLE_LOG_ERRORE'],
                    pageTitle: 'uniromaLandingApp.rejectedRow.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rejectedRow/rejectedRow-detail.html',
                        controller: 'RejectedRowDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('rejectedRow');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'RejectedRow', function($stateParams, RejectedRow) {
                        return RejectedRow.get({id : $stateParams.id});
                    }]
                }
            })
            .state('rejectedRow.new', {
                parent: 'rejectedRow',
                url: '/new',
                data: {
                    authorities: ['ROLE_LOG_ERRORE'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/rejectedRow/rejectedRow-dialog.html',
                        controller: 'RejectedRowDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    idJob: null,
                                    rejectedTypeId: null,
                                    payload: null,
                                    cause: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('rejectedRow', null, { reload: true });
                    }, function() {
                        $state.go('rejectedRow');
                    })
                }]
            })
            .state('rejectedRow.edit', {
                parent: 'rejectedRow',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_LOG_ERRORE'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/rejectedRow/rejectedRow-dialog.html',
                        controller: 'RejectedRowDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['RejectedRow', function(RejectedRow) {
                                return RejectedRow.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('rejectedRow', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            })
            .state('rejectedRow.delete', {
                parent: 'rejectedRow',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_LOG_ERRORE']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/rejectedRow/rejectedRow-delete-dialog.html',
                        controller: 'RejectedRowDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['RejectedRow', function(RejectedRow) {
                                return RejectedRow.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('rejectedRow', null, { reload: 'rejectedRow' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
'use strict';

angular.module('uniromaLandingApp')
    .controller('RejectedRowController', 
    		['$scope', 'RejectedRow', 'RejectedRowFilter', 'RejectedType','ParseLinks', 'SessionStorage', 
    		 function ($scope, RejectedRow, RejectedRowFilter, RejectedType,ParseLinks, SessionStorage) {
        $scope.rejectedRows = [];
        $scope.page = 0;
        
        $scope.idJobFilter = 0;
        $scope.idTypeFilter = 0;
        $scope.payloadFilter = "";
        
        $scope.filterIdJobList = [];
        $scope.filterRejectedTypeList = [];
        
        
        
        $scope.getIdJobList = function(){
        	RejectedRowFilter.query({}, function(result, headers) {
        		$scope.filterIdJobList = result;
        	});
        };
        $scope.getRejectedTypeList = function(){
        	RejectedType.query({}, function(result, headers) {
        		$scope.filterRejectedTypeList = result;
        	});
        };
        
        $scope.loadAll = function() {
        	if($scope.idJobFilter == null || $scope.idJobFilter=="")
        		$scope.idJobFilter = 0;
        	if($scope.idTypeFilter == null || $scope.idTypeFilter=="")
                $scope.idTypeFilter = 0;
        	if($scope.payloadFilter == null)
                $scope.payloadFilter = "";
        	
        	SessionStorage.saveAll($scope, "UR1L.rejectedRows", ["idJobFilter", "idTypeFilter", "payloadFilter"]);
        	
            RejectedRow.query({page: $scope.page, size: 20, sort:'id,desc', idJob:$scope.idJobFilter, idType:$scope.idTypeFilter, payload:$scope.payloadFilter}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.rejectedRows = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        
        SessionStorage.init($scope, "UR1L.rejectedRows", ["idJobFilter", "idTypeFilter", "payloadFilter"]);
        
        $scope.loadAll();
        $scope.getIdJobList();
        $scope.getRejectedTypeList();

        $scope.delete = function (id) {
            RejectedRow.get({id: id}, function(result) {
                $scope.rejectedRow = result;
                $('#deleteRejectedRowConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            RejectedRow.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteRejectedRowConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.rejectedRow = {
                idJob: null,
                rejectedTypeId: null,
                payload: null,
                cause: null,
                id: null
            };
        };
    }]);

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Provider_trDialogController', Provider_trDialogController);

    Provider_trDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Provider_tr', 'Provider'];

    function Provider_trDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Provider_tr, Provider) {
        var vm = this;

        vm.providerId = $stateParams.id;
        vm.provider_tr = entity;
        vm.clear = clear;
        vm.save = save;
        vm.providers = Provider.query();
        

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.provider_tr.id !== null) {
                Provider_tr.update(vm.provider_tr, onSaveSuccess, onSaveError);
            } else {
                Provider_tr.save(vm.provider_tr, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:provider_trUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Provider_trDetailController', Provider_trDetailController);

    Provider_trDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Provider_tr', 'Provider'];

    function Provider_trDetailController($scope, $rootScope, $stateParams, previousState, entity, Provider_tr, Provider) {
        var vm = this;

        vm.provider_tr = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('uniromaLandingApp:provider_trUpdate', function(event, result) {
            vm.provider_tr = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Provider_trDeleteController',Provider_trDeleteController);

    Provider_trDeleteController.$inject = ['$uibModalInstance', 'entity', 'Provider_tr'];

    function Provider_trDeleteController($uibModalInstance, entity, Provider_tr) {
        var vm = this;

        vm.provider_tr = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Provider_tr.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('provider-tr', {
            parent: 'entity',
            url: '/provider-tr?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.provider_tr.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provider-tr/provider-trs.html',
                    controller: 'Provider_trController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('provider_tr');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('provider-tr-detail', {
            parent: 'provider-tr',
            url: '/provider-tr/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.provider_tr.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provider-tr/provider-tr-detail.html',
                    controller: 'Provider_trDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('provider_tr');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Provider_tr', function($stateParams, Provider_tr) {
                    return Provider_tr.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'provider-tr',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('provider-tr-detail.edit', {
            parent: 'provider-tr-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-tr/provider-tr-dialog.html',
                    controller: 'Provider_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Provider_tr', function(Provider_tr) {
                            return Provider_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provider-tr.new', {
            parent: 'registryEntities',
            url: '/provider-tr/{id}/new',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal','Provider', function($stateParams, $state, $uibModal,Provider) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-tr/provider-tr-dialog.html',
                    controller: 'Provider_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                field: null,
                                value: null,
                                language: null,
                                id: null,
                                provider: Provider.get({id : $stateParams.id})
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('registryEntities');
                });
            }]
        })
        .state('provider-tr.edit', {
            parent: 'registryEntities',
            url: '/provider-tr/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-tr/provider-tr-dialog.html',
                    controller: 'Provider_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Provider_tr', function(Provider_tr) {
                            return Provider_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provider-tr.delete', {
            parent: 'registryEntities',
            url: '/provider-tr/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-tr/provider-tr-delete-dialog.html',
                    controller: 'Provider_trDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Provider_tr', function(Provider_tr) {
                            return Provider_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null,{reload:'registryEntities'});
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Provider_tr', Provider_tr);

    Provider_tr.$inject = ['$resource'];

    function Provider_tr ($resource) {
        var resourceUrl =  'api/provider-trs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Provider_trController', Provider_trController);

    Provider_trController.$inject = ['$state', 'Provider_tr', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function Provider_trController($state, Provider_tr, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Provider_tr.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.provider_trs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ProviderDialogController', ProviderDialogController);

    ProviderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Provider'];

    function ProviderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Provider) {
        var vm = this;

        vm.provider = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.provider.id !== null) {
                Provider.update(vm.provider, onSaveSuccess, onSaveError);
            } else {
                Provider.save(vm.provider, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:providerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ProviderDetailController', ProviderDetailController);

    ProviderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Provider'];

    function ProviderDetailController($scope, $rootScope, $stateParams, previousState, entity, Provider) {
        var vm = this;

        vm.provider = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('uniromaLandingApp:providerUpdate', function(event, result) {
            vm.provider = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ProviderDeleteController',ProviderDeleteController);

    ProviderDeleteController.$inject = ['$uibModalInstance', 'entity', 'Provider'];

    function ProviderDeleteController($uibModalInstance, entity, Provider) {
        var vm = this;

        vm.provider = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
       

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Provider.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('provider', {
            parent: 'entity',
            url: '/provider?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.provider.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provider/providers.html',
                    controller: 'ProviderController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('provider');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('error');
                    return $translate.refresh();
                }]
            }
        })
        .state('provider-detail', {
            parent: 'provider',
            url: '/provider/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.provider.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provider/provider-detail.html',
                    controller: 'ProviderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('provider');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Provider', function($stateParams, Provider) {
                    return Provider.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'provider',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('provider-detail.edit', {
            parent: 'provider-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider/provider-dialog.html',
                    controller: 'ProviderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Provider', function(Provider) {
                            return Provider.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provider.new', {
            parent: 'registryEntities',
            url: '/provider/new',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider/provider-dialog.html',
                    controller: 'ProviderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('registryEntities');
                });
            }]
        })
        .state('provider.edit', {
            parent: 'registryEntities',
            url: '/provider/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider/provider-dialog.html',
                    controller: 'ProviderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Provider', function(Provider) {
                            return Provider.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provider.delete', {
            parent: 'registryEntities',
            url: '/provider/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider/provider-delete-dialog.html',
                    controller: 'ProviderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Provider', function(Provider) {
                            return Provider.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Provider', Provider);

    Provider.$inject = ['$resource'];

    function Provider ($resource) {
        var resourceUrl =  'api/providers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ProviderController', ProviderController);

    ProviderController.$inject = ['$state', 'Provider', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ProviderController($state, Provider, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Provider.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.providers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Product_trDialogController', Product_trDialogController);

    Product_trDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Product_tr', 'Product'];

    function Product_trDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Product_tr, Product) {
        var vm = this;

        vm.product_tr = entity;
        vm.clear = clear;
        vm.save = save;
        vm.products = Product.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.product_tr.id !== null) {
                Product_tr.update(vm.product_tr, onSaveSuccess, onSaveError);
            } else {
                Product_tr.save(vm.product_tr, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:product_trUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Product_trDetailController', Product_trDetailController);

    Product_trDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Product_tr', 'Product'];

    function Product_trDetailController($scope, $rootScope, $stateParams, previousState, entity, Product_tr, Product) {
        var vm = this;

        vm.product_tr = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('uniromaLandingApp:product_trUpdate', function(event, result) {
            vm.product_tr = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Product_trDeleteController',Product_trDeleteController);

    Product_trDeleteController.$inject = ['$uibModalInstance', 'entity', 'Product_tr'];

    function Product_trDeleteController($uibModalInstance, entity, Product_tr) {
        var vm = this;

        vm.product_tr = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Product_tr.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product-tr', {
            parent: 'entity',
            url: '/product-tr?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.product_tr.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-tr/product-trs.html',
                    controller: 'Product_trController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product_tr');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-tr-detail', {
            parent: 'product-tr',
            url: '/product-tr/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.product_tr.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-tr/product-tr-detail.html',
                    controller: 'Product_trDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product_tr');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Product_tr', function($stateParams, Product_tr) {
                    return Product_tr.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'product-tr',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('product-tr-detail.edit', {
            parent: 'product-tr-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-tr/product-tr-dialog.html',
                    controller: 'Product_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Product_tr', function(Product_tr) {
                            return Product_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product-tr.new', {
            parent: 'registryEntities',
            url: '/produc-tr/{id}/new',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal','Product', function($stateParams, $state, $uibModal,Product) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-tr/product-tr-dialog.html',
                    controller: 'Product_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                field: null,
                                value: null,
                                language: null,
                                id: null,
                                product: Product.get({id:$stateParams.id})
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('registryEntities');
                });
            }]
        })
        .state('product-tr.edit', {
            parent: 'registryEntities',
            url: '/product-tr/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-tr/product-tr-dialog.html',
                    controller: 'Product_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Product_tr', function(Product_tr) {
                            return Product_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null, { reload: 'registryEntities' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product-tr.delete', {
            parent: 'registryEntities',
            url: '/product-tr/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-tr/product-tr-delete-dialog.html',
                    controller: 'Product_trDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Product_tr', function(Product_tr) {
                            return Product_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Product_tr', Product_tr);

    Product_tr.$inject = ['$resource'];

    function Product_tr ($resource) {
        var resourceUrl =  'api/product-trs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Product_trController', Product_trController);

    Product_trController.$inject = ['$state', 'Product_tr', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function Product_trController($state, Product_tr, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Product_tr.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.product_trs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ProductDialogController', ProductDialogController);

    ProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Product', 'Provider', 'Environment'];

    function ProductDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Product, Provider, Environment) {
        var vm = this;

        vm.product = entity;
        vm.clear = clear;
        vm.save = save;
        vm.providers = Provider.query();
        vm.environments = Environment.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            
            //Set Enviroment
            if(vm.environments.length==1){
            	vm.product.environment = vm.environments[0];
            }
            	
            if (vm.product.id !== null) {
                Product.update(vm.product, onSaveSuccess, onSaveError);
            } else {
                Product.save(vm.product, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:productUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ProductDetailController', ProductDetailController);

    ProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Product', 'Provider', 'Environment'];

    function ProductDetailController($scope, $rootScope, $stateParams, previousState, entity, Product, Provider, Environment) {
        var vm = this;

        vm.product = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('uniromaLandingApp:productUpdate', function(event, result) {
            vm.product = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ProductDeleteController',ProductDeleteController);

    ProductDeleteController.$inject = ['$uibModalInstance', 'entity', 'Product'];

    function ProductDeleteController($uibModalInstance, entity, Product) {
        var vm = this;

        vm.product = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Product.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product', {
            parent: 'entity',
            url: '/product?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.product.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/products.html',
                    controller: 'ProductController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-detail', {
            parent: 'product',
            url: '/product/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.product.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/product-detail.html',
                    controller: 'ProductDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Product', function($stateParams, Product) {
                    return Product.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'product',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('product-detail.edit', {
            parent: 'product-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product.new', {
            parent: 'registryEntities',
            url: '/{id}/product/new',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal','Provider', function($stateParams, $state, $uibModal,Provider) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                version: null,
                                code: null,
                                base_url: null,
                                id: null,
                                provider: Provider.get({id:$stateParams.id})
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('registryEntities');
                });
            }]
        })
        .state('product.edit', {
            parent: 'registryEntities',
            url: '/product/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product.delete', {
            parent: 'registryEntities',
            url: '/product/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-delete-dialog.html',
                    controller: 'ProductDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Product', Product);

    Product.$inject = ['$resource'];

    function Product ($resource) {
        var resourceUrl =  'api/products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ProductController', ProductController);

    ProductController.$inject = ['$state', 'Product', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ProductController($state, Product, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Product.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.products = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('TestPolicyDialogController', TestPolicyDialogController);

    
    
    
    
    TestPolicyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance','AnagraficaService','Service','SessionStorage'];
    // , 'Policy', 'Group', 'IdmCategoria','IdmStatiGenerali'

    function TestPolicyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, AnagraficaService, Service, SessionStorage) {
    	//, Policy, Group, IdmCategoria,IdmStatiGenerali
        var vm = this;
        vm.autoload = true;
        vm.clear = clear;
        vm.loadListaUtenti = loadListaUtenti;
        vm.selectUtente = selectUtente;
        vm.testPolicies = testPolicies;
        vm.typing = true;
        vm.loading = false;
        vm.services = [];
        vm.attributes = {};
        vm.user = null;
        vm.roles = [];
        vm.executions = [];
        vm.attributesSize = 0;
        
        SessionStorage.init(vm, "UR1L.testPolicy", ["selectedUser"]);
        
        if (vm.autoload && vm.selectedUser) {
        	testPolicies();
        }
        
        $scope.$watch('vm.selectedUser', function (newValue) {
        	vm.typing = true;
            vm.services = [];
            vm.attributes = {};
            vm.user = null;
            vm.roles = [];
            vm.executions = [];
            vm.attributesSize = 0;
        });

        function testPolicies(){
        	vm.typing = false;
            vm.loading = true;
        	Service.testPolicy({"uid":vm.selectedUser}, function(result) {
        		console.log(result);
        		vm.services = result.services;
                vm.attributes = result.rawAttributes;
                delete vm.attributes["userPassword"];
                vm.user = result.user;
                vm.roles = result.roles;
                vm.executions = result.executions;

                vm.loading = false;
                vm.attributesSize = Object.keys(result.rawAttributes).length;
        	}, function(error) {
                vm.loading = false;
        	});
//        	Service.userDetails({"account":vm.selectedUser}, function(result) {
//        		vm.attributes = {};
//        		vm.attributesSize = 0;
//        		angular.forEach(result.attributeList, function(value, key) {
//                    if (true || /^(nome|cognome|mail|userId|categoria|employeeNumber|mmEnabledService|uid|ou|givenName|objectClass|o|employeeType|mmActive|groups|businessCategory)$/.test(key)) {
//                    	vm.attributes[key] = value;
//                    	vm.attributesSize++;
//                    }
//                });
//        		vm.roles = result.roleList;
//        	}, function(error) {
//        	});
        }
        
        function selectUtente($item, $model, $label){
        	if ($item && $item.userId) {
        		vm.selectedUser = $item.userId;
        	} else {
            	vm.selectedUser = "";
        	}
        	SessionStorage.saveAll(vm, "UR1L.testPolicy", ["selectedUser"]);
        }
        
        function loadListaUtenti(testo){
        	
        	if(testo.length>=5){
	            return AnagraficaService.anagrafiche.get({filtroTesto:testo}).$promise
        	}
        	else{
        		return [];
        	}

        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

//        var inputChangedPromise;
//        vm.save = save;
//        vm.switchMode = switchMode;
//        vm.whyPolicyIsIncorrect = null;
//        vm.policyIsCorrect = null;
//        vm.addService = addService;
//        vm.removeService = removeService;
//        vm.addCategory = addCategory;
//        vm.addPosition = addPosition;
//        vm.removeCategory = removeCategory;
//        vm.removePosition = removePosition;
//        vm.addGroup = addGroup;
//        vm.removeGroup = removeGroup;
////        vm.getCategorie = getCategorie;
////        vm.getSottoCategorie = getSottoCategorie;
////        vm.getStatiSpecifici = getStatiSpecifici;
////        vm.addRegola = addRegola;
////        vm.removeRegola = removeRegola;
//        vm.addUtente = addUtente;
//        vm.addNuovoUtente = addNuovoUtente;
//        vm.removeUtente = removeUtente;
//        vm.atLeastOneService = atLeastOneService;
//        
//        vm.policy = entity;
//        
//        vm.listaPosizioni = [{posizione: "DIPENDENTE", id:"1"}, {posizione: "ESTERNO", id:"2"}, {posizione: "ALTRO", id:"3"}];
//        
//        //Modifica
//        if(vm.policy.id!=null){
//        	vm.regole = vm.policy.regole;
//        	vm.policyUsers = vm.policy.utenti;
//        	vm.policyServices = vm.policy.servizi;
//        	vm.policyCategories = vm.policy.categorie;
//        	vm.policyPositions = vm.policy.posizioni.map(function(x){
//        		var flt = vm.listaPosizioni.filter(function(y){ return y.posizione == x;})
//        		return (flt && flt.length > 0) ? flt[0] : {posizione: x};
//        	});
//        	vm.policyGroups = vm.policy.gruppi.map(function(x){ return {gruppo: x};});
//        }
//        //Nuovo
//        else{
//        	vm.regole = [];
//        	vm.policyUsers = [];
//        	vm.policyServices = [];
//        	vm.policyCategories = [];
//        	vm.policyPositions = [];
//        	vm.policyGroups = [];
//        }
//        
//        //Modalità guidata
//        if(vm.policy.flInserimentoGuidato || vm.policy.id==null){
//        	/*Elenco dei servizi*/
//            Service.getAll({}, function(result){
//            	vm.listaServizi = result;
//            },
//            function(response){
//            	console.log(response);
//            });
//            
//        	/*Elenco dei gruppi*/
//            Group.getAll({}, function(result){
//            	vm.listaGruppi = result;
//            },
//            function(response){
//            	console.log(response);
//            });
//            
//            /*Elenco categorie*/
//            IdmCategoria.query({}, function(result){
//            	vm.listaCategorie = result;
//            },
//            function(response){
//            	console.log(response);
//            });
//            
            /*Elenco stati generali*/
//            IdmStatiGenerali.query({}, function(result){
//            	vm.listaStatiGenerali = result;
//            },
//            function(response){
//            	console.log(response);
//            });
//        }
        
        
        
        

        
        
       
        

//        function save () {
//            vm.isSaving = true;
//            var obj = {
//        		servizi: vm.policyServices,
//        		utenti: vm.policyUsers,
//        		categorie: vm.policyCategories,
//        		posizioni: vm.policyPositions.map(function(x){return x.posizione;}),
//        		gruppi: vm.policyGroups.map(function(x){return x.gruppo;}),
//        		regole: vm.regole,
//        		name: vm.policy.name,
//        		description: vm.policy.description,
//        		policyXACML: vm.policy.policyXACML,
//        		flInserimentoGuidato: vm.policy.flInserimentoGuidato,
//        		id: vm.policy.id,
//        		isActive: vm.policy.isActive
//        	};
//            
//            
//            //Policy inserita in maniera testuale
//            if(!vm.policy.flInserimentoGuidato){
//            	if (vm.policy.id !== null) {
//            		Policy.update(obj, onSaveSuccess, onSaveError);
//                } else {
//                	Policy.save(obj, onSaveSuccess, onSaveError);
//                }
//            }
//            //Policy inserita in maniera guidata
//            else{
//
//            	if (vm.policy.id !== null)
//            		Policy.update(obj, onSaveSuccess, onSaveError);
//            	else
//            		Policy.create(obj, onSaveSuccess, onSaveError);
//            }
//            
//            
//            
//        }
//
//        function onSaveSuccess (result) {
//            $scope.$emit('cinecaLandingApp:policyUpdate', result);
//            $uibModalInstance.close(result);
//            vm.isSaving = false;
//        }
//
//        function onSaveError () {
//            vm.isSaving = false;
//        }
        
//        //Aggiunge un nuovo utente, se non è stato trovato dall'autocompletamento
//        function addNuovoUtente(){
//        	if(vm.selectedUser!=null && vm.selectedUser!=""){
//		    	if(vm.policyUsers == null)
//		    		vm.policyUsers = [];
//    	
//		    	var utente = {
//		    		userId: vm.selectedUser,
//		    		nome: null,
//		    		cognome: null
//		    	};
//		    	var index = vm.policyUsers.indexOf(utente);
//		    	if(index==-1)
//		    		vm.policyUsers.push(utente);
//		    	vm.selectedUser = null;
//        	}
//        }
//        //Rimuove l'utente selezionato
//        function removeUtente(utente){
//        	var index = vm.policyUsers.indexOf(utente);
//        	vm.policyUsers.splice(index, 1); 
//        	
//        }
        
        
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('onReadFile',['$parse', function ($parse) {
		    return {
		        restrict: 'A',
		        scope: false,
		        link: function(scope, element, attrs) {
		            element.bind('change', function(e) {
		                
		                var onFileReadFn = $parse(attrs.onReadFile);
		                var reader = new FileReader();
		                
		                reader.onload = function() {
		                    var fileContents = reader.result;
		                    // invoke parsed function on scope
		                    // special syntax for passing in data
		                    // to named parameters
		                    // in the parsed function
		                    // we are providing a value for the property 'contents'
		                    // in the scope we pass in to the function
		                    scope.$apply(function() {
		                        onFileReadFn(scope, {
		                            'contents' : fileContents
		                        });
		                    });
		                };
		                reader.readAsText(element[0].files[0]);
		            });
		        }
		    };
		}])
        .controller('PolicyDialogController', PolicyDialogController);

    
    
    
    
    PolicyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Policy','Service','IdmCategoria','IdmStatiGenerali','AnagraficaService','SessionStorage'];

    function PolicyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Policy, Service,IdmCategoria,IdmStatiGenerali,AnagraficaService,SessionStorage) {
        var vm = this;

        var inputChangedPromise;
        vm.clear = clear;
        vm.save = save;
        vm.switchMode = switchMode;
        vm.testMode = false;
        vm.whyPolicyIsIncorrect = null;
        vm.policyIsCorrect = null;
        vm.addService = addService;
        vm.removeService = removeService;
        vm.getCategorie = getCategorie;
        vm.getSottoCategorie = getSottoCategorie;
        vm.getStatiSpecifici = getStatiSpecifici;
        vm.addRegola = addRegola;
        vm.removeRegola = removeRegola;
        vm.addUtente = addUtente;
        vm.addNuovoUtente = addNuovoUtente;
        vm.removeUtente = removeUtente;
        vm.loadListaUtenti = loadListaUtenti;
        vm.atLeastOneService = atLeastOneService;
        
        vm.policy = entity;
        
        vm.selectUtente = selectUtente;
        vm.testPolicies = testPolicies;
        vm.typing = true;
        vm.loading = false;
        vm.services = [];
        vm.attributes = {};
        vm.user = null;
        vm.roles = [];
        vm.executions = [];
        vm.attributesSize = 0;
        
        vm.selAttrValide = false;
        
        SessionStorage.init(vm, "UR1L.testPolicy", ["selectedUser"]);
        
        $scope.$watch('vm.selectedUser', function (newValue) {
        	vm.typing = true;
            vm.services = [];
            vm.attributes = {};
            vm.user = null;
            vm.roles = [];
            vm.executions = [];
            vm.attributesSize = 0;
        });
        
        function testPolicies(){
        	vm.typing = false;
            vm.loading = true;
        	Service.testPolicy({"uid":vm.selectedUser,name:vm.policy.name,policyJS:vm.policy.policyJS,services:vm.policyServices}, function(result) {
        		console.log(result);
        		vm.services = result.services;
                vm.attributes = result.rawAttributes;
                delete vm.attributes["userPassword"];
                vm.user = result.user;
                vm.roles = result.roles;
                vm.executions = result.executions;

                vm.loading = false;
                vm.attributesSize = Object.keys(result.rawAttributes).length;
        	}, function(error) {
                vm.loading = false;
        	});
        }
        
        function selectUtente($item, $model, $label){
        	if ($item && $item.userId) {
        		vm.selectedUser = $item.userId;
        	} else {
            	vm.selectedUser = "";
        	}
        	SessionStorage.saveAll(vm, "UR1L.testPolicy", ["selectedUser"]);
        }
        
        vm.selectUid = function($item, $model, $label){
        	if ($item && $item.userId) {
        		vm.selectedUid = $item.userId;
        	} else {
            	vm.selectedUid = "";
        	}
        };
        
        //Modifica
        if(vm.policy.id!=null){
        	vm.regole = vm.policy.regole ? ( vm.policy.regole.map(function(rule) {
        		var newRule = {};
        		angular.forEach(rule, function(value, key) {
    			  this[key] = (value ? value.replace(/^\(\?i\)\\b/, "").replace(/\\b\(\?-i\)$/, "") : value);
    			}, newRule);
        		return newRule;
        	}) ) : vm.policy.regole;
        	
        	vm.policyUsers = vm.policy.utenti;
        	vm.policyServices = vm.policy.servizi;
        }
        //Nuovo
        else{
        	vm.regole = [];
        	vm.policyUsers = [];
        	vm.policyServices = [];
        }
        
        //Modalità guidata
        if(true || vm.policy.flInserimentoGuidato || vm.policy.id==null){
        	/*Elenco dei servizi*/
            Service.getAll({}, function(result){
            	vm.listaServizi = result;
            },
            function(response){
            	console.log(response);
            });
            
            /*Elenco categorie*/
            IdmCategoria.query({}, function(result){
            	vm.listaMacroCategorie = result;
            	vm.listaCategorieNonVuote = [];
            	angular.forEach(vm.listaMacroCategorie, function(mc, key) {
            		angular.forEach(mc.figli, function(cat, key) {
              		  var figli = cat.figli.filter(function(x) { return x != null && x.descrizione != null && x.descrizione != '-'})
              		  if (figli.length > 0) {
              			vm.listaCategorieNonVuote.push(cat);
              		  }
              		}, {});
        		}, {});
            },
            function(response){
            	console.log(response);
            });
            
//            /*Elenco stati generali*/
//            IdmStatiGenerali.query({}, function(result){
//            	vm.listaStatiGenerali = result;
//            	vm.listaStatiSpecifici = [];
//            	angular.forEach(vm.listaStatiGenerali, function(sg, key) {
//            		angular.forEach(sg.statiSpecifici, function(sp, key) {
//            			vm.listaStatiSpecifici.push(sp);
//              		}, {});
//        		}, {});
//            	vm.listaStatiSpecifici = vm.listaStatiSpecifici.sort().filter(function(el,i,a) {
//                    return (i==a.indexOf(el));
//                });
//            },
//            function(response){
//            	console.log(response);
//            });
            
            /*Elenco macro stati*/
            IdmStatiGenerali.macroStati({}, function(result){
            	vm.listaMacroStati = result;
            },
            function(response){
            	console.log(response);
            });
            
            /*Elenco stati*/
            IdmStatiGenerali.allStati({}, function(result){
            	vm.listaStati = result.sort();
            },
            function(response){
            	console.log(response);
            });
            
            /*Elenco ruoli*/
            IdmStatiGenerali.ruoli({}, function(result){
            	vm.listaRuoli = result;
            },
            function(response){
            	console.log(response);
            });
        }
        
        
        
        

        
        
       
        
        /**** Editor di testo ****/
        $scope.aceLoaded = function(_editor){
        	console.log(vm.policy.policyJS);
        	if(vm.policy.policyJS!=null)
        		$scope.verificaPolicy();
//			// Editor part
//			var _session = _editor.getSession();
//			var _renderer = _editor.renderer;
//			// Options
//			_renderer.setShowGutter(true);
//			_session.setUseWrapMode(true);
//			_session.setMode('ace/mode/javascript');
//			_session.setUndoManager(new ace.UndoManager());
//			_editor.setHighlightActiveLine(true);
//			_editor.setHighlightSelectedWord(true);
//			_editor.setShowPrintMargin(false);
//			_editor.setTheme('ace/theme/tomorrow');
//			_editor.on("change", $scope.aceChanged);

		};
		
		$scope.aceChanged = function(){
//			if(inputChangedPromise){
//		        $timeout.cancel(inputChangedPromise);
//		    }
//		    inputChangedPromise = $timeout($scope.verificaPolicy,1000);
			
		};
		
		$scope.verificaPolicy = function() {
			Policy.verify(vm.policy, function(response){
				if(response.code===200){
					 vm.policyIsCorrect = true;
					 vm.whyPolicyIsIncorrect = null;
				}
				else{
					vm.policyIsCorrect = false;
					vm.whyPolicyIsIncorrect = response.message;
				}
			},
			function(response){
				vm.policyIsCorrect = false;
				vm.whyPolicyIsIncorrect = response.data.description;
			});
	    };
	    

		$scope.displayFileContents = function(contents) {
			vm.policy.policyXACML = contents;
	    };

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            
            var obj = {
        		servizi: vm.policyServices,
        		utenti: vm.policyUsers,
        		regole: vm.regole,
        		name: vm.policy.name,
        		description: vm.policy.description,
        		policyJS: vm.policy.policyJS,
        		priority: vm.policy.priority,
        		flInserimentoGuidato: vm.policy.flInserimentoGuidato,
        		id: vm.policy.id,
        		isActive: vm.policy.isActive
        	};
            
        	if (vm.policy.id !== null) {
        		Policy.update(obj, onSaveSuccess, onSaveError);
            } else {
            	Policy.create(obj, onSaveSuccess, onSaveError);
            }
            
//            //Policy inserita in maniera testuale
//            if(!vm.policy.flInserimentoGuidato){
//            	if (vm.policy.id !== null) {
//            		Policy.update(obj, onSaveSuccess, onSaveError);
//                } else {
//                	Policy.save(obj, onSaveSuccess, onSaveError);
//                }
//            }
//            //Policy inserita in maniera guidata
//            else{
//            	if(vm.currentMacroCat!=null || vm.currentStatoGenerale!=null){
//                	addRegola();
//                }
//            	if (vm.policy.id !== null)
//            		Policy.update(obj, onSaveSuccess, onSaveError);
//            	else
//            		Policy.create(obj, onSaveSuccess, onSaveError);
//            }
            
            
            
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:policyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
            $("div.modal").scrollTop(0);
        }
        
        //Cambia da "inserimento manuale" a "inserimento guidato" (e viceversa)
        function switchMode(value){
        	vm.testMode = value;
        }
        
        //Aggiunge un servizio, chiamata all'onClick sull'autocompletamento
        function addService($item, $model, $label){
        	if(vm.policyServices == null)
        		vm.policyServices = [];
        	
        	var index = vm.policyServices.indexOf($item.code);
        	if(index==-1)
        		vm.policyServices.push($item.code);
        	vm.selectedService = null;
        }
        //Rimuove il servizio selezionato
        function removeService(servizio){
        	var index = vm.policyServices.indexOf(servizio);
        	vm.policyServices.splice(index, 1); 
        	
        }
        //Recupera l'elenco delle categorie, in base alla macroCategoria selezionata
        function getCategorie(){
        	if(vm.currentMacroCat!=null)
        		vm.listaCategorie = vm.currentMacroCat.figli;
        	else
        		vm.listaCategorie = [];

        }
        //Recupera l'elenco delle sottoCategorie, in base alla categoria selezionata
        function getSottoCategorie(){
        	if(vm.currentCategoria!=null)
        		vm.listaSottoCategorie = vm.currentCategoria.figli;
        	else
        		vm.listaSottoCategorie = [];
        }
        //Recupera l'elenco degli stati specifici, in base allo stato generale selezionato
        function getStatiSpecifici(){
        	if(vm.currentStatoGenerale!=null)
        		vm.listaStatiSpecifici = vm.currentStatoGenerale.statiSpecifici;
        	else
        		vm.listaStatiSpecifici = [];
        }
        
        //Aggiunge la regola
        function addRegola(){
        	var object = {};
        	if(vm.currentMacroCat!=null)
        		object.macroCategoria = vm.currentMacroCat.descrizione;
        	if(vm.currentCategoria!=null)
        		object.categoria = vm.currentCategoria.descrizione;
        	if(vm.currentSottoCat!=null)
        		object.sottoCategoria = vm.currentSottoCat.descrizione;
        	if(vm.currentStatoGenerale!=null)
        		object.statoGenerale = vm.currentStatoGenerale.statoGenerale;
        	
        	object.statoSpecifico = vm.currentStatoSpecifico;
        	
        	if(vm.regole.indexOf(object)==-1)
        		vm.regole.push(object);
        	
        	//Pulisco i campi
        	vm.currentMacroCat = null;
        	vm.currentCategoria = null;
        	vm.currentSottoCat = null;
        	vm.currentStatoGenerale = null;
        	vm.currentStatoSpecifico = null;
        }
        //Rimuove la regola selezionata
        function removeRegola(regola){
        	var index = vm.regole.indexOf(regola);
        	vm.regole.splice(index, 1); 
        }
        //Aggiunge l'utente selezionato dall'autocompletamento
        function addUtente($item, $model, $label){
        	if(vm.policyUsers == null)
        		vm.policyUsers = [];
        	
        	var index = vm.policyUsers.indexOf($item);
        	if(index==-1)
        		vm.policyUsers.push($item);
        	vm.selectedUser = null;
        }
        //Aggiunge un nuovo utente, se non è stato trovato dall'autocompletamento
        function addNuovoUtente(){
        	if(vm.selectedUser!=null && vm.selectedUser!=""){
		    	if(vm.policyUsers == null)
		    		vm.policyUsers = [];
    	
		    	var utente = {
		    		userId: vm.selectedUser,
		    		nome: null,
		    		cognome: null
		    	};
		    	var index = vm.policyUsers.indexOf(utente);
		    	if(index==-1)
		    		vm.policyUsers.push(utente);
		    	vm.selectedUser = null;
        	}
        }
        //Rimuove l'utente selezionato
        function removeUtente(utente){
        	var index = vm.policyUsers.indexOf(utente);
        	vm.policyUsers.splice(index, 1); 
        	
        }
        
        function loadListaUtenti(testo){
        	
        	if(testo.length>=5){
	            return AnagraficaService.anagrafiche.get({filtroTesto:testo}).$promise
        	}
        	else{
        		return [];
        	}

        }
        
        function atLeastOneService(){
        	if((true || vm.policy.flInserimentoGuidato) && (vm.policyServices==null || vm.policyServices.length==0))
        		return false;
        	return true;
        }
        
        function toStringAttributeOperation(selAttr, selOperation, value) {
        	var toAdd = '';
        	if (selOperation == '*=') {
				toAdd = selAttr + '.match(/' + value + '/i)';
			} else {
				toAdd = selAttr + selOperation + '\'' + value + '\'';
			}
        	return toAdd;
        }
        
        vm.validate = function() {
        	switch(vm.selAttr){
    		case 'user.uid': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.selectedUid && vm.selectedUid != '';
    			break;
    		case 'user.nome': 
    		case 'user.cognome': 
    		case 'rawAttributes.codiceFiscale': 
    		case 'rawAttributes.matricolaStudente': 
    		case 'rawAttributes.email': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.testoLibero && vm.testoLibero != '';
    			break;
    		case 'role.ruolo': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentRuolo && vm.currentRuolo != '';
    			break;
    		case 'role.macroCategoria': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentMacroCat && vm.currentMacroCat.descrizione && vm.currentMacroCat.descrizione != '';
    			break;
    		case 'role.categoria': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentCat && vm.currentCat != '';
    			break;
    		case 'role.sottoCategoria': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentSottoCat && vm.currentSottoCat != '';
    			break;
    		case 'user.statoAggregato': 
    		case 'role.macroStato': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentMacroStato && vm.currentMacroStato.macroStato && vm.currentMacroStato.macroStato != '';
    			break;
    		case 'role.statoSpecifico': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentStatoSpecifico && vm.currentStatoSpecifico != '';
    			break;
    		case 'role.decorrenza': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && 
    			(
    				(vm.currentDecorrenza && vm.currentDecorrenza != '' && vm.selOperation.indexOf('NMesi') < 0) 
    				|| (vm.numeroLibero && vm.numeroLibero != '' && vm.selOperation.indexOf('NMesi') >= 0)
    			);
    			break;
    		case 'role.giorniDaDecorrenza': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.numeroLibero && vm.numeroLibero != '';
    			break;
	    		default: vm.selAttrValide = false; break;
	    	}
    	}
        
        vm.addToPolicy = function() {
        	var toAdd = '';
        	switch(vm.selAttr){
    		case 'user.uid': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.selectedUid);
    			break;
    		case 'user.nome': 
    		case 'user.cognome': 
    		case 'rawAttributes.codiceFiscale': 
    		case 'rawAttributes.matricolaStudente': 
    		case 'rawAttributes.email': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.testoLibero);
    			break;
    		case 'role.ruolo': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentRuolo);
    			break;
    		case 'role.macroCategoria': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentMacroCat.descrizione);
    			break;
    		case 'role.categoria': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentCat);
    			break;
    		case 'role.sottoCategoria': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentSottoCat);
    			break;
    		case 'user.statoAggregato': 
    		case 'role.macroStato': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentMacroStato.macroStato);
    			break;
    		case 'role.statoSpecifico': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentStatoSpecifico);
    			break;
    		case 'role.decorrenza': 
    			if (vm.selOperation.indexOf('NMesi') < 0) {
    				toAdd = 'new Date(Date.parse(role.decorrenza))'+((vm.selOperation == '==' || vm.selOperation == '!=')?'.getTime()':'')
    				+ vm.selOperation 
    				+ 'new Date(Date.parse(\''+vm.currentDecorrenza.toISOString()+'\'))'+((vm.selOperation == '==' || vm.selOperation == '!=')?'.getTime()':'');
    			} else if (vm.selOperation == 'entroNMesi') {
    				toAdd = 'new Date(Date.parse(role.decorrenza))>=('
    				+ 'new Date(new Date().setMonth(new Date().getMonth()' + (vm.numeroLibero >= 0 ? '-'+vm.numeroLibero : '+'+(0-vm.numeroLibero)) + ')))';
    			} else if (vm.selOperation == 'traNMesi') {
    				toAdd = 'new Date(Date.parse(role.decorrenza))<=('
    				+ 'new Date(new Date().setMonth(new Date().getMonth()' + (vm.numeroLibero >= 0 ? '-'+vm.numeroLibero : '+'+(0-vm.numeroLibero)) + ')))';
    			}
    			
    			break;
    		case 'role.giorniDaDecorrenza': 
    			toAdd = vm.selAttr + vm.selOperation + vm.numeroLibero;
    			break;

	    		default: vm.selAttrValide = false; break;
	    	}
        	if (toAdd != '') {
        		vm.policy.policyJS = ((vm.policy.policyJS && vm.policy.policyJS.length > 0) ? vm.policy.policyJS + ' && (' : '(') + toAdd + ')';
        	}
    	}
        
        vm.addElencoToPolicy = function() {
        	var arr = vm.currentElenco.split(/\r?\n/);
        	var toAdd = '';
        	angular.forEach(arr, function(str, key) {
        		str = str.trim();
        		if (str != '') {
        			if (toAdd == '') {
        				toAdd = '[';
        			} else {
        				toAdd += ',';
        			}
        			toAdd += '\''+ str +'\'';
        		}
    		}, {});
        	if (toAdd != '') {
        		toAdd += '].indexOf(' + vm.selAttr + ')>=0';
        		vm.policy.policyJS = ((vm.policy.policyJS && vm.policy.policyJS.length > 0) ? vm.policy.policyJS + ' && (' : '(') + toAdd + ')';
        	}
        }
        
        vm.validate();
        
        $scope.editorOptions = "{ lineNumbers: true, mode: 'javascript', onLoad : aceLoaded }"

    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('PolicyDetailController', PolicyDetailController);

    PolicyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Policy'];

    function PolicyDetailController($scope, $rootScope, $stateParams, previousState, entity, Policy) {
        var vm = this;

        vm.policy = entity;
        vm.previousState = previousState.name;
        
        $scope.aceLoaded = function(_editor){
			// Editor part
			var _session = _editor.getSession();
			var _renderer = _editor.renderer;

			// Options
			_session.setUndoManager(new ace.UndoManager());
			_editor.setHighlightActiveLine(true);
			_editor.setHighlightSelectedWord(true);
			_editor.setShowPrintMargin(false);

		};
		
		$scope.aceOptions = {
				useWrapMode : true,
				showGutter: true,
				mode: 'xml',
				firstLineNumber: 1,
				theme: 'tomorrow',
				onLoad: $scope.aceLoaded
		};

        var unsubscribe = $rootScope.$on('uniromaLandingApp:policyUpdate', function(event, result) {
            vm.policy = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('PolicyDeleteController',PolicyDeleteController);

    PolicyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Policy'];

    function PolicyDeleteController($uibModalInstance, entity, Policy) {
        var vm = this;

        vm.policy = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Policy.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('policy', {
            parent: 'app',
            url: '/policy?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY'],
                pageTitle: 'uniromaLandingApp.policy.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/policy/policies.html',
                    controller: 'PolicyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                	var searchParam = $stateParams.search ? JSON.parse($stateParams.search) : {};
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: searchParam
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('policy');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('policy-detail', {
            parent: 'policy',
            url: '/policy/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY'],
                pageTitle: 'uniromaLandingApp.policy.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/policy/policy-detail.html',
                    controller: 'PolicyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('policy');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Policy', function($stateParams, Policy) {
                    return Policy.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'policy',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('policy-detail.edit', {
            parent: 'policy-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy/policy-dialog.html',
                    controller: 'PolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Policy', function(Policy) {
                            return Policy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('policy.new', {
            parent: 'policy',
            url: '/new',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy/policy-dialog.html',
                    controller: 'PolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                            	name: null,
                                policyXACML: null,
                                priority: null,
                                id: null,
                                isActive: 0,
                                flInserimentoGuidato:false
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('policy', null, { reload: 'policy' });
                }, function() {
                    $state.go('policy');
                });
            }]
        })
        .state('policy.test', {
            parent: 'policy',
            url: '/test',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy/test-policy-dialog.html',
                    controller: 'TestPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('policy', null, { reload: 'policy' });
                }, function() {
                    $state.go('policy');
                });
            }]
        })
        .state('policy.edit', {
            parent: 'policy',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy/policy-dialog.html',
                    controller: 'PolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Policy', function(Policy) {
                            return Policy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('policy', null, { reload: 'policy' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('policy.delete', {
            parent: 'policy',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy/policy-delete-dialog.html',
                    controller: 'PolicyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Policy', function(Policy) {
                            return Policy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('policy', null, { reload: 'policy' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Policy', Policy);

    Policy.$inject = ['$resource'];

    function Policy ($resource) {
        var resourceUrl =  'api/policies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'verify': {
                method: 'POST',
                url: 'api/verify-policy'
            },
            'create': {
                method: 'POST',
                url: 'api/create-policy'
            },
            'activate': {
                method: 'POST',
                url: 'api/activate-policy'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('PolicyController', PolicyController);

    PolicyController.$inject = ['$state', 'Policy', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PolicyController($state, Policy, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.currentSearch = pagingParams.search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll () {
            Policy.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                textFilter: vm.currentSearch ? vm.currentSearch.nameFilter : null
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.policies = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: JSON.stringify(vm.currentSearch)
            });
        }
        
        function onSaveSuccess (result) {
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        vm.toggleActivation = function(policy){
        	policy.isActive = !policy.isActive;
        	var obj = {
        		id: policy.id,
        		activate: policy.isActive
        	}
        	
        	Policy.activate(obj, onSaveSuccess, onSaveError);
        } ;
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('TestPolicyAnagDialogController', TestPolicyAnagDialogController);

    
    
    
    
    TestPolicyAnagDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance','AnagraficaService','Service','SessionStorage'];
    // , 'PolicyAnag', 'Group', 'IdmCategoria','IdmStatiGenerali'

    function TestPolicyAnagDialogController ($timeout, $scope, $stateParams, $uibModalInstance, AnagraficaService, Service, SessionStorage) {
    	//, PolicyAnag, Group, IdmCategoria,IdmStatiGenerali
        var vm = this;
        vm.autoload = true;
        vm.clear = clear;
        vm.loadListaUtenti = loadListaUtenti;
        vm.selectUtente = selectUtente;
        vm.testPolicies = testPolicies;
        vm.typing = true;
        vm.loading = false;
        vm.anagAttributes = {};
        vm.attributes = {};
        vm.user = null;
        vm.roles = [];
        vm.executions = [];
        vm.attributesSize = 0;
        
        SessionStorage.init(vm, "UR1L.testPolicyAnag", ["selectedUser"]);
        
        if (vm.autoload && vm.selectedUser) {
        	testPolicies();
        }
        
        $scope.$watch('vm.selectedUser', function (newValue) {
        	vm.typing = true;
            vm.anagAttributes = {};
            vm.attributes = {};
            vm.user = null;
            vm.roles = [];
            vm.executions = [];
            vm.attributesSize = 0;
        });

        function testPolicies(){
        	vm.typing = false;
            vm.loading = true;
        	Service.testPolicyAnag({"uid":vm.selectedUser}, function(result) {
        		console.log(result);
        		vm.anagAttributes = result.anagAttributes;
                vm.attributes = result.rawAttributes;
                delete vm.attributes["userPassword"];
                vm.user = result.user;
                vm.roles = result.roles;
                vm.executions = result.executions;

                vm.loading = false;
                vm.attributesSize = Object.keys(result.rawAttributes).length;
        	}, function(error) {
                vm.loading = false;
        	});
//        	Service.userDetails({"account":vm.selectedUser}, function(result) {
//        		vm.attributes = {};
//        		vm.attributesSize = 0;
//        		angular.forEach(result.attributeList, function(value, key) {
//                    if (true || /^(nome|cognome|mail|userId|categoria|employeeNumber|mmEnabledService|uid|ou|givenName|objectClass|o|employeeType|mmActive|groups|businessCategory)$/.test(key)) {
//                    	vm.attributes[key] = value;
//                    	vm.attributesSize++;
//                    }
//                });
//        		vm.roles = result.roleList;
//        	}, function(error) {
//        	});
        }
        
        function selectUtente($item, $model, $label){
        	if ($item && $item.userId) {
        		vm.selectedUser = $item.userId;
        	} else {
            	vm.selectedUser = "";
        	}
        	SessionStorage.saveAll(vm, "UR1L.testPolicyAnag", ["selectedUser"]);
        }
        
        function loadListaUtenti(testo){
        	
        	if(testo.length>=5){
	            return AnagraficaService.anagrafiche.get({filtroTesto:testo}).$promise
        	}
        	else{
        		return [];
        	}

        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

//        var inputChangedPromise;
//        vm.save = save;
//        vm.switchMode = switchMode;
//        vm.whyPolicyIsIncorrect = null;
//        vm.policyIsCorrect = null;
//        vm.addService = addService;
//        vm.removeService = removeService;
//        vm.addCategory = addCategory;
//        vm.addPosition = addPosition;
//        vm.removeCategory = removeCategory;
//        vm.removePosition = removePosition;
//        vm.addGroup = addGroup;
//        vm.removeGroup = removeGroup;
////        vm.getCategorie = getCategorie;
////        vm.getSottoCategorie = getSottoCategorie;
////        vm.getStatiSpecifici = getStatiSpecifici;
////        vm.addRegola = addRegola;
////        vm.removeRegola = removeRegola;
//        vm.addUtente = addUtente;
//        vm.addNuovoUtente = addNuovoUtente;
//        vm.removeUtente = removeUtente;
//        vm.atLeastOneService = atLeastOneService;
//        
//        vm.policy = entity;
//        
//        vm.listaPosizioni = [{posizione: "DIPENDENTE", id:"1"}, {posizione: "ESTERNO", id:"2"}, {posizione: "ALTRO", id:"3"}];
//        
//        //Modifica
//        if(vm.policy.id!=null){
//        	vm.regole = vm.policy.regole;
//        	vm.policyUsers = vm.policy.utenti;
//        	vm.policyServices = vm.policy.servizi;
//        	vm.policyCategories = vm.policy.categorie;
//        	vm.policyPositions = vm.policy.posizioni.map(function(x){
//        		var flt = vm.listaPosizioni.filter(function(y){ return y.posizione == x;})
//        		return (flt && flt.length > 0) ? flt[0] : {posizione: x};
//        	});
//        	vm.policyGroups = vm.policy.gruppi.map(function(x){ return {gruppo: x};});
//        }
//        //Nuovo
//        else{
//        	vm.regole = [];
//        	vm.policyUsers = [];
//        	vm.policyServices = [];
//        	vm.policyCategories = [];
//        	vm.policyPositions = [];
//        	vm.policyGroups = [];
//        }
//        
//        //Modalità guidata
//        if(vm.policy.flInserimentoGuidato || vm.policy.id==null){
//        	/*Elenco dei servizi*/
//            Service.getAll({}, function(result){
//            	vm.listaServizi = result;
//            },
//            function(response){
//            	console.log(response);
//            });
//            
//        	/*Elenco dei gruppi*/
//            Group.getAll({}, function(result){
//            	vm.listaGruppi = result;
//            },
//            function(response){
//            	console.log(response);
//            });
//            
//            /*Elenco categorie*/
//            IdmCategoria.query({}, function(result){
//            	vm.listaCategorie = result;
//            },
//            function(response){
//            	console.log(response);
//            });
//            
            /*Elenco stati generali*/
//            IdmStatiGenerali.query({}, function(result){
//            	vm.listaStatiGenerali = result;
//            },
//            function(response){
//            	console.log(response);
//            });
//        }
        
        
        
        

        
        
       
        

//        function save () {
//            vm.isSaving = true;
//            var obj = {
//        		servizi: vm.policyServices,
//        		utenti: vm.policyUsers,
//        		categorie: vm.policyCategories,
//        		posizioni: vm.policyPositions.map(function(x){return x.posizione;}),
//        		gruppi: vm.policyGroups.map(function(x){return x.gruppo;}),
//        		regole: vm.regole,
//        		name: vm.policy.name,
//        		description: vm.policy.description,
//        		policyXACML: vm.policy.policyXACML,
//        		flInserimentoGuidato: vm.policy.flInserimentoGuidato,
//        		id: vm.policy.id,
//        		isActive: vm.policy.isActive
//        	};
//            
//            
//            //Policy inserita in maniera testuale
//            if(!vm.policy.flInserimentoGuidato){
//            	if (vm.policy.id !== null) {
//            		Policy.update(obj, onSaveSuccess, onSaveError);
//                } else {
//                	Policy.save(obj, onSaveSuccess, onSaveError);
//                }
//            }
//            //Policy inserita in maniera guidata
//            else{
//
//            	if (vm.policy.id !== null)
//            		Policy.update(obj, onSaveSuccess, onSaveError);
//            	else
//            		Policy.create(obj, onSaveSuccess, onSaveError);
//            }
//            
//            
//            
//        }
//
//        function onSaveSuccess (result) {
//            $scope.$emit('cinecaLandingApp:policyUpdate', result);
//            $uibModalInstance.close(result);
//            vm.isSaving = false;
//        }
//
//        function onSaveError () {
//            vm.isSaving = false;
//        }
        
//        //Aggiunge un nuovo utente, se non è stato trovato dall'autocompletamento
//        function addNuovoUtente(){
//        	if(vm.selectedUser!=null && vm.selectedUser!=""){
//		    	if(vm.policyUsers == null)
//		    		vm.policyUsers = [];
//    	
//		    	var utente = {
//		    		userId: vm.selectedUser,
//		    		nome: null,
//		    		cognome: null
//		    	};
//		    	var index = vm.policyUsers.indexOf(utente);
//		    	if(index==-1)
//		    		vm.policyUsers.push(utente);
//		    	vm.selectedUser = null;
//        	}
//        }
//        //Rimuove l'utente selezionato
//        function removeUtente(utente){
//        	var index = vm.policyUsers.indexOf(utente);
//        	vm.policyUsers.splice(index, 1); 
//        	
//        }
        
        
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('onReadFile',['$parse', function ($parse) {
		    return {
		        restrict: 'A',
		        scope: false,
		        link: function(scope, element, attrs) {
		            element.bind('change', function(e) {
		                
		                var onFileReadFn = $parse(attrs.onReadFile);
		                var reader = new FileReader();
		                
		                reader.onload = function() {
		                    var fileContents = reader.result;
		                    // invoke parsed function on scope
		                    // special syntax for passing in data
		                    // to named parameters
		                    // in the parsed function
		                    // we are providing a value for the property 'contents'
		                    // in the scope we pass in to the function
		                    scope.$apply(function() {
		                        onFileReadFn(scope, {
		                            'contents' : fileContents
		                        });
		                    });
		                };
		                reader.readAsText(element[0].files[0]);
		            });
		        }
		    };
		}])
        .controller('PolicyAnagDialogController', PolicyAnagDialogController);

    
    
    
    
    PolicyAnagDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PolicyAnag','Service','IdmCategoria','IdmStatiGenerali','AnagraficaService','SessionStorage'];

    function PolicyAnagDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PolicyAnag, Service,IdmCategoria,IdmStatiGenerali,AnagraficaService,SessionStorage) {
        var vm = this;

        var inputChangedPromise;
        vm.clear = clear;
        vm.save = save;
        vm.switchMode = switchMode;
        vm.testMode = false;
        vm.whyPolicyIsIncorrect = null;
        vm.policyIsCorrect = null;
        vm.addService = addService;
        vm.removeService = removeService;
        vm.getCategorie = getCategorie;
        vm.getSottoCategorie = getSottoCategorie;
        vm.getStatiSpecifici = getStatiSpecifici;
        vm.addRegola = addRegola;
        vm.removeRegola = removeRegola;
        vm.addUtente = addUtente;
        vm.addNuovoUtente = addNuovoUtente;
        vm.removeUtente = removeUtente;
        vm.loadListaUtenti = loadListaUtenti;
        vm.atLeastOneService = atLeastOneService;
        
        vm.policy = entity;
        
        vm.selectUtente = selectUtente;
        vm.testPolicies = testPolicies;
        vm.typing = true;
        vm.loading = false;
        vm.anagAttributes = {};
        vm.attributes = {};
        vm.user = null;
        vm.roles = [];
        vm.executions = [];
        vm.attributesSize = 0;
        
        vm.selAttrValide = false;
        
        SessionStorage.init(vm, "UR1L.testPolicyAnag", ["selectedUser"]);
        
        $scope.$watch('vm.selectedUser', function (newValue) {
        	vm.typing = true;
            vm.anagAttributes = {};
            vm.attributes = {};
            vm.user = null;
            vm.roles = [];
            vm.executions = [];
            vm.attributesSize = 0;
        });
        
        function testPolicies(){
        	vm.typing = false;
            vm.loading = true;
        	Service.testPolicyAnag({"uid":vm.selectedUser,name:vm.policy.name,policyJS:vm.policy.policyJS,fieldName:vm.policy.fieldName,fieldValue:vm.policy.fieldValue}, function(result) {
        		console.log(result);
        		vm.anagAttributes = result.anagAttributes;
                vm.attributes = result.rawAttributes;
                delete vm.attributes["userPassword"];
                vm.user = result.user;
                vm.roles = result.roles;
                vm.executions = result.executions;

                vm.loading = false;
                vm.attributesSize = Object.keys(result.rawAttributes).length;
        	}, function(error) {
                vm.loading = false;
        	});
        }
        
        function selectUtente($item, $model, $label){
        	if ($item && $item.userId) {
        		vm.selectedUser = $item.userId;
        	} else {
            	vm.selectedUser = "";
        	}
        	SessionStorage.saveAll(vm, "UR1L.testPolicyAnag", ["selectedUser"]);
        }
        
        vm.selectUid = function($item, $model, $label){
        	if ($item && $item.userId) {
        		vm.selectedUid = $item.userId;
        	} else {
            	vm.selectedUid = "";
        	}
        };
        
        //Modifica
        if(vm.policy.id!=null){
        	vm.regole = vm.policy.regole ? ( vm.policy.regole.map(function(rule) {
        		var newRule = {};
        		angular.forEach(rule, function(value, key) {
    			  this[key] = (value ? value.replace(/^\(\?i\)\\b/, "").replace(/\\b\(\?-i\)$/, "") : value);
    			}, newRule);
        		return newRule;
        	}) ) : vm.policy.regole;
        	
        	vm.policyUsers = vm.policy.utenti;
        	vm.policyServices = vm.policy.servizi;
        }
        //Nuovo
        else{
        	vm.regole = [];
        	vm.policyUsers = [];
        	vm.policyServices = [];
        }
        
        //Modalità guidata
        if(true || vm.policy.flInserimentoGuidato || vm.policy.id==null){
        	/*Elenco dei servizi*/
            Service.getAll({}, function(result){
            	vm.listaServizi = result;
            },
            function(response){
            	console.log(response);
            });
            
            /*Elenco categorie*/
            IdmCategoria.query({}, function(result){
            	vm.listaMacroCategorie = result;
            	vm.listaCategorieNonVuote = [];
            	angular.forEach(vm.listaMacroCategorie, function(mc, key) {
            		angular.forEach(mc.figli, function(cat, key) {
              		  var figli = cat.figli.filter(function(x) { return x != null && x.descrizione != null && x.descrizione != '-'})
              		  if (figli.length > 0) {
              			vm.listaCategorieNonVuote.push(cat);
              		  }
              		}, {});
        		}, {});
            },
            function(response){
            	console.log(response);
            });
            
//            /*Elenco stati generali*/
//            IdmStatiGenerali.query({}, function(result){
//            	vm.listaStatiGenerali = result;
//            	vm.listaStatiSpecifici = [];
//            	angular.forEach(vm.listaStatiGenerali, function(sg, key) {
//            		angular.forEach(sg.statiSpecifici, function(sp, key) {
//            			vm.listaStatiSpecifici.push(sp);
//              		}, {});
//        		}, {});
//            	vm.listaStatiSpecifici = vm.listaStatiSpecifici.sort().filter(function(el,i,a) {
//                    return (i==a.indexOf(el));
//                });
//            },
//            function(response){
//            	console.log(response);
//            });
            
            /*Elenco macro stati*/
            IdmStatiGenerali.macroStati({}, function(result){
            	vm.listaMacroStati = result;
            },
            function(response){
            	console.log(response);
            });
            
            /*Elenco stati*/
            IdmStatiGenerali.allStati({}, function(result){
            	vm.listaStati = result.sort();
            },
            function(response){
            	console.log(response);
            });
            
            /*Elenco ruoli*/
            IdmStatiGenerali.ruoli({}, function(result){
            	vm.listaRuoli = result;
            },
            function(response){
            	console.log(response);
            });
        }
        
        
        
        

        
        
       
        
        /**** Editor di testo ****/
        $scope.aceLoaded = function(_editor){
        	console.log(vm.policy.policyJS);
        	if(vm.policy.policyJS!=null)
        		$scope.verificaPolicy();
//			// Editor part
//			var _session = _editor.getSession();
//			var _renderer = _editor.renderer;
//			// Options
//			_renderer.setShowGutter(true);
//			_session.setUseWrapMode(true);
//			_session.setMode('ace/mode/javascript');
//			_session.setUndoManager(new ace.UndoManager());
//			_editor.setHighlightActiveLine(true);
//			_editor.setHighlightSelectedWord(true);
//			_editor.setShowPrintMargin(false);
//			_editor.setTheme('ace/theme/tomorrow');
//			_editor.on("change", $scope.aceChanged);

		};
		
		$scope.aceChanged = function(){
//			if(inputChangedPromise){
//		        $timeout.cancel(inputChangedPromise);
//		    }
//		    inputChangedPromise = $timeout($scope.verificaPolicy,1000);
			
		};
		
		$scope.verificaPolicy = function() {
			PolicyAnag.verify(vm.policy, function(response){
				if(response.code===200){
					 vm.policyIsCorrect = true;
					 vm.whyPolicyAnagIsIncorrect = null;
				}
				else{
					vm.policyIsCorrect = false;
					vm.whyPolicyIsIncorrect = response.message;
				}
			},
			function(response){
				vm.policyIsCorrect = false;
				vm.whyPolicyIsIncorrect = response.data.description;
			});
	    };
	    

		$scope.displayFileContents = function(contents) {
			vm.policy.policyXACML = contents;
	    };

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            
            var obj = {
        		name: vm.policy.name,
        		description: vm.policy.description,
        		policyJS: vm.policy.policyJS,
        		priority: vm.policy.priority,
        		fieldName: vm.policy.fieldName,
        		fieldValue: vm.policy.fieldValue,
        		id: vm.policy.id,
        		isActive: vm.policy.isActive
        	};
            
            console.log(obj);
            
        	if (vm.policy.id !== null) {
        		PolicyAnag.update(obj, onSaveSuccess, onSaveError);
            } else {
            	PolicyAnag.save(obj, onSaveSuccess, onSaveError);
            }
            
//            //Policy inserita in maniera testuale
//            if(!vm.policy.flInserimentoGuidato){
//            	if (vm.policy.id !== null) {
//            		Policy.update(obj, onSaveSuccess, onSaveError);
//                } else {
//                	Policy.save(obj, onSaveSuccess, onSaveError);
//                }
//            }
//            //Policy inserita in maniera guidata
//            else{
//            	if(vm.currentMacroCat!=null || vm.currentStatoGenerale!=null){
//                	addRegola();
//                }
//            	if (vm.policy.id !== null)
//            		Policy.update(obj, onSaveSuccess, onSaveError);
//            	else
//            		Policy.create(obj, onSaveSuccess, onSaveError);
//            }
            
            
            
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:policyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
            $("div.modal").scrollTop(0);
        }
        
        //Cambia da "inserimento manuale" a "inserimento guidato" (e viceversa)
        function switchMode(value){
        	vm.testMode = value;
        }
        
        //Aggiunge un servizio, chiamata all'onClick sull'autocompletamento
        function addService($item, $model, $label){
        	if(vm.policyServices == null)
        		vm.policyServices = [];
        	
        	var index = vm.policyServices.indexOf($item.code);
        	if(index==-1)
        		vm.policyServices.push($item.code);
        	vm.selectedService = null;
        }
        //Rimuove il servizio selezionato
        function removeService(servizio){
        	var index = vm.policyServices.indexOf(servizio);
        	vm.policyServices.splice(index, 1); 
        	
        }
        //Recupera l'elenco delle categorie, in base alla macroCategoria selezionata
        function getCategorie(){
        	if(vm.currentMacroCat!=null)
        		vm.listaCategorie = vm.currentMacroCat.figli;
        	else
        		vm.listaCategorie = [];

        }
        //Recupera l'elenco delle sottoCategorie, in base alla categoria selezionata
        function getSottoCategorie(){
        	if(vm.currentCategoria!=null)
        		vm.listaSottoCategorie = vm.currentCategoria.figli;
        	else
        		vm.listaSottoCategorie = [];
        }
        //Recupera l'elenco degli stati specifici, in base allo stato generale selezionato
        function getStatiSpecifici(){
        	if(vm.currentStatoGenerale!=null)
        		vm.listaStatiSpecifici = vm.currentStatoGenerale.statiSpecifici;
        	else
        		vm.listaStatiSpecifici = [];
        }
        
        //Aggiunge la regola
        function addRegola(){
        	var object = {};
        	if(vm.currentMacroCat!=null)
        		object.macroCategoria = vm.currentMacroCat.descrizione;
        	if(vm.currentCategoria!=null)
        		object.categoria = vm.currentCategoria.descrizione;
        	if(vm.currentSottoCat!=null)
        		object.sottoCategoria = vm.currentSottoCat.descrizione;
        	if(vm.currentStatoGenerale!=null)
        		object.statoGenerale = vm.currentStatoGenerale.statoGenerale;
        	
        	object.statoSpecifico = vm.currentStatoSpecifico;
        	
        	if(vm.regole.indexOf(object)==-1)
        		vm.regole.push(object);
        	
        	//Pulisco i campi
        	vm.currentMacroCat = null;
        	vm.currentCategoria = null;
        	vm.currentSottoCat = null;
        	vm.currentStatoGenerale = null;
        	vm.currentStatoSpecifico = null;
        }
        //Rimuove la regola selezionata
        function removeRegola(regola){
        	var index = vm.regole.indexOf(regola);
        	vm.regole.splice(index, 1); 
        }
        //Aggiunge l'utente selezionato dall'autocompletamento
        function addUtente($item, $model, $label){
        	if(vm.policyUsers == null)
        		vm.policyUsers = [];
        	
        	var index = vm.policyUsers.indexOf($item);
        	if(index==-1)
        		vm.policyUsers.push($item);
        	vm.selectedUser = null;
        }
        //Aggiunge un nuovo utente, se non è stato trovato dall'autocompletamento
        function addNuovoUtente(){
        	if(vm.selectedUser!=null && vm.selectedUser!=""){
		    	if(vm.policyUsers == null)
		    		vm.policyUsers = [];
    	
		    	var utente = {
		    		userId: vm.selectedUser,
		    		nome: null,
		    		cognome: null
		    	};
		    	var index = vm.policyUsers.indexOf(utente);
		    	if(index==-1)
		    		vm.policyUsers.push(utente);
		    	vm.selectedUser = null;
        	}
        }
        //Rimuove l'utente selezionato
        function removeUtente(utente){
        	var index = vm.policyUsers.indexOf(utente);
        	vm.policyUsers.splice(index, 1); 
        	
        }
        
        function loadListaUtenti(testo){
        	
        	if(testo.length>=5){
	            return AnagraficaService.anagrafiche.get({filtroTesto:testo}).$promise
        	}
        	else{
        		return [];
        	}

        }
        
        vm.loadFieldNames = function(testo){
        	
        	if(testo.length>=3){
	            return PolicyAnag.findFieldNames({filtroTesto:testo}).$promise
        	}
        	else{
        		return [];
        	}

        }
        
        function atLeastOneService(){
        	if((true || vm.policy.flInserimentoGuidato) && (vm.policyServices==null || vm.policyServices.length==0))
        		return false;
        	return true;
        }
        
        function toStringAttributeOperation(selAttr, selOperation, value) {
        	var toAdd = '';
        	if (selOperation == '*=') {
				toAdd = selAttr + '.match(/' + value + '/i)';
			} else {
				toAdd = selAttr + selOperation + '\'' + value + '\'';
			}
        	return toAdd;
        }
        
        vm.validate = function() {
        	switch(vm.selAttr){
    		case 'user.uid': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.selectedUid && vm.selectedUid != '';
    			break;
    		case 'user.nome': 
    		case 'user.cognome': 
    		case 'rawAttributes.codiceFiscale': 
    		case 'rawAttributes.matricolaStudente': 
    		case 'rawAttributes.email': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.testoLibero && vm.testoLibero != '';
    			break;
    		case 'role.ruolo': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentRuolo && vm.currentRuolo != '';
    			break;
    		case 'role.macroCategoria': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentMacroCat && vm.currentMacroCat.descrizione && vm.currentMacroCat.descrizione != '';
    			break;
    		case 'role.categoria': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentCat && vm.currentCat != '';
    			break;
    		case 'role.sottoCategoria': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentSottoCat && vm.currentSottoCat != '';
    			break;
    		case 'user.statoAggregato': 
    		case 'role.macroStato': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentMacroStato && vm.currentMacroStato.macroStato && vm.currentMacroStato.macroStato != '';
    			break;
    		case 'role.statoSpecifico': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentStatoSpecifico && vm.currentStatoSpecifico != '';
    			break;
    		case 'role.decorrenza': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && 
    			(
    				(vm.currentDecorrenza && vm.currentDecorrenza != '' && vm.selOperation.indexOf('NMesi') < 0) 
    				|| (vm.numeroLibero && vm.numeroLibero != '' && vm.selOperation.indexOf('NMesi') >= 0)
    			);
    			break;
    		case 'role.giorniDaDecorrenza': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.numeroLibero && vm.numeroLibero != '';
    			break;
	    		default: vm.selAttrValide = false; break;
	    	}
    	}
        
        vm.addToPolicy = function() {
        	var toAdd = '';
        	switch(vm.selAttr){
    		case 'user.uid': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.selectedUid);
    			break;
    		case 'user.nome': 
    		case 'user.cognome': 
    		case 'rawAttributes.codiceFiscale': 
    		case 'rawAttributes.matricolaStudente': 
    		case 'rawAttributes.email': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.testoLibero);
    			break;
    		case 'role.ruolo': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentRuolo);
    			break;
    		case 'role.macroCategoria': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentMacroCat.descrizione);
    			break;
    		case 'role.categoria': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentCat);
    			break;
    		case 'role.sottoCategoria': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentSottoCat);
    			break;
    		case 'user.statoAggregato': 
    		case 'role.macroStato': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentMacroStato.macroStato);
    			break;
    		case 'role.statoSpecifico': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentStatoSpecifico);
    			break;
    		case 'role.decorrenza': 
    			if (vm.selOperation.indexOf('NMesi') < 0) {
    				toAdd = 'new Date(Date.parse(role.decorrenza))'+((vm.selOperation == '==' || vm.selOperation == '!=')?'.getTime()':'')
    				+ vm.selOperation 
    				+ 'new Date(Date.parse(\''+vm.currentDecorrenza.toISOString()+'\'))'+((vm.selOperation == '==' || vm.selOperation == '!=')?'.getTime()':'');
    			} else if (vm.selOperation == 'entroNMesi') {
    				toAdd = 'new Date(Date.parse(role.decorrenza))>=('
    				+ 'new Date(new Date().setMonth(new Date().getMonth()' + (vm.numeroLibero >= 0 ? '-'+vm.numeroLibero : '+'+(0-vm.numeroLibero)) + ')))';
    			} else if (vm.selOperation == 'traNMesi') {
    				toAdd = 'new Date(Date.parse(role.decorrenza))<=('
    				+ 'new Date(new Date().setMonth(new Date().getMonth()' + (vm.numeroLibero >= 0 ? '-'+vm.numeroLibero : '+'+(0-vm.numeroLibero)) + ')))';
    			}
    			
    			break;
    		case 'role.giorniDaDecorrenza': 
    			toAdd = vm.selAttr + vm.selOperation + vm.numeroLibero;
    			break;

	    		default: vm.selAttrValide = false; break;
	    	}
        	if (toAdd != '') {
        		vm.policy.policyJS = ((vm.policy.policyJS && vm.policy.policyJS.length > 0) ? vm.policy.policyJS + ' && (' : '(') + toAdd + ')';
        	}
    	}
        
        vm.addElencoToPolicy = function() {
        	var arr = vm.currentElenco.split(/\r?\n/);
        	var toAdd = '';
        	angular.forEach(arr, function(str, key) {
        		str = str.trim();
        		if (str != '') {
        			if (toAdd == '') {
        				toAdd = '[';
        			} else {
        				toAdd += ',';
        			}
        			toAdd += '\''+ str +'\'';
        		}
    		}, {});
        	if (toAdd != '') {
        		toAdd += '].indexOf(' + vm.selAttr + ')>=0';
        		vm.policy.policyJS = ((vm.policy.policyJS && vm.policy.policyJS.length > 0) ? vm.policy.policyJS + ' && (' : '(') + toAdd + ')';
        	}
        }
        
        vm.validate();
        
        $scope.editorOptions = "{ lineNumbers: true, mode: 'javascript', onLoad : aceLoaded }"

    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('PolicyAnagDetailController', PolicyAnagDetailController);

    PolicyAnagDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PolicyAnag'];

    function PolicyAnagDetailController($scope, $rootScope, $stateParams, previousState, entity, PolicyAnag) {
        var vm = this;

        vm.policy = entity;
        vm.previousState = previousState.name;
        
        $scope.aceLoaded = function(_editor){
			// Editor part
			var _session = _editor.getSession();
			var _renderer = _editor.renderer;

			// Options
			_session.setUndoManager(new ace.UndoManager());
			_editor.setHighlightActiveLine(true);
			_editor.setHighlightSelectedWord(true);
			_editor.setShowPrintMargin(false);

		};
		
		$scope.aceOptions = {
				useWrapMode : true,
				showGutter: true,
				mode: 'xml',
				firstLineNumber: 1,
				theme: 'tomorrow',
				onLoad: $scope.aceLoaded
		};

        var unsubscribe = $rootScope.$on('uniromaLandingApp:policyUpdate', function(event, result) {
            vm.policy = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('PolicyAnagDeleteController',PolicyAnagDeleteController);

    PolicyAnagDeleteController.$inject = ['$uibModalInstance', 'entity', 'PolicyAnag'];

    function PolicyAnagDeleteController($uibModalInstance, entity, PolicyAnag) {
        var vm = this;

        vm.policy = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PolicyAnag.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('policy-anag', {
            parent: 'app',
            url: '/policy-anag?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY'],
                pageTitle: 'uniromaLandingApp.policyAnag.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/policy-anag/policies.html',
                    controller: 'PolicyAnagController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                	var searchParam = $stateParams.search ? JSON.parse($stateParams.search) : {};
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: searchParam
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('policyAnag');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('policy-anag-detail', {
            parent: 'policy-anag',
            url: '/policy-anag/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY'],
                pageTitle: 'uniromaLandingApp.policyAnag.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/policy-anag/policy-detail.html',
                    controller: 'PolicyAnagDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('policyAnag');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PolicyAnag', function($stateParams, PolicyAnag) {
                    return PolicyAnag.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'policy-anag',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('policy-anag-detail.edit', {
            parent: 'policy-anag-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-anag/policy-dialog.html',
                    controller: 'PolicyAnagDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PolicyAnag', function(PolicyAnag) {
                            return PolicyAnag.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('policy-anag.new', {
            parent: 'policy-anag',
            url: '/new',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-anag/policy-dialog.html',
                    controller: 'PolicyAnagDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                            	name: null,
                                priority: null,
                                id: null,
                                isActive: 0,
                                flInserimentoGuidato:false
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('policy-anag', null, { reload: 'policy-anag' });
                }, function() {
                    $state.go('policy-anag');
                });
            }]
        })
        .state('policy-anag.test', {
            parent: 'policy-anag',
            url: '/test',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-anag/test-policy-dialog.html',
                    controller: 'TestPolicyAnagDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('policy-anag', null, { reload: 'policy-anag' });
                }, function() {
                    $state.go('policy-anag');
                });
            }]
        })
        .state('policy-anag.edit', {
            parent: 'policy-anag',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-anag/policy-dialog.html',
                    controller: 'PolicyAnagDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PolicyAnag', function(PolicyAnag) {
                            return PolicyAnag.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('policy-anag', null, { reload: 'policy-anag' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('policy-anag.delete', {
            parent: 'policy-anag',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-anag/policy-delete-dialog.html',
                    controller: 'PolicyAnagDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PolicyAnag', function(PolicyAnag) {
                            return PolicyAnag.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('policy-anag', null, { reload: 'policy-anag' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('PolicyAnag', PolicyAnag);

    PolicyAnag.$inject = ['$resource'];

    function PolicyAnag ($resource) {
        var resourceUrl =  'api/anag-policies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            
            'update': { method:'PUT' },
            'findFieldNames': {
                method: 'GET',
                isArray: true,
                url: 'api/anag-policy-fields',
                transformResponse: function (data) {
                	if (data) {
                        data = angular.fromJson(data);
                        data = data.map(function(str, i) {return {fieldName: str}});
                    }
                    return data;
                }
            },
            'verify': {
                method: 'POST',
                url: 'api/verify-policy'
            },
            'create': {
                method: 'POST',
                url: 'api/create-anag-policy'
            },
            'activate': {
                method: 'POST',
                url: 'api/activate-anag-policy'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('PolicyAnagController', PolicyAnagController);

    PolicyAnagController.$inject = ['$state', 'PolicyAnag', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PolicyAnagController($state, PolicyAnag, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.currentSearch = pagingParams.search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll () {
            PolicyAnag.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                textFilter: vm.currentSearch ? vm.currentSearch.nameFilter : null
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.policies = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: JSON.stringify(vm.currentSearch)
            });
        }
        
        function onSaveSuccess (result) {
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        vm.toggleActivation = function(policy){
        	policy.isActive = !policy.isActive;
        	var obj = {
        		id: policy.id,
        		activate: policy.isActive
        	}
        	
        	PolicyAnag.activate(obj, onSaveSuccess, onSaveError);
        } ;
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Module_trDialogController', Module_trDialogController);

    Module_trDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Module_tr', 'Module'];

    function Module_trDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Module_tr, Module) {
        var vm = this;

        vm.module_tr = entity;
        vm.clear = clear;
        vm.save = save;
        vm.modules = Module.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.module_tr.id !== null) {
                Module_tr.update(vm.module_tr, onSaveSuccess, onSaveError);
            } else {
                Module_tr.save(vm.module_tr, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:module_trUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Module_trDetailController', Module_trDetailController);

    Module_trDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Module_tr', 'Module'];

    function Module_trDetailController($scope, $rootScope, $stateParams, previousState, entity, Module_tr, Module) {
        var vm = this;

        vm.module_tr = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('uniromaLandingApp:module_trUpdate', function(event, result) {
            vm.module_tr = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Module_trDeleteController',Module_trDeleteController);

    Module_trDeleteController.$inject = ['$uibModalInstance', 'entity', 'Module_tr'];

    function Module_trDeleteController($uibModalInstance, entity, Module_tr) {
        var vm = this;

        vm.module_tr = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Module_tr.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('module-tr', {
            parent: 'entity',
            url: '/module-tr?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.module_tr.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/module-tr/module-trs.html',
                    controller: 'Module_trController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('module_tr');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('module-tr-detail', {
            parent: 'module-tr',
            url: '/module-tr/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.module_tr.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/module-tr/module-tr-detail.html',
                    controller: 'Module_trDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('module_tr');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Module_tr', function($stateParams, Module_tr) {
                    return Module_tr.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'module-tr',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('module-tr-detail.edit', {
            parent: 'module-tr-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/module-tr/module-tr-dialog.html',
                    controller: 'Module_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Module_tr', function(Module_tr) {
                            return Module_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('module-tr.new', {
            parent: 'registryEntities',
            url: '/module-tr/{id}/new',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal','Module', function($stateParams, $state, $uibModal,Module) {
                $uibModal.open({
                    templateUrl: 'app/entities/module-tr/module-tr-dialog.html',
                    controller: 'Module_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                field: null,
                                value: null,
                                language: null,
                                id: null,
                                module: Module.get({id:$stateParams.id})
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('registryEntities');
                });
            }]
        })
        .state('module-tr.edit', {
            parent: 'registryEntities',
            url: '/module-tr/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/module-tr/module-tr-dialog.html',
                    controller: 'Module_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Module_tr', function(Module_tr) {
                            return Module_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('module-tr', null, { reload: 'module-tr' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('module-tr.delete', {
            parent: 'registryEntities',
            url: '/module-tr/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/module-tr/module-tr-delete-dialog.html',
                    controller: 'Module_trDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Module_tr', function(Module_tr) {
                            return Module_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Module_tr', Module_tr);

    Module_tr.$inject = ['$resource'];

    function Module_tr ($resource) {
        var resourceUrl =  'api/module-trs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Module_trController', Module_trController);

    Module_trController.$inject = ['$state', 'Module_tr', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function Module_trController($state, Module_tr, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Module_tr.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.module_trs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ModuleDialogController', ModuleDialogController);

    ModuleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Module', 'Product'];

    function ModuleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Module, Product) {
        var vm = this;

        vm.module = entity;
        vm.clear = clear;
        vm.save = save;
        vm.products = Product.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.module.id !== null) {
                Module.update(vm.module, onSaveSuccess, onSaveError);
            } else {
                Module.save(vm.module, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:moduleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ModuleDetailController', ModuleDetailController);

    ModuleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Module', 'Product'];

    function ModuleDetailController($scope, $rootScope, $stateParams, previousState, entity, Module, Product) {
        var vm = this;

        vm.module = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('uniromaLandingApp:moduleUpdate', function(event, result) {
            vm.module = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ModuleDeleteController',ModuleDeleteController);

    ModuleDeleteController.$inject = ['$uibModalInstance', 'entity', 'Module'];

    function ModuleDeleteController($uibModalInstance, entity, Module) {
        var vm = this;

        vm.module = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Module.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('module', {
            parent: 'entity',
            url: '/module?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.module.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/module/modules.html',
                    controller: 'ModuleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('module');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('module-detail', {
            parent: 'module',
            url: '/module/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.module.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/module/module-detail.html',
                    controller: 'ModuleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('module');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Module', function($stateParams, Module) {
                    return Module.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'module',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('module-detail.edit', {
            parent: 'module-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/module/module-dialog.html',
                    controller: 'ModuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Module', function(Module) {
                            return Module.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('module.new', {
            parent: 'registryEntities',
            url: '/{id}/module/new',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal','Product', function($stateParams, $state, $uibModal,Product) {
                $uibModal.open({
                    templateUrl: 'app/entities/module/module-dialog.html',
                    controller: 'ModuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                version: null,
                                code: null,
                                id: null,
                                product: Product.get({id:$stateParams.id})
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('registryEntities');
                });
            }]
        })
        .state('module.edit', {
            parent: 'registryEntities',
            url: '/module/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/module/module-dialog.html',
                    controller: 'ModuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Module', function(Module) {
                            return Module.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('module.delete', {
            parent: 'registryEntities',
            url: '/module/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/module/module-delete-dialog.html',
                    controller: 'ModuleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Module', function(Module) {
                            return Module.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Module', Module);

    Module.$inject = ['$resource'];

    function Module ($resource) {
        var resourceUrl =  'api/modules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ModuleController', ModuleController);

    ModuleController.$inject = ['$state', 'Module', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ModuleController($state, Module, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Module.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.modules = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Iso_country_codesDialogController', Iso_country_codesDialogController);

    Iso_country_codesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Iso_country_codes'];

    function Iso_country_codesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Iso_country_codes) {
        var vm = this;

        vm.iso_country_codes = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.iso_country_codes.id !== null) {
                Iso_country_codes.update(vm.iso_country_codes, onSaveSuccess, onSaveError);
            } else {
                Iso_country_codes.save(vm.iso_country_codes, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:iso_country_codesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Iso_country_codesDetailController', Iso_country_codesDetailController);

    Iso_country_codesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Iso_country_codes'];

    function Iso_country_codesDetailController($scope, $rootScope, $stateParams, previousState, entity, Iso_country_codes) {
        var vm = this;

        vm.iso_country_codes = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('uniromaLandingApp:iso_country_codesUpdate', function(event, result) {
            vm.iso_country_codes = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Iso_country_codesDeleteController',Iso_country_codesDeleteController);

    Iso_country_codesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Iso_country_codes'];

    function Iso_country_codesDeleteController($uibModalInstance, entity, Iso_country_codes) {
        var vm = this;

        vm.iso_country_codes = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Iso_country_codes.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('iso-country-codes', {
            parent: 'entity',
            url: '/iso-country-codes',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'uniromaLandingApp.iso_country_codes.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/iso-country-codes/iso-country-codes.html',
                    controller: 'Iso_country_codesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('iso_country_codes');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('iso-country-codes-detail', {
            parent: 'iso-country-codes',
            url: '/iso-country-codes/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'uniromaLandingApp.iso_country_codes.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/iso-country-codes/iso-country-codes-detail.html',
                    controller: 'Iso_country_codesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('iso_country_codes');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Iso_country_codes', function($stateParams, Iso_country_codes) {
                    return Iso_country_codes.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'iso-country-codes',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('iso-country-codes-detail.edit', {
            parent: 'iso-country-codes-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/iso-country-codes/iso-country-codes-dialog.html',
                    controller: 'Iso_country_codesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Iso_country_codes', function(Iso_country_codes) {
                            return Iso_country_codes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('iso-country-codes.new', {
            parent: 'iso-country-codes',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/iso-country-codes/iso-country-codes-dialog.html',
                    controller: 'Iso_country_codesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                codice: null,
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('iso-country-codes', null, { reload: 'iso-country-codes' });
                }, function() {
                    $state.go('iso-country-codes');
                });
            }]
        })
        .state('iso-country-codes.edit', {
            parent: 'iso-country-codes',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/iso-country-codes/iso-country-codes-dialog.html',
                    controller: 'Iso_country_codesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Iso_country_codes', function(Iso_country_codes) {
                            return Iso_country_codes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('iso-country-codes', null, { reload: 'iso-country-codes' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('iso-country-codes.delete', {
            parent: 'iso-country-codes',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/iso-country-codes/iso-country-codes-delete-dialog.html',
                    controller: 'Iso_country_codesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Iso_country_codes', function(Iso_country_codes) {
                            return Iso_country_codes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('iso-country-codes', null, { reload: 'iso-country-codes' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Iso_country_codes', Iso_country_codes);

    Iso_country_codes.$inject = ['$resource'];

    function Iso_country_codes ($resource) {
        var resourceUrl =  'api/iso-country-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Iso_country_codesController', Iso_country_codesController);

    Iso_country_codesController.$inject = ['Iso_country_codes'];

    function Iso_country_codesController(Iso_country_codes) {

        var vm = this;

        vm.iso_country_codes = [];

        loadAll();

        function loadAll() {
            Iso_country_codes.query(function(result) {
                vm.iso_country_codes = result;
                vm.searchQuery = null;
            });
        }
    }
})();

'use strict';

angular.module('uniromaLandingApp').controller('EsterniDialogController',
		['$scope', '$stateParams', '$uibModalInstance', '$window','entity', 'Esterni','CodiceFiscaleService','CategorieService','EsterniStatiSpecService','User','$q', 
	        function($scope, $stateParams, $uibModalInstance, $window,entity, Esterni, CodiceFiscaleService, CategorieService, EsterniStatiSpecService, User, $q) {

    	var ctrl = this;
    	
    	$scope.enableUser = enableUser;
    	$scope.disableUser = disableUser;
    	$scope.enabled = null;
        
    	if (entity.$promise) {
            entity.$promise.then(function( ent ) {
            	console.log("PROMISE KEPT", ent);
            	if (ent.codiceFiscale) {
                    User.isEnabled({userId : ent.codiceFiscale},function(abilitatoDto){
                    	$scope.enabled = abilitatoDto.flAbilitato;
                    });
            	}
        	}); 
    	} else {
    		console.log("NO PROMISE", entity);
    	}
        
        function enableUser() {
        	User.setEnabled({userId : $scope.esterni.codiceFiscale, flAbilitato: true}, function(){ $scope.enabled = true; });
        }
        
        function disableUser() {
        	User.setEnabled({userId : $scope.esterni.codiceFiscale, flAbilitato: false}, function(){ $scope.enabled = false; });
        }

    	entity.dataNascita = new Date(entity.dataNascita);
    	$scope.esterni = entity;
    	
    	$scope.countryList = null;
    	$scope.genderList = ['M','F'];
    	//Categorie
    	$scope.categoryList = null;
    	getCategorieList();
    	//Stati specifici
    	$scope.statiSpecificiList = null;
    	getStatiSpecificiList();
    	
    	$scope.switchOptions = {
			onText : 'yes',
			offText : 'no', 
			isActive : true,
			size : 'medium',
			animate : true,
			radioOff : true,
			handleWidth : "auto",
			labelWidth : "auto",
			inverse : true,
			onColor : "uniroma",
			offColor : "default",
			switchIsSelected : $scope.esterni.dataFine!=null? true : false
		};
    	
    	$scope.today = new Date();
    	$scope.today.setDate($scope.today.getDate() - 1);
    	$scope.oneYear = new Date()
    	$scope.oneYear.setFullYear($scope.oneYear.getFullYear() + 1);
    	$scope.$watch("esterni.dataAttivazione", function(newStart) {
    	    if (newStart > $scope.esterni.dataFine && $scope.esterni.dataFine != null) {
    	      $scope.esterni.dataFine = newStart;
    	    }
    	}); 
    	$scope.$watch("switchOptions.switchIsSelected", function(newSelected) {
    	    if (!newSelected) {
      	      $scope.esterni.dataFine = null;
    	    } else {
    	    	if ($scope.esterni.dataAttivazione == null) {
    	    		$scope.esterni.dataAttivazione = $scope.today;
    	    	}
    	    	if ($scope.esterni.dataFine == null) {
    	    		$scope.esterni.dataFine = $scope.oneYear;
    	    	}
    	    }
    	}); 
    	
    	Esterni.getCountryList({},function(response){
        	$scope.countryList = response;
        });
    	
    	
    	
    	if($scope.esterni.id != null)
    		$scope.savedCodFis = $scope.esterni.codiceFiscale;
    	else
    		$scope.savedCodFis = null;
       
        $scope.esterniCopy = {};
      
        
        if ( $stateParams.id !== undefined ) {
	        entity.$promise.then(function( ent ) {
	        	//entity.provResidenza = provinciaSelected;
	        	angular.copy(ent, $scope.esterniCopy);
	        });
        }
        
        
        

        $scope.load = function(id) {
            Esterni.get({id : id}, function(result) {
                $scope.esterni = result;
              
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('uniromaLandingApp:esterniUpdate', result);
            $uibModalInstance.close(result);
        };

        var onSaveError = function (result){
        	$window.scrollTo(0, 0);
        }
        
        $scope.save = function () {
            if ($scope.esterni.id != null) {
                Esterni.update($scope.esterni, onSaveFinished, onSaveError);
            } else {
                Esterni.save($scope.esterni, onSaveFinished, onSaveError);
            }
        };
        

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        
        $scope.checkUniqueCodiceFiscale = function(codFis,docIdentita) {
        	var reqObject = {
    			codiceFiscale : codFis,
    			documentoIdentita: docIdentita,
    			nazionalita: $scope.esterni.nazionalita
        	};
        	var isValid = false;
        	var deferred = $q.defer();
        	CodiceFiscaleService.checkUniqueCodiceFiscale.check( reqObject, function(resp) {
        		isValid = resp.isUnique;
        		if(isValid) {
        			deferred.resolve(isValid);
        		}
        		//Il codice fiscale esiste perchè è quello dell'utente corrente.
        		else if($scope.savedCodFis != null && $scope.savedCodFis === codfis){
        			deferred.resolve(isValid);
        		}
        		else{
        			deferred.reject(false);
        		}
        	}, function(err) {
        			deferred.reject(false);
        	});
        	return deferred.promise;
        };
        
        
        $scope.checkCodiceFiscale = function(codfis) {
        	var isValid = false;
        	var deferred = $q.defer();
        	CodiceFiscaleService.checkCodiceFiscale.check( codfis, function(resp) {
        		isValid = resp.isValid;
        		if(isValid) {
        			deferred.resolve(isValid);
        		}
        		else {
        			deferred.reject(false);
        		}
        	}, function(err) {
        			deferred.reject(false);
        	});
        	return deferred.promise;
        };
        
        $scope.checkDateCodiceFiscale = function(dataNascita, codiceFiscale) {
        	var isValid = false;
        	var deferred = $q.defer();
        	var inputDate =  (dataNascita == null ? new Date() : dataNascita);
        	var payload = {
					"dataNascita": transformDate( inputDate ),
					"codiceFiscale" : codiceFiscale
			}; 
        	CodiceFiscaleService.checkDateCodiceFiscale.check( payload, function(resp) {
        	
        		isValid = resp.isValid;
        		if(isValid) {
        			deferred.resolve(isValid);
        		}
        		else {
        			deferred.reject(false);
        		}
        	}, function(err) {
        			deferred.reject(false);
        	});
        	return deferred.promise;
        };
        
        $scope.checkGenderCodFiscale = function(gender,codiceFiscale){
        	var isValid = false;
        	var deferred = $q.defer();
        	
        	if(codiceFiscale.length>=10){
        		var giornoNascita = codiceFiscale.substring(9,11);
        		if( (giornoNascita>=40 && gender==='F') || (giornoNascita<40 && gender==='M') ){
        			isValid = true;
        			deferred.resolve(isValid);
        		}
        		else{
        			deferred.reject(false);
        		}
        	}
        	return deferred.promise;
        };
        
        $scope.isActive = function(){
        	if($scope.esterni!=null && $scope.esterni.flAttivo==1)
        		return true;
        	return false;
        }
          
        
        function transformDate(date) {
        	var formatted = pad(date.getDate(), 2) + "/" + pad(date.getMonth() + 1, 2) + "/" + date.getFullYear();
        	return formatted;
        }
        
        function pad(n, width, z) {
        	z = z || '0';
        	n = n + '';
        	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
        
        ctrl.preventKeyboard = function($event) {
    		$event.preventDefault();
    	}
        
      
        function getCategorieList(){
        	CategorieService.external.get({}, function(resp) {
        		$scope.categoryList = resp;
        	}, function(err) {
        		deferred.reject(false);
        	});
        };
        
        function getStatiSpecificiList(){
        	EsterniStatiSpecService.stati.get({"idEsterno":$scope.esterni.id}, function(resp) {
        		$scope.statiSpecificiList = resp;
        	}, function(err) {
        		deferred.reject(false);
        	});
        };
        
        
}]);

'use strict';

angular.module('uniromaLandingApp').controller('EsterniDetailController',
		['$scope', '$rootScope', '$stateParams', 'entity', 'userId','Esterni',function ($scope, $rootScope, $stateParams, entity, userId, Esterni) {
        $scope.esterni = entity;
        $scope.userId = userId;

        
        $scope.load = function (id) {
            Esterni.get({id: id}, function(result) {
                $scope.esterni = result;
            });
        };
        $rootScope.$on('uniromaLandingApp:esterniUpdate', function(event, result) {
            $scope.esterni = result;
        });
    }]);

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('EsterniDeleteController',EsterniDeleteController);

    EsterniDeleteController.$inject = ['$uibModalInstance', 'entity', 'Esterni'];

    function EsterniDeleteController($uibModalInstance, entity, Esterni) {
        var vm = this;

        vm.esterni = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	Esterni.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('esterni', {
                parent: 'entity',
                url: '/esternis?page&sort&search',
                data: {
                    authorities: ['ROLE_GESTIONE_ESTERNI'],
                    pageTitle: 'uniromaLandingApp.esterni.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/esterni/esternis.html',
                        controller: 'EsterniController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'cognome,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                	pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('esterni');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('esterni.detail', {
                parent: 'entity',
                url: '/esterni/{id}?userId',
                data: {
                    authorities: ['ROLE_GESTIONE_ESTERNI', 'ROLE_GESTIONE_ESTERNI_RIDOTTI'],
                    pageTitle: 'uniromaLandingApp.esterni.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/esterni/esterni-detail.html',
                        controller: 'EsterniDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('esterni');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Esterni', function($stateParams, Esterni) {
                    	console.log("----------");
                    	console.log($stateParams);
                        return Esterni.get({id : $stateParams.id});
                    }],
                    userId: ['$stateParams', function($stateParams) {
                        return $stateParams.userId;
                    }]
                }
            })
            .state('esterni.new', {
                parent: 'esterni',
                url: '/new',
                data: {
                    authorities: ['ROLE_GESTIONE_ESTERNI'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                	$uibModal.open({
                        templateUrl: 'app/entities/esterni/esterni-dialog.html',
                        controller: 'EsterniDialogController',
                        controllerAs: 'esterniCtrl',
                        size: 'lg',
                        backdrop: 'static',
                        resolve: {
                            entity: function () {
                                return {
                                	id: null,
                                	data: null,
                                    codiceFiscale: null,
                                    documentoIdendita: null,
                                    nazionalita: null,
                                    nome: null,
                                    middleName: null,
                                    cognome: null,
                                    denominazione: null,
                                    genere: null,
                                    luogoNascita: null,
                                    emailPrivata: null,
                                    email: null,
                                    uidResponsabile: null,
                                    nominativo: null,
                                    aliasPosta: null,
                                    telefono: null,
                                    telefonoPrivato: null,
                                    fax: null,
                                    faxPrivato: null,
                                    mobile: null,
                                    mobilePrivato: null,
                                    flSmartCard: 0,
                                    flAttivo: 0,
                                    dataNascita: null,
                                    idAb: null,
                                    affiliation: null,
                                    entitlement: null,
                                    titolo: null,
                                    lingua: null,
                                    contattiIm: null,
                                    afferenzaOrg: null,
                                    affDida: null,
                                    affSede: null,
                                    affStudente: null,
                                    cdsStudente: null,
                                    uidUnix: null,
                                    gidUnix: null,
                                    pathShell: null,
                                    idSmartCard: null,
                                    certSmartCard: null,
                                    foto: null,
                                    ambito: null,
                                    categoria: null,
                                    statoSpecifico: null,
                                    cfResponsabile: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                    	$state.go('esterni', null, { reload: true });
                    }, function() {
                        $state.go('esterni');
                    })
                }]
            })
            .state('esterni.edit', {
                parent: 'esterni',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_GESTIONE_ESTERNI'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal','Esterni', function($stateParams, $state, $uibModal,Esterni) {
                	Esterni.get({id : $stateParams.id}, function(result) {
                		if(result.statoSpecifico.id==6){
                			$state.go('esterni');
                         }
                		else{
                			$uibModal.open({
                                templateUrl: 'app/entities/esterni/esterni-dialog.html',
                                controller: 'EsterniDialogController',
                                controllerAs: 'esterniCtrl',
                                backdrop: 'static',
                                size: 'lg',
                                resolve: {
                                    'entity': ['Esterni', function(Esterni) {
                                        return Esterni.get({id : $stateParams.id}).$promise;
                                    }]
                                }
                            }).result.then(function(result) {
                                $state.go('esterni', null, { reload: true });
                            }, function() {
                                $state.go('^');
                            })
                		}
                    });
                	
                	
                }]
            })
            /*
            .state('esterni.delete', {
	            parent: 'esterni',
	            url: '/{id}/delete',
	            data: {
	                authorities: ['ROLE_GESTIONE_ESTERNI']
	            },
	            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
	                $uibModal.open({
	                    templateUrl: 'app/entities/esterni/esterni-delete-dialog.html',
	                    controller: 'EsterniDeleteController',
	                    controllerAs: 'vm',
	                    size: 'md',
	                    resolve: {
	                        entity: ['Esterni', function(Esterni) {
	                            return Esterni.get({id : $stateParams.id}).$promise;
	                        }]
	                    }
	                }).result.then(function() {
	                    $state.go('esterni', null, { reload: 'esterni' });
	                }, function() {
	                    $state.go('^');
	                });
	            }]
            });
            */
    	}
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .filter('filtroTabellaEsterni', filtroTabellaEsterni)
        .controller('EsterniController', EsterniController);

    EsterniController.$inject = ['$state','$scope', 'Esterni', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','EsterniStatiSpecService','CategorieService','SessionStorage'];

    
    //Filtro per ricerca Esterni
    function filtroTabellaEsterni() {
    	return function(dataArray, searchTerm, typeFilter, statoFilter) {
		      if (!dataArray) {
		          return;
		      }
		      else if (!searchTerm && !typeFilter && !statoFilter) {
		          return dataArray;
		      }
		      else {
		           
		           
		           return dataArray.filter(function(item){
		        	  var textCondition = true;
		        	  var typeCondition = true;
		        	  var statoCondition = true;
		        	  if(searchTerm!=null && searchTerm.length>0){
		        		  var text = searchTerm.toLowerCase();
		        		  var nameMatch = item.nome.toLowerCase().indexOf(text) > -1;
			              var surnameMatch = item.cognome.toLowerCase().indexOf(text) > -1;
			              var emailMatch = item.emailPrivata.toLowerCase().indexOf(text) > -1;
			              var userIdMatch = item.userId!=null ? (item.userId.toLowerCase().indexOf(text) > -1) : false;
			              var codFisMatch;
			              if(item.codiceFiscale!=null)
			            	  codFisMatch = item.codiceFiscale.toLowerCase().indexOf(text) > -1;
			              else
			            	  codFisMatch = item.documentoIdentita.toLowerCase().indexOf(text) > -1;
			            	  
			              textCondition = nameMatch || surnameMatch || emailMatch || codFisMatch || userIdMatch;
		        		  
		        	  }
		        	  if(typeFilter!=null && typeFilter.length>0){
		        		  var type = parseInt(typeFilter,10);
		        		  if(item.categoria!=null)
		        			  typeCondition = item.categoria.id===type;
		        	  }
		        	  if(statoFilter!=null && statoFilter.length>0){
		        		  var stato = parseInt(statoFilter,10);
		        		  if(item.statoSpecifico!=null)
		        			  statoCondition = item.statoSpecifico.id===stato;
		        	  }
		        	  
		        	  return textCondition && typeCondition && statoCondition;
		           });
		      } 
		  }    
    }
    
    
    function EsterniController($state, $scope, Esterni, ParseLinks, AlertService, paginationConstants, pagingParams,EsterniStatiSpecService,CategorieService,SessionStorage) {

		var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        //Tipologie e stati
        vm.tipologiePerFiltro = null;
        vm.statiSpecPerFiltro = null;
    	getCategorieList();
    	getStatiSpecificiList();
        
		$scope.esternis = [];
        $scope.page = 0;
        
        SessionStorage.init(vm, "UR1L.esterni", ["nameFilter", "typeFilter", "statusFilter"]);
        
        loadAll();
        
        $scope.chengeFilter = function() {
        	SessionStorage.saveAll(vm, "UR1L.esterni", ["nameFilter", "typeFilter", "statusFilter"]);
        	loadAll();
        }
        
        function getSort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }
        
        function getQueryParams() {
        	var params = {
        		page: pagingParams.page - 1,
            	size: vm.itemsPerPage,
            	sort: getSort()
            };
        	if (vm.nameFilter) {
        		params["search"] = vm.nameFilter;
        	}
        	if (vm.typeFilter) {
        		params["type"] = vm.typeFilter;
        	}
        	if (vm.statusFilter) {
        		params["status"] = vm.statusFilter;
        	}
        	return params;
        }
        
        function loadAll() {
        	
            Esterni.query(getQueryParams(), onSuccess, onError);
                        
            function onSuccess(data, headers) {
            	var filter = headers('FILTER-search');
            	if (filter == vm.nameFilter || (!filter && vm.nameFilter == '') ) {
            		console.log("showing results filtered for: " + filter);
            		vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.page = pagingParams.page;
                    $scope.esternis = data;
            	} else {
            		console.log("filtering response not corresponding to actual query");
            	}
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
        
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        
        vm.activateUser = function(esterno,toActivate){
        	
        	
        	Esterni.activate({id: esterno.id, toActivate:toActivate},onSuccess,onError);
        	
        	function onSuccess(data, headers) {
        		esterno.flAttivo= toActivate ? 1 : 0;
        		esterno.statoSpecifico = data.statoSpecifico;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
        
        function getCategorieList(){
        	CategorieService.external.get({}, function(resp) {
        		vm.tipologiePerFiltro = resp;
        	}, function(err) {
        		deferred.reject(false);
        	});
        };
        
        function getStatiSpecificiList(){
        	EsterniStatiSpecService.stati.getAll({}, function(resp) {
        		vm.statiSpecPerFiltro = resp;
        	}, function(err) {
        		deferred.reject(false);
        	});
        };
        
    }
})();
(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Environment_trDialogController', Environment_trDialogController);

    Environment_trDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Environment_tr', 'Environment'];

    function Environment_trDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Environment_tr, Environment) {
        var vm = this;

        vm.environment_tr = entity;
        vm.clear = clear;
        vm.save = save;
        vm.environments = Environment.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.environment_tr.id !== null) {
                Environment_tr.update(vm.environment_tr, onSaveSuccess, onSaveError);
            } else {
                Environment_tr.save(vm.environment_tr, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:environment_trUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Environment_trDetailController', Environment_trDetailController);

    Environment_trDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Environment_tr', 'Environment'];

    function Environment_trDetailController($scope, $rootScope, $stateParams, previousState, entity, Environment_tr, Environment) {
        var vm = this;

        vm.environment_tr = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('uniromaLandingApp:environment_trUpdate', function(event, result) {
            vm.environment_tr = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Environment_trDeleteController',Environment_trDeleteController);

    Environment_trDeleteController.$inject = ['$uibModalInstance', 'entity', 'Environment_tr'];

    function Environment_trDeleteController($uibModalInstance, entity, Environment_tr) {
        var vm = this;

        vm.environment_tr = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Environment_tr.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('environment-tr', {
            parent: 'entity',
            url: '/environment-tr?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'uniromaLandingApp.environment_tr.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/environment-tr/environment-trs.html',
                    controller: 'Environment_trController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('environment_tr');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('environment-tr-detail', {
            parent: 'environment-tr',
            url: '/environment-tr/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'uniromaLandingApp.environment_tr.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/environment-tr/environment-tr-detail.html',
                    controller: 'Environment_trDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('environment_tr');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Environment_tr', function($stateParams, Environment_tr) {
                    return Environment_tr.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'environment-tr',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('environment-tr-detail.edit', {
            parent: 'environment-tr-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment-tr/environment-tr-dialog.html',
                    controller: 'Environment_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Environment_tr', function(Environment_tr) {
                            return Environment_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('environment-tr.new', {
            parent: 'environment-tr',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment-tr/environment-tr-dialog.html',
                    controller: 'Environment_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                field: null,
                                value: null,
                                language: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('environment-tr', null, { reload: 'environment-tr' });
                }, function() {
                    $state.go('environment-tr');
                });
            }]
        })
        .state('environment-tr.edit', {
            parent: 'environment-tr',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment-tr/environment-tr-dialog.html',
                    controller: 'Environment_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Environment_tr', function(Environment_tr) {
                            return Environment_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('environment-tr', null, { reload: 'environment-tr' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('environment-tr.delete', {
            parent: 'environment-tr',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment-tr/environment-tr-delete-dialog.html',
                    controller: 'Environment_trDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Environment_tr', function(Environment_tr) {
                            return Environment_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('environment-tr', null, { reload: 'environment-tr' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Environment_tr', Environment_tr);

    Environment_tr.$inject = ['$resource'];

    function Environment_tr ($resource) {
        var resourceUrl =  'api/environment-trs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Environment_trController', Environment_trController);

    Environment_trController.$inject = ['$state', 'Environment_tr', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function Environment_trController($state, Environment_tr, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Environment_tr.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.environment_trs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('EnvironmentDialogController', EnvironmentDialogController);

    EnvironmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Environment', 'Tenant'];

    function EnvironmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Environment, Tenant) {
        var vm = this;

        vm.environment = entity;
        vm.clear = clear;
        vm.save = save;
        vm.tenants = Tenant.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.environment.id !== null) {
                Environment.update(vm.environment, onSaveSuccess, onSaveError);
            } else {
                Environment.save(vm.environment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:environmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('EnvironmentDetailController', EnvironmentDetailController);

    EnvironmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Environment', 'Tenant'];

    function EnvironmentDetailController($scope, $rootScope, $stateParams, previousState, entity, Environment, Tenant) {
        var vm = this;

        vm.environment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('uniromaLandingApp:environmentUpdate', function(event, result) {
            vm.environment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('EnvironmentDeleteController',EnvironmentDeleteController);

    EnvironmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Environment'];

    function EnvironmentDeleteController($uibModalInstance, entity, Environment) {
        var vm = this;

        vm.environment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Environment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('environment', {
            parent: 'entity',
            url: '/environment?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'uniromaLandingApp.environment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/environment/environments.html',
                    controller: 'EnvironmentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('environment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('environment-detail', {
            parent: 'environment',
            url: '/environment/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'uniromaLandingApp.environment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/environment/environment-detail.html',
                    controller: 'EnvironmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('environment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Environment', function($stateParams, Environment) {
                    return Environment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'environment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('environment-detail.edit', {
            parent: 'environment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment/environment-dialog.html',
                    controller: 'EnvironmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Environment', function(Environment) {
                            return Environment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('environment.new', {
            parent: 'environment',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment/environment-dialog.html',
                    controller: 'EnvironmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('environment', null, { reload: 'environment' });
                }, function() {
                    $state.go('environment');
                });
            }]
        })
        .state('environment.edit', {
            parent: 'environment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment/environment-dialog.html',
                    controller: 'EnvironmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Environment', function(Environment) {
                            return Environment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('environment', null, { reload: 'environment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('environment.delete', {
            parent: 'environment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment/environment-delete-dialog.html',
                    controller: 'EnvironmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Environment', function(Environment) {
                            return Environment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('environment', null, { reload: 'environment' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Environment', Environment);

    Environment.$inject = ['$resource'];

    function Environment ($resource) {
        var resourceUrl =  'api/environments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('EnvironmentController', EnvironmentController);

    EnvironmentController.$inject = ['$state', 'Environment', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function EnvironmentController($state, Environment, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Environment.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.environments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

'use strict';

angular.module('uniromaLandingApp').controller('EccezioniDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Eccezioni', 'Omonimie', '$q',
        function($scope, $stateParams, $uibModalInstance, entity, Eccezioni, Omonimie, $q) {

        $scope.eccezioni = entity;

        
        $scope.eccezioneCopy = {};
        
        if ( $stateParams.id !== undefined ) {
	        entity.$promise.then(function( ecc ) {
	        	angular.copy(ecc, $scope.eccezioneCopy);
	        });
        }
               
        
        
        $scope.load = function(id) {
            Eccezioni.get({id : id}, function(result) {
                $scope.eccezioni = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('uniromaLandingApp:eccezioniUpdate', result);
            $uibModalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.eccezioni.id != null) {
                Eccezioni.update($scope.eccezioni, onSaveFinished);
            } else {
                Eccezioni.save($scope.eccezioni, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        
        $scope.checkUniqueUsername = function(username) {
        	var isValid = false;
        	var deferred = $q.defer();
        	Omonimie.get( { username: username }, function( resp ) {
        		var counter = resp.counter;
        		if (counter == 0) {
        			isValid = true;
        			deferred.resolve(isValid);
        		}
        		deferred.reject(isValid);
        	}, function( err ) {
        		deferred.reject(err);
        	});
        	return deferred.promise;
        };
}]);

'use strict';

angular.module('uniromaLandingApp').controller('EccezioniDetailController', 
		['$scope', '$rootScope', '$stateParams', 'entity', 'Eccezioni',function ($scope, $rootScope, $stateParams, entity, Eccezioni) {
        $scope.eccezioni = entity;
        $scope.load = function (id) {
            Eccezioni.get({id: id}, function(result) {
                $scope.eccezioni = result;
            });
        };
        $rootScope.$on('uniromaLandingApp:eccezioniUpdate', function(event, result) {
            $scope.eccezioni = result;
        });
    }]);

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('eccezioni', {
                parent: 'entity',
                url: '/eccezionis',
                data: {
                    authorities: ['ROLE_GESTIONE_ECCEZIONI'],
                    pageTitle: 'uniromaLandingApp.eccezioni.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/eccezioni/eccezionis.html',
                        controller: 'EccezioniController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('eccezioni');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('eccezioni.detail', {
                parent: 'entity',
                url: '/eccezioni/{id}',
                data: {
                    authorities: ['ROLE_GESTIONE_ECCEZIONI'],
                    pageTitle: 'uniromaLandingApp.eccezioni.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/eccezioni/eccezioni-detail.html',
                        controller: 'EccezioniDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('eccezioni');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Eccezioni', function($stateParams, Eccezioni) {
                        return Eccezioni.get({id : $stateParams.id});
                    }]
                }
            })
            .state('eccezioni.new', {
                parent: 'eccezioni',
                url: '/new',
                data: {
                    authorities: ['ROLE_GESTIONE_ECCEZIONI'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/eccezioni/eccezioni-dialog.html',
                        controller: 'EccezioniDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    codFis: null,
                                    fonte: 'UGOV',
                                    username: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('eccezioni', null, { reload: true });
                    }, function() {
                        $state.go('eccezioni');
                    })
                }]
            })
            .state('eccezioni.edit', {
                parent: 'eccezioni',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_GESTIONE_ECCEZIONI'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/eccezioni/eccezioni-dialog.html',
                        controller: 'EccezioniDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['Eccezioni', function(Eccezioni) {
                                return Eccezioni.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('eccezioni', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    }
})();

'use strict';

angular.module('uniromaLandingApp').controller('EccezioniController', 
		['$scope', 'Eccezioni', 'ParseLinks', function ($scope, Eccezioni, ParseLinks) {
        $scope.eccezionis = [];
        $scope.page = 0;
        $scope.loadAll = function() {
            Eccezioni.query({page: $scope.page, size: 20}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.eccezionis = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Eccezioni.get({id: id}, function(result) {
                $scope.eccezioni = result;
                $('#deleteEccezioniConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            Eccezioni.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteEccezioniConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.eccezioni = {
                codFis: null,
                fonte: 'UGOV',
                username: null,
                id: null
            };
        };
    }]);

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Distribution_listDialogController', Distribution_listDialogController);

    Distribution_listDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Distribution_list'];

    function Distribution_listDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Distribution_list) {
        var vm = this;

        vm.distribution_list = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.distribution_list.id !== null) {
                Distribution_list.update(vm.distribution_list, onSaveSuccess, onSaveError);
            } else {
                Distribution_list.save(vm.distribution_list, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:distribution_listUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Distribution_listDetailController', Distribution_listDetailController);

    Distribution_listDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Distribution_list'];

    function Distribution_listDetailController($scope, $rootScope, $stateParams, previousState, entity, Distribution_list) {
        var vm = this;

        vm.distribution_list = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('uniromaLandingApp:distribution_listUpdate', function(event, result) {
            vm.distribution_list = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Distribution_listDeleteController',Distribution_listDeleteController);

    Distribution_listDeleteController.$inject = ['$uibModalInstance', 'entity', 'Distribution_list'];

    function Distribution_listDeleteController($uibModalInstance, entity, Distribution_list) {
        var vm = this;

        vm.distribution_list = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Distribution_list.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                },function(response){
                	response.statusText = "Impossibile cancellare";
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('distribution-list', {
            parent: 'entity',
            url: '/distribution-list',
            data: {
                authorities: ['ROLE_GESTIONE_LISTE_DISTRIBUZIONE'],
                pageTitle: 'uniromaLandingApp.distribution_list.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/distribution-list/distribution-lists.html',
                    controller: 'Distribution_listController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('distribution_list');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('distribution-list-detail', {
            parent: 'distribution-list',
            url: '/detail/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_LISTE_DISTRIBUZIONE'],
                pageTitle: 'uniromaLandingApp.distribution_list.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/distribution-list/distribution-list-detail.html',
                    controller: 'Distribution_listDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('distribution_list');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Distribution_list', function($stateParams, Distribution_list) {
                    return Distribution_list.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'distribution-list',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('distribution-list-detail.edit', {
            parent: 'distribution-list-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_LISTE_DISTRIBUZIONE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/distribution-list/distribution-list-dialog.html',
                    controller: 'Distribution_listDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Distribution_list', function(Distribution_list) {
                            return Distribution_list.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('distribution-list.new', {
            parent: 'distribution-list',
            url: '/new',
            data: {
                authorities: ['ROLE_GESTIONE_LISTE_DISTRIBUZIONE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/distribution-list/distribution-list-dialog.html',
                    controller: 'Distribution_listDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('distribution-list', null, { reload: 'distribution-list' });
                }, function() {
                    $state.go('distribution-list');
                });
            }]
        })
        .state('distribution-list.edit', {
            parent: 'distribution-list',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_LISTE_DISTRIBUZIONE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            	if($stateParams.id>1){
	                $uibModal.open({
	                    templateUrl: 'app/entities/distribution-list/distribution-list-dialog.html',
	                    controller: 'Distribution_listDialogController',
	                    controllerAs: 'vm',
	                    backdrop: 'static',
	                    size: 'lg',
	                    resolve: {
	                        entity: ['Distribution_list', function(Distribution_list) {
	                            return Distribution_list.get({id : $stateParams.id}).$promise;
	                        }]
	                    }
	                }).result.then(function() {
	                    $state.go('distribution-list', null, { reload: 'distribution-list' });
	                }, function() {
	                    $state.go('^');
	                });
            	}
            }]
        })
        .state('distribution-list.delete', {
            parent: 'distribution-list',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_LISTE_DISTRIBUZIONE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            	if($stateParams.id>1){
	            	$uibModal.open({
	                    templateUrl: 'app/entities/distribution-list/distribution-list-delete-dialog.html',
	                    controller: 'Distribution_listDeleteController',
	                    controllerAs: 'vm',
	                    size: 'md',
	                    resolve: {
	                        entity: ['Distribution_list', function(Distribution_list) {
	                            return Distribution_list.get({id : $stateParams.id}).$promise;
	                        }]
	                    }
	                }).result.then(function() {
	                    $state.go('distribution-list', null, { reload: 'distribution-list' });
	                }, function() {
	                    $state.go('^');
	                });
            	}
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Distribution_list', Distribution_list);

    Distribution_list.$inject = ['$resource'];

    function Distribution_list ($resource) {
        var resourceUrl =  'api/distribution-lists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Distribution_listController', Distribution_listController);

    Distribution_listController.$inject = ['Distribution_list'];

    function Distribution_listController(Distribution_list) {

        var vm = this;

        vm.distribution_lists = [];

        loadAll();

        function loadAll() {
            Distribution_list.query(function(result) {
                vm.distribution_lists = result;
                vm.searchQuery = null;
            });
        }
    }
})();

'use strict';

angular.module('uniromaLandingApp').controller('ConfigParamDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ConfigParam',
        function($scope, $stateParams, $uibModalInstance, entity, ConfigParam) {

        $scope.configParam = entity;
        $scope.load = function(id) {
            ConfigParam.get({id : id}, function(result) {
                $scope.configParam = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('uniromaLandingApp:configParamUpdate', result);
            $uibModalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.configParam.id != null) {
                ConfigParam.update($scope.configParam, onSaveFinished);
            } else {
                ConfigParam.save($scope.configParam, onSaveFinished);
            }
        };

        $scope.clear = function() {
        	$uibModalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('uniromaLandingApp')
    .controller('ConfigParamDetailController', 
    		['$scope', '$rootScope', '$stateParams', 'entity', 'ConfigParam',function ($scope, $rootScope, $stateParams, entity, ConfigParam) {
        $scope.configParam = entity;
        $scope.load = function (id) {
            ConfigParam.get({id: id}, function(result) {
                $scope.configParam = result;
            });
        };
        $rootScope.$on('uniromaLandingApp:configParamUpdate', function(event, result) {
            $scope.configParam = result;
        });
    }]);

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ConfigParamDeleteController',ConfigParamDeleteController);

    ConfigParamDeleteController.$inject = ['$uibModalInstance', 'entity', 'ConfigParam'];

    function ConfigParamDeleteController($uibModalInstance, entity, ConfigParam) {
        var vm = this;

        vm.configParam = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	ConfigParam.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('configParam', {
                parent: 'admin',
                url: '/configParams',
                data: {
                    authorities: ['ROLE_CONFIGURAZIONE_PARAM'],
                    pageTitle: 'uniromaLandingApp.configParam.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/configParam/configParams.html',
                        controller: 'ConfigParamController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('configParam');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('configParam.detail', {
                parent: 'admin',
                url: '/configParam/{id}',
                data: {
                    authorities: ['ROLE_CONFIGURAZIONE_PARAM'],
                    pageTitle: 'uniromaLandingApp.configParam.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/configParam/configParam-detail.html',
                        controller: 'ConfigParamDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('configParam');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ConfigParam', function($stateParams, ConfigParam) {
                        return ConfigParam.get({id : $stateParams.id});
                    }]
                }
            })
            .state('configParam.new', {
                parent: 'configParam',
                url: '/new',
                data: {
                    authorities: ['ROLE_CONFIGURAZIONE_PARAM'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                	$uibModal.open({
                        templateUrl: 'app/entities/configParam/configParam-dialog.html',
                        controller: 'ConfigParamDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    configurationId: null,
                                    name: null,
                                    value: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('configParam', null, { reload: true });
                    }, function() {
                        $state.go('configParam');
                    })
                }]
            })
            .state('configParam.edit', {
                parent: 'configParam',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_CONFIGURAZIONE_PARAM'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                	$uibModal.open({
                        templateUrl: 'app/entities/configParam/configParam-dialog.html',
                        controller: 'ConfigParamDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['ConfigParam', function(ConfigParam) {
                                return ConfigParam.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('configParam', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            })
            .state('configParam.delete', {
                parent: 'configParam',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_CONFIGURAZIONE_PARAM']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/configParam/configParam-delete-dialog.html',
                        controller: 'ConfigParamDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ConfigParam', function(ConfigParam) {
                                return ConfigParam.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('configParam', null, { reload: 'configParam' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
            
    }
})();

'use strict';

angular.module('uniromaLandingApp')
    .controller('ConfigParamController', 
    		['$scope','ConfigParam','ParseLinks',function ($scope, ConfigParam, ParseLinks) {
        $scope.configParams = [];
        $scope.page = 0;
        $scope.loadAll = function() {
            ConfigParam.query({page: $scope.page, size: 20, sort:'name,asc'}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.configParams = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            ConfigParam.get({id: id}, function(result) {
                $scope.configParam = result;
                $('#deleteConfigParamConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            ConfigParam.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteConfigParamConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.configParam = {
                configurationId: null,
                name: null,
                value: null,
                id: null
            };
        };
    }])
    .filter('shortenValue', ['$filter',function($filter) {
    	return function(input, threeshold) {
    		var output = input;
    		if ( input != null && input.length > threeshold ) {
        		output = $filter('limitTo')(input, threeshold) + " ...";
        	}
        	return output;
    	}
    }]);

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('dashboard', {
           parent: 'admin',
           url: '/dashboard',
           data: {
               authorities: ['ROLE_DASHBOARD_PROVISIONING'],
               pageTitle: 'global.menu.dashboard.main'
           },
           views: {
               'content@': {
                   templateUrl: 'app/dashboard/dashboard.html',
                   controller: 'DashboardController'
               }
           },
           resolve: {
               mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                   $translatePartialLoader.addPart('dashboard');
                   $translatePartialLoader.addPart('global');
                   return $translate.refresh();
               }]
           }
       });
    }
})();
'use strict';

angular.module('uniromaLandingApp')
    .controller('DashboardController', ['$scope','Principal','ScheduledJobStats', function ($scope, Principal, ScheduledJobStats) {
        Principal.identity().then(function(account) {
            $scope.account = account;
            $scope.isAuthenticated = Principal.isAuthenticated;
        });
        
    }])
    .controller('WidgetLast10Ctrl', [ '$scope','ScheduledJob', function($scope, ScheduledJob) {
    	
    	  $scope.loadLast10 = function() {
              ScheduledJob.query({page: 0, size: 10, sort: ['id,desc', 'id']}, function(result, headers) {
                  $scope.scheduledJobs = result;
              });
          };
          
          $scope.loadLast10(); 
    	
    }])
    .controller('WidgetLast5ErrorsCtrl', [ '$scope','ScheduledJobErrors', function($scope, ScheduledJobErrors) {
    	$scope.loadLast5Errors = function() {
    		ScheduledJobErrors.query({page: 0, size: 5, sort: ['id,desc', 'id']}, function(result, headers) {
                $scope.scheduledJobs = result;
            });
        };
        
        $scope.loadLast5Errors();
    }])
    .controller("DoughnutCtrl", ['$scope', 'ScheduledJobStats',function ($scope, ScheduledJobStats) {
    		
    	 $scope.loadWidgetExecutionsData = function() {
         	ScheduledJobStats.query( function( result, headers ) {
         		$scope.widgetExecutionsData = result;
         		
         		
         		var labels = [];
         		var data = [];
         		var labels_percent = [];
         		var data_percent = [];
         		var totals = 0;
         		var colours = [];
         		var options =  {
         				legend: {
         					display: true,
         					labels: {
         						fontColor: 'rgb(255, 99, 132)'
         					}
         				}
         		};
         		
         		
         		result.forEach(function(entry) {
         			labels.push(entry.status); 	
         			if ( entry.status == 'SUCCESS') {
         				colours.push('#009900');
         			} else if ( entry.status == 'ERROR') {
         				colours.push('#FF0000');
         			} else {
         				colours.push('#DCDCDC');
         			}
         			
         			data.push(entry.numEntries);
         		   			
         			totals += entry.numEntries;
         		});
         		
         		
         		result.forEach(function(entry) {
         			labels_percent.push(entry.status);
         			data_percent.push( Math.round( entry.numEntries * 100 / totals ));
         		});
         		
         		$scope.labels_count = labels;
         		$scope.data_count = data;
         		$scope.totals_count = totals;
         		$scope.colours_count = colours;
         		
         		
         		$scope.labels_percent = labels_percent;
         		$scope.data_percent = data_percent;
         		$scope.colours_percent = colours;
         		
         		$scope.options = options;
         		
         	});
         };
         
         $scope.loadWidgetExecutionsData();
         
    	//	$scope.labels = ["Download Sales", "In-Store Sales", "Mail-Order Sales"];
    	//	$scope.data = [300, 500, 100];
    }])
     .controller("BarCtrl", ['$scope', 'ScheduledJobStats',function ($scope, ScheduledJobStats) {
    		
    	 $scope.loadWidgetExecutionsData = function() {
         	ScheduledJobStats.query( function( result, headers ) {
         		$scope.widgetExecutionsData = result;
         		
         		
         		var labels = ['Esecuzioni'];
         		var data = [];
         		var series = ['SUCCESS','ERROR', 'SKIPPED'];
         		var totals = 0;
         		var colours = ['#009900','#FF0000','#DCDCDC'];
         		var options =  {
         				legend: {
         					display: true,
         					labels: {
         						fontColor: 'rgb(255, 99, 132)'
         					}
         				}
         		};
         		
         		result.forEach(function(entry) {
         			
         			if ( entry.status == 'SUCCESS') {
         				data.splice(0,0, [entry.numEntries]);
         			} else if ( entry.status == 'ERROR') {
         				data.splice(1,0, [entry.numEntries]);
         			} else if ( entry.status = 'SKIPPED') {
         				data.splice(2,0, [entry.numEntries]);
         			}
         			  		
         		   			
         			totals += entry.numEntries;
         		});
         		
         		$scope.labels = labels;
                $scope.series = series;

         		$scope.data = data;
       
         		$scope.totals = totals;
         		$scope.colours = colours;
         		
         		$scope.options = options;
         		
         	});
         };
         
         $scope.loadWidgetExecutionsData();
         
    }]);
    

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('SessionStorage', SessionStorage);

    function SessionStorage() {

        var service = {
            get: getFromSession,
            save: putToSession,
            init: initFromSession,
            saveAll: saveAllToSession
        };

        return service;
        
        function initFromSession(obj, prefix, keys) {
        	angular.forEach(keys, function(key, index) {
        		var item = getFromSession(prefix + '.' + key);
        		this[key] = item;
    		}, obj);
        	
        }

        function saveAllToSession(obj, prefix, keys) {
        	angular.forEach(keys, function(key, index) {
        		putToSession(prefix + '.' + key, this[key]);
    		}, obj);
        }

        function getFromSession(key) {
        	if (sessionStorage) {
        		var item = sessionStorage.getItem(key);
        		if (item) {
        			item = JSON.parse(item);
        		}
        		return item;
        	}
        	return null;
        }

        function putToSession(key, val) {
        	if (sessionStorage) {
        		sessionStorage.setItem(key, JSON.stringify(val));
        	}
        	return null;
        }

    }

})();

(function(){
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('uniromaLandingApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                //console.log(dateString);
                //console.log( new Date(dateString[0], dateString[1] - 1, dateString[2].substr(0,2)));
                return new Date(dateString[0], dateString[1] - 1, dateString[2].substr(0,2));
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
        
       

    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .filter('formatRole', formatRole);

    function formatRole() {
        return formatRoleFilter;

        function formatRoleFilter (input) {
        	if (input !== null && input.ruolo !== undefined) {
        		var arr = [];
        		if (input.ruolo) arr.push(input.ruolo);
        		if (input.macroCategoria) arr.push(input.macroCategoria);
        		if (input.categoria) arr.push(input.categoria);
        		if (input.sottoCategoria) arr.push(input.sottoCategoria);
        		if (input.statoSpecifico) arr.push(input.statoSpecifico);
        		return arr.join("-");
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'hy': 'Հայերեն',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'th': 'ไทย',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$rootScope','$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($rootScope, $translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
            $rootScope.$broadcast('languageChange');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('uniromaLandingApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'it',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .filter('orderByStartWithFirst', orderByStartWithFirst);

    function orderByStartWithFirst() {
        return orderByStartWithFirstFilter;

        function orderByStartWithFirstFilter(array, property, q) {
        	var results = array;
    		results.sort(function(a,b) {
    			return (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    		});
        	results = results
            .reduce(function(res, elem) {
            	if (elem && elem[property]) {
                    var idx = elem[property].toLowerCase().indexOf(q.toLowerCase());
                    if(idx === 0) {
                      res[0].push(elem)
                    } else if(idx > 0) {
                      res[1].push(elem)
                    }
            	}
            	return res;   
            },[[],[]]);
        	return results[0].concat(results[1]);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('inputLuogoNascita', inputLuogoNascita);

    function inputLuogoNascita () {
        var directive = {
            restrict: 'E',
            scope: {
    			esterni: '=',
    			updateLuogo: '&'
    		},
    		controller:['$scope','ComuniCodiceFiscaleService', function MyInputController($scope,ComuniCodiceFiscaleService) {
    			//function
    			$scope.getElencoComuni = function(){
    	    		ComuniCodiceFiscaleService.query({}, onSuccess, onError);

    	    		function onSuccess(data, headers) {
    	    			$scope.listaComuni = data;
    	    		}
    	    		function onError(error) {
    	    			AlertService.error(error.data.message);
    	    		}
    	    	}
    			
    	        $scope.appendSiglaProvincia = function(siglaProvincia){
    	        	if(siglaProvincia!=null)
    	        		return " ("+siglaProvincia+")";
    	        	else
    	        		return "";
    	        }
    	        //Action
    	    	$scope.getElencoComuni();
    			
    	    	
    		}],
    		templateUrl: 'app/components/form/input-luogo-nascita.tpl.html'
        };

        return directive;

        
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('personalEmail', personalEmail);

    function personalEmail() {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };
        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.personalEmail = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || validPersonalEmail(modelValue);
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function validPersonalEmail(email) {
            return !endsWith("@uniroma1.it", email.toLowerCase());
        }
    }
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('uniromaLandingApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        //timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('uniromaLandingApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('uniromaLandingApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
            	if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                }
            	else if (httpResponse.headers() && httpResponse.headers("X-cinecaLandingApp-error")) {
                    addErrorAlert(httpResponse.headers("X-cinecaLandingApp-error"));
                } 
                else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('uniromaLandingApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {  //va gestito (o fatto passare) il 302 (controllo Location e ricarico home landing per far scattare shibboleth)
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('uniromaLandingApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector'];

    function authExpiredInterceptor($rootScope, $q, $injector) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "it"');
                $cookies.putObject(name, 'it');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('it');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor'); //al momento fa passare solo 401, va modificato per 302
        $httpProvider.interceptors.push('authExpiredInterceptor'); //gestisce 401
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('uniromaLandingApp')
        .constant('VERSION', "1.141-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', '$stateParams', 'User', 'JhiLanguageService','AnagraficaService','$q'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, $$stateParams, User, JhiLanguageService,AnagraficaService,$q) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_GESTIONE_UTENTI','ROLE_SP_ADD','ROLE_SP_APPROVE'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.enableUser = enableUser;
        vm.disableUser = disableUser;
//        vm.user = entity;
        vm.aggiungiAlias = aggiungiAlias;
        vm.removeAlias = removeAlias;
        vm.mailAliases = [];
        vm.newAliasPosta = null;
        //vm.checkUniqueAlias = checkUniqueAlias;
        
        vm.enabled = null;
        
        
        AnagraficaService.strutturato.getOne({userId : $stateParams.userId},function(user){
        	vm.user = user;
        	if(vm.user.aliasPosta!=null && vm.user.aliasPosta.length>0){
            	vm.mailAliases = vm.user.aliasPosta.split(";");
            }

        });
        
        User.isEnabled({userId : $stateParams.userId},function(abilitatoDto){
        	vm.enabled = abilitatoDto.flAbilitato;
        });

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function enableUser() {
        	User.setEnabled({userId : $stateParams.userId, flAbilitato: true}, function(){ vm.enabled = true; });
        }
        
        function disableUser() {
        	User.setEnabled({userId : $stateParams.userId, flAbilitato: false}, function(){ vm.enabled = false; });
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if(vm.mailAliases!=null && vm.mailAliases.length>1)
            	vm.user.aliasPosta = vm.mailAliases.join(";");
            else if(vm.mailAliases!=null)
            	vm.user.aliasPosta = vm.mailAliases[0];
            AnagraficaService.strutturato.update(vm.user, onSaveSuccess, onSaveError);
            
            
//            if (vm.user.id !== null) {
//                User.update(vm.user, onSaveSuccess, onSaveError);
//            } else {
//                User.save(vm.user, onSaveSuccess, onSaveError);
//            }
        }
        
        function aggiungiAlias(){
        	if(vm.mailAliases.indexOf(vm.newAliasPosta)==-1)
        		vm.mailAliases.push(vm.newAliasPosta);
        	
        	vm.newAliasPosta = null;
        };
        function removeAlias(alias){
        	var index = vm.mailAliases.indexOf(alias);
        	if(index>-1)
        		vm.mailAliases.splice(index,1);
        }
        
        
        /*function checkUniqueAlias(alias) {
        	var isValid = false;
        	var deferred = $q.defer();
        	
        	if(alias==null || alias.length==0)
        		deferred.resolve(true);
        	else{
	        	AnagraficaService.checkUniqueAlias.check(alias, function(resp) {
	        		isValid = resp.isUnique;
	        		if(isValid) {
	        			deferred.resolve(isValid);
	        		}
	        		else {
	        			deferred.reject(false);
	        		}
	        	}, function(err) {
	        			deferred.reject(false);
	        	});
        	}
        	return deferred.promise;
        };*/
        
       
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'AnagraficaService'];

    function UserManagementDetailController($stateParams, AnagraficaService) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.userId);

        function load(userId) {
        	AnagraficaService.strutturato.getOne({userId : $stateParams.userId}, function(result){
        		vm.user = result;
        		if(vm.user.aliasPosta!=null && vm.user.aliasPosta.length>0){
                	vm.mailAliases = vm.user.aliasPosta.split(";");
                }

        	});
           
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_GESTIONE_UTENTI'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.edit', {
            url: '/{userId}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_UTENTI']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
//                    resolve: {
//                        entity: ['AnagraficaService', function(AnagraficaService) {
//                            return AnagraficaService.strutturato.getOne({userId : $stateParams.userId});
//                        }]
//                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{userId}',
            data: {
                authorities: ['ROLE_GESTIONE_UTENTI'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_UTENTI']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService','AnagraficaService','SessionStorage'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService,AnagraficaService,SessionStorage) {
        var vm = this;

        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        
        SessionStorage.init(vm, "UR1L.strutturati", ["nameFilter", "profileFilter"]);
        
        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function loadAll () {
        	if(vm.nameFilter==="")
        		vm.nameFilter = null;
        	if(vm.profileFilter==="")
        		vm.profileFilter = null;
        	
        	SessionStorage.saveAll(vm, "UR1L.strutturati", ["nameFilter", "profileFilter"]);
        	
        	AnagraficaService.strutturati.get({
        		page: pagingParams.page - 1,
        		size: vm.itemsPerPage,
        		sort: sort(),
        		filterName: vm.nameFilter
        	}, onSuccess, onError);

        }

        function onSuccess(data, headers) {
        	var filter = headers('FILTER-filterName');
        	if (filter == vm.nameFilter || (!filter && vm.nameFilter == '') ) {
        		console.log("showing results filtered for: " + filter);
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.users = data;
        	} else {
        		console.log("filtering response not corresponding to actual query");
        	}
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
        	if(vm.nameFilter==="")
        		vm.nameFilter = null;
        	if(vm.profileFilter==="")
        		vm.profileFilter = null;
        	
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                filterName: vm.nameFilter,
                filterRole: vm.profileFilter
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('uniromaLandingApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER','ROLE_SETTINGS'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService','UserContacts', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, UserContacts,$translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        
        //CUSTOM
        vm.email = null;
        vm.telephone = null;
        vm.mobile = null;
        vm.fax = null;
        vm.isStudent = true;
        
        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });
        
        //Get current contacts
       var getUserContacts = function(){
    	   	UserContacts.get({}, function(result, headers) {
    	   		vm.email = result.email;
    	   		vm.telephone = result.telephone;
    	   		vm.mobile = result.mobile;
    	   		vm.fax = result.fax;
    	   		if(result.emailAlias!=null)
    	   			vm.mailAliases = result.emailAlias.split(";");
    	   		vm.isStudent = result.student;
    	   	});
       };

       getUserContacts();
       
       	function emptyToNull(stringa){
       		if(stringa === undefined || (stringa !== null && stringa.length == 0))
       			stringa = null;
       		
       		return stringa;
       	}
       	
       	
        function save () {
        	
        	vm.telephone = emptyToNull(vm.telephone);
        	vm.mobile = emptyToNull(vm.mobile);
        	vm.fax = emptyToNull(vm.fax);
        	vm.email = emptyToNull(vm.email);
        	
        	
        	UserContacts.save({telephone:vm.telephone,mobile:vm.mobile,fax:vm.fax,email:vm.email},function(result, headers) {
        		//Aggiorno solo se il salvataggio è andato a buon fine
        		updateAuth();
            },function(){
            	 vm.success = null;
                 vm.error = 'ERROR';
            });
        	
        	
           
        }
        
        function updateAuth(){
        	vm.settingsAccount.email = vm.email;
        	 Auth.updateAccount(vm.settingsAccount).then(function() {
                 vm.error = null;
                 vm.success = 'OK';
                 Principal.identity(true).then(function(account) {
                     vm.settingsAccount = copyAccount(account);
                 });
                 JhiLanguageService.getCurrent().then(function(current) {
                     if (vm.settingsAccount.langKey !== current) {
                         $translate.use(vm.settingsAccount.langKey);
                     }
                 });
             }).catch(function() {
                 vm.success = null;
                 vm.error = 'ERROR';
             });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'templates/reset-request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$scope', '$timeout', 'Auth', 'vcRecaptchaService', '$window'];

    function RequestResetController ($scope, $timeout, Auth, vcRecaptchaService, $window) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.errorMultipleAccounts = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;
        
    	vm.captchaValidated = null;
    	vm.publicCaptchaKey = $window.G_CAPTCHA_PUB_KEY;
    	
    	$scope.checkStud = function(){
	   		var weight="", zoom="", color="", space="";
			var matrStudMatch=vm.resetAccount.email.match(/^.+\.(\d+)@studenti\.uniroma1\.it$/)
			if (matrStudMatch){
				weight="bold"; zoom="2.5"; color="rgb(92, 73, 39)"; space="nowrap";
				vm.resetAccount.email=matrStudMatch[1];
			} else if (vm.resetAccount.email.match(/^.+\.(\d+)@.*$/)){
				var dom= vm.resetAccount.email.substring(vm.resetAccount.email.indexOf("@"))
				if (dom=="@studenti.uniroma1.it".substring(0,dom.length)){
					weight="bold"; zoom=dom.length>12?"2":"1.5"; color="rgb(102, 81, 44)"; space="nowrap";
				}
			}
			jQuery("#studHighlight").css("fontWeight",weight).css("zoom",zoom).css("color",color).css("whiteSpace",space);
		};
        
        //vm.type = 2;

        $timeout(function (){angular.element('#email').focus();});
		
        function requestReset () {

            vm.error = null;
            vm.success = null;
            vm.captchaValidated = null;
            
        	if(vcRecaptchaService.getResponse() === ""){//Deve validare il ReCaptcha
        		vm.captchaValidated = false;
        	}  
        	else{
        		vm.captchaValidated = true;
            
		        var objRequest = {};
	        	objRequest.mail = vm.resetAccount.email;
		        objRequest['g-recaptcha-response'] = vcRecaptchaService.getResponse();
		
		        Auth.resetPasswordInit(objRequest).then(function () {
		            vm.success = 'OK';
		        }).catch(function (response) {
		            if (response.status === 400 && response.data === 'email address not registered') {
		                vm.error = 'no-account';
		            } 
		            else if (response.status === 400 && response.data === 'private mail not found') {
		                vm.error = 'no-email';
		            }
		            else if (response.status === 400 && response.data === 'no suitable account found') {
		                vm.error = 'no-suitable-account';
		            }
	                else if (response.status === 400 && response.data === 'Found more than one username') {
	                    vm.error = 'multiple-results';
	                }
//	                else if (response.status === 400 && response.data === 'Account inactive') {
//	                    vm.error = 'account-inactive';
//	                }
	                else if (response.status === 400) {
	                    vm.error = response.data;
	                }
		            else {
		                vm.error = 'ERROR';
		            }
		            
		            vcRecaptchaService.reload();
		        });
        	}
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        }).state('finishReset2', {
            parent: 'account',
            url: '/reset/finish/:key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;
        vm.errorPPolicy = null;
        vm.errorPSync = null;
        vm.errorToken = null;
        vm.accounts = null;
        vm.showPassword=[false,false];
        vm.toggleShowPassword=toggleShowPassword;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
        	vm.doNotMatch = null;
            vm.error = null;
            vm.errorPPolicy = null;
            vm.errorPSync = null;
            vm.errorToken = null;
            vm.success = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
            	vm.accounts = null;
            	vm.sending = true;
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function (response) {
                	vm.sending = false;
                    vm.success = 'OK';
                    if (response && response.data) {
                		vm.accounts = response.data.split('<br />');
                	}
                }).catch(function (response) {
                	vm.sending = false;
                	if(response.data === 'IncorrectResetToken')
                		vm.errorToken = true;
                	else if(response.data === 'InvalidPassword')
                		vm.errorPPolicy = 'InvalidPassword';
                	else if(response.data === 'SyncPasswordError')
                		vm.errorPSync = true;
                	else
                		vm.error = 'ERROR';
                });
            }
        }
        
        function toggleShowPassword(index){
        	vm.showPassword[index]=!vm.showPassword[index];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('RegistrationConfirmedController', RegistrationConfirmedController);


    RegistrationConfirmedController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService','Esterni','$stateParams'];

    function RegistrationConfirmedController ($translate, $timeout, Auth, LoginService, Esterni,$stateParams) {
        var vm = this;
        
        vm.success = false;
        
        var token = $stateParams.token;
        Esterni.confirmRegistration({'token':token},function(){
        	vm.success = true;
        });
    }
    
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('esterni');
                    return $translate.refresh();
                }]
            }
        })
        .state('register.confirmed', {
            parent: 'account',
            url: '/confirm-registration/{token}',
            data: {
                authorities: [],
                pageTitle: 'register.confirmed.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/registration-confirmed.html',
                    controller: 'RegistrationConfirmedController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService','Esterni','CodiceFiscaleService','$q','CategorieService','$window'];

    function RegisterController ($translate, $timeout, Auth, LoginService, Esterni,CodiceFiscaleService,$q,CategorieService,$window) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        
        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'email address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
        
        
        /**** Registrazione utente esterno ****/
        
        vm.utenteEsterno = {"fl_attivo":0, "codice_fiscale":null,documento_identita:null};
        vm.genderList = ['M','F'];
        vm.countryList = null;
        vm.savedCodFis = null;
        getCategorieList();
        
        function transformDate(date) {
        	var formatted = pad(date.getDate(), 2) + "/" + pad(date.getMonth() + 1, 2) + "/" + date.getFullYear();
        	return formatted;
        }
        
        function pad(n, width, z) {
        	z = z || '0';
        	n = n + '';
        	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
        
        Esterni.getCountryList({},function(response){
        	vm.countryList = response;
        });
        
        
        vm.createAccount = function(){
        	Esterni.save(vm.utenteEsterno, onSaveFinished, onSaveError);
        };
        
        var onSaveFinished = function (result) {
        	vm.success = true;
        	$window.scrollTo(0, 0);
        };
        
        var onSaveError = function (response) {
        	vm.success = null;
        	var errorType = response.headers('X-uniromaLandingApp-error')
            if (response.status === 400 &&  errorType === 'error.emailexists') {
                vm.errorEmailExists = 'ERROR';
            } else {
                vm.error = 'ERROR';
            }
        	$window.scrollTo(0, 0);
        };
        
        //Verifica che non esista già un esterno con il codice fiscale inserito
        vm.checkUniqueCodiceFiscale = function(codFis,docIdentita) {
        	var reqObject = {
        		codiceFiscale : codFis,
        		documentoIdentita: docIdentita,
        		nazionalita: vm.utenteEsterno.nazionalita
        	};
        	var isValid = false;
        	var deferred = $q.defer();
        	CodiceFiscaleService.checkUniqueCodiceFiscale.check( reqObject, function(resp) {
        		isValid = resp.isUnique;
        		if(isValid) {
        			deferred.resolve(isValid);
        		}
        		//Il codice fiscale esiste perchè è quello dell'utente corrente.
        		else if(vm.savedCodFis != null && vm.savedCodFis === codfis){
        			deferred.resolve(isValid);
        		}
        		else{
        			deferred.reject(false);
        		}
        	}, function(err) {
        			deferred.reject(false);
        	});
        	return deferred.promise;
        };
        
        //Verifica la validità del codice fiscale
        vm.checkCodiceFiscale = function(codfis) {
        	var isValid = false;
        	var deferred = $q.defer();
        	CodiceFiscaleService.checkCodiceFiscale.check( codfis, function(resp) {
        		isValid = resp.isValid;
        		if(isValid) {
        			deferred.resolve(isValid);
        		}
        		else {
        			deferred.reject(false);
        		}
        	}, function(err) {
        			deferred.reject(false);
        	});
        	return deferred.promise;
        };
        
        //Verifica la validità del codice fiscale rispetto alla data di nascita inserita
        vm.checkDateCodiceFiscale = function(dataNascita, codiceFiscale) {
        	var isValid = false;
        	var deferred = $q.defer();
        	var inputDate =  (dataNascita == null ? new Date() : dataNascita);
        	var payload = {
					"dataNascita": transformDate( inputDate ),
					"codiceFiscale" : codiceFiscale
			}; 
        	CodiceFiscaleService.checkDateCodiceFiscale.check( payload, function(resp) {
        	
        		isValid = resp.isValid;
        		if(isValid) {
        			deferred.resolve(isValid);
        		}
        		else {
        			deferred.reject(false);
        		}
        	}, function(err) {
        			deferred.reject(false);
        	});
        	return deferred.promise;
        };
        
        vm.changeStep = function(value){
        	vm.stepConfirmation = value;
            vm.error = null;
            vm.errorUserExists = null;
            vm.errorEmailExists = null;
            vm.success = null;
            vm.checkConsenso = false;
        }
        
        //Verifica la validità del codice fiscale rispetto al genere inserito
        vm.checkGenderCodFiscale = function(gender,codiceFiscale){
        	var isValid = false;
        	var deferred = $q.defer();
        	
        	if(codiceFiscale.length>=10){
        		var giornoNascita = codiceFiscale.substring(9,11);
        		if( (giornoNascita>=40 && gender==='F') || (giornoNascita<40 && gender==='M') ){
        			isValid = true;
        			deferred.resolve(isValid);
        		}
        		else{
        			deferred.reject(false);
        		}
        	}
        	return deferred.promise;
        };
        
        function getCategorieList(){
        	CategorieService.external.get({}, function(resp) {
        		vm.categoryList = resp;
        		for(var i=0;i<resp.length;i++){
        			if(resp[i].sottoCategoria.toUpperCase() === "VISITATORE"){
        				vm.utenteEsterno.categoria = resp[i];
        				break;
        			}
        		}
        	}, function(err) {
        		deferred.reject(false);
        	});
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    //_force = (p.length <= 8) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 30) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password?us_account&idp_ver&idpUrl',
            data: {
            	authorities: [],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal','$stateParams','$http','$timeout','$window'];

    function PasswordController (Auth, Principal,$stateParams,$http,$timeout,$window) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.errorOldPassword = null;
        vm.errorPPolicy = null;
        vm.errorPSync = null;
        vm.us_account=$stateParams.us_account;
        vm.escapeSingleQuote = escapeSingleQuote;
        vm.accounts = null;
        vm.showPassword=[false,false,false];
        vm.toggleShowPassword=toggleShowPassword;

        if(vm.us_account){
        	vm.account = {};
        	getUserName();
        	
        }else{
	        Principal.identity().then(function(account) {
	            vm.account = account;
	        });
        }
        
        function getUserName(){
        	$http.get('api/account/whois',{
        	    params: {us_account: vm.us_account}
        	 }).then(function(result) {
                
        		if(result.status == 200){
        			vm.account = result.data;
        		}
                
            });

        };
        
        function goToAuth(){
        	$window.location.href = 'auth/'; 
        }

        function changePassword () {
            vm.error = null;
            vm.success = null;
            vm.doNotMatch = null;
            vm.errorPPolicy = null;
            vm.errorPSync = null;
            vm.errorOldPassword = null;
            if (vm.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
            	vm.accounts = null;
            	vm.sending = true;
                Auth.changePassword(vm.oldPassword,vm.password,vm.us_account).then(function (response) {
                	vm.sending = false;
                	vm.success = 'OK';
                	if (response && response.data) {
                		vm.accounts = response.data.split('<br />');
                	}
                	//scrolliamo per mostrare i messaggi
                	window.scrollTo(0,0)
                    if($stateParams.us_account!=null){
                    	$timeout(goToAuth, 10000);
                    }
                    
                }).catch(function (response) {
                	vm.sending = false;
                	if(response.data === 'IncorrectOldPassword')
                		vm.errorOldPassword = 'IncorrectOldPassword';
                	else if(response.data === 'InvalidPassword')
                		vm.errorPPolicy = 'InvalidPassword';
                	else if(response.data === 'SyncPasswordError')
                		vm.errorPSync = true;
                	else
                		vm.error = 'ERROR';
                	//scrolliamo per mostrare i messaggi
                	window.scrollTo(0,0)
                });
            }
        }
        
        function toggleShowPassword(index){
        	vm.showPassword[index]=!vm.showPassword[index];
        }
        
        function escapeSingleQuote(stringa){
        	stringa = stringa ? stringa.replace(/'/g, "\\'") : '';
        	return stringa;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('uniromaLandingApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/dashboard/dashboard.html','<div ng-switch="isAuthenticated()"><div ng-switch-when="true"><div class="row"><div class="col-md-12"><h1 translate="dashboard.title">Dashboard</h1><div class="alert alert-success" ng-switch-when="true" translate="main.logged.message" translate-values="{username: \'{{account.login}}\'}">You are logged in as user "{{account.login}}".</div><!-- TABELLA ULTIME 10 ESECUZIONI --><div class="col-md-12" ng-controller="WidgetLast10Ctrl"><div class="panel panel-default panel-uniroma1"><div class="panel-heading-uniroma1"><h3 class="panel-title" translate="dashboard.last10.title" style="padding-top:8px ;float:left">Ultime 10 esecuzioni</h3><button class="btn btn-default pull-right" translate="dashboard.last10.button" ui-sref="scheduledJob">Mostra tutti</button><div class="clearfix"></div></div><table class="table table-striped"><thead><th>#</th><th translate="dashboard.last10.job">Job</th><th translate="dashboard.last10.status">Stato</th><th translate="dashboard.last10.start">Inizio</th><th translate="dashboard.last10.end">Fine</th><th translate="dashboard.last10.new">Nuovi</th><th translate="dashboard.last10.changed">Modificati</th><th translate="dashboard.last10.deleted">Cancellati</th><th translate="dashboard.last10.identical">Identici</th><th translate="dashboard.last10.error">Errori</th></thead><tbody><tr ng-show="scheduledJobs.length == 0"><td colspan="10"><p class="text-center" translate="dashboard.last10.nothing">Nessuna esecuzione</p></td></tr><tr ng-repeat="job in scheduledJobs"><td><a ui-sref="scheduledJob.detail({id:job.id})">{{job.id}}</a></td><td>{{job.jobName}}</td><td><i class="fa fa-lg fa-{{job.status == \'SUCCESS\' ? \'check\' : (job.status == \'ERROR\' ? \'exclamation-circle\' : ( job.status == \'STARTED\' ? \'clock-o\' : \'minus\'))}}" aria-hidden="true" title="{{job.status}}"></i></td><td>{{job.dateStart | date:\'dd-MM-yy HH:mm:ss\'}}</td><td>{{job.dateEnd | date:\'dd-MM-yy HH:mm:ss\'}}</td><td>{{job.newRecords}}</td><td>{{job.changedRecords}}</td><td>{{job.deletedRecords}}</td><td>{{job.identicalRecords}}</td><td>{{job.rejectedRecords}}</td></tr></tbody></table></div></div></div></div><div class="row"><div class="col-md-12"><!-- ULTIMI 5 ERRORI --><div class="col-md-4" ng-controller="WidgetLast5ErrorsCtrl"><div class="panel panel-danger"><div class="panel-heading"><h3 class="panel-title" translate="dashboard.last5Error.title">Ultime 5 esecuzioni in errore</h3></div><table class="table table-striped"><thead><th>#</th><th translate="dashboard.last5Error.job">Job</th></thead><tbody><tr ng-show="scheduledJobs.length == 0"><td colspan="2"><p class="text-center" translate="dashboard.last5Error.nothing">Nessuna esecuzione</p></td></tr><tr ng-repeat="job in scheduledJobs"><td><a ui-sref="scheduledJob.detail({id:job.id})">{{job.id}}</a></td><td>{{job.jobName}}</td></tr></tbody></table></div></div><!-- GRAFICO A BARRE --><div class="col-md-4" ng-controller="BarCtrl"><div class="panel panel-default panel-uniroma1"><div class="panel-heading-uniroma1"><h3 class="panel-title" ng-cloak translate="dashboard.barGraph.title" translate-values="{total: \'{{totals}}\'}">esecuzioni totali</h3></div><div class="panel-body"><p class="text-center" ng-show="data.length == 0" translate="dashboard.barGraph.nothing">Nessuna esecuzione</p><canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-series="series" chart-colors="colours" chart-options="options" ng-show="data.length > 0"></canvas></div></div></div><!-- GRAFICO CIAMBELLA --><div class="col-md-4" ng-controller="DoughnutCtrl"><div class="panel panel-uniroma1"><div class="panel-heading-uniroma1"><h3 class="panel-title" ng-cloak translate="dashboard.doughnutGraph.title">% Esecuzioni</h3></div><div class="panel-body"><p class="text-center" ng-show="data_percent.length == 0" translate="dashboard.doughnutGraph.nothing">Nessuna esecuzione</p><canvas id="doughnut_percent" class="chart chart-doughnut" chart-options="options" chart-data="data_percent" chart-labels="labels_percent" chart-colors="colours_percent" ng-show="data_percent.length > 0"></canvas></div></div></div></div></div></div></div>');
$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><!-- <div class="col-md-4">\r\n            <span class="logo-home img-responsive img-rounded"></span>\r\n        </div>\r\n         --><div class="col-md-12"><!-- <h1 data-translate="home.title">Welcome, Java Hipster!</h1> --><div ng-switch="vm.isAuthenticated()"><!--  \r\n                <div class="alert alert-uniroma1" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.firstName}} {{vm.account.lastName}}\'}">\r\n                    You are logged in as user "{{vm.account.login}}".\r\n                </div>\r\n            --><div ng-switch-when="true"><h1><span data-translate="home.title" translate-values="{username: \'{{vm.escapeSingleQuote(vm.account.firstName)}} {{vm.escapeSingleQuote(vm.account.lastName)}}\' }">Welcome</span> <span style="white-space:nowrap" title="{{vm.account.login.match(\'^\\\\d{8}$\') ? (\'home.idmID\'|translate).replaceAll(\'e\\\'\',\'&egrave;\'): \'\'}}">[{{vm.account.login.match(\'^(i|a)\\\\d{7}$\') ? vm.account.email:vm.account.login}}]</span></h1></div><div ng-switch-when="true" class="margin-top-20 margin-bottom-20" ng-repeat="role in userType.roleList"><ul class="nav nav-pills no-pointer" role="tablist"><li role="presentation" class="active"><span data-translate="global.form.macroCategoria">Macro Categoria</span>: <span class="badge">{{role.macroCategoria}}</span></li><li role="presentation" class="active"><span data-translate="global.form.categoria">Categoria</span>: <span class="badge">{{role.categoria}}</span></li><li role="presentation" class="active"><span data-translate="global.form.sottoCategoria">Sotto Categoria</span>: <span class="badge">{{role.sottoCategoria}}</span></li><li role="presentation" class="active"><span data-translate="global.form.statoSpecifico">Stato Specifico</span>: <span class="badge">{{role.statoSpecifico}}</span></li><li role="presentation" class="active"><span data-translate="global.form.codRuolo">Ruolo</span>: <span class="badge">{{role.ruolo}}</span></li></ul></div><!-- Custom --><div ng-switch-when="true" style="min-height:300px"><div class="col-md-4"><label data-translate="home.section.profileServices">Servizi disponibili per il tuo profilo</label><ul><li ng-repeat="service in userServices | orderBy:\'serviceName\'" ng-if="service.serviceType == \'profile\'" ng-switch="service.url.indexOf(\'/landing\')"><a ng-attr-id="serv_{{service.serviceId}}" ng-switch-default ng-show="service.url" href="{{service.url}}" target="_blank">{{service.serviceName}} <span class="glyphicon glyphicon-new-window"></span></a> <a ng-attr-id="serv_{{service.serviceId}}" ng-switch-when="0" ng-show="service.url" href="{{service.url}}">{{service.serviceName}}</a> <span ng-show="!service.url">{{service.serviceName}}</span></li></ul></div><div class="col-md-4"><label data-translate="home.section.personalServices">Servizi disponibili per il tuo utente</label><ul><li ng-repeat="service in userServices | orderBy:\'serviceName\'" ng-if="service.serviceType == \'user\'" ng-switch="service.url.indexOf(\'/landing\')"><a ng-switch-default ng-show="service.url" href="{{service.url}}" target="_blank">{{service.serviceName}} <span class="glyphicon glyphicon-new-window"></span></a> <a ng-switch-when="0" ng-show="service.url" href="{{service.url}}">{{service.serviceName}}</a> <span ng-show="!service.url">{{service.serviceName}}</span></li></ul></div><div class="col-md-4"><label data-translate="home.section.selfServices">Servizi Self-Service</label><ul><li ng-repeat="service in userServices | orderBy:\'serviceName\'" ng-if="service.serviceType == \'self\'" ng-switch="service.url.indexOf(\'/landing\')"><a ng-switch-default ng-show="service.url" href="{{service.url}}" target="_blank">{{service.serviceName}} <span class="glyphicon glyphicon-new-window"></span></a> <a ng-switch-when="0" ng-show="service.url" href="{{service.url}}">{{service.serviceName}}</a> <span ng-show="!service.url">{{service.serviceName}}</span></li></ul></div></div><div class="alert alert-warning hide" ng-switch-when="false" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div><div class="alert alert-warning hide" ng-switch-when="false" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" ui-sref="register">Register a new account</a></div><div class="" ng-switch-when="false"><p>Non sei autenticato</p><h2><a class="" href="auth/">Accedi</a></h2></div></div></div></div></div>');
$templateCache.put('app/registry/registryEntities.html','<div><h2 translate="uniromaLandingApp.registry.home.title">Registry</h2><jh-alert></jh-alert><!-- TEMPLATE START --><!-- PROVIDER --><script type="text/ng-template" id="providerNodes.html"><div ui-tree-handle class="tree-node tree-node-content" ng-class="{\'selected-node\': selectedNode.id==provider.id&&currentNodeType==\'provider\'}"\r\n\t   ng-init="updateCurrentNode(provider,\'provider\')">\r\n    <a class="btn btn-default btn-xs" ng-if="provider.products && provider.products.length > 0" data-nodrag \r\n\t\tng-click="collapseNode(provider.id,\'provider\',this)"\r\n\t\tng-init="triggerCollapse(provider.id,\'provider\',this)">\r\n\t\t<span class="glyphicon" ng-class="{\'glyphicon-chevron-right\': collapsed,\'glyphicon-chevron-down\': !collapsed}"></span>\r\n\t</a>\r\n    {{provider.code}} <span class="label label-uniroma" translate="uniromaLandingApp.provider.detail.title">Provider</span>\r\n\t\r\n\t<div class="btn-group btn-group-xs pull-right" role="group">\r\n\t\t<a class="btn btn-primary btn-xs" style="margin-right:0px !important;" data-nodrag ng-click="showNodeInfo(provider,\'provider\')"\r\n\t\t\tdata-toggle="tooltip">\r\n\t\t\t<span class="glyphicon glyphicon-pencil"></span>\r\n\t\t</a>\r\n    \t<a class="btn btn-success btn-xs" style="margin-right:0px !important;" data-nodrag ui-sref="product.new({id:provider.id})" style="margin-right: 8px;">\r\n\t\t\t<span class="glyphicon glyphicon-plus"></span>\r\n\t\t</a>\r\n\t\t<a ng-if="provider.products.length==0" class="btn btn-danger btn-xs" style="margin-right:0px !important;" data-nodrag ui-sref="provider.delete({id:provider.id})">\r\n\t\t\t<span class="glyphicon glyphicon-trash"></span>\r\n\t\t</a>\r\n\t</div>    \r\n\r\n\r\n  </div>\r\n  <ol ui-tree-nodes="" ng-model="provider.products" ng-class="{hidden: collapsed}">\r\n    <li ng-repeat="product in provider.products" ui-tree-node ng-include="\'productNodes.html\'" collapsed="true"></li>\r\n  </ol></script><!-- PRODUCT --><script type="text/ng-template" id="productNodes.html"><div ui-tree-handle class="tree-node tree-node-content" ng-class="{\'selected-node\': selectedNode.id==product.id&&currentNodeType==\'product\'}"\r\n\t   ng-init="updateCurrentNode(product,\'product\')">\r\n    <a class="btn btn-default btn-xs" ng-if="product.module && product.module.length > 0" data-nodrag ng-click="collapseNode(product.id,\'product\',this)"><span\r\n        ng-init="triggerCollapse(product.id,\'product\',this)"\r\n\t\tclass="glyphicon"\r\n        ng-class="{\r\n          \'glyphicon-chevron-right\': collapsed,\r\n          \'glyphicon-chevron-down\': !collapsed\r\n        }"></span></a>\r\n    {{product.code}} <span class="label label-default" translate="uniromaLandingApp.product.detail.title">Prodotto</span>\r\n   \t\r\n\t<div class="btn-group btn-group-xs pull-right" role="group">\r\n\t\t<a class="btn btn-primary btn-xs" style="margin-right:0px !important;" data-nodrag \r\n\t\t\tng-click="showNodeInfo(product,\'product\')" data-toggle="tooltip" title="edit">\r\n\t\t\t<span class="glyphicon glyphicon-pencil"></span>\r\n\t\t</a>\r\n    \t<a class="btn btn-success btn-xs" style="margin-right:0px !important;" data-nodrag ui-sref="module.new({id:product.id})">\r\n\t\t\t<span class="glyphicon glyphicon-plus"></span>\r\n\t\t</a>\r\n\t\t<a ng-if="product.module.length==0" class="btn btn-danger btn-xs" style="margin-right:0px !important;" data-nodrag ui-sref="product.delete({id:product.id})">\r\n\t\t\t<span class="glyphicon glyphicon-trash"></span>\r\n\t\t</a>\r\n\t</div>\r\n\t\r\n  </div>\r\n  <ol ui-tree-nodes="" ng-model="product.module" ng-class="{hidden: collapsed}">\r\n    <li ng-repeat="module in product.module" ui-tree-node ng-include="\'moduleNodes.html\'" collapsed="true">\r\n    </li>\r\n  </ol></script><!-- MODULE --><script type="text/ng-template" id="moduleNodes.html"><div ui-tree-handle class="tree-node tree-node-content" ng-class="{\'selected-node\': selectedNode.id==module.id&&currentNodeType==\'module\'}"\r\n\t ng-init="updateCurrentNode(module,\'module\')">\r\n    <a class="btn btn-default btn-xs" ng-if="module.services && module.services.length > 0" data-nodrag ng-click="collapseNode(module.id,\'module\',this)"><span\r\n        ng-init="triggerCollapse(module.id,\'module\',this)"\r\n\t\tclass="glyphicon"\r\n        ng-class="{\r\n          \'glyphicon-chevron-right\': collapsed,\r\n          \'glyphicon-chevron-down\': !collapsed\r\n        }"></span></a>\r\n    {{module.code}} <span class="label label-primary" translate="uniromaLandingApp.module.detail.title">Modulo</span>\r\n   \t\r\n\t<div class="btn-group btn-group-xs pull-right" role="group">\r\n\t\t<a class="btn btn-primary btn-xs" style="margin-right:0px !important;" data-nodrag ng-click="showNodeInfo(module,\'module\')" style="margin-right: 8px;">\r\n\t\t\t<span class="glyphicon glyphicon-pencil"></span>\r\n\t\t</a>\r\n    \t<a class="btn btn-success btn-xs" style="margin-right:0px !important;" data-nodrag ui-sref="service.new({id:module.id})" style="margin-right: 8px;">\r\n\t\t\t<span class="glyphicon glyphicon-plus"></span>\r\n\t\t</a>\r\n\t\t<a ng-if="module.services.length==0" class="btn btn-danger btn-xs" style="margin-right:0px !important;" data-nodrag ui-sref="module.delete({id:module.id})">\r\n\t\t\t<span class="glyphicon glyphicon-trash"></span>\r\n\t\t</a>\r\n\t</div>\r\n\t\r\n  </div>\r\n  <ol ui-tree-nodes="" ng-model="module.services" ng-class="{hidden: collapsed}">\r\n    <li ng-repeat="service in module.services" ui-tree-node ng-include="\'serviceNode.html\'" collapsed="true">\r\n    </li>\r\n  </ol></script><!-- SERVICE --><script type="text/ng-template" id="serviceNode.html"><div ui-tree-handle class="tree-node tree-node-content" ng-class="{\'selected-node\': selectedNode.id==service.id&&currentNodeType==\'service\'}" \r\n\t ng-init="updateCurrentNode(service,\'service\')">\r\n    {{service.code}} <span class="label label-info" translate="uniromaLandingApp.service.detail.title">Servizio</span>\r\n   \t\r\n\t<div class="btn-group btn-group-xs pull-right" role="group">\r\n\t\t<a class="btn btn-primary btn-xs" style="margin-right:0px !important;" data-nodrag ng-click="showNodeInfo(service,\'service\')" style="margin-right: 8px;">\r\n\t\t\t<span class="glyphicon glyphicon-pencil"></span>\r\n\t\t</a>\r\n\t\t<a ng-if="!service.cantDelete" class="btn btn-danger btn-xs" style="margin-right:0px !important;" data-nodrag ui-sref="service.delete({id:service.id})">\r\n\t\t\t<span class="glyphicon glyphicon-trash"></span>\r\n\t\t</a>\r\n\t</div>\r\n  </div></script><!-- TEMPLATE END --><div class="row"><div class="col-sm-12"><button class="btn btn-uniroma btn-sm" ui-sref="provider.new()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down" translate="uniromaLandingApp.provider.home.createLabel">New Provider</span></button> <button class="btn btn-default btn-sm" ng-click="expandAll()"><span class="glyphicon glyphicon-chevron-down"></span> <span class="hidden-sm-down" translate="uniromaLandingApp.registry.home.lb_expandAll">Expand all</span></button> <button class="btn btn-default btn-sm" ng-click="collapseAll()"><span class="glyphicon glyphicon-chevron-up"></span> <span class="hidden-sm-down" translate="uniromaLandingApp.registry.home.lb_collapseAll">Collapse all</span></button></div></div><div class="row"><div class="col-sm-5"><div ui-tree id="tree-root" data-drag-enabled="false"><ol ui-tree-nodes ng-model="data"><li ng-repeat="provider in data" ui-tree-node ng-include="\'providerNodes.html\'" collapsed="true"></li></ol></div></div><div class="col-sm-7 details" ng-if="currentNodeType!=null"><!-- PROVIDER INFO --><div ng-if="currentNodeType==\'provider\'"><div class="col-sm-3"><h4 translate="uniromaLandingApp.registry.home.lb_details">Dettagli</h4></div><table class="jh-table table table-striped"><thead><tr><th><span data-translate="uniromaLandingApp.provider.code">Code</span></th></tr></thead><tbody><tr><td>{{selectedNode.code}}</td><td><a class="pull-right btn btn-primary btn-xs" data-nodrag ui-sref="provider.edit({id:selectedNode.id})" style="margin-right: 8px"><span class="glyphicon glyphicon-pencil"></span></a></td></tr></tbody></table></div><!-- PRODUCT --><div ng-if="currentNodeType==\'product\'"><div class="col-sm-3"><h4 translate="uniromaLandingApp.registry.home.lb_details">Dettagli</h4></div><table class="jh-table table table-striped"><thead><tr><th><span data-translate="uniromaLandingApp.product.version">Version</span></th><th><span data-translate="uniromaLandingApp.product.code">Code</span></th><th><span data-translate="uniromaLandingApp.product.base_url">BaseURL</span></th><th></th></tr></thead><tbody><tr><td>{{selectedNode.version}}</td><td>{{selectedNode.code}}</td><td>{{selectedNode.base_url}}</td><td><a class="pull-right btn btn-primary btn-xs" data-nodrag ui-sref="product.edit({id:selectedNode.id})" style="margin-right: 8px"><span class="glyphicon glyphicon-pencil"></span></a></td></tr></tbody></table></div><!-- MODULE --><div ng-if="currentNodeType==\'module\'"><div class="col-sm-3"><h4 translate="uniromaLandingApp.registry.home.lb_details">Dettagli</h4></div><table class="jh-table table table-striped"><thead><tr><th><span data-translate="uniromaLandingApp.module.version">Version</span></th><th><span data-translate="uniromaLandingApp.module.code">Code</span></th><th></th></tr></thead><tbody><tr><td>{{selectedNode.version}}</td><td>{{selectedNode.code}}</td><td><a class="pull-right btn btn-primary btn-xs" data-nodrag ui-sref="module.edit({id:selectedNode.id,product_id:2})" style="margin-right: 8px"><span class="glyphicon glyphicon-pencil"></span></a></td></tr></tbody></table></div><!-- SERVICE --><div ng-if="currentNodeType==\'service\'"><div class="col-sm-3"><h4 translate="uniromaLandingApp.registry.home.lb_details">Dettagli</h4></div><table class="jh-table table table-striped"><thead><tr><th><span data-translate="uniromaLandingApp.service.profile">Profile</span></th><th><span data-translate="uniromaLandingApp.service.code">Code</span></th><th><span data-translate="uniromaLandingApp.service.entityId">EntityId</span></th><th></th></tr></thead><tbody><tr><td>{{selectedNode.profile}}</td><td>{{selectedNode.code}}</td><td>{{selectedNode.entityId}}</td><td><a class="pull-right btn btn-primary btn-xs" data-nodrag ui-sref="service.edit({id:selectedNode.id})" style="margin-right: 8px"><span class="glyphicon glyphicon-pencil"></span></a></td></tr></tbody></table></div><!-- GENERAL --><br><div ng-if="selectedNode!=null && selectedNode.translations!=null"><div class="col-sm-3"><h4 translate="uniromaLandingApp.registry.home.lb_translation">Traduzioni</h4></div><div class="col-sm-9"><button class="pull-right btn btn-uniroma btn-sm" ng-click="newTranslation(translation)" style="margin-right: 8px; margin-top:4px"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.service_tr.home.createLabel"></span></button></div><table class="jh-table table table-striped"><thead><tr><th class="col-md-1"><span data-translate="uniromaLandingApp.provider_tr.field">Field</span></th><th class="col-md-7"><span data-translate="uniromaLandingApp.provider_tr.value">Value</span></th><th class="col-md-1"><span data-translate="uniromaLandingApp.provider_tr.language">Language</span></th><th class="col-md-1"></th></tr></thead><tbody><tr ng-repeat="translation in selectedNode.translations"><td>{{translation.field}}</td><td>{{translation.value}}</td><td>{{translation.language}}</td><td><div class="btn-group btn-group-xs pull-right" role="group"><a class="btn btn-primary btn-xs" data-nodrag ng-click="editTranslation(translation)"><span class="glyphicon glyphicon-pencil"></span> </a><a class="btn btn-danger btn-xs" data-nodrag ng-click="deleteTranslation(translation)"><span class="glyphicon glyphicon-trash"></span></a></div></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-10 col-md-offset-1"><h2 data-translate="password.title" translate-values="{username: \'{{vm.escapeSingleQuote(vm.account.firstName)}} {{vm.escapeSingleQuote(vm.account.lastName)}} [{{vm.account.login}}]\' }">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong data-translate="password.messages.success">Password changed!</strong><p ng-if="vm.accounts"><span data-translate="global.messages.affectedAccounts" translate-compile></span></p><div ng-repeat="account in vm.accounts"><span>{{account}}</span></div><p></p></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.errorOldPassword" data-translate="password.messages.errorOldPassword"><strong>An error has occurred!</strong> The old password is wrong.</div><div class="alert alert-danger" ng-show="vm.errorPPolicy" data-translate="password.messages.errorPPolicy"><strong>An error has occurred!</strong> The password does not meet the password policy requirements.</div><div class="alert alert-danger" ng-show="vm.errorPSync" data-translate="password.messages.errorPSync"><strong>An error has occurred!</strong> Unable to sync password.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div class="alert alert-info" data-translate="global.messages.info.passwordRules">La password deve essere complessa. Immettere una password che soddisfi tutti i criteri specificati di seguito.<ul><li>la password deve essere di almeno 8 caratteri</li><li>non pu&ograve; essere una delle ultime 24 password utilizzate</li><li>non pu&ograve; un gruppo di 3 caratteri consecutivi contenuti nel nome account, n&egrave; nei propri nome e cognome</li><li>deve contenere almeno 3 dei seguenti gruppi di caratteri:<ul><li>caratteri dell\'alfabeto inglese maiuscoli (A-Z)</li><li>caratteri dell\'alfabeto inglese minuscoli (a-z)</li><li>numeri (0-9)</li><li>caratteri non alfabetici (ad esempio,!,@,^,?,+,$,#,%)</li></ul></li></ul>La password pu&ograve; essere cambiata una sola volta al giorno.<br>Un account bloccato torna utilizzabile dopo 10 minuti. In questo caso non &egrave; necessario cambiare la password.</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation ng-hide="vm.success==\'OK\'"><div class="form-group"><label class="control-label" for="oldPassword" data-translate="global.form.oldpassword">Old password</label><div ng-click="vm.toggleShowPassword(0)" ng-class="\'glyphicon pass-eye-\'+(vm.showPassword[0] ? \'open\' : \'close\')" ng-attr-title="{{(\'global.form.\'+(vm.showPassword[0]?\'hide\':\'show\')|translate)+(\'global.form.oldpassword\'|translate|lowercase)}}"></div><input ng-attr-type="{{ vm.showPassword[0] ? \'text\' : \'password\' }}" class="form-control" id="oldPassword" name="oldPassword" placeholder="{{\'global.form.oldpassword.placeholder\' | translate}}" ng-model="vm.oldPassword" required><div ng-show="form.oldPassword.$dirty && form.oldPassword.$invalid"><p class="help-block" ng-show="form.oldPassword.$error.required" data-translate="global.messages.validate.oldpassword.required">Your old password is required.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><div ng-click="vm.toggleShowPassword(1)" ng-class="\'glyphicon pass-eye-\'+(vm.showPassword[1] ? \'open\' : \'close\')" ng-attr-title="{{(\'global.form.\'+(vm.showPassword[1]?\'hide\':\'show\')|translate)+(\'global.form.newpassword\'|translate|lowercase)}}"></div><input ng-attr-type="{{ vm.showPassword[1] ? \'text\' : \'password\' }}" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="8" ng-maxlength="50" ng-model-options="{allowInvalid: true}" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 8 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><div ng-click="vm.toggleShowPassword(2)" ng-class="\'glyphicon pass-eye-\'+(vm.showPassword[2] ? \'open\' : \'close\')" ng-attr-title="{{(\'global.form.\'+(vm.showPassword[2]?\'hide\':\'show\')|translate)+(\'global.form.confirmpassword\'|translate|lowercase)}}"></div><input ng-attr-type="{{ vm.showPassword[2] ? \'text\' : \'password\' }}" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid || vm.sending" class="btn btn-uniroma" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-10 col-md-offset-1"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-10 col-md-offset-1"><form ng-disabled="vm.success" name="registerForm" role="form" novalidate ng-submit="vm.createAccount()" show-validation><fieldset ng-disabled="vm.success||vm.stepConfirmation"><!-- CATEGORIA --><div class="row"><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.categoria" for="field_categoria">categoria</label>*<select class="form-control" name="categoria" id="field_categoria" ng-model="vm.utenteEsterno.categoria.id" ng-required="true" ng-options="categoria.id as categoria.sottoCategoria for categoria in vm.categoryList"></select><div ng-show="registerForm.genere.$invalid && !registerForm.genere.$pristine"><p class="help-block" ng-show="registerForm.genere.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><!-- TITOLO --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.titolo" for="field_titolo">titolo</label><input type="text" class="form-control" name="titolo" id="field_titolo" ng-model="vm.utenteEsterno.titolo"></div><!-- NOME --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.nome" for="field_nome">Nome</label>* <input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.utenteEsterno.nome" required><div ng-show="registerForm.nome.$invalid && !registerForm.nome.$pristine"><p class="help-block" ng-show="registerForm.nome.$error.required" translate="entity.validation.required">This field is required.</p></div></div><!-- SECONDO NOME --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.middleName" for="field_middleName">MiddleName</label><input type="text" class="form-control" name="middleName" id="field_middleName" ng-model="vm.utenteEsterno.middleName"></div><!-- COGNOME --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.cognome" for="field_cognome">Cognome</label>* <input type="text" class="form-control" name="cognome" id="field_cognome" ng-model="vm.utenteEsterno.cognome" required><div ng-show="registerForm.cognome.$invalid && !registerForm.cognome.$pristine"><p class="help-block" ng-show="registerForm.cognome.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><!-- GENERE --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.genere" for="field_genere">genere</label>*<select class="form-control" name="genere" id="field_genere" ng-model="vm.utenteEsterno.genere" ng-required="true" ng-options="gender for gender in vm.genderList"></select><div ng-show="registerForm.genere.$invalid && !registerForm.genere.$pristine"><p class="help-block" ng-show="registerForm.genere.$error.required" translate="entity.validation.required">This field is required.</p></div></div><!-- DATA DI NASCITA --><div class="form-group col-md-12" ng-class="{\'has-error\' : registerForm.dtNascita.$invalid && registerForm.dtNascita.$dirty, \'has-feedback\' :  registerForm.dtNascita.$invalid &&  registerForm.dtNascita.$dirty }"><label translate="uniromaLandingApp.esterni.dtNascita" for="field_dtNascita">DtNascita</label>* <input type="date" datepicker-popup="{{format}}" show-button-bar="false" name="dtNascita" class="form-control" placeholder="{{format}}" ng-model="vm.utenteEsterno.dataNascita" ng-required="true" is-open="open" ng-click="open = true" datepicker-localdate><div ng-show="registerForm.dtNascita.$invalid && !registerForm.dtNascita.$pristine"><p class="help-block" ng-show="registerForm.dtNascita.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="registerForm.dtNascita.$dirty &&  registerForm.dtNascita.$invalid" translate="entity.validation.invalidDate">Format not valid.</p></div></div><!-- LUOGO DI NASCITA --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.luogoNascita" for="field_luogoNascita">luogoNascita</label>* <input type="text" class="form-control" name="luogoNascita" id="field_luogoNascita" ng-model="vm.utenteEsterno.luogoNascita" required><div ng-show="registerForm.luogoNascita.$invalid && !registerForm.luogoNascita.$pristine"><p class="help-block" ng-show="registerForm.luogoNascita.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><!-- NAZIONALITA/CITTADINANZA --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.nazionalita" for="field_nazionalita">nazionalita</label>*<!-- \r\n\t\t            <input type="text" class="form-control" name="nazionalita" id="field_nazionalita"\r\n\t\t                    ng-model="vm.utenteEsterno.nazionalita" ng-maxlength=5\r\n\t\t                    required>\r\n\t\t             --><select class="form-control" name="nazionalita" id="field_nazionalita" ng-model="vm.utenteEsterno.nazionalita" ng-required="true" ng-options="country.nome as country.codice for country in vm.countryList" ng-change="vm.utenteEsterno.codiceFiscale=null;vm.utenteEsterno.documentoIdentita=null;"></select><div ng-show="registerForm.nazionalita.$invalid && !registerForm.nazionalita.$pristine"><p class="help-block" ng-show="registerForm.nazionalita.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="registerForm.nazionalita.$error.maxlength" data-translate="entity.validation.maxlength" translate-values="{ max: 5}">max 5 chars.</p></div></div><!-- CODICE FISCALE --><div ng-if="vm.utenteEsterno.nazionalita && vm.utenteEsterno.nazionalita==\'IT\'" class="form-group col-md-12" ng-class="{\'has-error\' : registerForm.codFis.$invalid &&  registerForm.codFis.$dirty, \'has-feedback\' :  registerForm.codFis.$invalid &&  registerForm.codFis.$dirty}"><label translate="uniromaLandingApp.esterni.codFis" for="field_codFis">CodFis</label>* <input type="text" class="form-control" name="codFis" id="field_codFis" ng-model="vm.utenteEsterno.codiceFiscale" ui-validate="{validCodfis: \'registerForm.codFis.$pristine || vm.checkCodiceFiscale($modelValue)\', \r\n\t                    \t\t\t\t\tgenderCodfis: \'registerForm.codFis.$pristine || vm.checkGenderCodFiscale(vm.utenteEsterno.genere,$modelValue)\',\r\n                    \t\t\t\t\t\tdateCodFis: \'registerForm.codFis.$pristine || vm.checkDateCodiceFiscale(vm.utenteEsterno.dataNascita, $modelValue)\',\r\n                    \t\t\t\t\t\tuniqueCodFis: \'registerForm.codFis.$pristine || vm.checkUniqueCodiceFiscale($modelValue,null)\'}" ui-validate-watch=" [\'vm.utenteEsterno.dataNascita\',\'vm.utenteEsterno.genere\'] " ng-model-options="{ debounce: 400 }" ng-required="true" required><div ng-show="registerForm.codFis.$invalid && !registerForm.codFis.$pristine"><p class="help-block" ng-show="registerForm.codFis.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="registerForm.codFis.$error.validCodfis" translate="entity.validation.invalidCodFis">Il codice fiscale non &amp; valido</p><p class="help-block" ng-show="registerForm.codFis.$error.genderCodfis" translate="entity.validation.genderCodFis">entity.validation.genderCodFis</p><p class="help-block" ng-show="registerForm.codFis.$error.dateCodFis" translate="entity.validation.dateCodFis">Il codice fiscale non rispecchia la data di nascita inserita.</p><p class="help-block" ng-show="registerForm.codFis.$error.uniqueCodFis" translate="entity.validation.uniqueCodFis">Il codice fiscale inserito &egrave; gi&agrave; presente tra le anagrafiche.</p><!-- p class="help-block"\r\n\t\t                    ng-show="registerForm.codFis.$error.codComuneCodFis" translate="entity.validation.codComuneCodFis">\r\n\t\t                    Il codice fiscale non rispecchia il comune di nascita inserito.\r\n\t\t                </p --></div></div><!-- DOCUMENTO IDENTITA\' --><div ng-if="vm.utenteEsterno.nazionalita && vm.utenteEsterno.nazionalita!==\'IT\'" class="form-group col-md-12" ng-class="{\'has-error\' : registerForm.codFis.$invalid &&  registerForm.codFis.$dirty, \'has-feedback\' :  registerForm.codFis.$invalid &&  registerForm.codFis.$dirty}"><label translate="uniromaLandingApp.esterni.docIdentita" for="field_documentoIdentita">docIdentita</label>* <input type="text" class="form-control" name="documentoIdentita" id="field_documentoIdentita" ng-model="vm.utenteEsterno.documentoIdentita" ui-validate="{uniqueCodFis: \'registerForm.codFis.$pristine || vm.checkUniqueCodiceFiscale(null, $modelValue)\'}" required><div ng-show="registerForm.documentoIdentita.$invalid && !registerForm.documentoIdentita.$pristine"><p class="help-block" ng-show="registerForm.documentoIdentita.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="registerForm.documentoIdentita.$error.uniqueCodFis" translate="entity.validation.uniqueDocIdentita">Il codice fiscale inserito &egrave; gi&agrave; presente tra le anagrafiche.</p></div></div></div><div class="row"><!-- EMAIL PRIVATA --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.emailPrivata" for="field_emailPrivata">emailPrivata</label>* <input type="email" class="form-control" name="emailPrivata" id="field_emailPrivata" ng-model="vm.utenteEsterno.emailPrivata" required><div ng-show="registerForm.emailPrivata.$invalid && !registerForm.emailPrivata.$pristine"><p class="help-block" ng-show="registerForm.emailPrivata.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="registerForm.emailPrivata.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><!-- TELEFONO CELLULARE PRIVATO --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.mobilePrivato" for="field_mobilePrivato">mobilePrivato</label><input type="text" class="form-control" name="mobilePrivato" id="field_mobilePrivato" ng-model="vm.utenteEsterno.mobilePrivato"></div></div><div class="row"><!-- TELEFONO FISSO PRIVATO --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.telefonoPrivato" for="field_telefonoPrivato">telefonoPrivato</label><input type="text" class="form-control" name="telefonoPrivato" id="field_telefonoPrivato" ng-model="vm.utenteEsterno.telefonoPrivato"></div><!-- FAX PRIVATO --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.faxPrivato" for="field_faxPrivato">faxPrivato</label><input type="text" class="form-control" name="faxPrivato" id="field_faxPrivato" ng-model="vm.utenteEsterno.faxPrivato"></div></div></fieldset><!-- CONSENSO --><div class="row" ng-if="vm.stepConfirmation"><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.consenso.label" for="field_consenso">Consenso</label><textarea class="form-control" name="consenso" id="field_consenso" style="height:200px" disabled="disabled">{{\'uniromaLandingApp.esterni.consenso.content\' | translate}}\r\n\t\t\t\t\t</textarea></div><div class="form-group col-md-12"><input type="checkbox" name="checkConsenso" id="field_checkConsenso" ng-model="vm.checkConsenso"><label translate="uniromaLandingApp.esterni.consenso.check" for="field_checkConsenso">Consenso</label></div></div><div><!-- Indietro --> <button type="button" ng-click="vm.changeStep(false)" class="btn btn-uniroma" ng-disabled="(registerForm.$invalid && registerForm.$dirty) || registerForm.$pristine" ng-if="vm.stepConfirmation"><i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;<span translate="register.form.bt_back">Indietro</span></button><!-- Avanti --> <button type="button" ng-click="vm.changeStep(true)" class="btn btn-uniroma pull-right" ng-disabled="(registerForm.$invalid && registerForm.$dirty) || registerForm.$pristine" ng-if="!vm.stepConfirmation"><i class="fa fa-arrow-right" aria-hidden="true"></i>&nbsp;<span translate="register.form.bt_proceed">Avanti</span></button><!-- Conferma --> <button type="submit" ng-disabled="(registerForm.$invalid && registerForm.$dirty) || registerForm.$pristine || !vm.checkConsenso" class="btn btn-uniroma pull-right" ng-if="vm.stepConfirmation"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;<span translate="register.form.bt_save">Salva</span></button></div></form></div></div></div>');
$templateCache.put('app/account/register/registration-confirmed.html','<div><div class="row"><div class="col-md-10 col-md-offset-1"><h1 data-translate="register.confirmed.title">Registration confirmed</h1><jhi-alert-error></jhi-alert-error><div ng-if="vm.success" class="alert alert-success" data-translate="register.confirmed.message">success</div></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2 data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-10 col-md-offset-1"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.firstName}} {{vm.settingsAccount.lastName}} - {{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><div class="alert alert-warning" ng-show="!vm.email" data-translate="settings.messages.noPersonalMail">Per procedere &egrave; necessario inserire un indirizzo di mail privata che potr&agrave; essere utilizzato, se necessario, per reimpostare autonomamente la password.</div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50" disabled="disabled"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50" disabled="disabled"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><!--                 <div class="form-group"> --><!--                     <label for="langKey" data-translate="settings.form.language">Language</label> --><!--                     <select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select> --><!--                 </div> --><!-- CUSTOM --><div><hr><h3 data-translate="settings.contact.title">Contacts settings</h3></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.emailPersonale">Email</label>* <input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.email" ng-minlength="5" ng-maxlength="100" required personal-email maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.personalEmail" data-translate="global.messages.validate.email.invalidPersonalEmail">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group" ng-if="!vm.isStudent"><label class="control-label" for="telephone" data-translate="global.form.telephone">Telephone</label><input type="text" class="form-control" id="telephone" name="telephone" placeholder="{{\'global.form.telephone.placeholder\' | translate}}" ng-model="vm.telephone"></div><div class="form-group" ng-if="!vm.isStudent"><label class="control-label" for="fax" data-translate="global.form.fax">Fax</label><input type="text" class="form-control" id="fax" name="fax" placeholder="{{\'global.form.fax.placeholder\' | translate}}" ng-model="vm.fax"></div><div class="form-group" ng-if="!vm.isStudent"><label class="control-label" for="mobile" data-translate="global.form.mobile">Mobile</label><input type="text" class="form-control" id="mobile" name="mobile" placeholder="{{\'global.form.mobile.placeholder\' | translate}}" ng-model="vm.mobile"></div><div class="form-group" ng-if="vm.mailAliases.length>0" ng-if="!vm.isStudent"><label class="control-label" data-translate="global.form.aliasPosta">alias posta</label><ul><li ng-repeat="alias in vm.mailAliases | orderBy:\'alias\'">{{alias}}</li></ul><!-- \r\n\t\t\t\t\t<table class="table table-striped">\r\n\t\t\t\t\t\t<thead>\r\n\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t<th translate="global.form.aliasPosta">Alias</th>\r\n\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t</thead>\r\n\t\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t\t<tr ng-repeat="alias in vm.mailAliases | orderBy:\'alias\'">\r\n\t\t\t\t\t\t\t\t<td>{{alias}}</td>\r\n\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t</tbody>\r\n\t\t\t\t\t</table>\r\n\t\t\t\t\t --></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-uniroma" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.nome}} {{vm.user.cognome}}</b>]</h2><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span data-translate="userManagement.userId">username</span></td><td>{{vm.user.userId}}<span ng-if="vm.user.flDeleted">&nbsp;<span class="label label-warning" data-translate="global.form.cessato">cessato</span></span></td></tr><tr><td><span data-translate="userManagement.firstName">First Name</span></td><td>{{vm.user.nome}}</td></tr><tr><td><span data-translate="userManagement.lastName">last Name</span></td><td>{{vm.user.cognome}}</td></tr><tr><td><span data-translate="userManagement.codiceFiscale">codice Fiscale</span></td><td>{{vm.user.codiceFiscale}}</td></tr><tr><td><span data-translate="userManagement.email">email</span></td><td>{{vm.user.emailPrivata}}</td></tr><tr ng-if="vm.user.email"><td><span data-translate="userManagement.email2">email</span></td><td>{{vm.user.email}}</td></tr><tr ng-if="vm.user.emailStudenti"><td><span data-translate="userManagement.emailStudenti">email Studenti</span></td><td>{{vm.user.emailStudenti}}</td></tr><tr ng-if="vm.user.matricolaStudente"><td><span data-translate="userManagement.matricolaStudente">matricola Studente</span></td><td>{{vm.user.matricolaStudente}}</td></tr><tr><td><span data-translate="global.form.telephone">telephone</span></td><td>{{vm.user.telefonoPrivato}}</td></tr><tr><td><span data-translate="global.form.mobile">mobile</span></td><td>{{vm.user.cellularePrivato}}</td></tr><tr><td><span data-translate="global.form.fax">fax</span></td><td>{{vm.user.faxPrivato}}</td></tr><tr><td><span data-translate="global.form.aliasPosta">alias</span></td><td><ul><li ng-repeat="alias in vm.mailAliases | orderBy:\'alias\'">{{alias}}</li></ul></td></tr><tr><td><span data-translate="global.form.statoAggregato">statoAggregato</span></td><td>{{vm.user.statoAggregato}}</td></tr><tr ng-if="!vm.user.roleList || vm.user.roleList.length === 0"><td><span data-translate="global.form.categoria">categoria</span></td><td>{{vm.user.categoria}}</td></tr><tr ng-if="!vm.user.roleList || vm.user.roleList.length === 0"><td><span data-translate="global.form.macroCategoria">macroCategoria</span></td><td>{{vm.user.macroCategoria}}</td></tr><tr ng-if="!vm.user.roleList || vm.user.roleList.length === 0"><td><span data-translate="global.form.sottoCategoria">sottoCategoria</span></td><td>{{vm.user.sottoCategoria}}</td></tr><tr ng-if="!vm.user.roleList || vm.user.roleList.length === 0"><td><span data-translate="global.form.statoSpecifico">statoSpecifico</span></td><td>{{vm.user.statoSpecifico}}</td></tr><tr ng-if="!vm.user.roleList || vm.user.roleList.length === 0"><td><span data-translate="global.form.codRuolo">codRuolo</span></td><td>{{vm.user.codRuolo}}</td></tr><tr><td><span data-translate="global.form.affOrg">affOrg</span></td><td>{{vm.user.affOrg}}</td></tr><tr><td><span data-translate="global.form.affDida">affDida</span></td><td>{{vm.user.affDida}}</td></tr><tr><td><span data-translate="global.form.affSede">affSede</span></td><td>{{vm.user.affSede}}</td></tr></tbody></table><h5>Ruoli</h5><div class="table-responsive"><table class="jh-table table table-striped"><tbody><tr ng-repeat="role in vm.user.roleList"><td><b>ruolo: </b>{{role.ruolo}}<br><b>macro-categoria: </b>{{role.macroCategoria}}<br><b>categoria: </b>{{role.categoria}}<br><b>sotto-categoria: </b>{{role.sottoCategoria}}<br><b>stato specifico: </b>{{role.statoSpecifico}}<br><b>macro-stato: </b>{{role.macroStato}}<br><b>decorrenza: </b>{{role.decorrenza | date:\'shortDate\'}} ({{role.giorniDaDecorrenza}} giorni)<br></td></tr></tbody></table></div><!-- \r\n        <dt><span data-translate="userManagement.profiles">Profiles</span></dt>\r\n        <dd>\r\n            <ul class="list-unstyled">\r\n                <li ng-repeat="authority in vm.user.authorities">\r\n                    <span class="label label-uniroma">{{authority}}</span>\r\n                </li>\r\n            </ul>\r\n        </dd>\r\n         --> <button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.editLabel" translate-values="{nome: \'{{vm.user.nome}} {{vm.user.cognome}}\'}">edit user</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="userManagement.userId">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.userId" disabled="disabled"></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.nome" disabled="disabled"></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.cognome" disabled="disabled"></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.emailPersonale">Email</label>* <input type="email" class="form-control" id="email" name="email" placeholder="{{\'userManagement.emailPlaceHolder\' | translate}}" ng-model="vm.user.emailPrivata" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="telephone" data-translate="global.form.telephone">Telephone</label><input type="text" class="form-control" id="telephone" name="telephone" placeholder="{{\'userManagement.telefonoPlaceHolder\' | translate}}" ng-model="vm.user.telefonoPrivato"></div><div class="form-group"><label class="control-label" for="fax" data-translate="global.form.fax">Fax</label><input type="text" class="form-control" id="fax" name="fax" placeholder="{{\'userManagement.faxPlaceHolder\' | translate}}" ng-model="vm.user.faxPrivato"></div><div class="form-group"><label class="control-label" for="mobile" data-translate="global.form.mobile">Mobile</label><input type="text" class="form-control" id="mobile" name="mobile" placeholder="{{\'userManagement.cellularePlaceHolder\' | translate}}" ng-model="vm.user.cellularePrivato"></div><!-- ALIAS --><div class="form-group"><label class="control-label" for="alias" data-translate="global.form.aliasPosta">alias posta</label><div class="input-group"><input type="email" class="form-control" id="alias" name="alias" placeholder="{{\'userManagement.aliasPlaceHolder\' | translate}}" ng-model="vm.newAliasPosta"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-click="vm.aggiungiAlias()" data-translate="entity.action.add" ng-disabled="editForm.alias.$invalid">Aggiungi</button></span></div><div ng-show="editForm.alias.$invalid && !editForm.alias.$pristine"><p class="help-block" ng-show="editForm.alias.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="editForm.alias.$error.uniqueAlias && !editForm.alias.$error.email" translate="entity.validation.uniqueAlias">Alias gi&agrave; assegnato ad altro utente.</p></div><!-- /input-group --></div><div class="form-group" ng-if="vm.mailAliases.length>0"><table class="table table-striped"><thead><tr><th translate="global.form.aliasPosta">Alias</th><th translate="entity.action.delete">Rimuovi</th></tr></thead><tbody><tr ng-repeat="alias in vm.mailAliases | orderBy:\'alias\'"><td>{{alias}}</td><td><button type="button" ng-click="vm.removeAlias(alias)" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></button></td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <span ng-if="vm.enabled != null"><button type="button" class="btn btn-primary" ng-click="vm.enableUser()" ng-show="!vm.enabled"><span data-translate="entity.action.active">Activate</span></button> <button type="button" class="btn btn-danger" ng-click="vm.disableUser()" ng-show="vm.enabled"><span data-translate="entity.action.deactivate">Deactivate</span></button> </span><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><!-- Filters --><div class="row"><div class="col-md-9"><label translate="userManagement.filters.nameFilter">Cerca per username o email</label><input type="text" class="form-control" ng-model="vm.nameFilter" ng-change="vm.loadAll()" ng-model-options="{allowInvalid: true, updateOn: \'default\', debounce: 500}" placeholder="{{\'userManagement.filters.nameFilterPlaceHolder\' | translate }}"></div><div class="col-md-3"><a href="api/download-strutturati{{((vm.nameFilter) ? \'?filterName=\'+vm.nameFilter : \'\')}}" target="_blank" class="btn btn-info btn-sm pull-right"><span class="glyphicon glyphicon-download"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.downloadCsv"></span></a></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="cognome"><span translate="userManagement.nominativo">Nominativo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="username"><span data-translate="userManagement.userId">UserId</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="emailPrivata"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="codiceFiscale"><span data-translate="userManagement.codiceFiscale">Codice Fiscale</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.userId"><td>{{user.cognome}} {{user.nome}}<span ng-if="user.flDeleted">&nbsp;<span class="label label-warning" data-translate="global.form.cessato">cessato</span></span></td><td>{{user.userId}}</td><td>{{user.emailPrivata}}</td><td>{{user.codiceFiscale}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({userId:user.userId})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({userId:user.userId})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/form/input-luogo-nascita.tpl.html','<input type="text" ng-model="esterni.luogoNascita" uib-typeahead="(com.denominazioneComune + appendSiglaProvincia(com.siglaProvincia)) for com in listaComuni | orderByStartWithFirst:\'denominazioneComune\':$viewValue" typeahead-min-length="3" name="luogoNascita" id="field_luogoNascita" typeahead-on-select="updateLuogo({luogo:$item})" class="form-control" ng-disabled="esterni.id" autocomplete="off" required>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div></div></div>');
$templateCache.put('app/entities/configParam/configParam-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.configParam.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.configParam.delete.question" translate-values="{id: \'{{vm.configParam.name}}\'}">Are you sure you want to delete this configParam?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/configParam/configParam-detail.html','<div><h2><span translate="uniromaLandingApp.configParam.detail.title">ConfigParam</span> {{configParam.name}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><!-- tr>\r\n                <td>\r\n                    <span translate="uniromaLandingApp.configParam.configurationId">ConfigurationId</span>\r\n                </td>\r\n                <td>\r\n                    <span class="form-control-static">{{configParam.configurationId}}</span>\r\n                </td>\r\n            </tr --><tr><td><span translate="uniromaLandingApp.configParam.name">Name</span></td><td><span class="form-control-static">{{configParam.name}}</span></td></tr><tr><td><span translate="uniromaLandingApp.configParam.aValue">AValue</span></td><td><span class="form-control-static">{{configParam.value}}</span></td></tr></tbody></table></div><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/configParam/configParam-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myConfigParamLabel" translate="uniromaLandingApp.configParam.home.createOrEditLabel">Create or edit a ConfigParam</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><!-- div class="form-group">\r\n            <label for="id" translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="configParam.id" readonly>\r\n        </div --><!-- div class="form-group">\r\n            <label translate="uniromaLandingApp.configParam.configurationId" for="field_configurationId">ConfigurationId</label>\r\n            <input type="number" class="form-control" name="configurationId" id="field_configurationId"\r\n                    ng-model="configParam.configurationId"\r\n                    >\r\n        </div --><div class="form-group"><label translate="uniromaLandingApp.configParam.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="configParam.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="uniromaLandingApp.configParam.aValue" for="field_aValue">AValue</label><input type="text" class="form-control" name="value" id="field_aValue" ng-model="configParam.value"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || editForm.$submitted" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/configParam/configParams.html','<div><h2 translate="uniromaLandingApp.configParam.home.title">ConfigParams</h2><jh-alert></jh-alert><!-- PER ORA NON SERVE\r\n    <div class="container">\r\n        <div class="row">\r\n            <div class="col-md-4">\r\n                <button class="btn btn-primary" ui-sref="configParam.new">\r\n                    <span class="glyphicon glyphicon-flash"></span> <span translate="uniromaLandingApp.configParam.home.createLabel">Create a new ConfigParam</span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n \t--><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="uniromaLandingApp.configParam.name">Name</th><th translate="uniromaLandingApp.configParam.aValue">AValue</th><th></th></tr></thead><tbody><tr ng-repeat="configParam in configParams track by configParam.id"><td><a ui-sref="configParam.detail({id:configParam.id})">{{configParam.name}}</a></td><td>{{configParam.value | shortenValue:50}}</td><td><button type="submit" ui-sref="configParam.detail({id:configParam.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="configParam.edit({id:configParam.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ui-sref="configParam.delete({id:configParam.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></td></tr></tbody></table><nav><ul class="pagination"><li ng-show="links[\'first\'] >= 0" ng-click="loadPage(links[\'first\'])"><a>&lt;&lt;</a></li><li ng-show="page > 0" ng-click="loadPage(links[\'prev\'] || 0)"><a>&lt;</a></li><li ng-show="page > 1" ng-click="loadPage(page - 2)"><a>{{page - 1}}</a></li><li ng-show="page > 0" ng-click="loadPage(page - 1)"><a>{{page}}</a></li><li class="active"><a>{{page + 1}}</a></li><li ng-show="page < links[\'last\']" ng-click="loadPage(page + 1)"><a>{{page + 2}}</a></li><li ng-show="page < links[\'last\'] - 1" ng-click="loadPage(page + 2)"><a>{{page + 3}}</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a>&gt;</a></li><li ng-show="links[\'last\'] > 0" ng-click="loadPage(links[\'last\'])"><a>&gt;&gt;</a></li></ul></nav></div></div>');
$templateCache.put('app/entities/distribution-list/distribution-list-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.distribution_list.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.distribution_list.delete.question" translate-values="{id: \'{{vm.distribution_list.id}}\'}">Are you sure you want to delete this Distribution List?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/distribution-list/distribution-list-detail.html','<div><h2><span data-translate="uniromaLandingApp.distribution_list.detail.title">Distribution List</span> {{vm.distribution_list.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.distribution_list.code">Code</span></dt><dd><span>{{vm.distribution_list.code}}</span></dd><dt><span data-translate="uniromaLandingApp.distribution_list.name">Name</span></dt><dd><span>{{vm.distribution_list.name}}</span></dd><dt><span data-translate="uniromaLandingApp.distribution_list.description">Description</span></dt><dd><span>{{vm.distribution_list.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button ng-if="vm.distribution_list.id>1" type="button" ui-sref="distribution-list-detail.edit({id:vm.distribution_list.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/distribution-list/distribution-list-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDistribution_listLabel" data-translate="uniromaLandingApp.distribution_list.home.createOrEditLabel">Create or edit a Distribution List</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.distribution_list.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.distribution_list.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.distribution_list.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.distribution_list.code" ng-disabled="vm.distribution_list.id!=null" ng-trim="false" ng-change="vm.distribution_list.code = vm.distribution_list.code.split(\' \').join(\'\')" required><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.distribution_list.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.distribution_list.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.distribution_list.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.distribution_list.description"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/distribution-list/distribution-lists.html','<div><h2 data-translate="uniromaLandingApp.distribution_list.home.title">Distribution Lists</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-uniroma" ui-sref="distribution-list.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.distribution_list.home.createLabel">Create new Distribution List</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="uniromaLandingApp.distribution_list.code">Code</span></th><th><span data-translate="uniromaLandingApp.distribution_list.name">Name</span></th><th><span data-translate="uniromaLandingApp.distribution_list.description">Description</span></th><th></th></tr></thead><tbody><tr ng-repeat="distribution_list in vm.distribution_lists track by distribution_list.id"><td><a ui-sref="distribution-list-detail({id:distribution_list.id})">{{distribution_list.code}}</a></td><td>{{distribution_list.name}}</td><td>{{distribution_list.description}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><a class="btn btn-default btn-sm" href="./api/metadata/lista/{{distribution_list.code}}" target="_self" download="{{file}}"><span class="glyphicon glyphicon-download"></span> <span class="hidden-sm-down">Download</span> </a><button type="submit" ng-if="distribution_list.id>1" ui-sref="distribution-list.edit({id:distribution_list.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ng-if="distribution_list.id>1" ui-sref="distribution-list.delete({id:distribution_list.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/eccezioni/eccezioni-detail.html','<div><h2><span translate="uniromaLandingApp.eccezioni.detail.title">Eccezione</span> "{{eccezioni.username}}"</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="uniromaLandingApp.eccezioni.codFis">CodFis</span></td><td><span class="form-control-static">{{eccezioni.codFis}}</span></td></tr><tr><td><span translate="uniromaLandingApp.eccezioni.docIdentita">docIdentita</span></td><td><span class="form-control-static">{{eccezioni.docIdentita}}</span></td></tr><tr><td><span translate="uniromaLandingApp.eccezioni.nazionalita">nazionalita</span></td><td><span class="form-control-static">{{eccezioni.nazionalita}}</span></td></tr><tr><td><span translate="uniromaLandingApp.eccezioni.username">Username</span></td><td><span class="form-control-static">{{eccezioni.username}}</span></td></tr></tbody></table></div><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/eccezioni/eccezioni-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myEccezioniLabel" translate="uniromaLandingApp.eccezioni.home.createOrEditLabel">Create or edit a Eccezioni</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><!-- div class="form-group">\r\n            <label for="id" translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="eccezioni.id" readonly>\r\n        </div --><div class="form-group"><label translate="uniromaLandingApp.eccezioni.codFis" for="field_codFis">CodFis</label><input type="text" class="form-control" name="codFis" id="field_codFis" ng-model="eccezioni.codFis" required ng-maxlength="16"><div ng-show="editForm.codFis.$invalid"><p class="help-block" ng-show="editForm.codFis.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.codFis.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label translate="uniromaLandingApp.eccezioni.username" for="field_username">Username</label><input type="text" class="form-control" name="username" id="field_username" ui-validate-async="{uniqueUsername: \'editForm.username.$pristine \r\n             \t\t\t\t\t\t|| editForm.username.$viewValue == eccezioneCopy.username \r\n             \t\t\t\t\t\t|| checkUniqueUsername($modelValue)\'}" ng-model-options="{ debounce: 400 }" ng-required="true" ng-model="eccezioni.username" required><div ng-show="editForm.username.$invalid"><p class="help-block" ng-show="editForm.username.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.username.$error.uniqueUsername" translate="entity.validation.uniqueUsername">Lo username inserito risulta gi&agrave; assegnato.</p></div></div><div class="form-group"><label translate="uniromaLandingApp.eccezioni.fonte" for="field_fonte">Fonte</label><input type="text" class="form-control" name="fonte" id="field_fonte" ng-model="eccezioni.fonte" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || editForm.$submitted" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/eccezioni/eccezionis.html','<div><h2 translate="uniromaLandingApp.eccezioni.home.title">Eccezionis</h2><jh-alert></jh-alert><div class="container"><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="eccezioni.new"><span class="glyphicon glyphicon-plus"></span> <span translate="uniromaLandingApp.eccezioni.home.createLabel">Create a new Eccezioni</span></button></div></div></div><!-- \r\n    <div class="modal fade" id="deleteEccezioniConfirmation">\r\n        <div class="modal-dialog">\r\n            <div class="modal-content">\r\n                <form name="deleteForm" ng-submit="confirmDelete(eccezioni.id)">\r\n                    <div class="modal-header">\r\n                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                                ng-click="clear()">&times;</button>\r\n                        <h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4>\r\n                    </div>\r\n                    <div class="modal-body">\r\n                        <p translate="uniromaLandingApp.eccezioni.delete.question" translate-values="{id: \'{{eccezioni.username}}\'}">Are you sure you want to delete this Eccezione?</p>\r\n                    </div>\r\n                    <div class="modal-footer">\r\n                        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()">\r\n                            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span>\r\n                        </button>\r\n                        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\r\n                            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span>\r\n                        </button>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n --><div class="table-responsive"><table class="table table-striped"><thead><tr><!-- th translate="global.field.id">ID</th --><th translate="uniromaLandingApp.eccezioni.username">Username</th><th translate="uniromaLandingApp.eccezioni.codFis">CodFis</th><th translate="uniromaLandingApp.eccezioni.docIdentita">Documento</th><th translate="uniromaLandingApp.eccezioni.nazionalita">Nazionalit\uFFFD</th><th></th></tr></thead><tbody><tr ng-repeat="eccezioni in eccezionis track by eccezioni.id"><!-- td><a ui-sref="eccezioni.detail({id:eccezioni.id})">{{eccezioni.id}}</a></td --><td><a ui-sref="eccezioni.detail({id:eccezioni.id})">{{eccezioni.username}}</a></td><td>{{eccezioni.codFis}}</td><td>{{eccezioni.docIdentita}}</td><td>{{eccezioni.nazionalita}}</td><td><button type="submit" ui-sref="eccezioni.detail({id:eccezioni.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="eccezioni.edit({id:eccezioni.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="delete(eccezioni.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><nav><ul class="pagination"><li ng-show="links[\'first\'] >= 0" ng-click="loadPage(links[\'first\'])"><a>&lt;&lt;</a></li><li ng-show="page > 0" ng-click="loadPage(links[\'prev\'] || 0)"><a>&lt;</a></li><li ng-show="page > 1" ng-click="loadPage(page - 2)"><a>{{page - 1}}</a></li><li ng-show="page > 0" ng-click="loadPage(page - 1)"><a>{{page}}</a></li><li class="active"><a>{{page + 1}}</a></li><li ng-show="page < links[\'last\']" ng-click="loadPage(page + 1)"><a>{{page + 2}}</a></li><li ng-show="page < links[\'last\'] - 1" ng-click="loadPage(page + 2)"><a>{{page + 3}}</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a>&gt;</a></li><li ng-show="links[\'last\'] > 0" ng-click="loadPage(links[\'last\'])"><a>&gt;&gt;</a></li></ul></nav></div></div>');
$templateCache.put('app/entities/environment/environment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.environment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.environment.delete.question" translate-values="{id: \'{{vm.environment.id}}\'}">Are you sure you want to delete this Environment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/environment/environment-detail.html','<div><h2><span data-translate="uniromaLandingApp.environment.detail.title">Environment</span> {{vm.environment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.environment.name">Name</span></dt><dd><span>{{vm.environment.name}}</span></dd><dt><span data-translate="uniromaLandingApp.environment.type">Type</span></dt><dd><span>{{vm.environment.type}}</span></dd><dt><span data-translate="uniromaLandingApp.environment.tenant">Tenant</span></dt><dd><a ui-sref="tenant-detail({id:vm.environment.tenant.id})">{{vm.environment.tenant.code}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="environment-detail.edit({id:vm.environment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/environment/environment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEnvironmentLabel" data-translate="uniromaLandingApp.environment.home.createOrEditLabel">Create or edit a Environment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.environment.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.environment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.environment.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.environment.name"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.environment.type" for="field_type">Type</label><input type="text" class="form-control" name="type" id="field_type" ng-model="vm.environment.type"></div><div class="form-group"><label data-translate="uniromaLandingApp.environment.tenant" for="field_tenant">Tenant</label><select class="form-control" id="field_tenant" name="tenant" ng-model="vm.environment.tenant" ng-options="tenant as tenant.code for tenant in vm.tenants track by tenant.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/environment/environments.html','<div><h2 data-translate="uniromaLandingApp.environment.home.title">Environments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="environment.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.environment.home.createLabel">Create new Environment</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="uniromaLandingApp.environment.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="uniromaLandingApp.environment.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tenant.code"><span data-translate="uniromaLandingApp.environment.tenant">Tenant</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="environment in vm.environments track by environment.id"><td><a ui-sref="environment-detail({id:environment.id})">{{environment.id}}</a></td><td>{{environment.name}}</td><td>{{environment.type}}</td><td><a ui-sref="tenant-detail({id:environment.tenant.id})">{{environment.tenant.code}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="environment-detail({id:environment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="environment.edit({id:environment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="environment.delete({id:environment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/environment-tr/environment-tr-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.environment_tr.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.environment_tr.delete.question" translate-values="{id: \'{{vm.environment_tr.id}}\'}">Are you sure you want to delete this Environment Tr?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/environment-tr/environment-tr-detail.html','<div><h2><span data-translate="uniromaLandingApp.environment_tr.detail.title">Environment Tr</span> {{vm.environment_tr.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.environment_tr.field">Field</span></dt><dd><span>{{vm.environment_tr.field}}</span></dd><dt><span data-translate="uniromaLandingApp.environment_tr.value">Value</span></dt><dd><span>{{vm.environment_tr.value}}</span></dd><dt><span data-translate="uniromaLandingApp.environment_tr.language">Language</span></dt><dd><span>{{vm.environment_tr.language}}</span></dd><dt><span data-translate="uniromaLandingApp.environment_tr.environment">Environment</span></dt><dd><a ui-sref="environment-detail({id:vm.environment_tr.environment.id})">{{vm.environment_tr.environment.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="environment-tr-detail.edit({id:vm.environment_tr.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/environment-tr/environment-tr-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEnvironment_trLabel" data-translate="uniromaLandingApp.environment_tr.home.createOrEditLabel">Create or edit a Environment Tr</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.environment_tr.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.environment_tr.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.environment_tr.field" for="field_field">Field</label><input type="text" class="form-control" name="field" id="field_field" ng-model="vm.environment_tr.field"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.environment_tr.value" for="field_value">Value</label><input type="text" class="form-control" name="value" id="field_value" ng-model="vm.environment_tr.value"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.environment_tr.language" for="field_language">Language</label><input type="text" class="form-control" name="language" id="field_language" ng-model="vm.environment_tr.language"></div><div class="form-group"><label data-translate="uniromaLandingApp.environment_tr.environment" for="field_environment">Environment</label><select class="form-control" id="field_environment" name="environment" ng-model="vm.environment_tr.environment" ng-options="environment as environment.name for environment in vm.environments track by environment.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/environment-tr/environment-trs.html','<div><h2 data-translate="uniromaLandingApp.environment_tr.home.title">Environment Trs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="environment-tr.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.environment_tr.home.createLabel">Create new Environment Tr</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="field"><span data-translate="uniromaLandingApp.environment_tr.field">Field</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="value"><span data-translate="uniromaLandingApp.environment_tr.value">Value</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="language"><span data-translate="uniromaLandingApp.environment_tr.language">Language</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="environment.name"><span data-translate="uniromaLandingApp.environment_tr.environment">Environment</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="environment_tr in vm.environment_trs track by environment_tr.id"><td><a ui-sref="environment-tr-detail({id:environment_tr.id})">{{environment_tr.id}}</a></td><td>{{environment_tr.field}}</td><td>{{environment_tr.value}}</td><td>{{environment_tr.language}}</td><td><a ui-sref="environment-detail({id:environment_tr.environment.id})">{{environment_tr.environment.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="environment-tr-detail({id:environment_tr.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="environment-tr.edit({id:environment_tr.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="environment-tr.delete({id:environment_tr.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/esterni/esterni-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.esterni.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.esterni.delete.question" translate-values="{id: \'{{vm.esterni.id}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/esterni/esterni-detail.html','<div><h2><span translate="uniromaLandingApp.esterni.detail.title">Esterni</span> [ {{esterni.nome}} {{esterni.cognome}} ]</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr ng-if="userId!=null"><td><span translate="uniromaLandingApp.esterni.username">userId</span></td><td><span class="form-control-static">{{userId}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.categoria">Categoria</span></td><td><span class="form-control-static">{{esterni.categoria.sottoCategoria}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.stato_specifico.label">Stato specifico</span></td><td><span class="form-control-static" translate="uniromaLandingApp.esterni.stato_specifico.{{esterni.statoSpecifico.id}}"></span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.flActive">flAttivo</span></td><td><span class="form-control-static glyphicon glyphicon-{{ esterni.flAttivo ? \'ok\' : \'remove\'}}"></span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.dataCreazione">dataCreazione</span></td><td><span class="form-control-static">{{esterni.dataCreazione | date:\'mediumDate\'}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.dataAttivazione">dataAttivazione</span></td><td><span class="form-control-static">{{esterni.dataAttivazione | date:\'mediumDate\'}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.dataFine">dataFine</span></td><td><span class="form-control-static">{{esterni.dataFine | date:\'mediumDate\'}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.titolo">titolo</span></td><td><span class="form-control-static">{{esterni.titolo}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.nome">Nome</span></td><td><span class="form-control-static">{{esterni.nome}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.middleName">middleName</span></td><td><span class="form-control-static">{{esterni.middleName}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.cognome">Cognome</span></td><td><span class="form-control-static">{{esterni.cognome}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.dtNascita">dtNascita</span></td><td><span class="form-control-static">{{esterni.dataNascita | date:\'mediumDate\'}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.luogoNascita">luogoNascita</span></td><td><span class="form-control-static">{{esterni.luogoNascita}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.nazionalita">nazionalita</span></td><td><span class="form-control-static">{{esterni.nazionalita}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.genere">genere</span></td><td><span class="form-control-static">{{esterni.genere}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.codFis">codFis</span></td><td><span class="form-control-static">{{esterni.codiceFiscale}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.emailPrivata">emailPrivata</span></td><td><span class="form-control-static">{{esterni.emailPrivata}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.mobilePrivato">mobilePrivato</span></td><td><span class="form-control-static">{{esterni.mobilePrivato}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.telefonoPrivato">telefonoPrivato</span></td><td><span class="form-control-static">{{esterni.telefonoPrivato}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.faxPrivato">faxPrivato</span></td><td><span class="form-control-static">{{esterni.faxPrivato}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.profilo">Profilo</span></td><td><span class="form-control-static">{{esterni.profilo}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.cfResponsabile">Codice Fiscale Responsabile</span></td><td><span class="form-control-static">{{esterni.cfResponsabile}}</span></td></tr><tr><td><span translate="uniromaLandingApp.esterni.note">Note</span></td><td><span class="form-control-static">{{esterni.note}}</span></td></tr></tbody></table></div><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/esterni/esterni-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myEsterniLabel" translate="uniromaLandingApp.esterni.home.createOrEditLabel">Create or edit a Esterni</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!-- CATEGORIA --><div class="row"><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.categoria" for="field_categoria">categoria</label>*<select class="form-control" name="categoria" id="field_categoria" ng-model="esterni.categoria.id" ng-required="true" ng-options="categoria.id as categoria.sottoCategoria for categoria in categoryList"></select><div ng-show="editForm.genere.$invalid && !editForm.genere.$pristine"><p class="help-block" ng-show="editForm.genere.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><!-- STATO SPECIFICO --><div class="row"><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.stato_specifico.label" for="field_statoSpecifico">statoSpecifico</label>*<select class="form-control" name="statoSpecifico" id="field_statoSpecifico" ng-model="esterni.statoSpecifico.id" ng-required="true" ng-options="statoSpecifico.id as statoSpecifico.statoSpecifico for statoSpecifico in statiSpecificiList"></select><div ng-show="editForm.genere.$invalid && !editForm.genere.$pristine"><p class="help-block" ng-show="editForm.genere.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><!-- RANGE ATTIVAZIONE --><div class="row"><!-- Periodo di validit&agrave; --><div class="col-md-4"><label translate="uniromaLandingApp.esterni.range.label"></label><input bs-switch ng-model="switchOptions.switchIsSelected" type="checkbox" switch-active="{{ switchOptions.isActive }}" switch-size="{{ switchOptions.size }}" switch-animate="{{ switchOptions.animate }}" switch-label="{{ switchOptions.label }}" switch-on-text="{{ \'uniromaLandingApp.esterni.range.onText\' | translate }}" switch-off-text="{{ \'uniromaLandingApp.esterni.range.offText\' | translate }}" switch-on-color="{{ switchOptions.onColor }}" switch-off-color="{{ switchOptions.offColor }}" switch-label-width="{{ switchOptions.labelWidth }}" switch-handle-width="{{switchOptions.handleWidth }}" switch-inverse="{{ switchOptions.inverse }}" ng-true-value="true" ng-false-value="false"></div><!-- Inizio --><div class="form-group col-md-4" ng-if="switchOptions.switchIsSelected==true" ng-class="{\'has-error\' : editForm.dataAttivazione.$invalid && editForm.dataAttivazione.$dirty, \'has-feedback\' :  editForm.dataAttivazione.$invalid &&  editForm.dataAttivazione.$dirty }"><label translate="uniromaLandingApp.esterni.dataAttivazione" for="field_dataAttivazione">dataAttivazione</label>* <input type="date" datepicker-popup="{{format}}" show-button-bar="false" name="dataAttivazione" class="form-control" placeholder="{{format}}" ng-model="esterni.dataAttivazione" ng-required="true" is-open="open" ng-click="open = true" datepicker-localdate ng-disabled="isActive()" zmin="{{today}}"><div ng-show="editForm.dataAttivazione.$invalid && !editForm.dataAttivazione.$pristine"><p class="help-block" ng-show="editForm.dataAttivazione.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.dataAttivazione.$dirty &&  editForm.dataAttivazione.$invalid" translate="entity.validation.invalidDate">Format not valid.</p></div></div><!-- Fine --><div class="form-group col-md-4" ng-if="switchOptions.switchIsSelected==true" ng-class="{\'has-error\' : editForm.dataFine.$invalid && editForm.dataFine.$dirty, \'has-feedback\' :  editForm.dataFine.$invalid &&  editForm.dataFine.$dirty }"><label translate="uniromaLandingApp.esterni.dataFine" for="field_dataFine">dataFine</label>* <input type="date" datepicker-popup="{{format}}" show-button-bar="false" name="dataFine" class="form-control" placeholder="{{format}}" ng-model="esterni.dataFine" ng-required="true" is-open="open" ng-click="open = true" datepicker-localdate min="{{esterni.dataAttivazione}}"><div ng-show="editForm.dataFine.$invalid && !editForm.dataFine.$pristine"><p class="help-block" ng-show="editForm.dataFine.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.dataFine.$dirty &&  editForm.dataFine.$invalid" translate="entity.validation.invalidDate">Format not valid.</p></div></div></div><div class="row"><!-- TITOLO --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.titolo" for="field_titolo">titolo</label><input type="text" class="form-control" name="titolo" id="field_titolo" ng-model="esterni.titolo"></div><!-- NOME --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.nome" for="field_nome">Nome</label>* <input type="text" class="form-control" name="nome" id="field_nome" ng-model="esterni.nome" required ng-disabled="esterni.id"><div ng-show="editForm.nome.$invalid && !editForm.nome.$pristine"><p class="help-block" ng-show="editForm.nome.$error.required" translate="entity.validation.required">This field is required.</p></div></div><!-- SECONDO NOME --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.middleName" for="field_middleName">MiddleName</label><input type="text" class="form-control" name="middleName" id="field_middleName" ng-model="esterni.middleName" ng-disabled="esterni.id"></div><!-- COGNOME --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.cognome" for="field_cognome">Cognome</label>* <input type="text" class="form-control" name="cognome" id="field_cognome" ng-model="esterni.cognome" required ng-disabled="esterni.id"><div ng-show="editForm.cognome.$invalid && !editForm.cognome.$pristine"><p class="help-block" ng-show="editForm.cognome.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><!-- GENERE --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.genere" for="field_genere">genere</label>*<select class="form-control" name="genere" id="field_genere" ng-model="esterni.genere" ng-required="true" ng-options="gender for gender in genderList" ng-disabled="esterni.id"></select><div ng-show="editForm.genere.$invalid && !editForm.genere.$pristine"><p class="help-block" ng-show="editForm.genere.$error.required" translate="entity.validation.required">This field is required.</p></div></div><!-- DATA DI NASCITA --><div class="form-group col-md-12" ng-class="{\'has-error\' : editForm.dtNascita.$invalid && editForm.dtNascita.$dirty, \'has-feedback\' :  editForm.dtNascita.$invalid &&  editForm.dtNascita.$dirty }"><label translate="uniromaLandingApp.esterni.dtNascita" for="field_dtNascita">DtNascita</label>* <input type="date" datepicker-popup="{{format}}" show-button-bar="false" name="dtNascita" class="form-control" placeholder="{{format}}" ng-model="esterni.dataNascita" ng-required="true" is-open="open" ng-click="open = true" ng-disabled="esterni.id" datepicker-localdate><div ng-show="editForm.dtNascita.$invalid && !editForm.dtNascita.$pristine"><p class="help-block" ng-show="editForm.dtNascita.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.dtNascita.$dirty &&  editForm.dtNascita.$invalid" translate="entity.validation.invalidDate">Format not valid.</p></div></div><!-- LUOGO DI NASCITA --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.luogoNascita" for="field_luogoNascita">luogoNascita</label>*<input-luogo-nascita esterni="esterni" update-luogo="updateLuogoNascitaSelezionato(luogo)"></input-luogo-nascita><div ng-show="editForm.luogoNascita.$invalid && !editForm.luogoNascita.$pristine"><p class="help-block" ng-show="editForm.luogoNascita.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><!-- NAZIONALITA/CITTADINANZA --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.nazionalita" for="field_nazionalita">nazionalita</label>*<select class="form-control" name="nazionalita" id="field_nazionalita" ng-model="esterni.nazionalita" ng-required="true" ng-options="country.nome as country.codice for country in countryList" ng-change="esterni.codiceFiscale=null;esterni.documentoIdentita=null;editForm.tipoId=\'CF\';" ng-disabled="esterni.id"></select><div ng-show="editForm.nazionalita.$invalid && !editForm.nazionalita.$pristine"><p class="help-block" ng-show="editForm.nazionalita.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nazionalita.$error.maxlength" data-translate="entity.validation.maxlength" translate-values="{ max: 5}">max 5 chars.</p></div></div><div ng-if="esterni.nazionalita &amp;&amp; esterni.nazionalita!==\'IT\' && !esterni.id" class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.identificativo">Tipologia identitificativo</label><div class="form-control" style="text-align:center"><input type="radio" id="rTipoCF" name="tipoIdF" ng-value="\'CF\'" ng-model="editForm.tipoId"><label translate="uniromaLandingApp.esterni.codFis" for="rTipoCF" style="padding-right: 2em;padding-left: 0.5ex">Codice Fiscale</label><input type="radio" id="rTipoID" name="tipoIdF" ng-value="\'ID\'" ng-model="editForm.tipoId"><label translate="uniromaLandingApp.esterni.docIdentita" for="rTipoID" style="padding-left: 0.5ex">Documento d\'identit&agrave;</label></div></div><!-- CODICE FISCALE --><div ng-if="esterni.nazionalita && (esterni.nazionalita==\'IT\' || editForm.tipoId==\'CF\')" class="form-group col-md-12" ng-class="{\'has-error\' : editForm.codFis.$invalid &&  editForm.codFis.$dirty, \'has-feedback\' :  editForm.codFis.$invalid &&  editForm.codFis.$dirty}"><label translate="uniromaLandingApp.esterni.codFis" for="field_codFis">CodFis</label>* <input type="text" class="form-control" name="codFis" id="field_codFis" ng-model="esterni.codiceFiscale" ui-validate="{validCodfis: \'editForm.codFis.$pristine || editForm.codFis.$viewValue == esterniCopy.codFis || checkCodiceFiscale($modelValue)\', \r\n\t                    \t\t\t\t\tgenderCodfis: \'editForm.codFis.$pristine || editForm.codFis.$viewValue == esterniCopy.codFis || checkGenderCodFiscale(esterni.genere,$modelValue)\',\r\n                    \t\t\t\t\t\tdateCodFis: \'editForm.codFis.$pristine || editForm.codFis.$viewValue == esterniCopy.codFis || checkDateCodiceFiscale(esterni.dataNascita, $modelValue)\',\r\n                    \t\t\t\t\t\tuniqueCodFis: \'editForm.codFis.$pristine || editForm.codFis.$viewValue == esterniCopy.codFis || checkUniqueCodiceFiscale($modelValue,null)\'}" ui-validate-watch=" [\'esterni.dataNascita\',\'esterni.genere\'] " ng-model-options="{ debounce: 400 }" ng-required="true" required ng-disabled="esterni.id"><div ng-show="editForm.codFis.$invalid && !editForm.codFis.$pristine"><p class="help-block" ng-show="editForm.codFis.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.codFis.$error.validCodfis" translate="entity.validation.invalidCodFis">Il codice fiscale non &amp; valido</p><p class="help-block" ng-show="editForm.codFis.$error.genderCodfis" translate="entity.validation.genderCodFis">entity.validation.genderCodFis</p><p class="help-block" ng-show="editForm.codFis.$error.dateCodFis" translate="entity.validation.dateCodFis">Il codice fiscale non rispecchia la data di nascita inserita.</p><p class="help-block" ng-show="editForm.codFis.$error.uniqueCodFis" translate="entity.validation.uniqueCodFis">Il codice fiscale inserito &egrave; gi&agrave; presente tra le anagrafiche.</p></div></div><!-- DOCUMENTO IDENTITA\' --><div ng-if="esterni.nazionalita && esterni.nazionalita!==\'IT\' && editForm.tipoId==\'ID\'" class="form-group col-md-12" ng-class="{\'has-error\' : editForm.codFis.$invalid &&  editForm.codFis.$dirty, \'has-feedback\' :  editForm.codFis.$invalid &&  editForm.codFis.$dirty}"><label translate="uniromaLandingApp.esterni.docIdentita" for="field_documentoIdentita">docIdentita</label>* <input type="text" class="form-control" name="documentoIdentita" id="field_documentoIdentita" ng-model="esterni.documentoIdentita" ui-validate="{uniqueCodFis: \'editForm.documentoIdentita.$pristine || editForm.documentoIdentita.$viewValue == esterniCopy.documentoIdentita || checkUniqueCodiceFiscale(null,$modelValue)\'}" required ng-disabled="esterni.id"><div ng-show="editForm.documentoIdentita.$invalid && !editForm.documentoIdentita.$pristine"><p class="help-block" ng-show="editForm.documentoIdentita.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.documentoIdentita.$error.uniqueCodFis" translate="entity.validation.uniqueDocIdentita">Il numero di documento inserito &egrave; gi&agrave; presente tra le anagrafiche.</p></div></div></div><div class="row"><!-- EMAIL PRIVATA --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.emailPrivata" for="field_emailPrivata">emailPrivata</label>* <input type="email" class="form-control" name="emailPrivata" id="field_emailPrivata" ng-model="esterni.emailPrivata" required><div ng-show="editForm.emailPrivata.$invalid && !editForm.emailPrivata.$pristine"><p class="help-block" ng-show="editForm.emailPrivata.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.emailPrivata.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><!-- TELEFONO CELLULARE PRIVATO --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.mobilePrivato" for="field_mobilePrivato">mobilePrivato</label><input type="text" class="form-control" name="mobilePrivato" id="field_mobilePrivato" ng-model="esterni.mobilePrivato"></div></div><div class="row"><!-- TELEFONO FISSO PRIVATO --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.telefonoPrivato" for="field_telefonoPrivato">telefonoPrivato</label><input type="text" class="form-control" name="telefonoPrivato" id="field_telefonoPrivato" ng-model="esterni.telefonoPrivato"></div><!-- FAX PRIVATO --><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.faxPrivato" for="field_faxPrivato">faxPrivato</label><input type="text" class="form-control" name="faxPrivato" id="field_faxPrivato" ng-model="esterni.faxPrivato"></div></div><div class="row"><div class="form-group col-md-12" ng-class="{   \'has-error\' : editForm.cfResponsabile.$invalid && editForm.cfResponsabile.$dirty, \r\n\t\t                      \'has-feedback\' : editForm.cfResponsabile.$invalid && editForm.cfResponsabile.$dirty}"><label translate="uniromaLandingApp.esterni.cfResponsabile" for="field_codFisResp">CFR</label>* <input type="text" class="form-control" name="cfResponsabile" id="field_codFisResp" ng-model="esterni.cfResponsabile" ng-model-options="{ debounce: 400 }" ng-required="true" required ui-validate="{ presentCFResponsabile: \'editForm.cfResponsabile.$pristine || editForm.cfResponsabile.$viewValue == esterniCopy.cfResponsabile || checkCFResponsabile($modelValue)\'}" ng-disabled="ridotto === \'Y\' && esterni.id"><div ng-show="editForm.cfResponsabile.$invalid && !editForm.cfResponsabile.$pristine"><p class="help-block" ng-show="editForm.cfResponsabile.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.cfResponsabile.$error.presentCFResponsabile" translate="entity.validation.presentCFResponsabile">Il Codice Fiscale non presente tra le anagrafiche.</p></div></div></div><!-- NOTE --><div class="row"><div class="form-group col-md-12"><label translate="uniromaLandingApp.esterni.note" for="field_note">note</label><textarea class="form-control" name="note" id="field_note" ng-model="esterni.note" rows="3" maxlength="400"></textarea><span class="help-block" translate="global.form.caratteriRimanenti" translate-values="{char: 400 - esterni.note.length}">{{400 - esterni.note.length}} caratteri rimanenti</span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <span ng-if="enabled != null"><button type="button" class="btn btn-primary" ng-click="enableUser()" ng-show="!enabled"><span data-translate="entity.action.active">Activate</span></button> <button type="button" class="btn btn-danger" ng-click="disableUser()" ng-show="enabled"><span data-translate="entity.action.deactivate">Deactivate</span></button> </span><button type="submit" ng-disabled="(editForm.$invalid && editForm.$dirty) || editForm.$pristine" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/esterni/esternis.html','<div><h2 translate="uniromaLandingApp.esterni.home.title">Esternis</h2><jh-alert></jh-alert><div class="container"><div class="row"><div class="col-md-12"><button class="btn btn-uniroma" ui-sref="esterni.new"><i class="fa fa-user-plus" aria-hidden="true"></i> <span translate="uniromaLandingApp.esterni.home.createLabel">Create a new Esterni</span></button> <a href="api/download-esternis?filterName={{vm.nameFilter}}&filterType={{vm.typeFilter}}&filterStatus={{vm.statusFilter}}" target="_blank" class="btn btn-info"><span class="glyphicon glyphicon-download"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.downloadCsv"></span></a></div></div><div class="row"><div class="col-md-12"></div></div><div class="row"><div class="col-md-6"><label translate="uniromaLandingApp.esterni.filters.text-label">Cerca per username o email</label><input type="text" class="form-control" ng-model="vm.nameFilter" ng-change="chengeFilter()" ng-model-options="{allowInvalid: true, updateOn: \'default\', debounce: 500}" placeholder="{{\'uniromaLandingApp.esterni.filters.text-placeholder\' | translate }}"></div><div class="col-md-3"><label translate="uniromaLandingApp.esterni.filters.type-label">Tipo</label><select class="form-control" ng-model="vm.typeFilter" ng-change="chengeFilter()"><option value=""></option><option ng-repeat="tipologia in vm.tipologiePerFiltro" value="{{tipologia.id}}">{{tipologia.sottoCategoria}}</option></select></div><div class="col-md-3"><label translate="uniromaLandingApp.esterni.filters.stati-label">Stati</label><select class="form-control" ng-model="vm.statusFilter" ng-change="chengeFilter()"><option value=""></option><option ng-repeat="stato in vm.statiSpecPerFiltro" value="{{stato.id}}" translate="uniromaLandingApp.esterni.stato_specifico.{{stato.id}}"></option></select></div></div></div><div class="modal fade" id="deleteEsterniConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(esterni.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="uniromaLandingApp.esterni.delete.question" translate-values="{id: \'{{esterni.cognome | uppercase}} {{esterni.nome | uppercase}}\'}">Are you sure you want to delete this Esterni?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th translate="uniromaLandingApp.esterni.username">Username</th> --><th jh-sort-by="cognome"><span translate="uniromaLandingApp.esterni.nominativo">Nominativo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="emailPrivata"><span translate="uniromaLandingApp.esterni.emailPrivata">Email Privata</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="username"><span translate="uniromaLandingApp.esterni.username">Username</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="codiceFiscale"><span translate="uniromaLandingApp.esterni.docIdentita">CodFis</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="categoria"><span translate="uniromaLandingApp.esterni.sottoCategoria">Profilo</span><span class="glyphicon glyphicon-sort"></span></th><th translate="uniromaLandingApp.esterni.stato_specifico.label">Stato Specifico</th><th></th></tr></thead><tbody><tr ng-repeat="esterni in esternis track by esterni.id"><td>{{esterni.cognome}} {{esterni.nome}}</td><td>{{esterni.emailPrivata}}</td><td>{{esterni.userId}}</td><td><span ng-if="esterni.codiceFiscale!=null">{{esterni.codiceFiscale}}</span> <span ng-if="esterni.documentoIdentita!=null">{{esterni.documentoIdentita}}</span></td><td ng-if="esterni.categoria!=null">{{esterni.categoria.sottoCategoria | uppercase}}</td><td class="nowrap"><span translate="uniromaLandingApp.esterni.stato_specifico.{{esterni.statoSpecifico.id}}"></span> <span ng-show="esterni.note" class="glyphicon glyphicon-info-sign" uib-tooltip="{{esterni.note}}"></span></td><td><button type="submit" ui-sref="esterni.detail({id:esterni.id,userId:esterni.userId})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span>&nbsp;<span translate="entity.action.view"> View</span></button> <button ng-if="esterni.statoSpecifico.id!=6" type="submit" ui-sref="esterni.edit({id:esterni.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span>&nbsp;<span translate="entity.action.edit"> Edit</span></button><!-- button ng-if="esterni.flAttivo==1" type="submit" ng-click="vm.activateUser(esterni,false)"\r\n                                class="btn btn-danger btn-sm">\r\n                            <i class="fa fa-ban" aria-hidden="true"></i>&nbsp;<span translate="entity.action.block"> Block</span>\r\n                        </button>\r\n                        <button ng-if="esterni.flAttivo==0&&esterni.statoSpecifico.id!=6" type="submit" ng-click="vm.activateUser(esterni,true)"\r\n                                class="btn btn-success btn-sm">\r\n                            <i class="fa fa-check" aria-hidden="true"></i>&nbsp;<span translate="entity.action.active"> Attiva</span>\r\n                        </button --></td></tr></tbody></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/iso-country-codes/iso-country-codes-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.iso_country_codes.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.iso_country_codes.delete.question" translate-values="{id: \'{{vm.iso_country_codes.id}}\'}">Are you sure you want to delete this Iso Country Codes?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/iso-country-codes/iso-country-codes-detail.html','<div><h2><span data-translate="uniromaLandingApp.iso_country_codes.detail.title">Iso Country Codes</span> {{vm.iso_country_codes.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.iso_country_codes.codice">Codice</span></dt><dd><span>{{vm.iso_country_codes.codice}}</span></dd><dt><span data-translate="uniromaLandingApp.iso_country_codes.nome">Nome</span></dt><dd><span>{{vm.iso_country_codes.nome}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="iso-country-codes-detail.edit({id:vm.iso_country_codes.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/iso-country-codes/iso-country-codes-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myIso_country_codesLabel" data-translate="uniromaLandingApp.iso_country_codes.home.createOrEditLabel">Create or edit a Iso Country Codes</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.iso_country_codes.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.iso_country_codes.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.iso_country_codes.codice" for="field_codice">Codice</label><input type="text" class="form-control" name="codice" id="field_codice" ng-model="vm.iso_country_codes.codice"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.iso_country_codes.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.iso_country_codes.nome"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/iso-country-codes/iso-country-codes.html','<div><h2 data-translate="uniromaLandingApp.iso_country_codes.home.title">Iso Country Codes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="iso-country-codes.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.iso_country_codes.home.createLabel">Create new Iso Country Codes</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="uniromaLandingApp.iso_country_codes.codice">Codice</span></th><th><span data-translate="uniromaLandingApp.iso_country_codes.nome">Nome</span></th><th></th></tr></thead><tbody><tr ng-repeat="iso_country_codes in vm.iso_country_codes track by iso_country_codes.id"><td><a ui-sref="iso-country-codes-detail({id:iso_country_codes.id})">{{iso_country_codes.id}}</a></td><td>{{iso_country_codes.codice}}</td><td>{{iso_country_codes.nome}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="iso-country-codes-detail({id:iso_country_codes.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="iso-country-codes.edit({id:iso_country_codes.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="iso-country-codes.delete({id:iso_country_codes.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/module/module-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.module.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.module.delete.question" translate-values="{id: \'{{vm.module.id}}\'}">Are you sure you want to delete this Module?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/module/module-detail.html','<div><h2><span data-translate="uniromaLandingApp.module.detail.title">Module</span> {{vm.module.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.module.version">Version</span></dt><dd><span>{{vm.module.version}}</span></dd><dt><span data-translate="uniromaLandingApp.module.code">Code</span></dt><dd><span>{{vm.module.code}}</span></dd><dt><span data-translate="uniromaLandingApp.module.product">Product</span></dt><dd><a ui-sref="product-detail({id:vm.module.product.id})">{{vm.module.product.code}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="module-detail.edit({id:vm.module.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/module/module-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myModuleLabel" data-translate="uniromaLandingApp.module.home.createOrEditLabel">Create or edit a Module</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.module.version" for="field_version">Version</label><input type="text" class="form-control" name="version" id="field_version" ng-model="vm.module.version" required><p ng-show="vm.module.version==null || vm.module.version===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.module.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.module.code" required><p ng-show="vm.module.version==null || vm.module.version===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label data-translate="uniromaLandingApp.module.product" for="field_product">Product</label><select class="form-control" id="field_product" name="product" ng-model="vm.module.product" ng-options="product as product.code for product in vm.products track by product.id" disabled="disabled"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/module/modules.html','<div><h2 data-translate="uniromaLandingApp.module.home.title">Modules</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="module.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.module.home.createLabel">Create new Module</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="version"><span data-translate="uniromaLandingApp.module.version">Version</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span data-translate="uniromaLandingApp.module.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="product.code"><span data-translate="uniromaLandingApp.module.product">Product</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="module in vm.modules track by module.id"><td><a ui-sref="module-detail({id:module.id})">{{module.id}}</a></td><td>{{module.version}}</td><td>{{module.code}}</td><td><a ui-sref="product-detail({id:module.product.id})">{{module.product.code}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="module-detail({id:module.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="module.edit({id:module.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="module.delete({id:module.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/module-tr/module-tr-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.module_tr.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.module_tr.delete.question" translate-values="{id: \'{{vm.module_tr.id}}\'}">Are you sure you want to delete this Module Tr?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/module-tr/module-tr-detail.html','<div><h2><span data-translate="uniromaLandingApp.module_tr.detail.title">Module Tr</span> {{vm.module_tr.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.module_tr.field">Field</span></dt><dd><span>{{vm.module_tr.field}}</span></dd><dt><span data-translate="uniromaLandingApp.module_tr.value">Value</span></dt><dd><span>{{vm.module_tr.value}}</span></dd><dt><span data-translate="uniromaLandingApp.module_tr.language">Language</span></dt><dd><span>{{vm.module_tr.language}}</span></dd><dt><span data-translate="uniromaLandingApp.module_tr.module">Module</span></dt><dd><a ui-sref="module-detail({id:vm.module_tr.module.id})">{{vm.module_tr.module.code}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="module-tr-detail.edit({id:vm.module_tr.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/module-tr/module-tr-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myModule_trLabel" data-translate="uniromaLandingApp.module_tr.home.createOrEditLabel">Create or edit a Module Tr</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.module_tr.field" for="field_field">Field</label><input type="text" class="form-control" name="field" id="field_field" ng-model="vm.module_tr.field" required><p ng-show="vm.module_tr.field==null || vm.module_tr.field===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.module_tr.value" for="field_value">Value</label><input type="text" class="form-control" name="value" id="field_value" ng-model="vm.module_tr.value" required><p ng-show="vm.module_tr.value==null || vm.module_tr.value===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.module_tr.language" for="field_language">Language</label><input type="text" class="form-control" name="language" id="field_language" ng-model="vm.module_tr.language" required><p ng-show="vm.module_tr.language==null || vm.module_tr.language===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label data-translate="uniromaLandingApp.module_tr.module" for="field_module">Module</label><select class="form-control" id="field_module" name="module" ng-model="vm.module_tr.module" ng-options="module as module.code for module in vm.modules track by module.id" disabled="disabled"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/module-tr/module-trs.html','<div><h2 data-translate="uniromaLandingApp.module_tr.home.title">Module Trs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="module-tr.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.module_tr.home.createLabel">Create new Module Tr</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="field"><span data-translate="uniromaLandingApp.module_tr.field">Field</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="value"><span data-translate="uniromaLandingApp.module_tr.value">Value</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="language"><span data-translate="uniromaLandingApp.module_tr.language">Language</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="module.code"><span data-translate="uniromaLandingApp.module_tr.module">Module</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="module_tr in vm.module_trs track by module_tr.id"><td><a ui-sref="module-tr-detail({id:module_tr.id})">{{module_tr.id}}</a></td><td>{{module_tr.field}}</td><td>{{module_tr.value}}</td><td>{{module_tr.language}}</td><td><a ui-sref="module-detail({id:module_tr.module.id})">{{module_tr.module.code}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="module-tr-detail({id:module_tr.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="module-tr.edit({id:module_tr.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="module-tr.delete({id:module_tr.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/policy/policies.html','<div><h2 data-translate="uniromaLandingApp.policy.home.title">Policies</h2><jhi-alert></jhi-alert><div class="container"><div class="row"><div class="col-12"><button class="btn btn-uniroma" ui-sref="policy.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down" translate="uniromaLandingApp.policy.home.createLabel">New Policy</span></button> <button class="btn btn-info" ui-sref="policy.test"><span class="glyphicon glyphicon-list"></span> <span class="hidden-sm-down" translate="uniromaLandingApp.policy.home.testItLabel">Test Policies</span></button></div></div><br><!-- Filters --><div class="row"><div class="col-12"><label translate="uniromaLandingApp.policy.filters.text-label">Filtra per nome, descrizione o servizi</label><input type="text" class="form-control" ng-model="vm.currentSearch.nameFilter" ng-model-options="{allowInvalid: true, updateOn: \'default\', debounce: 500}" placeholder="{{\'uniromaLandingApp.policy.filters.text-placeholder\' | translate }}" ng-change="vm.loadAll()"></div></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="uniromaLandingApp.policy.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="uniromaLandingApp.policy.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="priority"><span data-translate="uniromaLandingApp.policy.priority">Priority</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="uniromaLandingApp.policy.services">Services</span></th><th><span data-translate="uniromaLandingApp.policy.is_active">is_active</span> / <span data-translate="uniromaLandingApp.policy.is_deactive">is_active</span></th><th></th></tr></thead><tbody><tr ng-repeat="policy in vm.policies track by policy.id"><td><a ui-sref="policy.edit({id:policy.id})">{{policy.name}}</a></td><td>{{policy.description}}</td><td>{{policy.priority}}</td><td><div ng-repeat="service in policy.services.split(\';\')">{{service}}</div></td><td><a class="btn btn-xs" ng-click="vm.toggleActivation(policy)" ng-class="{\'btn-success\': policy.isActive==true,\'btn-default\': policy.isActive==false}"><span class="glyphicon" ng-class="{\'glyphicon-ok\': policy.isActive==true,\'glyphicon-ban-circle\': policy.isActive==false}"></span> <span ng-if="policy.isActive" data-translate="uniromaLandingApp.policy.is_active">Attivo</span> <span ng-if="!policy.isActive" data-translate="uniromaLandingApp.policy.is_deactive">Disattivo</span></a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><!--                             <button type="submit" --><!--                                     ui-sref="policy-detail({id:policy.id})" --><!--                                     class="btn btn-info btn-sm"> --><!--                                 <span class="glyphicon glyphicon-eye-open"></span> --><!--                                 <span class="hidden-sm-down" data-translate="entity.action.view"></span> --><!--                             </button> --> <button type="submit" ui-sref="policy.edit({id:policy.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="policy.delete({id:policy.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/policy/policy-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.policy.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.policy.delete.question" translate-values="{id: \'{{vm.policy.id}}\'}">Are you sure you want to delete this Policy?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/policy/policy-detail.html','<div><h2><span data-translate="uniromaLandingApp.policy.detail.title">Policy</span> {{vm.policy.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.policy.name">Name</span></dt><dd><span>{{vm.policy.name}}</span></dd><dt><span data-translate="uniromaLandingApp.policy.description">Description</span></dt><dd><span>{{vm.policy.description}}</span></dd><dt><span data-translate="uniromaLandingApp.policy.is_active">Active</span></dt><dd><span class="glyphicon" ng-class="{\'glyphicon-ok\': vm.policy.isActive==true,\'glyphicon-remove\': vm.policy.isActive==false||vm.policy.isActive==null}"></span></dd></dl><dl class="dl-horizontal jh-entity-details" ng-if="vm.policy.flInserimentoGuidato"><!-- Servizi --><dt ng-if="vm.policy.servizi.length>0"><span data-translate="uniromaLandingApp.policy.creation.service">Servizi</span></dt><dd ng-if="vm.policy.servizi.length>0"><ul><li ng-repeat="serv in vm.policy.servizi | orderBy:\'code\'">{{serv.code}}</li></ul></dd><!-- Utenti --><dt ng-if="vm.policy.utenti.length>0"><span data-translate="uniromaLandingApp.policy.creation.utente">Utenti</span></dt><dd ng-if="vm.policy.utenti.length>0"><ul><li ng-repeat="utente in vm.policy.utenti | orderBy:\'code\'">{{utente.userId}}</li></ul></dd><!-- Attributi --><dt ng-if="vm.policy.regole.length>0"><span data-translate="uniromaLandingApp.policy.creation.categorie">Categorie</span></dt><dd ng-if="vm.policy.regole.length>0"><ul><li ng-repeat="regola in vm.policy.regole"><label data-translate="uniromaLandingApp.policy.macroCategoria">Macro categoria</label>: <span ng-if="regola.macroCategoria!=null">{{regola.macroCategoria}}</span><span ng-if="regola.macroCategoria==null" data-translate="uniromaLandingApp.policy.creation.any"></span><label data-translate="uniromaLandingApp.policy.categoria">categoria</label>: <span ng-if="regola.categoria!=null">{{regola.categoria}}</span><span ng-if="regola.categoria==null" data-translate="uniromaLandingApp.policy.creation.any"></span><label data-translate="uniromaLandingApp.policy.sottoCategoria">Sotto categoria</label>: <span ng-if="regola.sottoCategoria!=null">{{regola.sottoCategoria}}</span><span ng-if="regola.sottoCategoria==null" data-translate="uniromaLandingApp.policy.creation.any"></span><label data-translate="uniromaLandingApp.policy.statoGenerale">Stato generale</label>: <span ng-if="regola.statoGenerale!=null">{{regola.statoGenerale}}</span><span ng-if="regola.statoGenerale==null" data-translate="uniromaLandingApp.policy.creation.any"></span><label data-translate="uniromaLandingApp.policy.statoSpecifico">Stato specifico</label>: <span ng-if="regola.statoSpecifico!=null">{{regola.statoSpecifico}}</span><span ng-if="regola.statoSpecifico==null" data-translate="uniromaLandingApp.policy.creation.any"></span></li></ul></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.policy.rule">Rule</span></dt><dd><div ui-ace="aceOptions" style="height: 400px; border:1px solid rgba(77, 77, 76, 0.24); margin-top:10px" ng-model="vm.policy.policyXACML" readonly="readonly"></div></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="policy-detail.edit({id:vm.policy.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/policy/policy-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPolicyLabel" data-translate="uniromaLandingApp.policy.home.createOrEditLabel">Create or edit a Policy</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group txt-center"><div class="btn-group btn-group-lg" role="group"><button type="button" class="btn" ng-class="{\'btn-primary\':!vm.testMode,\'btn-default\':!vm.testMode}" ng-click="vm.switchMode(false)">Modifica della policy</button> <button type="button" class="btn" ng-class="{\'btn-primary\':vm.testMode,\'btn-default\':vm.testMode}" ng-click="vm.switchMode(true)">Test di esecuzione</button></div></div><!-- INSERIMENTO POLICY MANUALE \r\n        <div class="form-group" ng-if="!vm.policy.flInserimentoGuidato">\r\n            <label class="control-label" data-translate="uniromaLandingApp.policy.rule" for="field_policyXACML">Rule</label>\r\n            <br>\r\n            <label class="btn btn-default">\r\n\t\t\t\t<span class="glyphicon glyphicon-upload"></span> \r\n\t\t\t\t<span data-translate="global.form.upload"></span>\r\n\t\t\t\t<input type="file" on-read-file="displayFileContents(contents)" accept="application/xml" style="display:none;">\r\n\t\t\t</label>\r\n\t\t\t<span ng-if="vm.policy.policyXACML!=null">\r\n\t\t\t\t<i class="fa fa-check-circle fa-2x text-success" ng-if="vm.policyIsCorrect===true"></i>\r\n\t\t\t\t<i class="fa fa-times-circle fa-2x text-danger" ng-if="vm.policyIsCorrect===false"></i>\r\n\t\t\t\t<span ng-if=\'vm.whyPolicyIsIncorrect!=null && vm.policyIsCorrect===false\' class=\'text-danger\'>{{vm.whyPolicyIsIncorrect}}</span>\r\n\t\t\t\t<span ng-if=\'vm.whyPolicyIsIncorrect==null && vm.policyIsCorrect===true\' class=\'text-success\'\r\n\t\t\t\t\tdata-translate="uniromaLandingApp.policy.isValid">Policy Valida</span>\r\n\t\t\t</span>\r\n\t\t\t<br>\r\n            <div ui-ace="{ mode: \'xml\', onLoad : aceLoaded }" style="height: 400px; border:1px solid rgba(77, 77, 76, 0.24); margin-top:10px;" ng-model="vm.policy.policyXACML" required></div>\r\n        </div>\r\n        --><!-- INSERIMENTO POLICY GUIDATO --><div class="form-group" ng-if="!vm.testMode"><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.policy.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.policy.name" required></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.policy.description" for="field_description">description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.policy.description"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.policy.priority" for="field_priority">priority</label><input type="number" class="form-control" name="priority" id="field_priority" ng-model="vm.policy.priority"></div><hr><!-- Servizi --><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.policy.creation.service_label" for="field_service">Seleziona servizi</label><br><input type="text" ng-model="vm.selectedService" uib-typeahead="serv.code for serv in vm.listaServizi | filter:$viewValue | limitTo:20" typeahead-on-select="vm.addService($item, $model, $label)" name="service" id="field_service" class="form-control" placeholder="digita il nome del servizio"></div><div class="form-group" ng-if="vm.policyServices.length>0"><table class="table table-striped"><thead><tr><th translate="uniromaLandingApp.policy.creation.service">Servizio</th><th translate="uniromaLandingApp.policy.creation.remove">Rimuovi</th></tr></thead><tbody><tr ng-repeat="serv in vm.policyServices"><td>{{serv}}</td><td><button type="button" ng-click="vm.removeService(serv)" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></button></td></tr></tbody></table></div><hr><label>Regola</label><div class="row"><div class="col-xs-4"><select class="form-control" id="mainSelect" ng-change="vm.validate()" placeholder="Selezionare la propriet\xE0" ng-model="vm.selAttr"><option id="vuoto" disabled="true" selected="true" value="">-- Selezionare la propriet\xE0 --</option><optgroup label="Utente"><option value="user.uid">UID</option><option value="user.nome">Nome</option><option value="user.cognome">Cognome</option><option value="rawAttributes.codiceFiscale">Codice Fiscale</option><option value="rawAttributes.matricolaStudente">Matricola Studente</option><option value="rawAttributes.email">Email</option><!-- \t\t\t\t\t\t\t<option value="rawAttributes.dataNascita">Data nascita</option> --><option value="user.statoAggregato">statoAggregato</option></optgroup><optgroup label="Ruolo"><option value="role.ruolo">Ruolo</option><option value="role.macroCategoria">Macrocategoria</option><option value="role.categoria">Categoria</option><option value="role.sottoCategoria">Sottocategoria</option><option value="role.macroStato">MacroStato</option><option value="role.statoSpecifico">Stato specifico</option><!-- \t\t\t\t\t\t\t<option value="role.decorrenza">Decorrenza</option> --><option value="role.giorniDaDecorrenza">Giorni dalla decorrenza</option></optgroup><!-- \t\t\t\t\t\t<optgroup label="Altro"> --><!-- \t\t\t\t\t\t\t<option value="newDate">Data corrente</option> --><!-- \t\t\t\t\t\t</optgroup> --></select></div><div class="col-xs-2"><select id="operation" class="form-control" ng-model="vm.selOperation" ng-change="vm.validate()" ng-if="vm.selAttr"><option value="==">==</option><option value="!=">!=</option><option value="*=" ng-if="vm.selAttr == \'user.nome\' || vm.selAttr == \'user.cognome\' || vm.selAttr == \'rawAttributes.codiceFiscale\' || vm.selAttr == \'rawAttributes.matricolaStudente\' || vm.selAttr == \'rawAttributes.email\' || vm.selAttr == \'user.uid\'">*=</option><option value=">=" ng-if="vm.selAttr == \'role.decorrenza\' || vm.selAttr == \'role.giorniDaDecorrenza\'">&gt;=</option><option value="<=" ng-if="vm.selAttr == \'role.decorrenza\' || vm.selAttr == \'role.giorniDaDecorrenza\'">&lt;=</option><option value="traNMesi" ng-if="vm.selAttr == \'role.decorrenza\'">N mesi dopo</option><option value="entroNMesi" ng-if="vm.selAttr == \'role.decorrenza\'">entro N mesi</option></select></div><div class="col-xs-4"><input type="text" ng-model="vm.selectedUid" uib-typeahead="(utente.nome + \' \'+utente.cognome+\' (\' + utente.userId + \')\') for utente in vm.loadListaUtenti($viewValue)" typeahead-on-select="vm.selectUid($item, $model, $label)" name="inputUid" id="field_inputUid" class="form-control form-element form-field" ng-if="vm.selAttr == \'user.uid\'" ng-change="vm.validate()" autocomplete="off"> <input type="text" id="inputLibero" value="Testo libero" class="form-control" ng-if="vm.selAttr == \'user.nome\' || vm.selAttr == \'user.cognome\' || vm.selAttr == \'rawAttributes.codiceFiscale\' || vm.selAttr == \'rawAttributes.matricolaStudente\' || vm.selAttr == \'rawAttributes.email\'" ng-model="vm.testoLibero" ng-change="vm.validate()"><select name="ruolo" id="field_ruolo" class="form-control" ng-model="vm.currentRuolo" ng-if="vm.selAttr == \'role.ruolo\'" ng-change="vm.validate()"><option ng-repeat="ruolo in vm.listaRuoli" value="{{ruolo.codRuolo}}">{{ruolo.ruoloDescrizione}} ({{ruolo.codRuolo}})</option></select><select name="macroCategoria" id="field_macroCategoria" class="form-control" ng-model="vm.currentMacroCat" ng-options="macroCategoria.descrizione for macroCategoria in vm.listaMacroCategorie" ng-if="vm.selAttr == \'role.macroCategoria\'" ng-change="vm.validate()"><option value=""></option></select><select name="categoria" id="field_categoria" class="form-control" ng-model="vm.currentCat" ng-if="vm.selAttr == \'role.categoria\'" ng-change="vm.validate()"><optgroup ng-repeat="macroCategoria in vm.listaMacroCategorie" label="{{macroCategoria.descrizione}}"><option ng-repeat="categoria in macroCategoria.figli" value="{{categoria.descrizione}}">{{categoria.descrizione}}</option></optgroup><option value=""></option></select><select name="sottoCategoria" id="field_sottoCategoria" class="form-control" ng-model="vm.currentSottoCat" ng-if="vm.selAttr == \'role.sottoCategoria\'" ng-change="vm.validate()"><optgroup ng-repeat="categoria in vm.listaCategorieNonVuote" label="{{categoria.descrizione}}"><option ng-repeat="sottoCategoria in categoria.figli" value="{{sottoCategoria.descrizione}}">{{sottoCategoria.descrizione}}</option></optgroup><option value=""></option></select><select class="form-control" name="macroStato" id="field_macroStato" ng-model="vm.currentMacroStato" ng-if="vm.selAttr == \'role.macroStato\' || vm.selAttr == \'user.statoAggregato\'" ng-options="macroStato.macroStato for macroStato in vm.listaMacroStati" ng-change="vm.validate()"><option value=""></option></select><select class="form-control" name="statoSpecifico" id="field_statoSpecifico" ng-model="vm.currentStatoSpecifico" ng-if="vm.selAttr == \'role.statoSpecifico\'" ng-options="stato for stato in vm.listaStati" ng-change="vm.validate()"><option value=""></option></select><input type="date" datepicker-popup="{{format}}" show-button-bar="false" name="decorrenza" class="form-control" placeholder="{{format}}" ng-model="vm.currentDecorrenza" ng-if="vm.selAttr == \'role.decorrenza\' && (vm.selOperation != \'traNMesi\' && vm.selOperation != \'entroNMesi\')" ng-change="vm.validate()" is-open="open" ng-click="open = true" datepicker-localdate> <input type="number" name="numeroLibero" class="form-control" ng-model="vm.numeroLibero" ng-if="(vm.selAttr == \'role.giorniDaDecorrenza\' || (vm.selAttr == \'role.decorrenza\' && (vm.selOperation == \'traNMesi\' || vm.selOperation == \'entroNMesi\')))" ng-change="vm.validate()"></div><div class="col-xs-2"><button type="button" class="btn btn-info" ng-click="vm.openMultiLoader()" uib-popover-template="\'myPopoverTemplate.html\'" uib-tooltip="carica elenco" ng-if="vm.selAttr == \'user.uid\' || vm.selAttr == \'rawAttributes.matricolaStudente\'"><span class="glyphicon glyphicon-download-alt"></span></button> <button type="button" class="btn btn-uniroma right" ng-click="vm.addToPolicy()" ng-disabled="!vm.selAttrValide"><span class="glyphicon glyphicon-arrow-down"></span></button></div></div><script type="text/ng-template" id="myPopoverTemplate.html"><div class="form-group">\r\n          \t<label>elenco di {{vm.selAttr}}</label>\r\n          \t<textarea rows="10" cols="30" ng-model="vm.currentElenco" ng-change="vm.validate()"></textarea>\r\n\t\t\t<button type="button" class="btn btn-uniroma right" ng-click="vm.addElencoToPolicy()" ng-disabled="!vm.selAttr || !vm.currentElenco">\r\n\t\t\t\t<span class="glyphicon glyphicon-arrow-down"></span>\r\n\t\t\t</button>\r\n        </div></script><!-- \t        <div ui-ace="{ mode: \'javascript\', onLoad : aceLoaded }" style="height: 400px; border:1px solid rgba(77, 77, 76, 0.24); margin-top:10px;" ng-model="vm.policy.policyJS" required></div> --><div ui-codemirror="{\r\n      lineNumbers: false,\r\n      theme:\'default\',\r\n      lineWrapping : true,\r\n      mode: \'js\'\r\n    }" ui-refresh="true" style="zheight: 400px; border:1px solid rgba(77, 77, 76, 0.24); margin-top:10px" ng-model="vm.policy.policyJS" required></div><!-- Utenti --><!--         \t<div class="form-group"> --><!--             \t<label class="control-label" data-translate="uniromaLandingApp.policy.creation.utente_label" for="field_utente">Seleziona utenti</label> --><!--             \t<br> --><!--             \t<div class="input-group"> --><!--       \t\t\t\t<input type="text" ng-model="vm.selectedUser" --><!-- \t\t\t\t\t\t\tuib-typeahead="(utente.nome + \' \'+utente.cognome+\' (\' + utente.userId + \')\') for utente in vm.loadListaUtenti($viewValue)" --><!-- \t\t\t\t\t\t\ttypeahead-on-select="vm.addUtente($item, $model, $label)" --><!-- \t\t\t\t\t\t\tname="utente" id="field_utente" --><!-- \t\t\t\t\t\t\tclass="form-control" --><!-- \t\t\t\t\t\t\tplaceholder="digita il nome o il cognome dell\'utente"> --><!--       \t\t\t\t\t<span class="input-group-btn"> --><!--         \t\t\t\t\t<button class="btn btn-default btn-input-group" type="button" ng-click="vm.addNuovoUtente()" --><!--         \t\t\t\t\t\t\tdata-translate="entity.action.add">Aggiungi --><!--         \t\t\t\t\t</button> --><!--       \t\t\t\t\t</span> --><!--     \t\t\t</div>/input-group --><!-- \t\t\t</div> --><!-- \t\t\t<div class="form-group" ng-if="vm.policyUsers.length>0"> --><!-- \t        \t<table class="table table-striped"> --><!-- \t\t\t\t\t<thead> --><!-- \t\t\t\t\t\t<tr> --><!-- \t\t\t\t\t\t\t<th translate="uniromaLandingApp.policy.creation.utente">Utente</th> --><!-- \t\t\t\t\t\t\t<th translate="uniromaLandingApp.policy.creation.remove">Rimuovi</th> --><!-- \t\t\t\t\t\t</tr> --><!-- \t\t\t\t\t</thead> --><!-- \t\t\t\t\t<tbody> --><!-- \t\t\t\t\t\t<tr ng-repeat="utente in vm.policyUsers | orderBy:\'code\'"> --><!-- \t\t\t\t\t\t\t<td> --><!-- \t\t\t\t\t\t\t\t<span ng-if="utente.nome!=null&&utente.cognome!=null">{{utente.nome}} {{utente.cognome}} (</span> --><!-- \t\t\t\t\t\t\t\t{{utente.userId}}  --><!-- \t\t\t\t\t\t\t\t<span ng-if="utente.nome!=null&&utente.cognome!=null">)</span> --><!-- \t\t\t\t\t\t\t</td> --><!-- \t\t\t\t\t\t\t<td> --><!-- \t\t\t\t\t\t\t\t<button type="button" --><!-- \t                                ng-click="vm.removeUtente(utente)" --><!-- \t                                class="btn btn-danger btn-sm"> --><!-- \t                            \t<i class="fa fa-trash"></i> --><!-- \t                        \t</button> --><!-- \t\t\t\t\t\t\t</td> --><!-- \t\t\t\t\t\t</tr> --><!-- \t\t\t\t\t</tbody> --><!-- \t\t\t\t</table> --><!-- \t        </div> --><!-- Attributi --><!-- \t        <div class="form-group"> --><!-- \t        \t<label class="control-label" data-translate="uniromaLandingApp.policy.creation.attribute_label">Gestione attributi</label> --><!-- \t        \t<div class="panel panel-default"> --><!-- \t\t\t\t\t<div class="panel-body"> --><!-- \t\t\t\t\t\tCategorie --><!-- \t\t\t\t\t\t<div class="row"> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label>Macro categoria</label> --><!-- \t\t\t\t\t    \t\t<select class="form-control" name="macroCategoria" id="field_macroCategoria" ng-model="vm.currentMacroCat" --><!-- \t\t           \t\t\t\t\tng-options="macroCategoria.descrizione for macroCategoria in vm.listaMacroCategorie" --><!-- \t\t           \t\t\t\t\tng-change="vm.getCategorie()"> --><!-- \t\t\t\t\t\t\t\t\t<option value=""></option> --><!-- \t\t\t\t\t\t\t\t</select> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label>categoria</label> --><!-- \t\t\t\t\t    \t\t<select class="form-control" name="categoria" id="field_categoria" --><!-- \t\t\t\t           \t\t\t\tng-model="vm.currentCategoria" --><!-- \t\t\t\t           \t\t\t\tng-change="vm.getSottoCategorie()" --><!-- \t\t\t\t           \t\t\t\tng-disabled="vm.currentMacroCat==null" --><!-- \t\t\t\t           \t\t\t\tng-options="categoria.descrizione for categoria in vm.listaCategorie"> --><!-- \t\t\t\t\t\t\t\t\t<option value=""></option> --><!-- \t\t\t\t\t\t\t\t</select> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label>Sotto categoria</label> --><!-- \t\t\t\t\t    \t\t<select class="form-control" name="sottoCategoria" id="field_sottoCategoria"  --><!-- \t\t\t\t           \t\t\t\tng-model="vm.currentSottoCat" --><!-- \t\t\t\t           \t\t\t\tng-disabled="vm.currentCategoria==null" --><!-- \t\t\t\t           \t\t\t\tng-options="sottoCategoria.descrizione for sottoCategoria in vm.listaSottoCategorie"> --><!-- \t\t\t\t\t\t\t\t\t<option value=""></option> --><!-- \t\t\t\t\t\t\t\t</select> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    </div> --><!-- \t\t\t\t\t    Stati --><!-- \t\t\t\t\t    <div class="row"> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label>Stato generale</label> --><!-- \t\t\t\t\t    \t\t<select class="form-control" name="statoGenerale" id="field_statoGenerale" ng-model="vm.currentStatoGenerale"  --><!-- \t\t           \t\t\t\t\tng-options="statoGenerale.statoGenerale for statoGenerale in vm.listaStatiGenerali" --><!-- \t\t           \t\t\t\t\tng-change="vm.getStatiSpecifici()"> --><!-- \t\t\t\t\t\t\t\t\t<option value=""></option> --><!-- \t\t\t\t\t\t\t\t</select> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label>Stato specifico</label> --><!-- \t\t\t\t\t    \t\t<select class="form-control" name="statoSpecifico" id="field_statoSpecifico"  --><!-- \t\t\t\t           \t\t\t\tng-model="vm.currentStatoSpecifico" --><!-- \t\t\t\t           \t\t\t\tng-disabled="vm.currentStatoGenerale==null" --><!-- \t\t\t\t           \t\t\t\tng-options="statoSpecifico for statoSpecifico in vm.listaStatiSpecifici"> --><!-- \t\t\t\t\t\t\t\t\t<option value=""></option> --><!-- \t\t\t\t\t\t\t\t</select> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label>&nbsp;</label> --><!-- \t\t\t\t\t    \t\t<br> --><!-- \t\t\t\t\t    \t\t<button type="button" class="btn btn-info float-right" ng-click="vm.addRegola()" ng-disabled="vm.currentMacroCat==null&&vm.currentStatoGenerale==null"> --><!--             \t\t\t\t\t\t<i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.add">add</span> --><!--         \t\t\t\t\t\t</button> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    </div> --><!-- \t\t\t\t  \t</div> --><!-- \t\t\t\t</div> --><!-- \t        </div> --><!-- \t        <div class="panel panel-default" ng-if="vm.regole.length>0"> --><!-- \t\t\t\t\t<div class="panel-body" ng-repeat="regola in vm.regole"> --><!-- \t\t\t\t\t\tCategorie --><!-- \t\t\t\t\t\t<div class="row"> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label data-translate="uniromaLandingApp.policy.macroCategoria"></label> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.macroCategoria!=null">{{regola.macroCategoria}}</span> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.macroCategoria==null" data-translate="uniromaLandingApp.policy.creation.any"></span> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label data-translate="uniromaLandingApp.policy.categoria"></label> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.categoria!=null">{{regola.categoria}}</span> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.categoria==null" data-translate="uniromaLandingApp.policy.creation.any"></span> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label data-translate="uniromaLandingApp.policy.sottoCategoria"></label> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.sottoCategoria!=null">{{regola.sottoCategoria}}</span> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.sottoCategoria==null" data-translate="uniromaLandingApp.policy.creation.any"></span> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    </div> --><!-- \t\t\t\t\t    Stati --><!-- \t\t\t\t\t    <div class="row"> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label data-translate="uniromaLandingApp.policy.statoGenerale"></label> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.statoGenerale!=null">{{regola.statoGenerale}}</span> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.statoGenerale==null" data-translate="uniromaLandingApp.policy.creation.any"></span> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label data-translate="uniromaLandingApp.policy.statoSpecifico"></label> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.statoSpecifico!=null">{{regola.statoSpecifico}}</span> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.statoSpecifico==null" data-translate="uniromaLandingApp.policy.creation.any"></span> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label>&nbsp;</label> --><!-- \t\t\t\t\t    \t\t<br> --><!-- \t\t\t\t\t    \t\t<button type="button" class="btn btn-danger float-right" ng-click="vm.removeRegola()"> --><!--             \t\t\t\t\t\t<i class="fa fa-remove"></i>&nbsp;<span data-translate="entity.action.delete">delete</span> --><!--         \t\t\t\t\t\t</button> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    </div> --><!-- \t\t\t\t  \t</div> --><!-- \t\t\t\t</div> --></div><div class="form-group" ng-if="vm.testMode"><!-- Utenti --><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.policy.creation.utente_label" for="field_utente">Seleziona utenti</label><br><div class="input-group"><input type="text" ng-model="vm.selectedUser" uib-typeahead="(utente.nome + \' \'+utente.cognome+\' (\' + utente.userId + \')\') for utente in vm.loadListaUtenti($viewValue)" typeahead-on-select="vm.selectUtente($item, $model, $label)" name="utente" id="field_utente" class="form-control form-element form-field" autocomplete="off"> <span class="input-group-btn"><button class="btn btn-default btn-input-group" type="button" ng-click="vm.testPolicies()" ng-disabled="!vm.selectedUser" data-translate="uniromaLandingApp.policy.test.testIt_label">Test</button></span></div><!-- /input-group --></div><div class="form-group row"><div class="col-xs-6 break-all" ng-if="vm.services.length > 0 || vm.executions.length > 0"><h5>Servizi abilitati</h5><dl ng-if="vm.services.length>0"><dd ng-repeat="service in vm.services">{{service}}</dd></dl><div class="form-group" ng-if="vm.services.length<=0 && !vm.typing && !vm.loading">Nessun servizio ablitato per {{vm.selectedUser}}</div><h5>Dettaglio di esecuzione motore delle regole</h5><div class="table-responsive" ng-if="vm.executions.length>0"><table class="jh-table table table-striped"><tbody><tr ng-repeat="execution in vm.executions"><td><b>{{execution.name}}</b> <span ng-if="execution.skipMessage">non eseguita: {{execution.skipMessage}}</span> <span ng-if="execution.role">eseguita per il ruolo: {{execution.role | formatRole}}</span> <span ng-if="execution.errorMessage" class="label label-danger">errore di esecuzione: {{execution.errorMessage}}</span> <span ng-if="execution.enabledServices" class="label label-info">servizi abilitati: {{execution.enabledServices.join(\', \')}}</span> - <b>{{execution.elapsed}}ms</b></td></tr></tbody></table></div></div><div class="col-xs-6 break-all" ng-if="vm.roles.length > 0 || vm.user != null || vm.attributesSize > 0"><h5>Utente (user)</h5><dl ng-if="vm.user != null"><dd ng-repeat="(name, attribute) in vm.user"><b>{{name}}</b> {{attribute}}</dd></dl><h5>Ruoli (role)</h5><div class="table-responsive" ng-if="vm.roles.length>0"><table class="jh-table table table-striped"><tbody><tr ng-repeat="role in vm.roles"><td><b>ruolo: </b>{{role.ruolo}}<br><b>macro-categoria: </b>{{role.macroCategoria}}<br><b>categoria: </b>{{role.categoria}}<br><b>sotto-categoria: </b>{{role.sottoCategoria}}<br><b>stato specifico: </b>{{role.statoSpecifico}}<br><b>macro-stato: </b>{{role.macroStato}}<br><b>decorrenza: </b>{{role.decorrenza | date:\'shortDate\'}}<span ng-if="role.decorrenza"> ({{role.giorniDaDecorrenza}} giorni)</span><br></td></tr></tbody></table></div><div class="form-group" ng-if="vm.roles.length<=0 && !vm.typing && !vm.loading">Nessun ruolo configurato per {{vm.selectedUser}}</div><h5>Attributi utente completi (rawAttributes)</h5><dl><dd ng-repeat="(name, attribute) in vm.attributes"><b>{{name}}</b> {{attribute}}</dd></dl></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || !vm.atLeastOneService()" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/policy/test-policy-dialog.html','<form class="registration-form" name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPolicyLabel" data-translate="uniromaLandingApp.policy.home.testItLabel">Test Policy</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!-- INSERIMENTO POLICY GUIDATO --><div class="form-group"><!-- Utenti --><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.policy.creation.utente_label" for="field_utente">Seleziona utenti</label><br><div class="input-group"><input type="text" ng-model="vm.selectedUser" uib-typeahead="(utente.nome + \' \'+utente.cognome+\' (\' + utente.userId + \')\') for utente in vm.loadListaUtenti($viewValue)" typeahead-on-select="vm.selectUtente($item, $model, $label)" name="utente" id="field_utente" class="form-control form-element form-field" autocomplete="off"> <span class="input-group-btn"><button class="btn btn-default btn-input-group" type="button" ng-click="vm.testPolicies()" ng-disabled="!vm.selectedUser" data-translate="uniromaLandingApp.policy.test.testIt_label">Test</button></span></div><!-- /input-group --></div><div class="form-group row"><div class="col-xs-6 break-all" ng-if="vm.roles.length > 0 || vm.services.length > 0 || vm.user != null || vm.executions.length > 0"><h5>Utente (user)</h5><dl ng-if="vm.user != null"><dd ng-repeat="(name, attribute) in vm.user"><b>{{name}}</b> {{attribute}}</dd></dl><h5>Ruoli (role)</h5><div class="table-responsive" ng-if="vm.roles.length>0"><table class="jh-table table table-striped"><tbody><tr ng-repeat="role in vm.roles"><td><b>ruolo: </b>{{role.ruolo}}<br><b>macro-categoria: </b>{{role.macroCategoria}}<br><b>categoria: </b>{{role.categoria}}<br><b>sotto-categoria: </b>{{role.sottoCategoria}}<br><b>stato specifico: </b>{{role.statoSpecifico}}<br><b>macro-stato: </b>{{role.macroStato}}<br><b>decorrenza: </b>{{role.decorrenza | date:\'shortDate\'}} ({{role.giorniDaDecorrenza}} giorni)<br></td></tr></tbody></table></div><div class="form-group" ng-if="vm.roles.length<=0 && !vm.typing && !vm.loading">Nessun ruolo configurato per {{vm.selectedUser}}</div><h5>Servizi abilitati</h5><dl ng-if="vm.services.length>0"><dd ng-repeat="service in vm.services">{{service}}</dd></dl><div class="form-group" ng-if="vm.services.length<=0 && !vm.typing && !vm.loading">Nessun servizio ablitato per {{vm.selectedUser}}</div><h5>Dettaglio di esecuzione motore delle regole</h5><div class="table-responsive" ng-if="vm.executions.length>0"><table class="jh-table table table-striped"><tbody><tr ng-repeat="execution in vm.executions"><td><b>{{execution.name}}</b> <span ng-if="execution.skipMessage">non eseguita: {{execution.skipMessage}}</span> <span ng-if="execution.role">eseguita per il ruolo: {{execution.role | formatRole}}</span> <span ng-if="execution.errorMessage" class="label label-danger">errore di esecuzione: {{execution.errorMessage}}</span> <span ng-if="execution.enabledServices" class="label label-info">servizi abilitati: {{execution.enabledServices.join(\', \')}}</span> - <b>{{execution.elapsed}}ms</b></td></tr></tbody></table></div></div><div class="col-xs-6 break-all" ng-if="vm.attributesSize > 0"><h5>Attributi utente completi (rawAttributes)</h5><dl><dd ng-repeat="(name, attribute) in vm.attributes"><b>{{name}}</b> {{attribute}}</dd></dl></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div></form>');
$templateCache.put('app/entities/policy-anag/policies.html','<div><h2 data-translate="uniromaLandingApp.policyAnag.home.title">Policies</h2><jhi-alert></jhi-alert><div class="container"><div class="row"><div class="col-12"><button class="btn btn-uniroma" ui-sref="policy-anag.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down" translate="uniromaLandingApp.policyAnag.home.createLabel">New Policy</span></button> <button class="btn btn-info" ui-sref="policy-anag.test"><span class="glyphicon glyphicon-list"></span> <span class="hidden-sm-down" translate="uniromaLandingApp.policyAnag.home.testItLabel">Test Policies</span></button></div></div><br><!-- Filters --><div class="row"><div class="col-12"><label translate="uniromaLandingApp.policyAnag.filters.text-label">Filtra per nome, descrizione o servizi</label><input type="text" class="form-control" ng-model="vm.currentSearch.nameFilter" ng-model-options="{allowInvalid: true, updateOn: \'default\', debounce: 500}" placeholder="{{\'uniromaLandingApp.policyAnag.filters.text-placeholder\' | translate }}" ng-change="vm.loadAll()"></div></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="uniromaLandingApp.policyAnag.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="uniromaLandingApp.policyAnag.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="priority"><span data-translate="uniromaLandingApp.policyAnag.priority">Priority</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="uniromaLandingApp.policyAnag.fieldName">Attribute</span></th><th><span data-translate="uniromaLandingApp.policyAnag.fieldValue">Value</span></th><th><span data-translate="uniromaLandingApp.policyAnag.is_active">is_active</span> / <span data-translate="uniromaLandingApp.policyAnag.is_deactive">is_active</span></th><th></th></tr></thead><tbody><tr ng-repeat="policy in vm.policies track by policy.id"><td><a ui-sref="policy-anag.edit({id:policy.id})">{{policy.name}}</a></td><td>{{policy.description}}</td><td>{{policy.priority}}</td><td>{{policy.fieldName}}</td><td>{{policy.fieldValue}}</td><td><a class="btn btn-xs" ng-click="vm.toggleActivation(policy)" ng-class="{\'btn-success\': policy.isActive==true,\'btn-default\': policy.isActive==false}"><span class="glyphicon" ng-class="{\'glyphicon-ok\': policy.isActive==true,\'glyphicon-ban-circle\': policy.isActive==false}"></span> <span ng-if="policy.isActive" data-translate="uniromaLandingApp.policyAnag.is_active">Attivo</span> <span ng-if="!policy.isActive" data-translate="uniromaLandingApp.policyAnag.is_deactive">Disattivo</span></a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><!--                             <button type="submit" --><!--                                     ui-sref="policy-detail({id:policy.id})" --><!--                                     class="btn btn-info btn-sm"> --><!--                                 <span class="glyphicon glyphicon-eye-open"></span> --><!--                                 <span class="hidden-sm-down" data-translate="entity.action.view"></span> --><!--                             </button> --> <button type="submit" ui-sref="policy-anag.edit({id:policy.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="policy-anag.delete({id:policy.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/policy-anag/policy-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.policy.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.policyAnag.delete.question" translate-values="{id: \'{{vm.policy.id}}\'}">Are you sure you want to delete this Policy?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/policy-anag/policy-detail.html','<div><h2><span data-translate="uniromaLandingApp.policyAnag.detail.title">Policy</span> {{vm.policy.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.policyAnag.name">Name</span></dt><dd><span>{{vm.policy.name}}</span></dd><dt><span data-translate="uniromaLandingApp.policyAnag.description">Description</span></dt><dd><span>{{vm.policy.description}}</span></dd><dt><span data-translate="uniromaLandingApp.policyAnag.is_active">Active</span></dt><dd><span class="glyphicon" ng-class="{\'glyphicon-ok\': vm.policy.isActive==true,\'glyphicon-remove\': vm.policy.isActive==false||vm.policy.isActive==null}"></span></dd></dl><dl class="dl-horizontal jh-entity-details" ng-if="vm.policy.flInserimentoGuidato"><!-- Servizi --><dt ng-if="vm.policy.servizi.length>0"><span data-translate="uniromaLandingApp.policyAnag.creation.service">Servizi</span></dt><dd ng-if="vm.policy.servizi.length>0"><ul><li ng-repeat="serv in vm.policy.servizi | orderBy:\'code\'">{{serv.code}}</li></ul></dd><!-- Utenti --><dt ng-if="vm.policy.utenti.length>0"><span data-translate="uniromaLandingApp.policyAnag.creation.utente">Utenti</span></dt><dd ng-if="vm.policy.utenti.length>0"><ul><li ng-repeat="utente in vm.policy.utenti | orderBy:\'code\'">{{utente.userId}}</li></ul></dd><!-- Attributi --><dt ng-if="vm.policy.regole.length>0"><span data-translate="uniromaLandingApp.policyAnag.creation.categorie">Categorie</span></dt><dd ng-if="vm.policy.regole.length>0"><ul><li ng-repeat="regola in vm.policy.regole"><label data-translate="uniromaLandingApp.policyAnag.macroCategoria">Macro categoria</label>: <span ng-if="regola.macroCategoria!=null">{{regola.macroCategoria}}</span><span ng-if="regola.macroCategoria==null" data-translate="uniromaLandingApp.policyAnag.creation.any"></span><label data-translate="uniromaLandingApp.policyAnag.categoria">categoria</label>: <span ng-if="regola.categoria!=null">{{regola.categoria}}</span><span ng-if="regola.categoria==null" data-translate="uniromaLandingApp.policyAnag.creation.any"></span><label data-translate="uniromaLandingApp.policyAnag.sottoCategoria">Sotto categoria</label>: <span ng-if="regola.sottoCategoria!=null">{{regola.sottoCategoria}}</span><span ng-if="regola.sottoCategoria==null" data-translate="uniromaLandingApp.policyAnag.creation.any"></span><label data-translate="uniromaLandingApp.policyAnag.statoGenerale">Stato generale</label>: <span ng-if="regola.statoGenerale!=null">{{regola.statoGenerale}}</span><span ng-if="regola.statoGenerale==null" data-translate="uniromaLandingApp.policyAnag.creation.any"></span><label data-translate="uniromaLandingApp.policyAnag.statoSpecifico">Stato specifico</label>: <span ng-if="regola.statoSpecifico!=null">{{regola.statoSpecifico}}</span><span ng-if="regola.statoSpecifico==null" data-translate="uniromaLandingApp.policyAnag.creation.any"></span></li></ul></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.policyAnag.rule">Rule</span></dt><dd><div ui-ace="aceOptions" style="height: 400px; border:1px solid rgba(77, 77, 76, 0.24); margin-top:10px" ng-model="vm.policy.policyXACML" readonly="readonly"></div></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="policy-detail.edit({id:vm.policy.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/policy-anag/policy-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPolicyLabel" data-translate="uniromaLandingApp.policyAnag.home.createOrEditLabel">Create or edit a Policy</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group txt-center"><div class="btn-group btn-group-lg" role="group"><button type="button" class="btn" ng-class="{\'btn-primary\':!vm.testMode,\'btn-default\':!vm.testMode}" ng-click="vm.switchMode(false)">Modifica della policy</button> <button type="button" class="btn" ng-class="{\'btn-primary\':vm.testMode,\'btn-default\':vm.testMode}" ng-click="vm.switchMode(true)">Test di esecuzione</button></div></div><!-- INSERIMENTO POLICY MANUALE \r\n        <div class="form-group" ng-if="!vm.policy.flInserimentoGuidato">\r\n            <label class="control-label" data-translate="uniromaLandingApp.policyAnag.rule" for="field_policyXACML">Rule</label>\r\n            <br>\r\n            <label class="btn btn-default">\r\n\t\t\t\t<span class="glyphicon glyphicon-upload"></span> \r\n\t\t\t\t<span data-translate="global.form.upload"></span>\r\n\t\t\t\t<input type="file" on-read-file="displayFileContents(contents)" accept="application/xml" style="display:none;">\r\n\t\t\t</label>\r\n\t\t\t<span ng-if="vm.policy.policyXACML!=null">\r\n\t\t\t\t<i class="fa fa-check-circle fa-2x text-success" ng-if="vm.policyIsCorrect===true"></i>\r\n\t\t\t\t<i class="fa fa-times-circle fa-2x text-danger" ng-if="vm.policyIsCorrect===false"></i>\r\n\t\t\t\t<span ng-if=\'vm.whyPolicyIsIncorrect!=null && vm.policyIsCorrect===false\' class=\'text-danger\'>{{vm.whyPolicyIsIncorrect}}</span>\r\n\t\t\t\t<span ng-if=\'vm.whyPolicyIsIncorrect==null && vm.policyIsCorrect===true\' class=\'text-success\'\r\n\t\t\t\t\tdata-translate="uniromaLandingApp.policyAnag.isValid">Policy Valida</span>\r\n\t\t\t</span>\r\n\t\t\t<br>\r\n            <div ui-ace="{ mode: \'xml\', onLoad : aceLoaded }" style="height: 400px; border:1px solid rgba(77, 77, 76, 0.24); margin-top:10px;" ng-model="vm.policy.policyXACML" required></div>\r\n        </div>\r\n        --><!-- INSERIMENTO POLICY GUIDATO --><div class="form-group" ng-if="!vm.testMode"><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.policyAnag.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.policy.name" required></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.policyAnag.description" for="field_description">description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.policy.description"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.policyAnag.priority" for="field_priority">priority</label><input type="number" class="form-control" name="priority" id="field_priority" ng-model="vm.policy.priority"></div><hr><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.policyAnag.fieldName" for="field_fieldName">fieldName</label><input type="text" class="form-control" name="priority" id="field_fieldName" ng-model="vm.policy.fieldName" uib-typeahead="field.fieldName for field in vm.loadFieldNames($viewValue)" autocomplete="off" required><!-- typeahead-on-select="vm.selectUtente($item, $model, $label)" --></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.policyAnag.fieldValue" for="field_fieldValue">fieldValue</label><input type="text" class="form-control" name="priority" id="field_fieldValue" ng-model="vm.policy.fieldValue"></div><hr><label>Regola</label><div class="row"><div class="col-xs-4"><select class="form-control" id="mainSelect" ng-change="vm.validate()" placeholder="Selezionare la propriet\xE0" ng-model="vm.selAttr"><option id="vuoto" disabled="true" selected="true" value="">-- Selezionare la propriet\xE0 --</option><optgroup label="Utente"><option value="user.uid">UID</option><option value="user.nome">Nome</option><option value="user.cognome">Cognome</option><option value="rawAttributes.codiceFiscale">Codice Fiscale</option><option value="rawAttributes.matricolaStudente">Matricola Studente</option><option value="rawAttributes.email">Email</option><!-- \t\t\t\t\t\t\t<option value="rawAttributes.dataNascita">Data nascita</option> --><option value="user.statoAggregato">statoAggregato</option></optgroup><optgroup label="Ruolo"><option value="role.ruolo">Ruolo</option><option value="role.macroCategoria">Macrocategoria</option><option value="role.categoria">Categoria</option><option value="role.sottoCategoria">Sottocategoria</option><option value="role.macroStato">MacroStato</option><option value="role.statoSpecifico">Stato specifico</option><!-- \t\t\t\t\t\t\t<option value="role.decorrenza">Decorrenza</option> --><option value="role.giorniDaDecorrenza">Giorni dalla decorrenza</option></optgroup><!-- \t\t\t\t\t\t<optgroup label="Altro"> --><!-- \t\t\t\t\t\t\t<option value="newDate">Data corrente</option> --><!-- \t\t\t\t\t\t</optgroup> --></select></div><div class="col-xs-2"><select id="operation" class="form-control" ng-model="vm.selOperation" ng-change="vm.validate()" ng-if="vm.selAttr"><option value="==">==</option><option value="!=">!=</option><option value="*=" ng-if="vm.selAttr == \'user.nome\' || vm.selAttr == \'user.cognome\' || vm.selAttr == \'rawAttributes.codiceFiscale\' || vm.selAttr == \'rawAttributes.matricolaStudente\' || vm.selAttr == \'rawAttributes.email\' || vm.selAttr == \'user.uid\'">*=</option><option value=">=" ng-if="vm.selAttr == \'role.decorrenza\' || vm.selAttr == \'role.giorniDaDecorrenza\'">&gt;=</option><option value="<=" ng-if="vm.selAttr == \'role.decorrenza\' || vm.selAttr == \'role.giorniDaDecorrenza\'">&lt;=</option><option value="traNMesi" ng-if="vm.selAttr == \'role.decorrenza\'">N mesi dopo</option><option value="entroNMesi" ng-if="vm.selAttr == \'role.decorrenza\'">entro N mesi</option></select></div><div class="col-xs-4"><input type="text" ng-model="vm.selectedUid" uib-typeahead="(utente.nome + \' \'+utente.cognome+\' (\' + utente.userId + \')\') for utente in vm.loadListaUtenti($viewValue)" typeahead-on-select="vm.selectUid($item, $model, $label)" name="inputUid" id="field_inputUid" class="form-control form-element form-field" ng-if="vm.selAttr == \'user.uid\'" ng-change="vm.validate()" autocomplete="off"> <input type="text" id="inputLibero" value="Testo libero" class="form-control" ng-if="vm.selAttr == \'user.nome\' || vm.selAttr == \'user.cognome\' || vm.selAttr == \'rawAttributes.codiceFiscale\' || vm.selAttr == \'rawAttributes.matricolaStudente\' || vm.selAttr == \'rawAttributes.email\'" ng-model="vm.testoLibero" ng-change="vm.validate()"><select name="ruolo" id="field_ruolo" class="form-control" ng-model="vm.currentRuolo" ng-if="vm.selAttr == \'role.ruolo\'" ng-change="vm.validate()"><option ng-repeat="ruolo in vm.listaRuoli" value="{{ruolo.codRuolo}}">{{ruolo.ruoloDescrizione}} ({{ruolo.codRuolo}})</option></select><select name="macroCategoria" id="field_macroCategoria" class="form-control" ng-model="vm.currentMacroCat" ng-options="macroCategoria.descrizione for macroCategoria in vm.listaMacroCategorie" ng-if="vm.selAttr == \'role.macroCategoria\'" ng-change="vm.validate()"><option value=""></option></select><select name="categoria" id="field_categoria" class="form-control" ng-model="vm.currentCat" ng-if="vm.selAttr == \'role.categoria\'" ng-change="vm.validate()"><optgroup ng-repeat="macroCategoria in vm.listaMacroCategorie" label="{{macroCategoria.descrizione}}"><option ng-repeat="categoria in macroCategoria.figli" value="{{categoria.descrizione}}">{{categoria.descrizione}}</option></optgroup><option value=""></option></select><select name="sottoCategoria" id="field_sottoCategoria" class="form-control" ng-model="vm.currentSottoCat" ng-if="vm.selAttr == \'role.sottoCategoria\'" ng-change="vm.validate()"><optgroup ng-repeat="categoria in vm.listaCategorieNonVuote" label="{{categoria.descrizione}}"><option ng-repeat="sottoCategoria in categoria.figli" value="{{sottoCategoria.descrizione}}">{{sottoCategoria.descrizione}}</option></optgroup><option value=""></option></select><select class="form-control" name="macroStato" id="field_macroStato" ng-model="vm.currentMacroStato" ng-if="vm.selAttr == \'role.macroStato\' || vm.selAttr == \'user.statoAggregato\'" ng-options="macroStato.macroStato for macroStato in vm.listaMacroStati" ng-change="vm.validate()"><option value=""></option></select><select class="form-control" name="statoSpecifico" id="field_statoSpecifico" ng-model="vm.currentStatoSpecifico" ng-if="vm.selAttr == \'role.statoSpecifico\'" ng-options="stato for stato in vm.listaStati" ng-change="vm.validate()"><option value=""></option></select><input type="date" datepicker-popup="{{format}}" show-button-bar="false" name="decorrenza" class="form-control" placeholder="{{format}}" ng-model="vm.currentDecorrenza" ng-if="vm.selAttr == \'role.decorrenza\' && (vm.selOperation != \'traNMesi\' && vm.selOperation != \'entroNMesi\')" ng-change="vm.validate()" is-open="open" ng-click="open = true" datepicker-localdate> <input type="number" name="numeroLibero" class="form-control" ng-model="vm.numeroLibero" ng-if="(vm.selAttr == \'role.giorniDaDecorrenza\' || (vm.selAttr == \'role.decorrenza\' && (vm.selOperation == \'traNMesi\' || vm.selOperation == \'entroNMesi\')))" ng-change="vm.validate()"></div><div class="col-xs-2"><button type="button" class="btn btn-info" ng-click="vm.openMultiLoader()" uib-popover-template="\'myPopoverTemplate.html\'" uib-tooltip="carica elenco" ng-if="vm.selAttr == \'user.uid\' || vm.selAttr == \'rawAttributes.matricolaStudente\'"><span class="glyphicon glyphicon-download-alt"></span></button> <button type="button" class="btn btn-uniroma right" ng-click="vm.addToPolicy()" ng-disabled="!vm.selAttrValide"><span class="glyphicon glyphicon-arrow-down"></span></button></div></div><script type="text/ng-template" id="myPopoverTemplate.html"><div class="form-group">\r\n          \t<label>elenco di {{vm.selAttr}}</label>\r\n          \t<textarea rows="10" cols="30" ng-model="vm.currentElenco" ng-change="vm.validate()"></textarea>\r\n\t\t\t<button type="button" class="btn btn-uniroma right" ng-click="vm.addElencoToPolicy()" ng-disabled="!vm.selAttr || !vm.currentElenco">\r\n\t\t\t\t<span class="glyphicon glyphicon-arrow-down"></span>\r\n\t\t\t</button>\r\n        </div></script><!-- \t        <div ui-ace="{ mode: \'javascript\', onLoad : aceLoaded }" style="height: 400px; border:1px solid rgba(77, 77, 76, 0.24); margin-top:10px;" ng-model="vm.policy.policyJS" required></div> --><div ui-codemirror="{\r\n      lineNumbers: false,\r\n      theme:\'default\',\r\n      lineWrapping : true,\r\n      mode: \'js\'\r\n    }" ui-refresh="true" style="zheight: 400px; border:1px solid rgba(77, 77, 76, 0.24); margin-top:10px" ng-model="vm.policy.policyJS" required></div><!-- Utenti --><!--         \t<div class="form-group"> --><!--             \t<label class="control-label" data-translate="uniromaLandingApp.policyAnag.creation.utente_label" for="field_utente">Seleziona utenti</label> --><!--             \t<br> --><!--             \t<div class="input-group"> --><!--       \t\t\t\t<input type="text" ng-model="vm.selectedUser" --><!-- \t\t\t\t\t\t\tuib-typeahead="(utente.nome + \' \'+utente.cognome+\' (\' + utente.userId + \')\') for utente in vm.loadListaUtenti($viewValue)" --><!-- \t\t\t\t\t\t\ttypeahead-on-select="vm.addUtente($item, $model, $label)" --><!-- \t\t\t\t\t\t\tname="utente" id="field_utente" --><!-- \t\t\t\t\t\t\tclass="form-control" --><!-- \t\t\t\t\t\t\tplaceholder="digita il nome o il cognome dell\'utente"> --><!--       \t\t\t\t\t<span class="input-group-btn"> --><!--         \t\t\t\t\t<button class="btn btn-default btn-input-group" type="button" ng-click="vm.addNuovoUtente()" --><!--         \t\t\t\t\t\t\tdata-translate="entity.action.add">Aggiungi --><!--         \t\t\t\t\t</button> --><!--       \t\t\t\t\t</span> --><!--     \t\t\t</div>/input-group --><!-- \t\t\t</div> --><!-- \t\t\t<div class="form-group" ng-if="vm.policyUsers.length>0"> --><!-- \t        \t<table class="table table-striped"> --><!-- \t\t\t\t\t<thead> --><!-- \t\t\t\t\t\t<tr> --><!-- \t\t\t\t\t\t\t<th translate="uniromaLandingApp.policyAnag.creation.utente">Utente</th> --><!-- \t\t\t\t\t\t\t<th translate="uniromaLandingApp.policyAnag.creation.remove">Rimuovi</th> --><!-- \t\t\t\t\t\t</tr> --><!-- \t\t\t\t\t</thead> --><!-- \t\t\t\t\t<tbody> --><!-- \t\t\t\t\t\t<tr ng-repeat="utente in vm.policyUsers | orderBy:\'code\'"> --><!-- \t\t\t\t\t\t\t<td> --><!-- \t\t\t\t\t\t\t\t<span ng-if="utente.nome!=null&&utente.cognome!=null">{{utente.nome}} {{utente.cognome}} (</span> --><!-- \t\t\t\t\t\t\t\t{{utente.userId}}  --><!-- \t\t\t\t\t\t\t\t<span ng-if="utente.nome!=null&&utente.cognome!=null">)</span> --><!-- \t\t\t\t\t\t\t</td> --><!-- \t\t\t\t\t\t\t<td> --><!-- \t\t\t\t\t\t\t\t<button type="button" --><!-- \t                                ng-click="vm.removeUtente(utente)" --><!-- \t                                class="btn btn-danger btn-sm"> --><!-- \t                            \t<i class="fa fa-trash"></i> --><!-- \t                        \t</button> --><!-- \t\t\t\t\t\t\t</td> --><!-- \t\t\t\t\t\t</tr> --><!-- \t\t\t\t\t</tbody> --><!-- \t\t\t\t</table> --><!-- \t        </div> --><!-- Attributi --><!-- \t        <div class="form-group"> --><!-- \t        \t<label class="control-label" data-translate="uniromaLandingApp.policyAnag.creation.attribute_label">Gestione attributi</label> --><!-- \t        \t<div class="panel panel-default"> --><!-- \t\t\t\t\t<div class="panel-body"> --><!-- \t\t\t\t\t\tCategorie --><!-- \t\t\t\t\t\t<div class="row"> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label>Macro categoria</label> --><!-- \t\t\t\t\t    \t\t<select class="form-control" name="macroCategoria" id="field_macroCategoria" ng-model="vm.currentMacroCat" --><!-- \t\t           \t\t\t\t\tng-options="macroCategoria.descrizione for macroCategoria in vm.listaMacroCategorie" --><!-- \t\t           \t\t\t\t\tng-change="vm.getCategorie()"> --><!-- \t\t\t\t\t\t\t\t\t<option value=""></option> --><!-- \t\t\t\t\t\t\t\t</select> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label>categoria</label> --><!-- \t\t\t\t\t    \t\t<select class="form-control" name="categoria" id="field_categoria" --><!-- \t\t\t\t           \t\t\t\tng-model="vm.currentCategoria" --><!-- \t\t\t\t           \t\t\t\tng-change="vm.getSottoCategorie()" --><!-- \t\t\t\t           \t\t\t\tng-disabled="vm.currentMacroCat==null" --><!-- \t\t\t\t           \t\t\t\tng-options="categoria.descrizione for categoria in vm.listaCategorie"> --><!-- \t\t\t\t\t\t\t\t\t<option value=""></option> --><!-- \t\t\t\t\t\t\t\t</select> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label>Sotto categoria</label> --><!-- \t\t\t\t\t    \t\t<select class="form-control" name="sottoCategoria" id="field_sottoCategoria"  --><!-- \t\t\t\t           \t\t\t\tng-model="vm.currentSottoCat" --><!-- \t\t\t\t           \t\t\t\tng-disabled="vm.currentCategoria==null" --><!-- \t\t\t\t           \t\t\t\tng-options="sottoCategoria.descrizione for sottoCategoria in vm.listaSottoCategorie"> --><!-- \t\t\t\t\t\t\t\t\t<option value=""></option> --><!-- \t\t\t\t\t\t\t\t</select> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    </div> --><!-- \t\t\t\t\t    Stati --><!-- \t\t\t\t\t    <div class="row"> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label>Stato generale</label> --><!-- \t\t\t\t\t    \t\t<select class="form-control" name="statoGenerale" id="field_statoGenerale" ng-model="vm.currentStatoGenerale"  --><!-- \t\t           \t\t\t\t\tng-options="statoGenerale.statoGenerale for statoGenerale in vm.listaStatiGenerali" --><!-- \t\t           \t\t\t\t\tng-change="vm.getStatiSpecifici()"> --><!-- \t\t\t\t\t\t\t\t\t<option value=""></option> --><!-- \t\t\t\t\t\t\t\t</select> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label>Stato specifico</label> --><!-- \t\t\t\t\t    \t\t<select class="form-control" name="statoSpecifico" id="field_statoSpecifico"  --><!-- \t\t\t\t           \t\t\t\tng-model="vm.currentStatoSpecifico" --><!-- \t\t\t\t           \t\t\t\tng-disabled="vm.currentStatoGenerale==null" --><!-- \t\t\t\t           \t\t\t\tng-options="statoSpecifico for statoSpecifico in vm.listaStatiSpecifici"> --><!-- \t\t\t\t\t\t\t\t\t<option value=""></option> --><!-- \t\t\t\t\t\t\t\t</select> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label>&nbsp;</label> --><!-- \t\t\t\t\t    \t\t<br> --><!-- \t\t\t\t\t    \t\t<button type="button" class="btn btn-info float-right" ng-click="vm.addRegola()" ng-disabled="vm.currentMacroCat==null&&vm.currentStatoGenerale==null"> --><!--             \t\t\t\t\t\t<i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.add">add</span> --><!--         \t\t\t\t\t\t</button> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    </div> --><!-- \t\t\t\t  \t</div> --><!-- \t\t\t\t</div> --><!-- \t        </div> --><!-- \t        <div class="panel panel-default" ng-if="vm.regole.length>0"> --><!-- \t\t\t\t\t<div class="panel-body" ng-repeat="regola in vm.regole"> --><!-- \t\t\t\t\t\tCategorie --><!-- \t\t\t\t\t\t<div class="row"> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label data-translate="uniromaLandingApp.policyAnag.macroCategoria"></label> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.macroCategoria!=null">{{regola.macroCategoria}}</span> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.macroCategoria==null" data-translate="uniromaLandingApp.policyAnag.creation.any"></span> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label data-translate="uniromaLandingApp.policyAnag.categoria"></label> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.categoria!=null">{{regola.categoria}}</span> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.categoria==null" data-translate="uniromaLandingApp.policyAnag.creation.any"></span> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label data-translate="uniromaLandingApp.policyAnag.sottoCategoria"></label> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.sottoCategoria!=null">{{regola.sottoCategoria}}</span> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.sottoCategoria==null" data-translate="uniromaLandingApp.policyAnag.creation.any"></span> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    </div> --><!-- \t\t\t\t\t    Stati --><!-- \t\t\t\t\t    <div class="row"> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label data-translate="uniromaLandingApp.policyAnag.statoGenerale"></label> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.statoGenerale!=null">{{regola.statoGenerale}}</span> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.statoGenerale==null" data-translate="uniromaLandingApp.policyAnag.creation.any"></span> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label data-translate="uniromaLandingApp.policyAnag.statoSpecifico"></label> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.statoSpecifico!=null">{{regola.statoSpecifico}}</span> --><!-- \t\t\t\t\t    \t\t<span ng-if="regola.statoSpecifico==null" data-translate="uniromaLandingApp.policyAnag.creation.any"></span> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    \t<div class="col-md-4"> --><!-- \t\t\t\t\t    \t\t<label>&nbsp;</label> --><!-- \t\t\t\t\t    \t\t<br> --><!-- \t\t\t\t\t    \t\t<button type="button" class="btn btn-danger float-right" ng-click="vm.removeRegola()"> --><!--             \t\t\t\t\t\t<i class="fa fa-remove"></i>&nbsp;<span data-translate="entity.action.delete">delete</span> --><!--         \t\t\t\t\t\t</button> --><!-- \t\t\t\t\t    \t</div> --><!-- \t\t\t\t\t    </div> --><!-- \t\t\t\t  \t</div> --><!-- \t\t\t\t</div> --></div><div class="form-group" ng-if="vm.testMode"><!-- Utenti --><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.policyAnag.creation.utente_label" for="field_utente">Seleziona utenti</label><br><div class="input-group"><input type="text" ng-model="vm.selectedUser" uib-typeahead="(utente.nome + \' \'+utente.cognome+\' (\' + utente.userId + \')\') for utente in vm.loadListaUtenti($viewValue)" typeahead-on-select="vm.selectUtente($item, $model, $label)" name="utente" id="field_utente" class="form-control form-element form-field" autocomplete="off"> <span class="input-group-btn"><button class="btn btn-default btn-input-group" type="button" ng-click="vm.testPolicies()" ng-disabled="!vm.selectedUser" data-translate="uniromaLandingApp.policyAnag.test.testIt_label">Test</button></span></div><!-- /input-group --></div><div class="form-group row"><div class="col-xs-6 break-all" ng-if="vm.services.length > 0 || vm.executions.length > 0"><h5>Attributi Assegnati</h5><dl ng-if="!equals({}, vm.anagAttributes)"><dd ng-repeat="(fieldName, fieldValue) in vm.anagAttributes"><b>{{fieldName}}</b> {{fieldValue}}</dd></dl><div class="form-group" ng-if="equals({}, vm.anagAttributes) && !vm.typing && !vm.loading">Nessun attributo assegnato a {{vm.selectedUser}}</div><h5>Dettaglio di esecuzione motore delle regole</h5><div class="table-responsive" ng-if="vm.executions.length>0"><table class="jh-table table table-striped"><tbody><tr ng-repeat="execution in vm.executions"><td><b>{{execution.name}}</b> <span ng-if="execution.skipMessage">non eseguita: {{execution.skipMessage}}</span> <span ng-if="execution.role">eseguita per il ruolo: {{execution.role | formatRole}}</span> <span ng-if="execution.errorMessage" class="label label-danger">errore di esecuzione: {{execution.errorMessage}}</span> <span ng-if="execution.enabledServices" class="label label-info">ASSEGNATO - {{execution.enabledServices.join(\', \')}}</span> - <b>{{execution.elapsed}}ms</b></td></tr></tbody></table></div></div><div class="col-xs-6 break-all" ng-if="vm.roles.length > 0 || vm.user != null || vm.attributesSize > 0"><h5>Utente (user)</h5><dl ng-if="vm.user != null"><dd ng-repeat="(name, attribute) in vm.user"><b>{{name}}</b> {{attribute}}</dd></dl><h5>Ruoli (role)</h5><div class="table-responsive" ng-if="vm.roles.length>0"><table class="jh-table table table-striped"><tbody><tr ng-repeat="role in vm.roles"><td><b>ruolo: </b>{{role.ruolo}}<br><b>macro-categoria: </b>{{role.macroCategoria}}<br><b>categoria: </b>{{role.categoria}}<br><b>sotto-categoria: </b>{{role.sottoCategoria}}<br><b>stato specifico: </b>{{role.statoSpecifico}}<br><b>macro-stato: </b>{{role.macroStato}}<br><b>decorrenza: </b>{{role.decorrenza | date:\'shortDate\'}}<span ng-if="role.decorrenza"> ({{role.giorniDaDecorrenza}} giorni)</span><br></td></tr></tbody></table></div><div class="form-group" ng-if="vm.roles.length<=0 && !vm.typing && !vm.loading">Nessun ruolo configurato per {{vm.selectedUser}}</div><h5>Attributi utente completi (rawAttributes)</h5><dl><dd ng-repeat="(name, attribute) in vm.attributes"><b>{{name}}</b> {{attribute}}</dd></dl></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/policy-anag/test-policy-dialog.html','<form class="registration-form" name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPolicyLabel" data-translate="uniromaLandingApp.policyAnag.home.testItLabel">Test Policy</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!-- INSERIMENTO POLICY GUIDATO --><div class="form-group"><!-- Utenti --><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.policyAnag.creation.utente_label" for="field_utente">Seleziona utenti</label><br><div class="input-group"><input type="text" ng-model="vm.selectedUser" uib-typeahead="(utente.nome + \' \'+utente.cognome+\' (\' + utente.userId + \')\') for utente in vm.loadListaUtenti($viewValue)" typeahead-on-select="vm.selectUtente($item, $model, $label)" name="utente" id="field_utente" class="form-control form-element form-field" autocomplete="off"> <span class="input-group-btn"><button class="btn btn-default btn-input-group" type="button" ng-click="vm.testPolicies()" ng-disabled="!vm.selectedUser" data-translate="uniromaLandingApp.policyAnag.test.testIt_label">Test</button></span></div><!-- /input-group --></div><div class="form-group row"><div class="col-xs-6 break-all" ng-if="vm.roles.length > 0 || vm.services.length > 0 || vm.user != null || vm.executions.length > 0"><h5>Utente (user)</h5><dl ng-if="vm.user != null"><dd ng-repeat="(name, attribute) in vm.user"><b>{{name}}</b> {{attribute}}</dd></dl><h5>Ruoli (role)</h5><div class="table-responsive" ng-if="vm.roles.length>0"><table class="jh-table table table-striped"><tbody><tr ng-repeat="role in vm.roles"><td><b>ruolo: </b>{{role.ruolo}}<br><b>macro-categoria: </b>{{role.macroCategoria}}<br><b>categoria: </b>{{role.categoria}}<br><b>sotto-categoria: </b>{{role.sottoCategoria}}<br><b>stato specifico: </b>{{role.statoSpecifico}}<br><b>macro-stato: </b>{{role.macroStato}}<br><b>decorrenza: </b>{{role.decorrenza | date:\'shortDate\'}} ({{role.giorniDaDecorrenza}} giorni)<br></td></tr></tbody></table></div><div class="form-group" ng-if="vm.roles.length<=0 && !vm.typing && !vm.loading">Nessun ruolo configurato per {{vm.selectedUser}}</div><h5>Attributi Assegnati</h5><dl ng-if="!equals({}, vm.anagAttributes)"><dd ng-repeat="(fieldName, fieldValue) in vm.anagAttributes"><b>{{fieldName}}</b> {{fieldValue}}</dd></dl><div class="form-group" ng-if="equals({}, vm.anagAttributes) && !vm.typing && !vm.loading">Nessun attributo assegnato a {{vm.selectedUser}}</div><h5>Dettaglio di esecuzione motore delle regole</h5><div class="table-responsive" ng-if="vm.executions.length>0"><table class="jh-table table table-striped"><tbody><tr ng-repeat="execution in vm.executions"><td><b>{{execution.name}}</b> <span ng-if="execution.skipMessage">non eseguita: {{execution.skipMessage}}</span> <span ng-if="execution.role">eseguita per il ruolo: {{execution.role | formatRole}}</span> <span ng-if="execution.errorMessage" class="label label-danger">errore di esecuzione: {{execution.errorMessage}}</span> <span ng-if="execution.enabledServices" class="label label-info">ASSEGNATO - {{execution.enabledServices.join(\', \')}}</span> - <b>{{execution.elapsed}}ms</b></td></tr></tbody></table></div></div><div class="col-xs-6 break-all" ng-if="vm.attributesSize > 0"><h5>Attributi utente completi (rawAttributes)</h5><dl><dd ng-repeat="(name, attribute) in vm.attributes"><b>{{name}}</b> {{attribute}}</dd></dl></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div></form>');
$templateCache.put('app/entities/product/product-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.product.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.product.delete.question" translate-values="{id: \'{{vm.product.id}}\'}">Are you sure you want to delete this Product?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/product/product-detail.html','<div><h2><span data-translate="uniromaLandingApp.product.detail.title">Product</span> {{vm.product.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.product.version">Version</span></dt><dd><span>{{vm.product.version}}</span></dd><dt><span data-translate="uniromaLandingApp.product.code">Code</span></dt><dd><span>{{vm.product.code}}</span></dd><dt><span data-translate="uniromaLandingApp.product.base_url">Base Url</span></dt><dd><span>{{vm.product.base_url}}</span></dd><dt><span data-translate="uniromaLandingApp.product.provider">Provider</span></dt><dd><a ui-sref="provider-detail({id:vm.product.provider.id})">{{vm.product.provider.code}}</a></dd><dt><span data-translate="uniromaLandingApp.product.environment">Environment</span></dt><dd><a ui-sref="environment-detail({id:vm.product.environment.id})">{{vm.product.environment.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="product-detail.edit({id:vm.product.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/product/product-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProductLabel" data-translate="uniromaLandingApp.product.home.createOrEditLabel">Create or edit a Product</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.product.version" for="field_version">Version</label><input type="text" class="form-control" name="version" id="field_version" ng-model="vm.product.version" required><p ng-show="vm.product.version==null || vm.product.version===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.product.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.product.code" required><p ng-show="vm.product.code==null || vm.product.code===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.product.base_url" for="field_base_url">Base Url</label><input type="text" class="form-control" name="base_url" id="field_base_url" ng-model="vm.product.base_url"></div><div class="form-group"><label data-translate="uniromaLandingApp.product.provider" for="field_provider">Provider</label><select class="form-control" id="field_provider" name="provider" ng-model="vm.product.provider" ng-options="provider as provider.code for provider in vm.providers track by provider.id" disabled="disabled"><option value=""></option></select></div><div class="form-group" ng-if="vm.environments.length>1"><label data-translate="uniromaLandingApp.product.environment" for="field_environment">Environment</label><select class="form-control" id="field_environment" name="environment" ng-model="vm.product.environment" ng-options="environment as environment.name for environment in vm.environments track by environment.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/product/products.html','<div><h2 data-translate="uniromaLandingApp.product.home.title">Products</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="product.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.product.home.createLabel">Create new Product</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="version"><span data-translate="uniromaLandingApp.product.version">Version</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span data-translate="uniromaLandingApp.product.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="base_url"><span data-translate="uniromaLandingApp.product.base_url">Base Url</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="provider.code"><span data-translate="uniromaLandingApp.product.provider">Provider</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="environment.name"><span data-translate="uniromaLandingApp.product.environment">Environment</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="product in vm.products track by product.id"><td><a ui-sref="product-detail({id:product.id})">{{product.id}}</a></td><td>{{product.version}}</td><td>{{product.code}}</td><td>{{product.base_url}}</td><td><a ui-sref="provider-detail({id:product.provider.id})">{{product.provider.code}}</a></td><td><a ui-sref="environment-detail({id:product.environment.id})">{{product.environment.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="product-detail({id:product.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="product.edit({id:product.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="product.delete({id:product.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/product-tr/product-tr-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.product_tr.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.product_tr.delete.question" translate-values="{id: \'{{vm.product_tr.id}}\'}">Are you sure you want to delete this Product Tr?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/product-tr/product-tr-detail.html','<div><h2><span data-translate="uniromaLandingApp.product_tr.detail.title">Product Tr</span> {{vm.product_tr.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.product_tr.field">Field</span></dt><dd><span>{{vm.product_tr.field}}</span></dd><dt><span data-translate="uniromaLandingApp.product_tr.value">Value</span></dt><dd><span>{{vm.product_tr.value}}</span></dd><dt><span data-translate="uniromaLandingApp.product_tr.language">Language</span></dt><dd><span>{{vm.product_tr.language}}</span></dd><dt><span data-translate="uniromaLandingApp.product_tr.product">Product</span></dt><dd><a ui-sref="product-detail({id:vm.product_tr.product.id})">{{vm.product_tr.product.code}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="product-tr-detail.edit({id:vm.product_tr.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/product-tr/product-tr-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProduct_trLabel" data-translate="uniromaLandingApp.product_tr.home.createOrEditLabel">Create or edit a Product Tr</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.product_tr.field" for="field_field">Field</label><input type="text" class="form-control" name="field" id="field_field" ng-model="vm.product_tr.field" required><p ng-show="vm.product_tr.field==null || vm.product_tr.field===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.product_tr.value" for="field_value">Value</label><input type="text" class="form-control" name="value" id="field_value" ng-model="vm.product_tr.value" required><p ng-show="vm.product_tr.value==null || vm.product_tr.value===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.product_tr.language" for="field_language">Language</label><input type="text" class="form-control" name="language" id="field_language" ng-model="vm.product_tr.language" required><p ng-show="vm.product_tr.language==null || vm.product_tr.language===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label data-translate="uniromaLandingApp.product_tr.product" for="field_product">Product</label><select class="form-control" id="field_product" name="product" ng-model="vm.product_tr.product" ng-options="product as product.code for product in vm.products track by product.id" disabled="disabled"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/product-tr/product-trs.html','<div><h2 data-translate="uniromaLandingApp.product_tr.home.title">Product Trs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="product-tr.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.product_tr.home.createLabel">Create new Product Tr</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="field"><span data-translate="uniromaLandingApp.product_tr.field">Field</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="value"><span data-translate="uniromaLandingApp.product_tr.value">Value</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="language"><span data-translate="uniromaLandingApp.product_tr.language">Language</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="product.code"><span data-translate="uniromaLandingApp.product_tr.product">Product</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="product_tr in vm.product_trs track by product_tr.id"><td><a ui-sref="product-tr-detail({id:product_tr.id})">{{product_tr.id}}</a></td><td>{{product_tr.field}}</td><td>{{product_tr.value}}</td><td>{{product_tr.language}}</td><td><a ui-sref="product-detail({id:product_tr.product.id})">{{product_tr.product.code}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="product-tr-detail({id:product_tr.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="product-tr.edit({id:product_tr.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="product-tr.delete({id:product_tr.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/provider/provider-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.provider.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.provider.delete.question" translate-values="{id: \'{{vm.provider.id}}\'}">Are you sure you want to delete this Provider?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/provider/provider-detail.html','<div><h2><span data-translate="uniromaLandingApp.provider.detail.title">Provider</span> {{vm.provider.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.provider.code">Code</span></dt><dd><span>{{vm.provider.code}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="provider-detail.edit({id:vm.provider.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/provider/provider-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProviderLabel" data-translate="uniromaLandingApp.provider.home.createOrEditLabel">Create or edit a Provider</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.provider.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.provider.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.provider.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.provider.code" required><p ng-show="vm.provider.code==null || vm.provider.code===\'\'" class="help-block" translate="entity.validation.required"></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/provider/providers.html','<div><h2 data-translate="uniromaLandingApp.provider.home.title">Providers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="provider.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.provider.home.createLabel">Create new Provider</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span data-translate="uniromaLandingApp.provider.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="provider in vm.providers track by provider.id"><td><a ui-sref="provider-detail({id:provider.id})">{{provider.id}}</a></td><td>{{provider.code}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="provider-detail({id:provider.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="provider.edit({id:provider.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="provider.delete({id:provider.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/provider-tr/provider-tr-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.provider_tr.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.provider_tr.delete.question" translate-values="{id: \'{{vm.provider_tr.id}}\'}">Are you sure you want to delete this Provider Tr?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/provider-tr/provider-tr-detail.html','<div><h2><span data-translate="uniromaLandingApp.provider_tr.detail.title">Provider Tr</span> {{vm.provider_tr.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.provider_tr.field">Field</span></dt><dd><span>{{vm.provider_tr.field}}</span></dd><dt><span data-translate="uniromaLandingApp.provider_tr.value">Value</span></dt><dd><span>{{vm.provider_tr.value}}</span></dd><dt><span data-translate="uniromaLandingApp.provider_tr.language">Language</span></dt><dd><span>{{vm.provider_tr.language}}</span></dd><dt><span data-translate="uniromaLandingApp.provider_tr.provider">Provider</span></dt><dd><a ui-sref="provider-detail({id:vm.provider_tr.provider.id})">{{vm.provider_tr.provider.code}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="provider-tr-detail.edit({id:vm.provider_tr.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/provider-tr/provider-tr-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProvider_trLabel" data-translate="uniromaLandingApp.provider_tr.home.createOrEditLabel">Create or edit a Provider Tr</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.provider_tr.field" for="field_field">Field</label><input type="text" class="form-control" name="field" id="field_field" ng-model="vm.provider_tr.field" required><p ng-show="vm.provider_tr.field==null || vm.provider_tr.field===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.provider_tr.value" for="field_value">Value</label><input type="text" class="form-control" name="value" id="field_value" ng-model="vm.provider_tr.value" required><p ng-show="vm.provider_tr.value==null || vm.provider_tr.value===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.provider_tr.language" for="field_language">Language</label><input type="text" class="form-control" name="language" id="field_language" ng-model="vm.provider_tr.language" required><p ng-show="vm.provider_tr.language==null || vm.provider_tr.language===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label data-translate="uniromaLandingApp.provider_tr.provider" for="field_provider">Provider</label><select class="form-control" id="field_provider" name="provider" ng-model="vm.provider_tr.provider" ng-options="provider as provider.code for provider in vm.providers track by provider.id" disabled="disabled"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/provider-tr/provider-trs.html','<div><h2 data-translate="uniromaLandingApp.provider_tr.home.title">Provider Trs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="provider-tr.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.provider_tr.home.createLabel">Create new Provider Tr</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="field"><span data-translate="uniromaLandingApp.provider_tr.field">Field</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="value"><span data-translate="uniromaLandingApp.provider_tr.value">Value</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="language"><span data-translate="uniromaLandingApp.provider_tr.language">Language</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="provider.code"><span data-translate="uniromaLandingApp.provider_tr.provider">Provider</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="provider_tr in vm.provider_trs track by provider_tr.id"><td><a ui-sref="provider-tr-detail({id:provider_tr.id})">{{provider_tr.id}}</a></td><td>{{provider_tr.field}}</td><td>{{provider_tr.value}}</td><td>{{provider_tr.language}}</td><td><a ui-sref="provider-detail({id:provider_tr.provider.id})">{{provider_tr.provider.code}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="provider-tr-detail({id:provider_tr.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="provider-tr.edit({id:provider_tr.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="provider-tr.delete({id:provider_tr.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/rejectedRow/rejectedRow-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rejectedRow.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.rejectedRow.delete.question" translate-values="{id: \'{{vm.rejectedRow.id}}\'}">Are you sure you want to delete this rejectedRow?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/rejectedRow/rejectedRow-detail.html','<div><h2><span translate="uniromaLandingApp.rejectedRow.detail.title">RejectedRow</span> {{rejectedRow.id}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="uniromaLandingApp.rejectedRow.idJob">IdJob</span></td><td><span class="form-control-static">{{rejectedRow.idJob}}</span></td></tr><!-- tr>\r\n                <td>\r\n                    <span translate="uniromaLandingApp.rejectedRow.rejectedTypeId">RejectedTypeId</span>\r\n                </td>\r\n                <td>\r\n                    <span class="form-control-static">{{rejectedRow.rejectedTypeId}}</span> \r\n                </td>\r\n            </tr --><tr><td><span class="" translate="uniromaLandingApp.rejectedRow.payload">Payload</span></td><td><span class="form-control-static break-all">{{rejectedRow.payload}}</span></td></tr><tr><td><span translate="uniromaLandingApp.rejectedRow.cause">Cause</span></td><td><span class="form-control-static">{{rejectedRow.cause}}</span></td></tr><tr><td><span translate="uniromaLandingApp.rejectedRow.rejectedType">rejectedType</span></td><td><!-- a ng-hide="true" class="form-control-static" ui-sref="rejectedType.detail({id:rejectedRow.rejectedType.id})">{{rejectedRow.rejectedType.id}}</a --><p class="form-control-static">{{rejectedRow.rejectedType.name}}<br>{{rejectedRow.rejectedType.description}}</p></td></tr></tbody></table></div><button ng-if="prev" type="submit" ui-sref="rejectedRow.detail({id:prev.id})" class="btn btn-default"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.prev"> Previous</span></button> <button type="submit" ui-sref="rejectedRow" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button ng-if="next" type="submit" ui-sref="rejectedRow.detail({id:next.id})" class="btn btn-default pull-right"><span translate="entity.action.next">Next </span>&nbsp;<span class="glyphicon glyphicon-arrow-right"></span></button></div>');
$templateCache.put('app/entities/rejectedRow/rejectedRow-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myRejectedRowLabel" translate="uniromaLandingApp.rejectedRow.home.createOrEditLabel">Create or edit a RejectedRow</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><div class="form-group"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="rejectedRow.id" readonly="readonly"></div><div class="form-group"><label translate="uniromaLandingApp.rejectedRow.idJob" for="field_idJob">IdJob</label><input type="number" class="form-control" name="idJob" id="field_idJob" ng-model="rejectedRow.idJob"></div><div class="form-group"><label translate="uniromaLandingApp.rejectedRow.rejectedTypeId" for="field_rejectedTypeId">RejectedTypeId</label><input type="number" class="form-control" name="rejectedTypeId" id="field_rejectedTypeId" ng-model="rejectedRow.rejectedTypeId"></div><div class="form-group"><label translate="uniromaLandingApp.rejectedRow.payload" for="field_payload">Payload</label><input type="text" class="form-control" name="payload" id="field_payload" ng-model="rejectedRow.payload"></div><div class="form-group"><label translate="uniromaLandingApp.rejectedRow.cause" for="field_cause">Cause</label><input type="text" class="form-control" name="cause" id="field_cause" ng-model="rejectedRow.cause"></div><div class="form-group"><label translate="uniromaLandingApp.rejectedRow.rejectedType" for="field_rejectedType">rejectedType</label><select class="form-control" id="field_rejectedType" name="rejectedType" ng-model="rejectedRow.rejectedType" ng-options="rejectedType as rejectedType.id for rejectedType in rejectedtypes track by rejectedType.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || editForm.$submitted" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/rejectedRow/rejectedRows.html','<div><h2 translate="uniromaLandingApp.rejectedRow.home.title">RejectedRows</h2><jh-alert></jh-alert><div class="container"><!-- div class="row">\r\n            <div class="col-md-4">\r\n                <button class="btn btn-primary" ui-sref="rejectedRow.new">\r\n                    <span class="glyphicon glyphicon-flash"></span> <span translate="uniromaLandingApp.rejectedRow.home.createLabel">Create a new RejectedRow</span>\r\n                </button>\r\n            </div>\r\n        </div --></div><!-- FILTRI --><div class="row"><div class="col-md-2"><label translate="uniromaLandingApp.rejectedRow.filter.idJobLabel">Filtra per id Job</label><select class="form-control" ng-model="idJobFilter" ng-change="loadPage(links[\'first\'])" ng-options="id for id in filterIdJobList"><option value=""></option></select></div><div class="col-md-4"><label translate="uniromaLandingApp.rejectedRow.filter.typeLabel">Filtra per tipologia</label><select class="form-control" ng-model="idTypeFilter" ng-change="loadPage(links[\'first\'])" ng-options="rejectType.id as rejectType.name for rejectType in filterRejectedTypeList | orderBy: \'name\'"><option value=""></option></select></div><div class="col-md-6"><label translate="uniromaLandingApp.rejectedRow.filter.payloadLabel">Filtra payload</label><input type="text" class="form-control" ng-model="payloadFilter" ng-change="loadPage(links[\'first\'])"> <span class="help-block">per campi specifici utilizzare anche il nome del campo come presente nel payload (es.: "EMPLOYEE_NUMBER":"XXXXXXXXXXXXXXXX").</span></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="global.field.id">ID</th><th translate="uniromaLandingApp.rejectedRow.idJob">IdJob</th><th translate="uniromaLandingApp.rejectedRow.rejectedType">rejectedType</th><!-- th translate="uniromaLandingApp.rejectedRow.payload">Payload</th --><th translate="uniromaLandingApp.rejectedRow.cause">Cause</th><th></th></tr></thead><tbody><tr ng-repeat="rejectedRow in rejectedRows track by rejectedRow.id"><td><a ui-sref="rejectedRow.detail({id:rejectedRow.id})">{{rejectedRow.id}}</a></td><td>{{rejectedRow.idJob}}</td><td><!-- a ui-sref="rejectedType.detail({id:rejectedRow.rejectedType.id})">{{rejectedRow.rejectedType.name}}</a --> {{rejectedRow.rejectedType.name}}</td><!-- td>{{rejectedRow.payload}}</td --><td>{{rejectedRow.cause}}</td><td><button type="submit" ui-sref="rejectedRow.detail({id:rejectedRow.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span>&nbsp;<span translate="entity.action.view"> View</span></button><!-- button type="submit"\r\n                                ui-sref="rejectedRow.edit({id:rejectedRow.id})"\r\n                                class="btn btn-primary btn-sm">\r\n                            <span class="glyphicon glyphicon-pencil"></span>&nbsp;<span translate="entity.action.edit"> Edit</span>\r\n                        </button --> <button type="submit" ui-sref="rejectedRow.delete({id:rejectedRow.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></td></tr></tbody></table><nav><ul class="pagination"><li ng-show="links[\'first\'] >= 0" ng-click="loadPage(links[\'first\'])"><a>&lt;&lt;</a></li><li ng-show="page > 0" ng-click="loadPage(links[\'prev\'] || 0)"><a>&lt;</a></li><li ng-show="page > 1" ng-click="loadPage(page - 2)"><a>{{page - 1}}</a></li><li ng-show="page > 0" ng-click="loadPage(page - 1)"><a>{{page}}</a></li><li class="active"><a>{{page + 1}}</a></li><li ng-show="page < links[\'last\']" ng-click="loadPage(page + 1)"><a>{{page + 2}}</a></li><li ng-show="page < links[\'last\'] - 1" ng-click="loadPage(page + 2)"><a>{{page + 3}}</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a>&gt;</a></li><li ng-show="links[\'last\'] > 0" ng-click="loadPage(links[\'last\'])"><a>&gt;&gt;</a></li></ul></nav></div></div>');
$templateCache.put('app/entities/rejectedType/rejectedType-detail.html','<div><h2><span translate="uniromaLandingApp.rejectedType.detail.title">RejectedType</span> {{rejectedType.id}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="uniromaLandingApp.rejectedType.name">Name</span></td><td><span class="form-control-static">{{rejectedType.name}}</span></td></tr><tr><td><span translate="uniromaLandingApp.rejectedType.description">Description</span></td><td><span class="form-control-static">{{rejectedType.description}}</span></td></tr></tbody></table></div><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/rejectedType/rejectedType-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myRejectedTypeLabel" translate="uniromaLandingApp.rejectedType.home.createOrEditLabel">Create or edit a RejectedType</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><div class="form-group"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="rejectedType.id" readonly="readonly"></div><div class="form-group"><label translate="uniromaLandingApp.rejectedType.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="rejectedType.name"></div><div class="form-group"><label translate="uniromaLandingApp.rejectedType.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="rejectedType.description"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || editForm.$submitted" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/rejectedType/rejectedTypes.html','<div><h2 translate="uniromaLandingApp.rejectedType.home.title">RejectedTypes</h2><jh-alert></jh-alert><div class="container"><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="rejectedType.new"><span class="glyphicon glyphicon-flash"></span> <span translate="uniromaLandingApp.rejectedType.home.createLabel">Create a new RejectedType</span></button></div></div></div><div class="modal fade" id="deleteRejectedTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(rejectedType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="uniromaLandingApp.rejectedType.delete.question" translate-values="{id: \'{{rejectedType.id}}\'}">Are you sure you want to delete this RejectedType?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="global.field.id">ID</th><th translate="uniromaLandingApp.rejectedType.name">Name</th><th translate="uniromaLandingApp.rejectedType.description">Description</th><th></th></tr></thead><tbody><tr ng-repeat="rejectedType in rejectedTypes track by rejectedType.id"><td><a ui-sref="rejectedType.detail({id:rejectedType.id})">{{rejectedType.id}}</a></td><td>{{rejectedType.name}}</td><td>{{rejectedType.description}}</td><td><button type="submit" ui-sref="rejectedType.detail({id:rejectedType.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="rejectedType.edit({id:rejectedType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="delete(rejectedType.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><nav><ul class="pagination"><li ng-show="links[\'first\'] >= 0" ng-click="loadPage(links[\'first\'])"><a>&lt;&lt;</a></li><li ng-show="page > 0" ng-click="loadPage(links[\'prev\'] || 0)"><a>&lt;</a></li><li ng-show="page > 1" ng-click="loadPage(page - 2)"><a>{{page - 1}}</a></li><li ng-show="page > 0" ng-click="loadPage(page - 1)"><a>{{page}}</a></li><li class="active"><a>{{page + 1}}</a></li><li ng-show="page < links[\'last\']" ng-click="loadPage(page + 1)"><a>{{page + 2}}</a></li><li ng-show="page < links[\'last\'] - 1" ng-click="loadPage(page + 2)"><a>{{page + 3}}</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a>&gt;</a></li><li ng-show="links[\'last\'] > 0" ng-click="loadPage(links[\'last\'])"><a>&gt;&gt;</a></li></ul></nav></div></div>');
$templateCache.put('app/entities/scheduledJob/scheduledJob-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.scheduledJob.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.scheduledJob.delete.question" translate-values="{id: \'{{vm.scheduledJob.id}}\'}">Are you sure you want to delete this scheduledJob?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/scheduledJob/scheduledJob-detail.html','<div><h2><span translate="uniromaLandingApp.scheduledJob.detail.title">ScheduledJob</span> {{scheduledJob.id}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="uniromaLandingApp.scheduledJob.dateStart">DateStart</span></td><td><span class="form-control-static">{{scheduledJob.dateStart | date:\'dd-MM-yy HH:mm:ss\'}}</span></td></tr><tr><td><span translate="uniromaLandingApp.scheduledJob.dateEnd">DateEnd</span></td><td><span class="form-control-static">{{scheduledJob.dateEnd | date:\'dd-MM-yy HH:mm:ss\'}}</span></td></tr><tr><td><span translate="uniromaLandingApp.scheduledJob.status">Status</span></td><td><span class="form-control-static">{{scheduledJob.status}}</span></td></tr><tr><td><span translate="uniromaLandingApp.scheduledJob.jobName">JobName</span></td><td><span class="form-control-static">{{scheduledJob.jobName}}</span></td></tr><tr><td><span translate="uniromaLandingApp.scheduledJob.newRecords">NewRecords</span></td><td><span class="form-control-static">{{scheduledJob.newRecords}}</span></td></tr><tr><td><span translate="uniromaLandingApp.scheduledJob.changedRecords">ChangedRecords</span></td><td><span class="form-control-static">{{scheduledJob.changedRecords}}</span></td></tr><tr><td><span translate="uniromaLandingApp.scheduledJob.deletedRecords">DeletedRecords</span></td><td><span class="form-control-static">{{scheduledJob.deletedRecords}}</span></td></tr><tr><td><span translate="uniromaLandingApp.scheduledJob.identicalRecords">IdenticalRecords</span></td><td><span class="form-control-static">{{scheduledJob.identicalRecords}}</span></td></tr><tr><td><span translate="uniromaLandingApp.scheduledJob.rejectedRecords">RejectedRecords</span></td><td><span class="form-control-static">{{scheduledJob.rejectedRecords}}</span></td></tr></tbody></table></div><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/scheduledJob/scheduledJob-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myScheduledJobLabel" translate="uniromaLandingApp.scheduledJob.home.createOrEditLabel">Create or edit a ScheduledJob</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><div class="form-group"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="scheduledJob.id" readonly="readonly"></div><div class="form-group"><label translate="uniromaLandingApp.scheduledJob.dateStart" for="field_dateStart">DateStart</label><input type="datetime-local" class="form-control" name="dateStart" id="field_dateStart" ng-model="scheduledJob.dateStart" ng-model-options="{timezone: \'UTC\'}"></div><div class="form-group"><label translate="uniromaLandingApp.scheduledJob.dateEnd" for="field_dateEnd">DateEnd</label><input type="datetime-local" class="form-control" name="dateEnd" id="field_dateEnd" ng-model="scheduledJob.dateEnd" ng-model-options="{timezone: \'UTC\'}"></div><div class="form-group"><label translate="uniromaLandingApp.scheduledJob.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="scheduledJob.status"></div><div class="form-group"><label translate="uniromaLandingApp.scheduledJob.jobName" for="field_jobName">JobName</label><input type="text" class="form-control" name="jobName" id="field_jobName" ng-model="scheduledJob.jobName"></div><div class="form-group"><label translate="uniromaLandingApp.scheduledJob.newRecords" for="field_newRecords">NewRecords</label><input type="number" class="form-control" name="newRecords" id="field_newRecords" ng-model="scheduledJob.newRecords"></div><div class="form-group"><label translate="uniromaLandingApp.scheduledJob.changedRecords" for="field_changedRecords">ChangedRecords</label><input type="number" class="form-control" name="changedRecords" id="field_changedRecords" ng-model="scheduledJob.changedRecords"></div><div class="form-group"><label translate="uniromaLandingApp.scheduledJob.deletedRecords" for="field_deletedRecords">DeletedRecords</label><input type="number" class="form-control" name="deletedRecords" id="field_deletedRecords" ng-model="scheduledJob.deletedRecords"></div><div class="form-group"><label translate="uniromaLandingApp.scheduledJob.identicalRecords" for="field_identicalRecords">IdenticalRecords</label><input type="number" class="form-control" name="identicalRecords" id="field_identicalRecords" ng-model="scheduledJob.identicalRecords"></div><div class="form-group"><label translate="uniromaLandingApp.scheduledJob.rejectedRecords" for="field_rejectedRecords">RejectedRecords</label><input type="number" class="form-control" name="rejectedRecords" id="field_rejectedRecords" ng-model="scheduledJob.rejectedRecords"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || editForm.$submitted" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/scheduledJob/scheduledJobs.html','<div><h2 translate="uniromaLandingApp.scheduledJob.home.title">ScheduledJobs</h2><jh-alert></jh-alert><div class="container"><!--  div class="row">\r\n            <div class="col-md-4">\r\n                <button class="btn btn-primary" ui-sref="scheduledJob.new">\r\n                    <span class="glyphicon glyphicon-flash"></span> <span translate="uniromaLandingApp.scheduledJob.home.createLabel">Create a new ScheduledJob</span>\r\n                </button>\r\n            </div>\r\n        </div --></div><!-- FILTRI --><div class="row"><div class="col-md-2"><label translate="uniromaLandingApp.scheduledJob.filter.statusLabel">Filtra per stato</label><select class="form-control" ng-model="statusFilter" ng-change="loadPage(links[\'first\'])" ng-options="status.status as status.status for status in filterStatusList"><option value=""></option></select></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="global.field.id">ID</th><th translate="uniromaLandingApp.scheduledJob.dateStart">DateStart</th><th translate="uniromaLandingApp.scheduledJob.dateEnd">DateEnd</th><th translate="uniromaLandingApp.scheduledJob.status">Status</th><th translate="uniromaLandingApp.scheduledJob.jobName">JobName</th><th translate="uniromaLandingApp.scheduledJob.newRecords">NewRecords</th><th translate="uniromaLandingApp.scheduledJob.changedRecords">ChangedRecords</th><th translate="uniromaLandingApp.scheduledJob.deletedRecords">DeletedRecords</th><th translate="uniromaLandingApp.scheduledJob.identicalRecords">IdenticalRecords</th><th translate="uniromaLandingApp.scheduledJob.rejectedRecords">RejectedRecords</th><th></th></tr></thead><tbody><tr ng-repeat="scheduledJob in scheduledJobs track by scheduledJob.id"><td><a ui-sref="scheduledJob.detail({id:scheduledJob.id})">{{scheduledJob.id}}</a></td><td>{{scheduledJob.dateStart | date:\'medium\'}}</td><td>{{scheduledJob.dateEnd | date:\'medium\'}}</td><td>{{scheduledJob.status}}</td><td>{{scheduledJob.jobName}}</td><td>{{scheduledJob.newRecords}}</td><td>{{scheduledJob.changedRecords}}</td><td>{{scheduledJob.deletedRecords}}</td><td>{{scheduledJob.identicalRecords}}</td><td>{{scheduledJob.rejectedRecords}}</td><td><button type="submit" ui-sref="scheduledJob.detail({id:scheduledJob.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="scheduledJob.edit({id:scheduledJob.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ui-sref="scheduledJob.delete({id:scheduledJob.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></td></tr></tbody></table><nav><ul class="pagination"><li ng-show="links[\'first\'] >= 0" ng-click="loadPage(links[\'first\'])"><a>&lt;&lt;</a></li><li ng-show="page > 0" ng-click="loadPage(links[\'prev\'] || 0)"><a>&lt;</a></li><li ng-show="page > 1" ng-click="loadPage(page - 2)"><a>{{page - 1}}</a></li><li ng-show="page > 0" ng-click="loadPage(page - 1)"><a>{{page}}</a></li><li class="active"><a>{{page + 1}}</a></li><li ng-show="page < links[\'last\']" ng-click="loadPage(page + 1)"><a>{{page + 2}}</a></li><li ng-show="page < links[\'last\'] - 1" ng-click="loadPage(page + 2)"><a>{{page + 3}}</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a>&gt;</a></li><li ng-show="links[\'last\'] > 0" ng-click="loadPage(links[\'last\'])"><a>&gt;&gt;</a></li></ul></nav></div></div>');
$templateCache.put('app/entities/service/service-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.service.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.service.delete.question" translate-values="{id: \'{{vm.service.id}}\'}">Are you sure you want to delete this Service?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/service/service-detail.html','<div><h2><span data-translate="uniromaLandingApp.service.detail.title">Service</span> {{vm.service.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.service.code">Code</span></dt><dd><span>{{vm.service.code}}</span></dd><dt><span data-translate="uniromaLandingApp.service.profile">Profile</span></dt><dd><span>{{vm.service.profile}}</span></dd><dt><span data-translate="uniromaLandingApp.service.module">Module</span></dt><dd><a ui-sref="module-detail({id:vm.service.module.id})">{{vm.service.module.code}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="service-detail.edit({id:vm.service.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/service/service-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myServiceLabel" data-translate="uniromaLandingApp.service.home.createOrEditLabel">Create or edit a Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.service.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.service.code" required><p ng-show="vm.service.code==null || vm.service.code===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.service.entityId" for="field_entityId">EntityId</label><input type="text" class="form-control" name="entityId" id="field_entityId" ng-model="vm.service.entityId"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.service.profile" for="field_profile">Profile</label><input type="text" class="form-control" name="profile" id="field_profile" ng-model="vm.service.profile" required><p ng-show="vm.service.profile==null || vm.service.profile===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label data-translate="uniromaLandingApp.service.module" for="field_module">Module</label><select class="form-control" id="field_module" name="module" ng-model="vm.service.module" ng-options="module as module.code for module in vm.modules track by module.id" disabled="disabled"><option value=""></option></select></div><div class="form-group"><label translate="uniromaLandingApp.service.rangeProvisioning.label"></label><input bs-switch ng-model="vm.service.recordProvisioning" type="checkbox" switch-active="true" switch-size="medium" switch-animate="true" switch-on-text="{{ \'uniromaLandingApp.service.rangeProvisioning.onText\' | translate }}" switch-off-text="{{ \'uniromaLandingApp.service.rangeProvisioning.offText\' | translate }}" switch-on-color="uniroma" switch-off-color="default" switch-label-width="auto" switch-handle-width="auto" switch-inverse="true" ng-true-value="true" ng-false-value="false"></div><div class="form-group"><label translate="uniromaLandingApp.service.rangeDeprovisioning.label"></label><input bs-switch ng-model="vm.service.recordDeprovisioning" type="checkbox" switch-active="true" switch-size="medium" switch-animate="true" switch-on-text="{{ \'uniromaLandingApp.service.rangeDeprovisioning.onText\' | translate }}" switch-off-text="{{ \'uniromaLandingApp.service.rangeDeprovisioning.offText\' | translate }}" switch-on-color="uniroma" switch-off-color="default" switch-label-width="auto" switch-handle-width="auto" switch-inverse="true" ng-true-value="true" ng-false-value="false"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/service/services.html','<div><h2 data-translate="uniromaLandingApp.service.home.title">Services</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="service.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.service.home.createLabel">Create new Service</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span data-translate="uniromaLandingApp.service.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile"><span data-translate="uniromaLandingApp.service.profile">Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="module.code"><span data-translate="uniromaLandingApp.service.module">Module</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="service in vm.services track by service.id"><td><a ui-sref="service-detail({id:service.id})">{{service.id}}</a></td><td>{{service.code}}</td><td>{{service.profile}}</td><td><a ui-sref="module-detail({id:service.module.id})">{{service.module.code}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="service-detail({id:service.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="service.edit({id:service.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="service.delete({id:service.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/service-provider/service-provider-comments.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myService_providerLabel" data-translate="uniromaLandingApp.service_provider.home.comments">Commenti</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row" ng-if="vm.service_provider.comments.length==0"><div class="col-sm-12"><div class="panel panel-default"><div class="panel-body" style="text-align:center"><i class="fa fa-comment-o" aria-hidden="true"></i> <span class="text-muted">Nessun commento</span></div></div></div></div><div><div class="row" ng-repeat="comment in vm.service_provider.comments| startFrom:vm.currentPage*vm.pageSize | limitTo:vm.pageSize"><div class="col-sm-12"><div class="panel panel-default"><div class="panel-heading"><i class="fa fa-user" aria-hidden="true"></i> <strong>{{comment.who_commented.firstName}} {{comment.who_commented.lastName}}</strong> <span ng-if="comment.who_commented.login==service_provider.whoCreated" class="label label-uniroma" data-translate="uniromaLandingApp.service_provider.comments.creator">Creatore</span> <span class="text-muted" style="float:right">{{comment.create_date | date:\'medium\'}}</span></div><div class="panel-body">{{comment.comment}}</div><!-- /panel-body --></div><!-- /panel panel-default --></div></div></div><!-- Pagination --><nav aria-label="Page navigation" style="text-align:center" ng-show="vm.service_provider.comments.length>vm.pageSize"><ul class="pagination pagination-sm"><li ng-class="{\'disabled\':vm.currentPage==0}"><a aria-label="Previous" ng-click="prevPage()"><span aria-hidden="true">&#60;</span></a></li><li ng-repeat="i in getNumber(vm.pageNumber) track by $index" ng-class="{\'active\': vm.currentPage==$index}"><a ng-click="vm.currentPage=$index">{{$index+1}}</a></li><li ng-class="{\'disabled\':vm.currentPage==(vm.pageNumber-1)}"><a aria-label="Next" ng-click="nextPage()"><span aria-hidden="true">></span></a></li></ul></nav><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.service_provider.comments.insert" for="field_comment">Comment</label><textarea type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.newComment.comment" style="min-height:100px" required>\r\n            </textarea><div ng-show="editForm.comment.$invalid"><p class="help-block" ng-show="editForm.comment.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-uniroma"><i class="fa fa-paper-plane" aria-hidden="true"></i>&nbsp;<span data-translate="entity.action.send">Invia</span></button></div></form>');
$templateCache.put('app/entities/service-provider/service-provider-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.service_provider.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.service_provider.delete.question" translate-values="{id: \'{{vm.service_provider.id}}\'}">Are you sure you want to delete this Service Provider?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/service-provider/service-provider-detail.html','<div><h2><span data-translate="uniromaLandingApp.service_provider.detail.title">Service Provider</span> {{vm.service_provider.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.service_provider.code">Code</span></dt><dd><span>{{vm.service_provider.code}}</span></dd><dt><span data-translate="uniromaLandingApp.service_provider.description">Description</span></dt><dd><span>{{vm.service_provider.description}}</span></dd><dt><span data-translate="uniromaLandingApp.service_provider.who_created">Responsible</span></dt><dd><span>{{vm.service_provider.whoCreated}}</span></dd><dt><span data-translate="uniromaLandingApp.service_provider.creation_date">creation_date"</span></dt><dd><span>{{vm.service_provider.creationDate | date:\'medium\'}}</span></dd><dt><span data-translate="uniromaLandingApp.service_provider.is_active">Is Active</span></dt><dd><span class="glyphicon" ng-class="{\'glyphicon-ok\': vm.service_provider.is_active==true,\'glyphicon-remove\': vm.service_provider.is_active==false||vm.service_provider.is_active==null}"></span></dd><dt><span data-translate="uniromaLandingApp.service_provider.is_approved">Is Approved</span></dt><dd><span class="glyphicon" ng-class="{\'glyphicon-ok\': vm.service_provider.is_approved==true,\'glyphicon-remove\': vm.service_provider.is_approved==false||vm.service_provider.is_approved==null}"></span></dd><dt ng-if="vm.service_provider.is_approved"><span data-translate="uniromaLandingApp.service_provider.who_approved">whoApproved</span></dt><dd ng-if="vm.service_provider.is_approved"><span>{{vm.service_provider.whoApproved}}</span></dd><dt ng-if="vm.service_provider.is_approved"><span data-translate="uniromaLandingApp.service_provider.approval_date">creation_date"</span></dt><dd ng-if="vm.service_provider.is_approved"><span>{{vm.service_provider.approvalDate | date:\'medium\'}}</span></dd><dt><span data-translate="uniromaLandingApp.service_provider.distribution_list">Distribution List</span></dt><dd><a ui-sref="distribution-list-detail({id:vm.service_provider.distribution_list.id})">{{vm.service_provider.distribution_list.code}}</a></dd><dt><span data-translate="uniromaLandingApp.service_provider.metadata">Metadata</span></dt><dd><div ui-ace="aceOptions" name="metadata" id="field_metadata" style="height: 400px; border:1px solid rgba(77, 77, 76, 0.24)" ng-model="vm.service_provider.metadata" readonly="readonly"></div></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="service-provider-detail.edit({id:vm.service_provider.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/service-provider/service-provider-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myService_providerLabel" data-translate="uniromaLandingApp.service_provider.home.createOrEditLabel">Create or edit a Service Provider</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.service_provider.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.service_provider.code" ng-disabled="vm.service_provider.id!=null" ng-trim="false" ng-change="vm.service_provider.code = vm.service_provider.code.split(\' \').join(\'\')" required><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.service_provider.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.service_provider.description"></div><div class="" ng-if="vm.service_provider.id!=null"><label class="control-label" data-translate="uniromaLandingApp.service_provider.is_active" for="field_is_active">Is Active</label><br><input bs-switch ng-model="vm.service_provider.is_active" type="checkbox" switch-active="{{ vm.switchOptions.isActive }}" switch-size="{{ vm.switchOptions.size }}" switch-animate="{{ vm.switchOptions.animate }}" switch-label="{{ vm.switchOptions.label }}" switch-on-text="{{ \'uniromaLandingApp.service_provider.filter.onText\' | translate }}" switch-off-text="{{ \'uniromaLandingApp.service_provider.filter.offText\' | translate }}" switch-on-color="{{ vm.switchOptions.onColor }}" switch-off-color="{{ vm.switchOptions.offColor }}" switch-label-width="{{ vm.switchOptions.labelWidth }}" switch-handle-width="{{ vm.switchOptions.handleWidth }}" switch-inverse="{{ vm.switchOptions.inverse }}" ng-true-value="true" ng-false-value="false"></div><div class="form-group"><label data-translate="uniromaLandingApp.service_provider.distribution_list" for="field_distribution_list">Distribution List</label><select class="form-control" id="field_distribution_list" name="distribution_list" ng-model="vm.service_provider.distribution_list" ng-options="distribution_list as distribution_list.code for distribution_list in vm.distribution_lists track by distribution_list.id"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.service_provider.metadata" for="field_metadata">Metadata</label><br><label class="btn btn-default"><span class="glyphicon glyphicon-upload"></span> <span data-translate="global.form.upload"></span> <input type="file" on-read-file="displayFileContents(contents)" accept="application/xml" style="display:none"></label><br><div ui-ace="aceOptions" name="metadata" id="field_metadata" style="height: 400px; \r\n           \t     border:1px solid rgba(77, 77, 76, 0.24); margin-top:10px" ng-model="vm.service_provider.metadata" required></div><div ng-show="editForm.metadata.$invalid"><p class="help-block" ng-show="editForm.metadata.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/service-provider/service-providers.html','<div><h2 data-translate="uniromaLandingApp.service_provider.home.title">Service Providers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-2 no-padding-left"><button class="btn btn-uniroma" ui-sref="service-provider.new" ng-disabled="!vm.canCreateNewSp"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.service_provider.home.createLabel">Create new Service Provider</span></button></div><div class="col-xs-3 no-padding-left" style="margin-left:10px"><button class="btn btn-uniroma" ui-sref="service-provider.new-list" ng-disabled="!vm.canCreateNewSp"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.service_provider.home.createListLabel">Create new SP List</span></button></div><!-- Filtro "nascondi attivi" --><div class="col-xs-3 no-padding-left pull-right" ng-if="vm.canApprove"><label translate="uniromaLandingApp.service_provider.filter.label"></label><input bs-switch ng-model="vm.switchOptions.switchIsSelected" type="checkbox" switch-active="{{ vm.switchOptions.isActive }}" switch-size="{{ vm.switchOptions.size }}" switch-animate="{{ vm.switchOptions.animate }}" switch-label="{{ vm.switchOptions.label }}" switch-on-text="{{ \'uniromaLandingApp.service_provider.filter.onText\' | translate }}" switch-off-text="{{ \'uniromaLandingApp.service_provider.filter.offText\' | translate }}" switch-on-color="{{ vm.switchOptions.onColor }}" switch-off-color="{{ vm.switchOptions.offColor }}" switch-label-width="{{ vm.switchOptions.labelWidth }}" switch-handle-width="{{ vm.switchOptions.handleWidth }}" switch-inverse="{{ vm.switchOptions.inverse }}" ng-true-value="true" ng-false-value="false"></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="uniromaLandingApp.service_provider.code">Code</span></th><th><span data-translate="uniromaLandingApp.service_provider.description">Description</span></th><th><span data-translate="uniromaLandingApp.service_provider.is_active">Is Active</span></th><th><span data-translate="uniromaLandingApp.service_provider.is_approved">Is Approved</span></th><th><span data-translate="uniromaLandingApp.service_provider.distribution_list">Distribution List</span></th><th></th></tr></thead><tbody><tr ng-repeat="service_provider in vm.service_providers track by service_provider.id" ng-hide="vm.switchOptions.switchIsSelected==true && service_provider.is_approved"><td><a ui-sref="service-provider-detail({id:service_provider.id})">{{service_provider.code}}</a></td><td>{{service_provider.description}}</td><td><button class="btn btn-xs" ng-click="vm.toggleActivation(service_provider)" ng-class="{\'btn-success\': service_provider.is_active==true,\'btn-default\': service_provider.is_active==false}" ng-disabled="service_provider.distribution_list==null || !service_provider.is_approved"><span uib-tooltip="{{ (!service_provider.is_approved ? \'uniromaLandingApp.service_provider.missApprove\' : \'uniromaLandingApp.service_provider.missList\') | translate }}" tooltip-enable="service_provider.distribution_list==null || !service_provider.is_approved"><span ng-if="service_provider.distribution_list!=null&&service_provider.is_approved" class="glyphicon" ng-class="{\'glyphicon-ok\': service_provider.is_active==true,\'glyphicon-ban-circle\': service_provider.is_active==false}"></span> <i ng-if="service_provider.distribution_list==null || !service_provider.is_approved" class="fa fa-exclamation-triangle" aria-hidden="true"></i> <span ng-if="service_provider.is_active" data-translate="uniromaLandingApp.service_provider.is_active">Attivo</span> <span ng-if="!service_provider.is_active" data-translate="uniromaLandingApp.service_provider.is_deactive">Disattivo</span></span></button></td><td ng-if="vm.canApprove&&!service_provider.is_approved"><button class="btn btn-xs btn-default" class="btn-default" ng-click="vm.toggleApproved(service_provider)" ng-disabled="service_provider.distribution_list==null" ng-style="{\'pointer-events\':disableButton ? \'none\' : \'\'}"><span uib-tooltip="{{ \'uniromaLandingApp.service_provider.missList\' | translate }}" tooltip-enable="service_provider.distribution_list==null"><i class="fa fa-thumbs-o-up" ng-if="service_provider.distribution_list!=null"></i> <i ng-if="service_provider.distribution_list==null" class="fa fa-exclamation-triangle" aria-hidden="true"></i> <span data-translate="uniromaLandingApp.service_provider.approve">Approve</span></span></button></td><td ng-if="!vm.canApprove||service_provider.is_approved"><span class="label" ng-class="{\'label-success\': service_provider.is_approved==true,\'label-default\': service_provider.is_approved==false}"><span class="glyphicon" ng-class="{\'glyphicon-ok\': service_provider.is_approved==true,\'glyphicon-ban-circle\': service_provider.is_approved==false}"></span> <span ng-if="service_provider.is_approved" data-translate="uniromaLandingApp.service_provider.is_approved">Attivo</span> <span ng-if="!service_provider.is_approved" data-translate="uniromaLandingApp.service_provider.is_notapproved">Disattivo</span></span></td><td><a ui-sref="distribution-list-detail({id:service_provider.distribution_list.id})">{{service_provider.distribution_list.code}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><notification-icon count="vm.countNewMessages(service_provider)"><span uib-tooltip="{{ \'uniromaLandingApp.service_provider.comments\' | translate }}"><button ng-click="vm.openComments(service_provider)" class="btn btn-default btn-sm" ng-if="vm.canCreateNewSp==true || vm.canApprove==true"><i class="fa fa-comments-o" aria-hidden="true"></i></button></span></notification-icon><span uib-tooltip="{{ \'uniromaLandingApp.service_provider.download\' | translate }}"><a class="btn btn-default btn-sm" href="./api/metadata/entityid/{{service_provider.id}}" target="_self" download="{{file}}"><i class="fa fa-download" aria-hidden="true"></i> </a></span><button type="submit" ui-sref="service-provider-detail({id:service_provider.id})" class="btn btn-info btn-sm"><i class="fa fa-eye" aria-hidden="true"></i> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="service-provider.edit({id:service_provider.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="service-provider.delete({id:service_provider.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/service-tr/service-tr-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.service_tr.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.service_tr.delete.question" translate-values="{id: \'{{vm.service_tr.id}}\'}">Are you sure you want to delete this Service Tr?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/service-tr/service-tr-detail.html','<div><h2><span data-translate="uniromaLandingApp.service_tr.detail.title">Service Tr</span> {{vm.service_tr.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.service_tr.field">Field</span></dt><dd><span>{{vm.service_tr.field}}</span></dd><dt><span data-translate="uniromaLandingApp.service_tr.value">Value</span></dt><dd><span>{{vm.service_tr.value}}</span></dd><dt><span data-translate="uniromaLandingApp.service_tr.language">Language</span></dt><dd><span>{{vm.service_tr.language}}</span></dd><dt><span data-translate="uniromaLandingApp.service_tr.service">Service</span></dt><dd><a ui-sref="service-detail({id:vm.service_tr.service.id})">{{vm.service_tr.service.code}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="service-tr-detail.edit({id:vm.service_tr.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/service-tr/service-tr-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myService_trLabel" data-translate="uniromaLandingApp.service_tr.home.createOrEditLabel">Create or edit a Service Tr</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.service_tr.field" for="field_field">Field</label><input type="text" class="form-control" name="field" id="field_field" ng-model="vm.service_tr.field" required><p ng-show="vm.service_tr.field==null || vm.service_tr.field===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.service_tr.value" for="field_value">Value</label><input type="text" class="form-control" name="value" id="field_value" ng-model="vm.service_tr.value" required><p ng-show="vm.service_tr.value==null || vm.service_tr.value===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.service_tr.language" for="field_language">Language</label><input type="text" class="form-control" name="language" id="field_language" ng-model="vm.service_tr.language" required><p ng-show="vm.service_tr.language==null || vm.service_tr.language===\'\'" class="help-block" translate="entity.validation.required"></p></div><div class="form-group"><label data-translate="uniromaLandingApp.service_tr.service" for="field_service">Service</label><select class="form-control" id="field_service" name="service" ng-model="vm.service_tr.service" ng-options="service as service.code for service in vm.services track by service.id" disabled="disabled"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/service-tr/service-trs.html','<div><h2 data-translate="uniromaLandingApp.service_tr.home.title">Service Trs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="service-tr.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.service_tr.home.createLabel">Create new Service Tr</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="field"><span data-translate="uniromaLandingApp.service_tr.field">Field</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="value"><span data-translate="uniromaLandingApp.service_tr.value">Value</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="language"><span data-translate="uniromaLandingApp.service_tr.language">Language</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="service.code"><span data-translate="uniromaLandingApp.service_tr.service">Service</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="service_tr in vm.service_trs track by service_tr.id"><td><a ui-sref="service-tr-detail({id:service_tr.id})">{{service_tr.id}}</a></td><td>{{service_tr.field}}</td><td>{{service_tr.value}}</td><td>{{service_tr.language}}</td><td><a ui-sref="service-detail({id:service_tr.service.id})">{{service_tr.service.code}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="service-tr-detail({id:service_tr.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="service-tr.edit({id:service_tr.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="service-tr.delete({id:service_tr.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/sp-commenti/sp-commenti-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sp_commenti.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.sp_commenti.delete.question" translate-values="{id: \'{{vm.sp_commenti.id}}\'}">Are you sure you want to delete this Sp Commenti?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/sp-commenti/sp-commenti-detail.html','<div><h2><span data-translate="uniromaLandingApp.sp_commenti.detail.title">Sp Commenti</span> {{vm.sp_commenti.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.sp_commenti.comment">Comment</span></dt><dd><span>{{vm.sp_commenti.comment}}</span></dd><dt><span data-translate="uniromaLandingApp.sp_commenti.create_date">Create Date</span></dt><dd><span>{{vm.sp_commenti.create_date | date:\'medium\'}}</span></dd><dt><span data-translate="uniromaLandingApp.sp_commenti.who_commented">Who Commented</span></dt><dd><a ui-sref="jhi-user-detail({id:vm.sp_commenti.who_commented.id})">{{vm.sp_commenti.who_commented.id}}</a></dd><dt><span data-translate="uniromaLandingApp.sp_commenti.service_provider">Service Provider</span></dt><dd><a ui-sref="service-provider-detail({id:vm.sp_commenti.service_provider.id})">{{vm.sp_commenti.service_provider.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="sp-commenti-detail.edit({id:vm.sp_commenti.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/sp-commenti/sp-commenti-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySp_commentiLabel" data-translate="uniromaLandingApp.sp_commenti.home.createOrEditLabel">Create or edit a Sp Commenti</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sp_commenti.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sp_commenti.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.sp_commenti.comment" for="field_comment">Comment</label><textarea class="form-control" name="comment" id="field_comment" ng-model="vm.sp_commenti.comment" required></textarea><div ng-show="editForm.comment.$invalid"><p class="help-block" ng-show="editForm.comment.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.sp_commenti.create_date" for="field_create_date">Create Date</label><div class="input-group"><input id="field_create_date" type="text" class="form-control" name="create_date" datetime-picker="{{dateformat}}" ng-model="vm.sp_commenti.create_date" is-open="vm.datePickerOpenStatus.create_date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'create_date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.create_date.$invalid"><p class="help-block" ng-show="editForm.create_date.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.create_date.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label data-translate="uniromaLandingApp.sp_commenti.who_commented" for="field_who_commented">Who Commented</label><select class="form-control" id="field_who_commented" name="who_commented" ng-model="vm.sp_commenti.who_commented" ng-options="jhi_user as jhi_user.id for jhi_user in vm.jhi_users track by jhi_user.id"><option value=""></option></select></div><div class="form-group"><label data-translate="uniromaLandingApp.sp_commenti.service_provider" for="field_service_provider">Service Provider</label><select class="form-control" id="field_service_provider" name="service_provider" ng-model="vm.sp_commenti.service_provider" ng-options="service_provider as service_provider.id for service_provider in vm.service_providers track by service_provider.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/sp-commenti/sp-commentis.html','<div><h2 data-translate="uniromaLandingApp.sp_commenti.home.title">Sp Commentis</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="sp-commenti.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.sp_commenti.home.createLabel">Create new Sp Commenti</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span data-translate="uniromaLandingApp.sp_commenti.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="create_date"><span data-translate="uniromaLandingApp.sp_commenti.create_date">Create Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="who_commented.id"><span data-translate="uniromaLandingApp.sp_commenti.who_commented">Who Commented</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="service_provider.id"><span data-translate="uniromaLandingApp.sp_commenti.service_provider">Service Provider</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="sp_commenti in vm.sp_commentis track by sp_commenti.id"><td><a ui-sref="sp-commenti-detail({id:sp_commenti.id})">{{sp_commenti.id}}</a></td><td>{{sp_commenti.comment}}</td><td>{{sp_commenti.create_date | date:\'medium\'}}</td><td><a ui-sref="jhi-user-detail({id:sp_commenti.who_commented.id})">{{sp_commenti.who_commented.id}}</a></td><td><a ui-sref="service-provider-detail({id:sp_commenti.service_provider.id})">{{sp_commenti.service_provider.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sp-commenti-detail({id:sp_commenti.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="sp-commenti.edit({id:sp_commenti.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="sp-commenti.delete({id:sp_commenti.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/tenant/tenant-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tenant.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.tenant.delete.question" translate-values="{id: \'{{vm.tenant.id}}\'}">Are you sure you want to delete this Tenant?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tenant/tenant-detail.html','<div><h2><span data-translate="uniromaLandingApp.tenant.detail.title">Tenant</span> {{vm.tenant.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.tenant.code">Code</span></dt><dd><span>{{vm.tenant.code}}</span></dd><dt><span data-translate="uniromaLandingApp.tenant.type">Type</span></dt><dd><span>{{vm.tenant.type}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tenant-detail.edit({id:vm.tenant.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tenant/tenant-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTenantLabel" data-translate="uniromaLandingApp.tenant.home.createOrEditLabel">Create or edit a Tenant</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tenant.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tenant.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.tenant.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.tenant.code"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.tenant.type" for="field_type">Type</label><input type="text" class="form-control" name="type" id="field_type" ng-model="vm.tenant.type"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tenant/tenants.html','<div><h2 data-translate="uniromaLandingApp.tenant.home.title">Tenants</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tenant.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.tenant.home.createLabel">Create new Tenant</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span data-translate="uniromaLandingApp.tenant.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="uniromaLandingApp.tenant.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="tenant in vm.tenants track by tenant.id"><td><a ui-sref="tenant-detail({id:tenant.id})">{{tenant.id}}</a></td><td>{{tenant.code}}</td><td>{{tenant.type}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tenant-detail({id:tenant.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tenant.edit({id:tenant.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tenant.delete({id:tenant.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/tenant-tr/tenant-tr-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tenant_tr.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="uniromaLandingApp.tenant_tr.delete.question" translate-values="{name: \'{{vm.tenant_tr.name}}\'}">Are you sure you want to delete this Tenant Tr?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tenant-tr/tenant-tr-detail.html','<div><h2><span data-translate="uniromaLandingApp.tenant_tr.detail.title">Tenant Tr</span> {{vm.tenant_tr.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="uniromaLandingApp.tenant_tr.field">Field</span></dt><dd><span>{{vm.tenant_tr.field}}</span></dd><dt><span data-translate="uniromaLandingApp.tenant_tr.value">Value</span></dt><dd><span>{{vm.tenant_tr.value}}</span></dd><dt><span data-translate="uniromaLandingApp.tenant_tr.language">Language</span></dt><dd><span>{{vm.tenant_tr.language}}</span></dd><dt><span data-translate="uniromaLandingApp.tenant_tr.tenant">Tenant</span></dt><dd><a ui-sref="tenant-detail({id:vm.tenant_tr.tenant.id})">{{vm.tenant_tr.tenant.code}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tenant-tr-detail.edit({id:vm.tenant_tr.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tenant-tr/tenant-tr-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTenant_trLabel" data-translate="uniromaLandingApp.tenant_tr.home.createOrEditLabel">Create or edit a Tenant Tr</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tenant_tr.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tenant_tr.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.tenant_tr.field" for="field_field">Field</label><input type="text" class="form-control" name="field" id="field_field" ng-model="vm.tenant_tr.field"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.tenant_tr.value" for="field_value">Value</label><input type="text" class="form-control" name="value" id="field_value" ng-model="vm.tenant_tr.value"></div><div class="form-group"><label class="control-label" data-translate="uniromaLandingApp.tenant_tr.language" for="field_language">Language</label><input type="text" class="form-control" name="language" id="field_language" ng-model="vm.tenant_tr.language"></div><div class="form-group"><label data-translate="uniromaLandingApp.tenant_tr.tenant" for="field_tenant">Tenant</label><select class="form-control" id="field_tenant" name="tenant" ng-model="vm.tenant_tr.tenant" ng-options="tenant as tenant.code for tenant in vm.tenants track by tenant.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-uniroma"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tenant-tr/tenant-trs.html','<div><h2 data-translate="uniromaLandingApp.tenant_tr.home.title">Tenant Trs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tenant-tr.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="uniromaLandingApp.tenant_tr.home.createLabel">Create new Tenant Tr</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="field"><span data-translate="uniromaLandingApp.tenant_tr.field">Field</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="value"><span data-translate="uniromaLandingApp.tenant_tr.value">Value</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="language"><span data-translate="uniromaLandingApp.tenant_tr.language">Language</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tenant.code"><span data-translate="uniromaLandingApp.tenant_tr.tenant">Tenant</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="tenant_tr in vm.tenant_trs track by tenant_tr.id"><td><a ui-sref="tenant-tr-detail({id:tenant_tr.id})">{{tenant_tr.id}}</a></td><td>{{tenant_tr.field}}</td><td>{{tenant_tr.value}}</td><td>{{tenant_tr.language}}</td><td><a ui-sref="tenant-detail({id:tenant_tr.tenant.id})">{{tenant_tr.tenant.code}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tenant-tr-detail({id:tenant_tr.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tenant-tr.edit({id:tenant_tr.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tenant-tr.delete({id:tenant_tr.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-navbar.png" alt="logo"> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- Registry entities --><li ui-sref-active="active" has-authority="ROLE_GESTIONE_REGISTRY"><a ui-sref="registryEntities" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.registry.main">Registry</span></a></li><!-- Policy --><li ui-sref-active="active" has-authority="ROLE_GESTIONE_POLICY"><a ui-sref="policy" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-screenshot"></span> <span class="hidden-sm" data-translate="global.menu.entities.policy">Policy</span></a></li><!-- MENU\' AMMINISTRATORE --><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-any-authority="{{vm.authorityAdmin}}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu-admin"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><!-- DASHBOARD --><li ui-sref-active="active" has-authority="ROLE_DASHBOARD_PROVISIONING"><a ui-sref="dashboard" ng-click="vm.collapseNavbar()"><i class="fa fa-tachometer" aria-hidden="true"></i>&nbsp; <span data-translate="global.menu.dashboard.main">Dashboard</span></a></li><li ui-sref-active="active" has-authority="ROLE_LOG_ERRORE"><a ui-sref="rejectedRow" ng-click="vm.collapseNavbar()"><i class="fa fa-times-circle" aria-hidden="true"></i>&nbsp; <span data-translate="global.menu.entities.rejectedRow">Rejected Row</span></a></li><li ui-sref-active="active" has-authority="ROLE_CONFIGURAZIONE_PARAM"><a ui-sref="configParam" ng-click="vm.collapseNavbar()"><i class="fa fa-briefcase" aria-hidden="true"></i>&nbsp; <span data-translate="global.menu.entities.configParam">configParam</span></a></li><li role="separator" class="divider"></li><!-- SP Management --><li ui-sref-active="active" has-any-authority="ROLE_CREAZIONE_SP,ROLE_APPROVAZIONE_SP"><a ui-sref="service-provider" ng-click="vm.collapseNavbar()"><i class="fa fa-asterisk" aria-hidden="true"></i>&nbsp; <span data-translate="global.menu.entities.serviceProviderMenu">Service Provider</span></a></li><li ui-sref-active="active" has-authority="ROLE_GESTIONE_LISTE_DISTRIBUZIONE"><a ui-sref="distribution-list" ng-click="vm.collapseNavbar()"><i class="fa fa-list-alt" aria-hidden="true"></i>&nbsp; <span data-translate="global.menu.entities.distributionListMenu">Liste distribuzione</span></a></li><li role="separator" class="divider"></li><li ui-sref-active="active" has-authority="ROLE_GESTIONE_UTENTI"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><i class="fa fa-users" aria-hidden="true"></i>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><!-- ESTERNI --><li ui-sref-active="active" has-authority="ROLE_GESTIONE_ESTERNI"><a ui-sref="esterni" ng-click="vm.collapseNavbar()"><i class="fa fa-users" aria-hidden="true"></i>&nbsp; <span data-translate="global.menu.entities.esterni">Esterni</span></a></li><li role="separator" class="divider"></li><li ui-sref-active="active" has-authority="ROLE_GESTIONE_POLICY"><a ui-sref="policy-anag" ng-click="vm.collapseNavbar()"><i class="glyphicon glyphicon-screenshot" aria-hidden="true"></i>&nbsp; <span data-translate="global.menu.entities.policyAnag">Policy Anagrafiche</span></a></li></ul></li><!-- MENU\' UTENTE --><li ng-class="{active: vm.$state.includes(\'account\')}" ng-show="vm.isAuthenticated()" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><i class="fa fa-user" aria-hidden="true"></i> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true" has-authority="ROLE_GESTIONE_DATI_PERSONALI"><a ui-sref="settings" ng-click="vm.collapseNavbar()" ng-attr-title="{{\'global.menu.account.settings_long\'|translate}}"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true" has-authority="ROLE_CAMBIO_PASSWORD"><a ui-sref="password" ng-click="vm.collapseNavbar()"><i class="fa fa-key" aria-hidden="true"></i>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><i class="fa fa-sign-out" aria-hidden="true"></i>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><i class="fa fa-sign-in" aria-hidden="true"></i>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-switch-when="false"><a href="/landing/auth/" id=""><i class="fa fa-sign-in" aria-hidden="true"></i>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-10 col-md-offset-1"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-danger" ng-show="vm.errorPPolicy" data-translate="reset.finish.messages.errorPPolicy"><strong>An error has occurred!</strong> The password does not meet the password policy requirements.</div><div class="alert alert-danger" ng-show="vm.errorPSync" data-translate="reset.finish.messages.errorPSync"><strong>An error has occurred!</strong> Unable to sync password.</div><div class="alert alert-danger" ng-show="vm.errorToken" data-translate="reset.finish.messages.errorToken"><strong>An error has occurred!</strong> The password does not meet the password policy requirements.</div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p><p ng-if="vm.accounts"><span data-translate="global.messages.affectedAccounts" translate-compile></span></p><div ng-repeat="account in vm.accounts"><span>{{account}}</span></div><p></p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><div ng-show="!vm.success" class="alert alert-info" data-translate="global.messages.info.passwordRules">La password deve essere complessa. Immettere una password che soddisfi tutti i criteri specificati di seguito.<ul><li>la password deve essere di almeno 8 caratteri</li><li>non pu&ograve; essere una delle ultime 24 password utilizzate</li><li>non pu&ograve; un gruppo di 3 caratteri consecutivi contenuti nel nome account, n&egrave; nei propri nome e cognome</li><li>deve contenere almeno 3 dei seguenti gruppi di caratteri:<ul><li>caratteri dell\'alfabeto inglese maiuscoli (A-Z)</li><li>caratteri dell\'alfabeto inglese minuscoli (a-z)</li><li>numeri (0-9)</li><li>caratteri non alfabetici (ad esempio,!,@,^,?,+,$,#,%)</li></ul></li></ul>La password pu&ograve; essere cambiata una sola volta al giorno.<br>Un account bloccato torna utilizzabile dopo 10 minuti. In questo caso non &egrave; necessario cambiare la password.</div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><div ng-click="vm.toggleShowPassword(0)" ng-class="\'glyphicon pass-eye-\'+(vm.showPassword[0] ? \'open\' : \'close\')" ng-attr-title="{{(\'global.form.\'+(vm.showPassword[0]?\'hide\':\'show\')|translate)+(\'global.form.newpassword\'|translate|lowercase)}}"></div><input ng-attr-type="{{ vm.showPassword[0] ? \'text\' : \'password\' }}" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="8" ng-maxlength="50" ng-model-options="{allowInvalid: true}" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 8 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><div ng-click="vm.toggleShowPassword(1)" ng-class="\'glyphicon pass-eye-\'+(vm.showPassword[1] ? \'open\' : \'close\')" ng-attr-title="{{(\'global.form.\'+(vm.showPassword[1]?\'hide\':\'show\')|translate)+(\'global.form.confirmpassword\'|translate|lowercase)}}"></div><input ng-attr-type="{{ vm.showPassword[1] ? \'text\' : \'password\' }}" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid || vm.sending" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');}]);})();